const products = [
  {
    id: 'tshirt',
    label: 'T-shirt BC01B',
    fullLabel: 'Tee-shirt homme col rond 150 organique - B&C - #BC01B',
    shopifyProductId: 'gid://shopify/Product/10526329110864',
    textilePriceCents: 352,
    print: { width: 32, height: 42 },
    area: { left: 36, top: 27, width: 28, height: 42 },
    colors: [
      { id: 'white', label: 'WHITE', hex: '#f7f7f2' },
      { id: 'black', label: 'BLACK PURE', hex: '#111111' },
      { id: 'navy', label: 'NAVY', hex: '#17223c' },
      { id: 'royal', label: 'ROYAL', hex: '#245bb3' },
      { id: 'red', label: 'RED', hex: '#c81e32' },
      { id: 'sage', label: 'SAGE', hex: '#94a781' },
      { id: 'soft-rose', label: 'SOFT ROSE', hex: '#e6b4c2' },
      { id: 'lime', label: 'LIME', hex: '#a6d83b' },
      { id: 'pure-orange', label: 'PURE ORANGE', hex: '#f16522' },
      { id: 'yellow-fizz', label: 'YELLOW FIZZ', hex: '#f3e243' },
      { id: 'forest-green', label: 'FOREST GREEN', hex: '#174f32' },
    ],
    views: [
      {
        id: 'front',
        label: 'Recto',
        images: {
          white: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_00_front.jpg?v=1781187279',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_WZ_front.jpg?v=1781187374',
          navy: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_13_front.jpg?v=1781187390',
          royal: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_11_front.jpg?v=1781186905',
          red: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_12_front.jpg?v=1781186922',
          sage: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_VF_front.jpg?v=1781187019',
          'soft-rose': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_SZ_front.jpg?v=1781186931',
          lime: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_N4_front.jpg?v=1781186913',
          'pure-orange': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_SM_front.jpg?v=1781186827',
          'yellow-fizz': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_SY_front.jpg?v=1781186827',
          'forest-green': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_N2_front.jpg?v=1781187140',
        },
      },
      {
        id: 'back',
        label: 'Verso',
        images: {
          white: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_00_back.jpg?v=1781187275',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_WZ_back.jpg?v=1781187283',
          navy: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_13_back.jpg?v=1781187386',
          royal: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_11_back.jpg?v=1781186831',
          red: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_12_back.jpg?v=1781186918',
          sage: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_VF_back.jpg?v=1781186935',
          'soft-rose': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_SZ_back.jpg?v=1781186927',
          lime: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_N4_back.jpg?v=1781186909',
          'pure-orange': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_SM_back.jpg?v=1781186823',
          'yellow-fizz': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_SY_back.jpg?v=1781186823',
          'forest-green': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC01B_N2_back.jpg?v=1781187136',
        },
      },
    ],
  },
  {
    id: 'hoodie',
    label: 'Sweat BC514',
    fullLabel: 'Sweat à capuche oversize - B&C - #BC514',
    shopifyProductId: 'gid://shopify/Product/10526719738192',
    textilePriceCents: 2012,
    print: { width: 30, height: 36 },
    area: { left: 35, top: 34, width: 30, height: 38 },
    colors: [
      { id: 'white', label: 'WHITE', hex: '#f7f7f2' },
      { id: 'black', label: 'BLACK', hex: '#111111' },
      { id: 'mastic', label: 'MASTIC', hex: '#c8bea7' },
    ],
    views: [
      {
        id: 'front',
        label: 'Recto',
        images: {
          white: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC514_00_front.jpg?v=1781205394',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC514_15_front.jpg?v=1781205400',
          mastic: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC514_34_front.jpg?v=1781205460',
        },
      },
      {
        id: 'back',
        label: 'Verso',
        images: {
          white: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC514_00_back.jpg?v=1781205391',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC514_15_back.jpg?v=1781205397',
          mastic: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC514_34_back.jpg?v=1781205404',
        },
      },
    ],
  },
  {
    id: 'cap',
    label: 'Casquette FX6778',
    fullLabel: 'Casquette en coton - FLEXFIT - #FX6778',
    shopifyProductId: 'gid://shopify/Product/10544048243024',
    textilePriceCents: 923,
    print: { width: 12, height: 6 },
    area: { left: 36, top: 39, width: 28, height: 15 },
    colors: [
      { id: 'navy', label: 'NAVY', hex: '#17223c' },
      { id: 'black', label: 'BLACK', hex: '#111111' },
      { id: 'heather', label: 'HEATHER', hex: '#8b8b8b' },
    ],
    views: [
      {
        id: 'front',
        label: 'Face',
        area: { left: 35, top: 38, width: 30, height: 16 },
        images: {
          navy: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/FX6778_13_front_c7321350-c4f4-4cb8-ab18-8ef1e54d611d.jpg?v=1782717590',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/FX6778_15_front.jpg?v=1782717663',
          heather: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/FX6778_RR_front.jpg?v=1782717676',
        },
      },
      {
        id: 'side',
        label: 'Côté',
        area: { left: 39, top: 39, width: 24, height: 14 },
        images: {
          navy: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/FX6778_13_rightside_671e3e09-5eca-412b-999f-df0bad4f66a9.jpg?v=1782717583',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/FX6778_15_rightside_bfc1d5e3-40ca-49cc-ad18-31338ef644f6.jpg?v=1782717596',
          heather: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/FX6778_RR_rightside.jpg?v=1782717669',
        },
      },
      {
        id: 'back',
        label: 'Dos',
        area: { left: 39, top: 38, width: 22, height: 14 },
        images: {
          navy: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/FX6778_13_back_8fd8f6a2-a129-47d8-a5d2-7d3e10d404c9.jpg?v=1782717586',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/FX6778_15_back_720f2b40-c257-4ee9-a2a6-4eab5f945f83.jpg?v=1782717599',
          heather: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/FX6778_RR_back.jpg?v=1782717673',
        },
      },
    ],
  },
  {
    id: 'beanie',
    label: 'Bonnet AT207',
    fullLabel: 'Bonnet en polyester recyclé - ATLANTIS HEADWEAR - #AT207',
    shopifyProductId: 'gid://shopify/Product/10525907517776',
    textilePriceCents: 477,
    shape: 'beanie',
    print: { width: 12, height: 6 },
    area: { left: 34, top: 45, width: 32, height: 14 },
    colors: [
      { id: 'black', label: 'BLACK', hex: '#111111' },
      { id: 'navy', label: 'NAVY', hex: '#17223c' },
      { id: 'burgundy', label: 'BURGUNDY', hex: '#713244' },
      { id: 'mustard', label: 'MUSTARD', hex: '#c6962f' },
      { id: 'light-grey', label: 'LIGHT GREY MELANGE', hex: '#a7a7a2' },
    ],
    views: [
      { id: 'front', label: 'Face', images: {} },
      { id: 'back', label: 'Dos', images: {} },
    ],
  },
  {
    id: 'polo',
    label: 'Polo BC400',
    fullLabel: 'Polo bio homme - B&C - #BC400',
    shopifyProductId: 'gid://shopify/Product/10526684447056',
    textilePriceCents: 624,
    print: { width: 28, height: 36 },
    area: { left: 35, top: 29, width: 30, height: 42 },
    colors: [
      { id: 'white', label: 'WHITE', hex: '#f7f7f2' },
      { id: 'black', label: 'BLACK', hex: '#111111' },
      { id: 'navy-blue', label: 'NAVY BLUE', hex: '#17223c' },
      { id: 'sky-blue', label: 'SKY BLUE', hex: '#91c4df', priceCents: 711 },
      { id: 'fire-red', label: 'FIRE RED', hex: '#c71d2f', priceCents: 711 },
      { id: 'millennial-mint', label: 'MILLENNIAL MINT', hex: '#9fcdbb', priceCents: 711 },
      { id: 'orange', label: 'ORANGE', hex: '#f36b21', priceCents: 711 },
      { id: 'heather-grey', label: 'HEATHER GREY', hex: '#9a9a9a', priceCents: 711 },
    ],
    views: [
      {
        id: 'front',
        label: 'Recto',
        images: {
          white: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_00_front.jpg?v=1781203182',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_15_front.jpg?v=1781203090',
          'navy-blue': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_N9_front.jpg?v=1781203101',
          'sky-blue': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_D1_front.jpg?v=1781202905',
          'fire-red': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_3D_front.jpg?v=1781202786',
          'millennial-mint': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_UX_front.jpg?v=1781202896',
          orange: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_20_front.jpg?v=1781202686',
          'heather-grey': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_M8_front.jpg?v=1781202885',
        },
      },
      {
        id: 'back',
        label: 'Verso',
        images: {
          white: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_00_Back.jpg?v=1781203107',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_15_Back.jpg?v=1781203086',
          'navy-blue': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_N9_back.jpg?v=1781203097',
          'sky-blue': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_D1_Back.jpg?v=1781202901',
          'fire-red': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_3D_Back.jpg?v=1781202778',
          'millennial-mint': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_UX_Back.jpg?v=1781202891',
          orange: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_20_Back.jpg?v=1781202682',
          'heather-grey': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/BC400_M8_Back.jpg?v=1781202802',
        },
      },
    ],
  },
  {
    id: 'tote',
    label: 'Tote LS42OE',
    fullLabel: 'Sac coton anses longues - NEW GEN - #LS42OE',
    shopifyProductId: 'gid://shopify/Product/10530867937616',
    textilePriceCents: 66,
    print: { width: 30, height: 30 },
    area: { left: 34, top: 36, width: 32, height: 34 },
    colors: [
      { id: 'natural', label: 'NATURAL', hex: '#d5c4a2' },
      { id: 'black', label: 'BLACK', hex: '#111111', priceCents: 105 },
      { id: 'white', label: 'WHITE', hex: '#f7f7f2', priceCents: 100 },
      { id: 'red', label: 'RED', hex: '#c81e32', priceCents: 105 },
      { id: 'navy', label: 'NAVY', hex: '#17223c', priceCents: 105 },
      { id: 'royal', label: 'ROYAL', hex: '#245bb3', priceCents: 105 },
    ],
    views: [
      {
        id: 'front',
        label: 'Recto',
        images: {
          natural: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_40_front.jpg?v=1781515206',
          white: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_00_front.jpg?v=1781515272',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_15_front.jpg?v=1781515213',
          navy: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_13_front.jpg?v=1781515283',
          royal: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_11_front.jpg?v=1781515289',
          red: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_12_front.jpg?v=1781515278',
        },
      },
      {
        id: 'back',
        label: 'Verso',
        images: {
          natural: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_40_front1.jpg?v=1781515204',
          white: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_00_front1.jpg?v=1781515270',
          black: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_15_front1.jpg?v=1781515209',
          navy: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_13_front1.jpg?v=1781515281',
          royal: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_11_front1.jpg?v=1781515287',
          red: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/LS42OE_12_front1.jpg?v=1781515275',
        },
      },
    ],
  },
  {
    id: 'softshell',
    label: 'Veste PK503',
    fullLabel: 'Blouson de sport léger - PEN DUICK - #PK503',
    shopifyProductId: 'gid://shopify/Product/10531847274832',
    textilePriceCents: 4524,
    shape: 'jacket',
    print: { width: 30, height: 36 },
    area: { left: 35, top: 30, width: 30, height: 38 },
    colors: [
      { id: 'navy', label: 'NAVY', hex: '#17223c' },
      { id: 'black', label: 'BLACK', hex: '#111111' },
      { id: 'grey', label: 'GREY', hex: '#6f747b' },
    ],
    views: [
      { id: 'front', label: 'Recto', images: {} },
      { id: 'back', label: 'Verso', images: {} },
    ],
  },
  {
    id: 'accessory',
    label: 'Bandana AT014',
    fullLabel: 'Bandana - ATLANTIS HEADWEAR - #AT014',
    shopifyProductId: 'gid://shopify/Product/10525844701520',
    textilePriceCents: 131,
    shape: 'accessory',
    print: { width: 28, height: 28 },
    area: { left: 34, top: 34, width: 32, height: 32 },
    colors: [
      { id: 'white', label: 'WHITE', hex: '#f7f7f2' },
      { id: 'black', label: 'BLACK', hex: '#111111' },
      { id: 'red', label: 'RED', hex: '#c81e32' },
      { id: 'royal', label: 'ROYAL', hex: '#245bb3' },
      { id: 'yellow', label: 'YELLOW', hex: '#f3d434' },
    ],
    views: [
      { id: 'front', label: 'Recto', images: {} },
      { id: 'back', label: 'Verso', images: {} },
    ],
  },
  {
    id: 'pants',
    label: 'Bermuda HK006',
    fullLabel: 'Bermuda de travail - HEROCK - #HK006',
    shopifyProductId: 'gid://shopify/Product/10529516519760',
    textilePriceCents: 2665,
    shape: 'pants',
    print: { width: 18, height: 12 },
    area: { left: 40, top: 44, width: 20, height: 16 },
    colors: [
      { id: 'black', label: 'BLACK', hex: '#111111' },
      { id: 'navy', label: 'NAVY', hex: '#17223c' },
      { id: 'grey-black', label: 'GREY/BLACK', hex: '#73777d' },
    ],
    views: [
      { id: 'front', label: 'Recto', images: {} },
      { id: 'back', label: 'Verso', images: {} },
    ],
  },
  {
    id: 'towel',
    label: 'Fouta OTRHA',
    fullLabel: 'Fouta en coton et polyester recyclé - THE ONE TOWELLING - #OTRHA',
    shopifyProductId: 'gid://shopify/Product/10531729277264',
    textilePriceCents: 870,
    shape: 'towel',
    print: { width: 35, height: 25 },
    area: { left: 25, top: 36, width: 50, height: 28 },
    colors: [
      { id: 'beige', label: 'BEIGE', hex: '#c9ad87' },
      { id: 'navy-blue', label: 'NAVY BLUE', hex: '#17223c' },
      { id: 'red', label: 'RED', hex: '#c81e32' },
      { id: 'ash-grey', label: 'ASH GREY', hex: '#9a9a9a' },
    ],
    views: [
      { id: 'front', label: 'Recto', images: {} },
      { id: 'back', label: 'Verso', images: {} },
    ],
  },
];

const PRODUCT_CATEGORIES = [
  {
    id: 'tshirts',
    label: 'T-shirts & débardeurs',
    collectionId: 'gid://shopify/Collection/617784574288',
    handle: 't-shirts-vierges',
    productCount: 183,
    witnessProductId: 'tshirt',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/collections/T-shirt_BY004.png?v=1720443565',
  },
  {
    id: 'caps',
    label: 'Casquettes & bonnets',
    collectionId: 'gid://shopify/Collection/648210121040',
    handle: 'casquettes-bonnets-vierges-pour-personnalisation',
    productCount: 467,
    witnessProductId: 'cap',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/collections/seo_Pages_d_accueil_27.png?v=1781536671',
  },
  {
    id: 'hoodies',
    label: 'Sweats & hoodies',
    collectionId: 'gid://shopify/Collection/648210743632',
    handle: 'sweats-hoodies-a-personnaliser',
    productCount: 173,
    witnessProductId: 'hoodie',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/collections/seo_Pages_d_accueil_28.png?v=1781537215',
  },
  {
    id: 'jackets',
    label: 'Vestes & softshells',
    collectionId: 'gid://shopify/Collection/620693586256',
    handle: 'vestes-vierges-a-personnaliser',
    productCount: 148,
    witnessProductId: 'softshell',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/collections/1_1e351e4e-fe39-4d6f-b7cf-c142839bf884.png?v=1729862130',
  },
  {
    id: 'accessories',
    label: 'Accessoires',
    collectionId: 'gid://shopify/Collection/617784705360',
    handle: 'accessoires-vierges-pour-transfert-dtf',
    productCount: 161,
    witnessProductId: 'accessory',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/collections/1.png?v=1720443597',
  },
  {
    id: 'pants',
    label: 'Pantalons & shorts',
    collectionId: 'gid://shopify/Collection/620763054416',
    handle: 'pantalons-et-shorts-vierges-a-personnaliser',
    productCount: 88,
    witnessProductId: 'pants',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/collections/Image_site_SEO_10.png?v=1730218372',
  },
  {
    id: 'bags',
    label: 'Bagageries & sac',
    collectionId: 'gid://shopify/Collection/648290042192',
    handle: 'bagageries-sacs',
    productCount: 232,
    witnessProductId: 'tote',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/collections/seo_Pages_d_accueil_30.png?v=1781616189',
  },
  {
    id: 'polos',
    label: 'Polos & chemises',
    collectionId: 'gid://shopify/Collection/648292565328',
    handle: 'polos-chemises',
    productCount: 131,
    witnessProductId: 'polo',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/collections/seo_Pages_d_accueil_32.png?v=1781617898',
  },
  {
    id: 'towels',
    label: 'Serviettes & éponges',
    collectionId: 'gid://shopify/Collection/648296661328',
    handle: 'serviettes-eponges',
    productCount: 32,
    witnessProductId: 'towel',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0606/3797/0611/collections/seo_Pages_d_accueil_33.png?v=1781618142',
  },
];

const PRODUCT_QUICK_CHOICES = [
  { id: 'quick-tshirt', label: 'Tshirt', witnessProductId: 'tshirt' },
  { id: 'quick-tank', label: 'Débardeur', witnessProductId: 'tshirt-bc072' },
  { id: 'quick-sweat', label: 'Sweat', witnessProductId: 'hoodie-bc500' },
  { id: 'quick-hoodie', label: 'Hoodie', witnessProductId: 'hoodie' },
  { id: 'quick-totebag', label: 'Totebag', witnessProductId: 'tote' },
  { id: 'quick-polo', label: 'Polo', witnessProductId: 'polo' },
  { id: 'quick-softshell', label: 'Softshell', witnessProductId: 'jacket-bc622' },
  { id: 'quick-jogging', label: 'Jogging', witnessProductId: 'pants-ea070' },
  { id: 'quick-cap', label: 'Casquette', witnessProductId: 'cap' },
  { id: 'quick-beanie', label: 'Bonnet', witnessProductId: 'beanie' },
];

// Top 20 couleurs textiles tendances (choix rapide). Les mockups SVG
// recolorent les fills blancs avec ces hex, indépendamment des photos produit.
const CUSTOM_TEXTILE_COLOR_ID = 'custom';
const DEFAULT_CUSTOM_TEXTILE_HEX = '#d8357d';

const TEXTILE_COLOR_LABELS_FR = {
  white: 'Blanc',
  black: 'Noir',
  ecru: 'Écru',
  sand: 'Sable',
  mocha: 'Moka',
  chocolate: 'Chocolat',
  'heather-grey': 'Gris chiné',
  charcoal: 'Anthracite',
  navy: 'Marine',
  'sky-blue': 'Bleu ciel',
  royal: 'Royal',
  sage: 'Sauge',
  olive: 'Olive',
  'forest-green': 'Forêt',
  burgundy: 'Bordeaux',
  terracotta: 'Terracotta',
  coral: 'Corail',
  'soft-rose': 'Rose poudré',
  butter: 'Beurre',
  lavender: 'Lavande',
  red: 'Rouge',
  lime: 'Citron vert',
  'pure-orange': 'Orange',
  'yellow-fizz': 'Jaune',
};

const TRENDING_TEXTILE_COLORS = [
  { id: 'white', label: 'Blanc', hex: '#f7f7f2' },
  { id: 'black', label: 'Noir', hex: '#111111' },
  { id: 'ecru', label: 'Écru', hex: '#f0e6d8' },
  { id: 'sand', label: 'Sable', hex: '#d4c4a8' },
  { id: 'mocha', label: 'Moka', hex: '#a47864' },
  { id: 'chocolate', label: 'Chocolat', hex: '#4a2c2a' },
  { id: 'heather-grey', label: 'Gris chiné', hex: '#9a9a9a' },
  { id: 'charcoal', label: 'Anthracite', hex: '#3d3d3d' },
  { id: 'navy', label: 'Marine', hex: '#17223c' },
  { id: 'sky-blue', label: 'Bleu ciel', hex: '#8eb8d8' },
  { id: 'royal', label: 'Royal', hex: '#245bb3' },
  { id: 'sage', label: 'Sauge', hex: '#94a781' },
  { id: 'olive', label: 'Olive', hex: '#6b7c3a' },
  { id: 'forest-green', label: 'Forêt', hex: '#174f32' },
  { id: 'burgundy', label: 'Bordeaux', hex: '#6b1f2a' },
  { id: 'terracotta', label: 'Terracotta', hex: '#c46a4a' },
  { id: 'coral', label: 'Corail', hex: '#e07a5f' },
  { id: 'soft-rose', label: 'Rose poudré', hex: '#e6b4c2' },
  { id: 'butter', label: 'Beurre', hex: '#f0d878' },
  { id: 'lavender', label: 'Lavande', hex: '#b8a9c9' },
];

const PRODUCT_REFERENCES = [
  referenceItem('tshirt', 'tshirts', 'tshirt', 'T-shirt BC01B', 'Tee-shirt homme col rond 150 organique - B&C - #BC01B', 'BC01B', 352, true),
  referenceItem('tshirt-bc01v', 'tshirts', 'tshirt', 'T-shirt BC01V', 'Tee-shirt homme col V 150 - B&C - #BC01V', 'BC01V', 337),
  referenceItem('tshirt-bc02b', 'tshirts', 'tshirt', 'T-shirt BC02B', 'Tee-shirt femme col rond 150 organique - B&C - #BC02B', 'BC02B', 352),
  referenceItem('tshirt-bc072', 'tshirts', 'tshirt', 'Débardeur BC072', 'Débardeur coton bio homme - B&C - #BC072', 'BC072', 481, false, 'tank'),
  referenceItem('tshirt-by003', 'tshirts', 'tshirt', 'Débardeur BY003', 'Débardeur - BUILD YOUR BRAND - #BY003', 'BY003', 361),
  referenceItem('tshirt-be3200', 'tshirts', 'tshirt', 'T-shirt BE3200', 'Tee-shirt baseball manches 3/4 - BELLA+CANVAS - #BE3200', 'BE3200', 776),
  referenceItem('tshirt-be3413', 'tshirts', 'tshirt', 'T-shirt BE3413', 'Tee-shirt unisexe Triblend - BELLA+CANVAS - #BE3413', 'BE3413', 694),
  referenceItem('tshirt-gn642', 'tshirts', 'tshirt', 'Débardeur GN642', 'Débardeur femme - GILDAN - #GN642', 'GN642', 322),

  referenceItem('cap', 'caps', 'cap', 'Casquette FX6778', 'Casquette en coton - FLEXFIT - #FX6778', 'FX6778', 923, true),
  referenceItem('cap-f110mu', 'caps', 'cap', 'Casquette F110MU', '110 MELANGE UNIPANEL - FLEXFIT - #F110MU', 'F110MU', 1095),
  referenceItem('cap-bm910', 'caps', 'cap', 'Casquette BM910', '5-Panel-Cap - PEN DUICK - #BM910', 'BM910', 227),
  referenceItem('cap-bm911', 'caps', 'cap', 'Casquette BM911', '6-Panel-Cap - PEN DUICK - #BM911', 'BM911', 252),
  referenceItem('beanie', 'caps', 'beanie', 'Bonnet AT207', 'Bonnet en polyester recyclé - ATLANTIS HEADWEAR - #AT207', 'AT207', 477, true),

  referenceItem('hoodie', 'hoodies', 'hoodie', 'Sweat BC514', 'Sweat à capuche oversize - B&C - #BC514', 'BC514', 2012, true),
  referenceItem('hoodie-by285', 'hoodies', 'hoodie', 'Hoodie BY285', 'FLUFFY ZIP HOODY - BUILD YOUR BRAND - #BY285', 'BY285', 2040),
  referenceItem('hoodie-it046', 'hoodies', 'hoodie', 'Sweat IT046', 'KIDS CREWNECK SWEATSHIRT - VESTI - #IT046', 'IT046', 1689),
  referenceItem('hoodie-bc500', 'hoodies', 'hoodie', 'Sweat BC500', 'Sweat col rond bio - B&C - #BC500', 'BC500', 1320, false, 'sweatshirt'),

  referenceItem('softshell', 'jackets', 'softshell', 'Veste PK503', 'Blouson de sport léger - PEN DUICK - #PK503', 'PK503', 4524, true),
  referenceItem('jacket-pk542', 'jackets', 'softshell', 'Blouson PK542', 'Blouson de travail - PEN DUICK - #PK542', 'PK542', 1287),
  referenceItem('jacket-hk110', 'jackets', 'softshell', 'Blouson HK110', 'Blouson de travail doublé - HEROCK - #HK110', 'HK110', 6338),
  referenceItem('jacket-bc622', 'jackets', 'softshell', 'Softshell BC622', 'Veste softshell homme - B&C - #BC622', 'BC622', 2880),

  referenceItem('accessory', 'accessories', 'accessory', 'Bandana AT014', 'Bandana - ATLANTIS HEADWEAR - #AT014', 'AT014', 131, true),
  referenceItem('accessory-at305', 'accessories', 'accessory', 'Bandana AT305', 'Bandana en polyester recyclé - ATLANTIS HEADWEAR - #AT305', 'AT305', 118),
  referenceItem('accessory-bg748', 'accessories', 'accessory', 'Pochettes BG748', '2 pochettes et 1 dragonne - BAG BASE - #BG748', 'BG748', 841),
  referenceItem('accessory-bg755', 'accessories', 'accessory', 'Voyage BG755', 'Accessoires de voyage - BAG BASE - #BG755', 'BG755', 638),

  referenceItem('pants', 'pants', 'pants', 'Bermuda HK006', 'Bermuda de travail - HEROCK - #HK006', 'HK006', 2665, true),
  referenceItem('pants-hk024', 'pants', 'pants', 'Bermuda HK024', 'Bermuda multi-poches - HEROCK - #HK024', 'HK024', 3484),
  referenceItem('pants-hk016', 'pants', 'pants', 'Bermuda HK016', 'Bermuda Ripstop extensible - HEROCK - #HK016', 'HK016', 4869),
  referenceItem('pants-ea070', 'pants', 'pants', 'Jogging EA070', 'Jogging en coton et polyester recyclés - ECOLOGIE - #EA070', 'EA070', 1559),

  referenceItem('tote', 'bags', 'tote', 'Tote LS42OE', 'Sac coton anses longues - NEW GEN - #LS42OE', 'LS42OE', 66, true),
  referenceItem('bag-bg748', 'bags', 'tote', 'Pochettes BG748', '2 pochettes et 1 dragonne - BAG BASE - #BG748', 'BG748', 841),
  referenceItem('bag-bg755', 'bags', 'tote', 'Voyage BG755', 'Accessoires de voyage - BAG BASE - #BG755', 'BG755', 638),
  referenceItem('bag-bg765', 'bags', 'tote', 'Bandoulière BG765', 'Bandoulière ajustable - BAG BASE - #BG765', 'BG765', 331),

  referenceItem('polo', 'polos', 'polo', 'Polo BC400', 'Polo bio homme - B&C - #BC400', 'BC400', 624, true),
  referenceItem('polo-bc401', 'polos', 'polo', 'Polo BC401', 'Polo bio femme - B&C - #BC401', 'BC401', 624),
  referenceItem('shirt-hy597', 'polos', 'polo', 'Blouse HY597', 'Blouse femme manches courtes - HENBURY - #HY597', 'HY597', 1231),
  referenceItem('shirt-hy598', 'polos', 'polo', 'Blouse HY598', 'Blouse femme manches longues - HENBURY - #HY598', 'HY598', 1543),
  referenceItem('shirt-kybf8', 'polos', 'polo', 'Chemise KYBF8', 'Chemise à carreaux femme Urban-Style - KARLOWSKY - #KYBF8', 'KYBF8', 3468),

  referenceItem('towel', 'towels', 'towel', 'Fouta OTRHA', 'Fouta en coton et polyester recyclé - THE ONE TOWELLING - #OTRHA', 'OTRHA', 870, true),
  referenceItem('towel-otsli', 'towels', 'towel', 'Chaussons OTSLI', 'Chaussons - THE ONE TOWELLING - #OTSLI', 'OTSLI', 298),
  referenceItem('towel-othte', 'towels', 'towel', 'Fouta OTHTE', 'Fouta en éponge - THE ONE TOWELLING - #OTHTE', 'OTHTE', 1855),
];

const SHOPIFY_BLANK_REFERENCES = normalizeShopifyBlankReferences(window.SHERPA_BAT_BLANK_PRODUCTS);
let ALL_PRODUCT_REFERENCES = mergeProductReferences(PRODUCT_REFERENCES, SHOPIFY_BLANK_REFERENCES);
const PRODUCT_CATEGORY_MAP = new Map(PRODUCT_CATEGORIES.map((category) => [category.id, category]));
const PRODUCT_QUICK_CHOICE_MAP = new Map(PRODUCT_QUICK_CHOICES.map((choice) => [choice.id, choice]));
const PRODUCT_REFERENCE_MAP = new Map(ALL_PRODUCT_REFERENCES.map((reference) => [reference.id, reference]));
products.push(...ALL_PRODUCT_REFERENCES
  .filter((reference) => !products.some((product) => product.id === reference.id))
  .map(createReferenceProduct));

const QUALITY_DPI = 300;
const MIN_DPI = 150;
const CM_PER_INCH = 2.54;
const BG_TOLERANCE = 30;
const THIN_MM = 0.35;
const MAX_IMPORT_EDGE = 4096;
const VISIBLE_ALPHA_THRESHOLD = 24;
const ACCEPTED_LOGO_EXTENSIONS = ['png', 'jpg', 'jpeg', 'ai', 'pdf'];
const RASTER_LOGO_EXTENSIONS = ['png', 'jpg', 'jpeg'];
// French default VAT rate used only to derive a TTC display value from HT sale
// prices. Internal cost/margin computations always stay HT.
const TVA_RATE = 0.2;
// Declared with other boot-time constants: createDefaultPricingSettings() runs
// during `state` init and must not hit a temporal dead zone later in the file.
const SIMPLIFIED_UNIT_PRICE_MODES = ['off', 'partial', 'total', 'totalExDelivery'];
const WORKSPACE_MODES = [
  { id: 'compose', label: '1. Textiles & marquages' },
  { id: 'profitability', label: '2. Tarifs & marges' },
];
const PROFITABILITY_STEPS = [
  { id: 'quantity', label: 'Quantités' },
  { id: 'price', label: 'Prix de vente' },
  { id: 'options', label: 'Options' },
  { id: 'costs', label: 'Coûts (interne)' },
  { id: 'quote', label: 'Devis' },
  { id: 'production', label: 'Production' },
];
const ZONE_OPTIONS = [
  { id: 'front', label: 'Face avant', print: { width: 35, height: 50 } },
  { id: 'back', label: 'Face arrière', print: { width: 35, height: 50 } },
  { id: 'collar', label: 'Col', print: { width: 10, height: 5 } },
  { id: 'right-side', label: 'Côté droit', print: { width: 14, height: 18 } },
  { id: 'left-side', label: 'Côté gauche', print: { width: 14, height: 18 } },
];
const ZONE_MARKING_TYPES = [
  { id: 'print', label: 'Impression' },
  { id: 'embroidery', label: 'Broderie' },
  { id: 'lettering-3d', label: 'Lettrage 3D' },
  { id: 'patch', label: 'Ecusson' },
];
const SIZE_OPTIONS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL'];
const LARGE_SIZE_OPTIONS = ['XXL', '3XL', '4XL', '5XL', '6XL'];
const QUANTITY_MODES = ['total', 'sizes'];
const MARKING_TECHNIQUES = [
  'Transfert DTF',
  'Transfert sérigraphique',
  'Transfert de sublimation',
  'DTG',
  'Sérigraphie',
  'Broderie',
  'Écusson',
  'Lettrage 3D',
  'Flex découpé',
  'Flex imprimé',
];
const CUSTOM_MARKING_TECHNIQUE = 'Autre';
const TRANSFER_MARKING_PREFIX = 'transfert ';
const MARKING_SUPPLIER_MODES = [
  { id: 'supplier', label: 'Fournisseur' },
  { id: 'internal', label: 'Fabrication interne' },
  { id: 'both', label: 'Fournisseur + interne' },
];
const CARRIER_PICKUP_OPTIONS = ['Chronopost', 'DHL', 'Fedex', 'Colissimo', 'Palette', 'Retrait atelier', 'Autre'];
const CUSTOMER_LEVELS = [
  { id: 1, label: 'Niveau 1', textileMultiplier: 1, textileDiscount: 0, easyOrderSegment: 'niveau_a' },
  { id: 2, label: 'Niveau 2', textileMultiplier: 0.9, textileDiscount: 10, easyOrderSegment: 'niveau_a' },
  { id: 3, label: 'Niveau 3', textileMultiplier: 0.8, textileDiscount: 20, easyOrderSegment: 'niveau_a' },
  { id: 4, label: 'Niveau 4', textileMultiplier: 0.7, textileDiscount: 30, easyOrderSegment: 'niveau_4' },
  { id: 5, label: 'Niveau 5', textileMultiplier: 0.7, textileDiscount: 30, easyOrderSegment: 'niveau_5' },
];
const FALLBACK_EASY_ORDER_RANGES = {
  source: 'fallback-prototype',
  prices: [
    { area: 0, price: 0.023, price_for_niveau_1_2_3: 0.023, price_for_niveau_4: 0.021, price_for_niveau_5: 0.02 },
    { area: 250, price: 0.021, price_for_niveau_1_2_3: 0.021, price_for_niveau_4: 0.019, price_for_niveau_5: 0.018 },
    { area: 500, price: 0.019, price_for_niveau_1_2_3: 0.019, price_for_niveau_4: 0.017, price_for_niveau_5: 0.016 },
    { area: 1000, price: 0.017, price_for_niveau_1_2_3: 0.017, price_for_niveau_4: 0.015, price_for_niveau_5: 0.014 },
  ],
  delivery_delay: [
    { plan: 'Standard', price: 1, price_for_niveau_1_2_3: 1, price_for_niveau_4: 1, price_for_niveau_5: 1 },
  ],
};
const ADMIN_DEFAULTS_STORAGE_KEY = 'sherpaBatGeneratorDefaultsV1';
const BAT_DRAFTS_STORAGE_PREFIX = 'sherpaBatDraftsV1';
const BAT_DRAFTS_MAX_COUNT = 30;
let activeAdminDefaults = loadAdminDefaults();
const initialProductChoiceId = PRODUCT_QUICK_CHOICE_MAP.has(activeAdminDefaults.compose.productChoiceId)
  ? activeAdminDefaults.compose.productChoiceId
  : 'quick-tshirt';
const initialProductId = PRODUCT_QUICK_CHOICE_MAP.get(initialProductChoiceId)?.witnessProductId || 'tshirt';
const initialProduct = getProductById(initialProductId) || products[0];
const initialProductColors = resolveProductColors(initialProduct, initialProductChoiceId);

const els = {
  app: document.querySelector('[data-app]'),
  rightPanel: document.querySelector('[data-right-panel]'),
  adminModal: document.querySelector('[data-admin-modal]'),
  logoEditorModal: document.querySelector('[data-logo-editor-modal]'),
  stepItems: document.querySelectorAll('[data-step]'),
  productList: document.querySelector('[data-product-list]'),
  productLabel: document.querySelector('[data-product-label]'),
  colorList: document.querySelector('[data-color-list]'),
  colorLabel: document.querySelector('[data-color-label]'),
  textileDossier: document.querySelector('[data-textile-dossier]'),
  logoInput: document.querySelector('[data-logo-input]'),
  logoList: document.querySelector('[data-logo-list]'),
  logoCount: document.querySelector('[data-logo-count]'),
  dropzone: document.querySelector('[data-dropzone]'),
  textContent: document.querySelector('[data-text-content]'),
  textFont: document.querySelector('[data-text-font]'),
  textColor: document.querySelector('[data-text-color]'),
  productArt: document.querySelector('[data-product-art]'),
  printArea: document.querySelector('[data-print-area]'),
  stage: document.querySelector('[data-stage]'),
  workspaceTabs: document.querySelector('[data-workspace-tabs]'),
  viewTabs: document.querySelector('[data-view-tabs]'),
  surfaceTabs: document.querySelector('[data-surface-tabs]'),
  viewList: document.querySelector('[data-view-list]'),
  activeViewLabel: document.querySelector('[data-active-view-label]'),
  selectedLabel: document.querySelector('[data-selected-label]'),
  qualityStatus: document.querySelector('[data-quality-status]'),
  qualityReport: document.querySelector('[data-quality-report]'),
  logoTools: document.querySelector('[data-logo-tools]'),
  dimensionFields: document.querySelector('[data-dimension-fields]'),
  rotationField: document.querySelector('[data-rotation-field]'),
  logoInlineBg: document.querySelector('[data-logo-inline-bg]'),
  batStatus: document.querySelector('[data-bat-status]'),
  headerPrice: document.querySelector('[data-header-price]'),
  headerPriceTotal: document.querySelector('[data-header-price-total]'),
  headerPriceLabel: document.querySelector('[data-header-price-label]'),
  headerMargin: document.querySelector('[data-header-margin]'),
  headerMarginValue: document.querySelector('[data-header-margin-value]'),
  priceEye: document.querySelector('[data-price-eye]'),
  summary: document.querySelector('[data-summary]'),
  pricingStatus: document.querySelector('[data-pricing-status]'),
  pricingControls: document.querySelector('[data-pricing-controls]'),
  productionStatus: document.querySelector('[data-production-status]'),
  productionSummary: document.querySelector('[data-production-summary]'),
  productionDossier: document.querySelector('[data-production-dossier]'),
  productionNotes: document.querySelector('[data-production-notes]'),
  productionPanelTitle: document.querySelector('[data-production-panel-title]'),
  productionDossierTitle: document.querySelector('[data-production-dossier-title]'),
  productionDossierTone: document.querySelector('[data-production-dossier-tone]'),
  productionNotesTitle: document.querySelector('[data-production-notes-title]'),
  productionNotesTone: document.querySelector('[data-production-notes-tone]'),
  profitabilityStatus: document.querySelector('[data-profitability-status]'),
  profitabilitySummary: document.querySelector('[data-profitability-summary]'),
  profitabilityControls: document.querySelector('[data-profitability-controls]'),
  inspector: document.querySelector('[data-inspector]'),
  layerName: document.querySelector('[data-layer-name]'),
  layerText: document.querySelector('[data-layer-text]'),
  layerFont: document.querySelector('[data-layer-font]'),
  layerColor: document.querySelector('[data-layer-color]'),
  layerWidth: document.querySelector('[data-layer-width]'),
  layerHeight: document.querySelector('[data-layer-height]'),
  layerRotation: document.querySelector('[data-layer-rotation]'),
  textOnlyFields: document.querySelectorAll('.bat-text-only'),
  imageOnlyFields: document.querySelectorAll('.bat-image-only'),
  layerToolsTitle: document.querySelector('[data-layer-tools-title]'),
  creditPill: document.querySelector('[data-credit-pill]'),
  creditLabel: document.querySelector('[data-credit-label]'),
  creditCount: document.querySelector('[data-credit-count]'),
  creditModal: document.querySelector('[data-credit-modal]'),
  creditModalTitle: document.querySelector('[data-credit-modal-title]'),
  creditModalText: document.querySelector('[data-credit-modal-text]'),
  creditModalBalance: document.querySelector('[data-credit-modal-balance]'),
  creditModalConfirm: document.querySelector('[data-credit-confirm]'),
  creditModalCancel: document.querySelector('[data-credit-cancel]'),
};

function parseCreditBalance(value) {
  if (value === null || typeof value === 'undefined' || value === '') return null;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : null;
  }
  if (typeof value === 'string') {
    const match = value.replace(',', '.').match(/-?\d+(\.\d+)?/);
    if (!match) return null;
    const parsed = Number(match[0]);
    return Number.isFinite(parsed) ? Math.max(0, Math.floor(parsed)) : null;
  }
  if (typeof value === 'object') {
    return parseCreditBalance(
      value.remaining ?? value.balance ?? value.credits ?? value.value ?? value.data
    );
  }
  return null;
}

const creditConfig = {
  required: els.app?.dataset.creditRequired === 'true',
  ledgerBase:
    els.app?.dataset.creditLedgerBase ||
    'https://pmd-credits.jet-feast.workers.dev/api/v1',
  buyUrl:
    els.app?.dataset.creditBuyUrl ||
    'https://www.sherpa-transfert.com/products/credits-supplementaires-printmydtf',
  loginUrl: els.app?.dataset.loginUrl || '/account/login',
  customerId: els.app?.dataset.customerId || '',
  isLoggedIn: els.app?.dataset.customerLoggedIn === 'true',
  initialBalance: parseCreditBalance(els.app?.dataset.creditBalance),
  freeDownloadEnabled: els.app?.dataset.freeDownloadEnabled === 'true',
};

const creditState = {
  balance: creditConfig.initialBalance,
  ready: !creditConfig.required || creditConfig.initialBalance !== null,
  loading: false,
  consuming: false,
};

let creditModalResolve = null;

const state = {
  productId: initialProductId,
  productCategoryId: getProductCategoryId(initialProduct),
  productChoiceId: initialProductChoiceId,
  productSearch: '',
  productPickerMode: 'quick',
  productReferenceModalOpen: false,
  colorId: initialProductColors[0]?.id || 'white',
  customColorHex: DEFAULT_CUSTOM_TEXTILE_HEX,
  viewId: 'front',
  workspaceMode: 'compose',
  rightColumnTab: 'textile',
  leftCollapsed: false,
  rightCollapsed: false,
  activeZoneIds: normalizeZoneIds(activeAdminDefaults.compose.activeZoneIds),
  zoneMarkings: normalizeZoneMarkings(activeAdminDefaults.compose.zoneMarkings),
  customZoneSize: normalizeCustomZoneSize(activeAdminDefaults.compose.customZoneSize),
  customerLevel: detectInitialCustomerLevel(),
  assets: [],
  layers: [],
  previewAdjustments: {},
  customProductPhotos: {},
  priceDisplayMode: 'HT',
  priceOverrides: {
    totalCents: null,
    textileCents: null,
    printCents: null,
    poseCents: null,
  },
  profitabilityStep: 'quantity',
  pricingSettings: createDefaultPricingSettings(),
  quantityMode: 'total',
  totalQuantity: createDefaultTotalQuantity(),
  totalLargeSizeQuantity: 0,
  sizeQuantities: createEmptySizeQuantities(),
  batConfig: createDefaultBatConfig(),
  productionConfig: createDefaultProductionConfig(),
  profitabilityConfig: createDefaultProfitabilityConfig(),
  currentDraftId: null,
  textiles: [],
  activeTextileId: '',
  selectedLayerId: null,
  pendingUploadViewId: null,
  drag: null,
  history: [],
  redoStack: [],
  formEditSnapshotActive: false,
  adminDefaults: activeAdminDefaults,
  adminDraft: cloneForHistory(activeAdminDefaults),
  adminOpen: false,
  logoEditorOpen: false,
};

// Declared before init(): preloadGarmentMockups() runs during boot and must not
// hit the temporal dead zone of a later `let` in this file.
const garmentSvgCache = new Map(); // key -> raw SVG text
let garmentSvgPreloadPromise = null;
let garmentUiRefreshTimer = null;
let editorBootPromise = null;
let editorHasOpenedOnce = false;

function showEditorBootScreen(message) {
  if (!els.app) return;
  els.app.classList.add('is-booting');
  els.app.classList.remove('is-ready');
  const boot = els.app.querySelector('[data-bat-boot-screen]');
  if (!boot) return;
  boot.hidden = false;
  boot.removeAttribute('hidden');
  boot.setAttribute('aria-busy', 'true');
  const label = boot.querySelector('strong');
  if (label && message) label.textContent = message;
}

function markEditorReady() {
  if (!els.app) return;
  els.app.classList.remove('is-booting');
  els.app.classList.add('is-ready');
  const boot = els.app.querySelector('[data-bat-boot-screen]');
  if (boot) {
    boot.setAttribute('aria-busy', 'false');
    boot.hidden = true;
  }
}

function waitAnimationFrames(count = 2) {
  return new Promise((resolve) => {
    const step = (left) => {
      if (left <= 0) {
        resolve();
        return;
      }
      requestAnimationFrame(() => step(left - 1));
    };
    step(count);
  });
}

function ensureEditorBooted() {
  return editorBootPromise || Promise.resolve();
}

async function settleEditorOpen() {
  showEditorBootScreen('Chargement de l\'éditeur…');
  await ensureEditorBooted();
  if (!isEditorOpen()) return;
  renderAll();
  // Let the heavy first paint commit before accepting clicks.
  await waitAnimationFrames(2);
  if (!isEditorOpen()) return;
  editorHasOpenedOnce = true;
  markEditorReady();
}

function scheduleGarmentMockupsUiRefresh() {
  // Coalesce dozens of SVG-load callbacks into one refresh so early clicks
  // (Ajouter du texte, etc.) are not lost mid-renderAll.
  if (garmentUiRefreshTimer != null) return;
  garmentUiRefreshTimer = window.setTimeout(() => {
    garmentUiRefreshTimer = null;
    if (els.app?.classList.contains('is-booting')) return;
    refreshGarmentMockupsUi();
  }, 80);
}

function startEditorBackgroundWarmup() {
  // Full mockup library in background — must never block UI.
  // Blank catalogue hydrate removed: textile picker is quick-choice only.
  preloadGarmentMockups()
    .then((count) => {
      if (count) scheduleGarmentMockupsUiRefresh();
    })
    .catch(() => {});
}

function init() {
  if (window.pdfjsLib) {
    window.pdfjsLib.GlobalWorkerOptions.workerSrc = els.app?.dataset.pdfWorkerUrl || window.SHERPA_BAT_PDF_WORKER_URL || '../printmydtf-live-theme-20260702/assets/pdf.worker.min.js';
  }
  bindEvents();
  bindCreditModalEvents();
  bindMesFichiersLibrary();
  refreshCredits();
  showEditorBootScreen('Chargement de l\'éditeur…');
  restoreBatDraftFromUrl();
  renderAll();

  // Critical path only: mockups for the active textile (a few hundred KB), not the
  // whole 8MB SVG library nor multi‑MB products.json pages.
  editorBootPromise = preloadPriorityGarmentMockups().catch(() => 0);

  editorBootPromise.finally(async () => {
    reopenEditorAfterLogin();
    // Fullscreen, or modal already open (bridge / ?bat_open=1): wait for first paint.
    if (!isModalMode() || isEditorOpen()) {
      await settleEditorOpen();
    } else {
      // Modal still closed: finish boot quietly; openEditor will show the spinner.
      markEditorReady();
    }
    startEditorBackgroundWarmup();
  });
}

function bindMesFichiersLibrary() {
  if (!window.MesFichiersLibrary?.mount || !els.app) return;
  const overlay = els.app.querySelector('[data-mf-library-overlay]');
  const openButton = els.app.querySelector('[data-library-open]');
  if (!overlay || !openButton) return;
  window.MesFichiersLibrary.mount({
    root: els.app,
    overlay,
    openButton,
    addLabel: 'Ajouter',
    toast: (message) => {
      try {
        alert(message);
      } catch (_) {
        /* ignore */
      }
    },
    onImport: async (file) => {
      await importFiles([file]);
      selectRightColumnTab('logos');
    },
  });
}

// After Shopify login redirect (?bat_open=1&return_url=...), reopen the modal.
function reopenEditorAfterLogin() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('bat_open') !== '1') return;
    if (!isCustomerLoggedIn()) return;
    params.delete('bat_open');
    const clean = `${window.location.pathname}${params.toString() ? `?${params}` : ''}${window.location.hash}`;
    window.history.replaceState({}, '', clean);
    openEditor();
  } catch (error) {
    /* ignore */
  }
}

function refreshGarmentMockupsUi() {
  if (!els.app) return;
  renderProducts();
  renderColors();
  renderTextileDossier();
  renderStage();
}

function eventElement(event) {
  const target = event?.target;
  if (target instanceof Element) return target;
  if (target instanceof Node) return target.parentElement;
  return null;
}

function bindEvents() {
  els.logoInput.addEventListener('change', (event) => {
    importFiles(Array.from(event.target.files || []));
    event.target.value = '';
  });

  ['dragenter', 'dragover'].forEach((name) => {
    els.dropzone.addEventListener(name, (event) => {
      event.preventDefault();
      els.dropzone.classList.add('is-dragging');
    });
  });

  ['dragleave', 'drop'].forEach((name) => {
    els.dropzone.addEventListener(name, () => els.dropzone.classList.remove('is-dragging'));
  });

  els.dropzone.addEventListener('drop', (event) => {
    event.preventDefault();
    importFiles(Array.from(event.dataTransfer?.files || []));
  });

  document.addEventListener('dragenter', (event) => {
    const canvas = eventElement(event)?.closest?.('[data-preview-canvas]');
    if (!canvas || !isEditorOpen()) return;
    event.preventDefault();
    canvas.classList.add('is-file-dragging');
  });
  document.addEventListener('dragover', (event) => {
    const canvas = eventElement(event)?.closest?.('[data-preview-canvas]');
    if (!canvas || !isEditorOpen()) return;
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
    canvas.classList.add('is-file-dragging');
  });
  document.addEventListener('dragleave', (event) => {
    const canvas = eventElement(event)?.closest?.('[data-preview-canvas]');
    if (!canvas) return;
    if (canvas.contains(event.relatedTarget)) return;
    canvas.classList.remove('is-file-dragging');
  });
  document.addEventListener('drop', (event) => {
    const canvas = eventElement(event)?.closest?.('[data-preview-canvas]');
    if (!canvas || !isEditorOpen()) return;
    event.preventDefault();
    canvas.classList.remove('is-file-dragging');
    const viewId = canvas.dataset.previewViewId || state.viewId;
    importFilesAtClientPoint(
      Array.from(event.dataTransfer?.files || []),
      canvas,
      event.clientX,
      event.clientY,
      viewId,
    );
  });

  document.addEventListener('click', (event) => {
    const target = eventElement(event);
    if (!target) return;
    const opener = target.closest('[data-bat-open-editor]');
    if (opener) {
      event.preventDefault();
      openEditor();
      return;
    }

    const closer = target.closest('[data-bat-close-editor]');
    if (closer) {
      event.preventDefault();
      closeEditor();
      return;
    }

    if (!isEditorOpen() || !target.closest('[data-app]')) return;
    if (!target.closest('[data-download-menu]')) closeDownloadMenu();
    if (target.closest('[data-project-textile-name]')) return;
    const actionEl = target.closest('[data-action]');
    const action = actionEl?.dataset.action;
    if (!action) return;
    // Price hide must ONLY come from an intentional click on the header eye.
    // Theme CSS / oversized hit boxes previously let stage/grey clicks reach
    // a mis-sized eye button and toggle the blur by accident.
    if (action === 'toggle-price-hidden' && !isHeaderPriceEyeClick(event, actionEl)) return;
    runAction(action, target.closest('[data-id]')?.dataset.id);
  });

  document.addEventListener('keydown', onKeyDown);

  document.addEventListener('input', (event) => {
    if (!isEditorOpen() || !event.target.closest('[data-app]')) return;
    const adminField = event.target.closest('[data-admin-field]');
    if (adminField) {
      updateAdminDraftField(adminField);
      return;
    }
    const sizeInput = event.target.closest('[data-size-qty]');
    if (sizeInput) {
      updateSizeQuantity(sizeInput, { render: false });
      return;
    }
    const totalQuantityInput = event.target.closest('[data-total-qty]');
    if (totalQuantityInput) {
      updateTotalQuantity(totalQuantityInput, { render: false });
      return;
    }
    const projectTextileQuantityInput = event.target.closest('[data-project-textile-qty]');
    if (projectTextileQuantityInput) {
      updateProjectTextileQuantity(projectTextileQuantityInput, { render: false });
      return;
    }
    const largeSizeQuantityInput = event.target.closest('[data-large-size-qty]');
    if (largeSizeQuantityInput) {
      updateLargeSizeQuantity(largeSizeQuantityInput, { render: false });
      return;
    }
    const textilePricingInput = event.target.closest('[data-textile-pricing-field]');
    if (textilePricingInput) {
      liveUpdateTextilePricingRow(textilePricingInput);
      return;
    }
    const layerMarkingInput = event.target.closest('[data-layer-marking-field]');
    if (layerMarkingInput && layerMarkingInput.dataset.layerMarkingField !== 'technique') {
      updateLayerMarkingField(layerMarkingInput, { render: false });
      if (layerMarkingInput.dataset.layerMarkingField !== 'techniqueCustom') {
        liveRefreshTextileBlockTotals(layerMarkingInput.dataset.textileId);
      }
      return;
    }
    const customTextileHexInput = event.target.closest('[data-custom-textile-hex]');
    if (customTextileHexInput) {
      const raw = String(customTextileHexInput.value || '').trim();
      if (!/^#?[0-9a-fA-F]{6}$/.test(raw)) return;
      setCustomTextileColor(raw.startsWith('#') ? raw : `#${raw}`, { render: false });
      syncCustomTextileColorControls();
      syncActiveTextileFromState();
      renderStage();
      return;
    }
    const customTextileColorInput = event.target.closest('[data-custom-textile-color]');
    if (customTextileColorInput) {
      setCustomTextileColor(customTextileColorInput.value, { render: false });
      syncCustomTextileColorControls(customTextileColorInput);
      syncActiveTextileFromState();
      renderStage();
      return;
    }
    const logoEditorField = event.target.closest('[data-logo-editor-field]');
    if (logoEditorField) {
      updateSelectedLayerFromLogoEditor(logoEditorField);
      return;
    }
    const projectTextileNameInput = event.target.closest('[data-project-textile-name]');
    if (projectTextileNameInput) {
      updateProjectTextileName(projectTextileNameInput, { render: false });
      return;
    }
    const productSearchInput = event.target.closest('[data-product-modal-search]');
    if (!productSearchInput) return;
    const caretPosition = productSearchInput.selectionStart;
    state.productSearch = productSearchInput.value;
    renderProducts();
    const nextSearchInput = document.querySelector('[data-product-modal-search]');
    nextSearchInput?.focus();
    if (Number.isFinite(caretPosition)) nextSearchInput?.setSelectionRange(caretPosition, caretPosition);
  });

  document.addEventListener('focusin', (event) => {
    if (!isEditorOpen() || !event.target.closest('[data-app]')) return;
    if (!event.target.closest('[data-layer-name], [data-layer-text], [data-layer-font], [data-layer-color], [data-layer-width], [data-layer-height], [data-layer-rotation], [data-logo-editor-field], [data-project-textile-name], [data-project-textile-qty], [data-textile-pricing-field]')) return;
    if (state.formEditSnapshotActive) return;
    pushHistory();
    state.formEditSnapshotActive = true;
  });

  document.addEventListener('focusout', (event) => {
    if (!isEditorOpen() || !event.target.closest('[data-app]')) return;
    if (!event.target.closest('[data-layer-name], [data-layer-text], [data-layer-font], [data-layer-color], [data-layer-width], [data-layer-height], [data-layer-rotation], [data-logo-editor-field], [data-project-textile-name], [data-project-textile-qty], [data-textile-pricing-field]')) return;
    state.formEditSnapshotActive = false;
  });

  document.addEventListener('change', (event) => {
    if (!isEditorOpen() || !event.target.closest('[data-app]')) return;
    const customTextileHexInput = event.target.closest('[data-custom-textile-hex]');
    if (customTextileHexInput) {
      setCustomTextileColor(customTextileHexInput.value);
      return;
    }
    const customTextileColorInput = event.target.closest('[data-custom-textile-color]');
    if (customTextileColorInput) {
      setCustomTextileColor(customTextileColorInput.value);
      return;
    }
    const adminLogoInput = event.target.closest('[data-admin-logo-input]');
    if (adminLogoInput) {
      updateAdminLogo(adminLogoInput);
      return;
    }
    const adminZoneInput = event.target.closest('[data-admin-zone]');
    if (adminZoneInput) {
      updateAdminDraftZone(adminZoneInput);
      return;
    }
    const adminField = event.target.closest('[data-admin-field]');
    if (adminField) {
      updateAdminDraftField(adminField);
      return;
    }
    const customProductPhotoInput = event.target.closest('[data-product-photo-input]');
    if (customProductPhotoInput) {
      updateCustomProductPhoto(customProductPhotoInput);
      return;
    }
    const zoneMarkingInput = event.target.closest('[data-zone-marking]');
    if (zoneMarkingInput) {
      updateZoneMarking(zoneMarkingInput);
      return;
    }
    const priceInput = event.target.closest('[data-price-override]');
    if (priceInput) {
      updatePriceOverride(priceInput);
      return;
    }
    const pricingSettingInput = event.target.closest('[data-pricing-setting]');
    if (pricingSettingInput) {
      updatePricingSetting(pricingSettingInput);
      return;
    }
    const sizeInput = event.target.closest('[data-size-qty]');
    if (sizeInput) {
      updateSizeQuantity(sizeInput);
      return;
    }
    const quantityModeInput = event.target.closest('[data-quantity-mode]');
    if (quantityModeInput) {
      updateQuantityMode(quantityModeInput.value);
      return;
    }
    const totalQuantityInput = event.target.closest('[data-total-qty]');
    if (totalQuantityInput) {
      updateTotalQuantity(totalQuantityInput);
      return;
    }
    const projectTextileQuantityInput = event.target.closest('[data-project-textile-qty]');
    if (projectTextileQuantityInput) {
      updateProjectTextileQuantity(projectTextileQuantityInput);
      return;
    }
    const largeSizeQuantityInput = event.target.closest('[data-large-size-qty]');
    if (largeSizeQuantityInput) {
      updateLargeSizeQuantity(largeSizeQuantityInput);
      return;
    }
    const textilePricingInput = event.target.closest('[data-textile-pricing-field]');
    if (textilePricingInput) {
      updateTextilePricingField(textilePricingInput);
      return;
    }
    const layerMarkingField = event.target.closest('[data-layer-marking-field]');
    if (layerMarkingField) {
      updateLayerMarkingField(layerMarkingField);
      return;
    }
    const batField = event.target.closest('[data-bat-field]');
    if (batField) {
      updateBatField(batField);
      return;
    }
    const productionField = event.target.closest('[data-production-field]');
    if (productionField) {
      updateProductionField(productionField);
      return;
    }
    const projectTextileNameInput = event.target.closest('[data-project-textile-name]');
    if (projectTextileNameInput) {
      updateProjectTextileName(projectTextileNameInput, { commit: true, render: true });
      return;
    }
    const profitabilityField = event.target.closest('[data-profitability-field]');
    if (profitabilityField) {
      updateProfitabilityField(profitabilityField);
      return;
    }
    const otherCostInput = event.target.closest('[data-other-cost-label], [data-other-cost-price], [data-other-cost-pricing-mode]');
    if (otherCostInput) {
      updateProfitabilityOtherCost(otherCostInput);
      return;
    }
    const optionInput = event.target.closest('[data-option-label], [data-option-price], [data-option-pricing-mode]');
    if (optionInput) {
      updateBatOption(optionInput);
      return;
    }
    const customZoneInput = event.target.closest('[data-custom-zone-size]');
    if (customZoneInput) updateCustomZoneSize(customZoneInput);
  });

  els.printArea.addEventListener('pointerdown', onLayerPointerDown);
  document.addEventListener('pointermove', onPointerMove);
  document.addEventListener('pointerup', endDrag);

  const inspectorInputs = [
    els.layerName,
    els.layerText,
    els.layerFont,
    els.layerColor,
    els.layerWidth,
    els.layerHeight,
    els.layerRotation,
  ];
  inspectorInputs.forEach((input) => {
    input.addEventListener('input', updateSelectedLayerFromInputs);
    input.addEventListener('change', updateSelectedLayerFromInputs);
  });
}

function isModalMode() {
  return els.app?.dataset.launchMode === 'modal';
}

function isEditorOpen() {
  return !isModalMode() || els.app?.classList.contains('is-open');
}

function ensureEditorRootMounted() {
  if (!els.app || els.app.parentElement === document.body) return;
  document.body.appendChild(els.app);
}

function isCustomerLoggedIn() {
  return Boolean(String(els.app?.dataset.customerId || '').trim());
}

function getBatLoginRedirectUrl() {
  const loginUrl = String(els.app?.dataset.loginUrl || '/account/login').trim() || '/account/login';
  const url = new URL(window.location.href);
  url.searchParams.set('bat_open', '1');
  const returnUrl = `${url.pathname}${url.search}${url.hash}`;
  return `${loginUrl}${loginUrl.includes('?') ? '&' : '?'}return_url=${encodeURIComponent(returnUrl)}`;
}

function requireCustomerLogin() {
  if (isCustomerLoggedIn()) return true;
  window.location.href = getBatLoginRedirectUrl();
  return false;
}

function openEditor() {
  if (!isModalMode()) return;
  if (!requireCustomerLogin()) return;
  ensureEditorRootMounted();
  els.app.classList.add('is-open');
  document.body.classList.add('bat-editor-is-open');
  // First open (and any open while assets still boot) keeps the global spinner
  // up — otherwise the UI looks clickable while renderAll / SVG mockups freeze it.
  if (!editorHasOpenedOnce || els.app.classList.contains('is-booting') || !els.app.classList.contains('is-ready')) {
    settleEditorOpen();
    return;
  }
  renderAll();
}
window.BAT_openEditor = openEditor;

function closeEditor() {
  if (!isModalMode()) return;
  closeDownloadMenu();
  if (state.adminOpen) closeAdmin();
  if (state.logoEditorOpen) closeLogoEditor();
  if (state.productReferenceModalOpen) closeProductReferenceModal();
  els.app.classList.remove('is-open');
  document.body.classList.remove('bat-editor-is-open');
}
window.BAT_closeEditor = closeEditor;

function onKeyDown(event) {
  if (!isEditorOpen()) return;

  if (event.key === 'Escape' && state.productReferenceModalOpen) {
    event.preventDefault();
    closeProductReferenceModal();
    return;
  }

  if (event.key === 'Escape' && state.logoEditorOpen) {
    event.preventDefault();
    closeLogoEditor();
    return;
  }

  if (isEditableTarget(event.target)) return;
  const layer = getSelectedLayer();
  const key = event.key.toLowerCase();
  const command = event.metaKey || event.ctrlKey;

  if (command && key === 'z' && !event.shiftKey) {
    event.preventDefault();
    undoLastChange();
    return;
  }

  if (command && (key === 'y' || (key === 'z' && event.shiftKey))) {
    event.preventDefault();
    redoLastChange();
    return;
  }

  if (!layer) return;

  if (event.key === 'Delete' || event.key === 'Backspace') {
    event.preventDefault();
    deleteSelectedLayer();
    return;
  }

  if (command && key === 'd') {
    event.preventDefault();
    duplicateSelectedLayer();
    return;
  }

  if (event.key === 'Escape') {
    event.preventDefault();
    if (state.adminOpen) {
      closeAdmin();
      return;
    }
    if (isModalMode()) {
      closeEditor();
      return;
    }
    state.selectedLayerId = null;
    renderAll();
    return;
  }

  const step = event.shiftKey ? 1 : 0.2;
  const moves = {
    ArrowLeft: [-step, 0],
    ArrowRight: [step, 0],
    ArrowUp: [0, -step],
    ArrowDown: [0, step],
  };
  const move = moves[event.key];
  if (!move) return;
  event.preventDefault();
  nudgeSelectedLayer(move[0], move[1], !event.repeat);
}

function isEditableTarget(target) {
  return Boolean(target?.closest('input, textarea, select, [contenteditable="true"]'));
}

function runAction(action, id) {
  if (action.startsWith('export-')) closeDownloadMenu();
  const actions = {
    'open-product-reference-modal': openProductReferenceModal,
    'close-product-reference-modal': closeProductReferenceModal,
    'select-product-picker-mode': () => selectProductPickerMode(id),
    'select-category': () => selectProductCategory(id),
    'select-product': () => selectProduct(id, 'reference'),
    'toggle-include-options-in-unit-price': () => setSimplifiedUnitPriceMode(id),
    'clear-product-search': clearProductSearch,
    'select-color': () => selectColor(id),
    'select-workspace': () => selectWorkspace(id),
    'select-right-tab': () => selectRightColumnTab(id),
    'toggle-left-panel': toggleLeftPanel,
    'toggle-right-panel': toggleRightPanel,
    'toggle-price-display': () => setPriceDisplayMode(id),
    'go-marking-step': () => triggerLogoUpload(id || state.viewId),
    'select-project-textile': () => selectProjectTextile(id),
    'add-project-textile': addProjectTextile,
    'duplicate-project-textile': () => duplicateProjectTextile(id),
    'remove-project-textile': () => removeProjectTextile(id),
    'select-profitability-step': () => selectProfitabilityStep(id),
    'profitability-next': nextProfitabilityStep,
    'profitability-prev': previousProfitabilityStep,
    'toggle-zone': () => toggleZone(id),
    'select-surface': () => selectView(id),
    'trigger-logo-upload': () => triggerLogoUpload(id),
    'add-asset': () => addAssetToView(id),
    'remove-asset': () => removeAsset(id),
    'add-text-layer': () => addTextLayer(id),
    'add-sample-logo': addSampleLogo,
    'duplicate-layer': duplicateSelectedLayer,
    'delete-layer': deleteSelectedLayer,
    'send-layer-backward': sendSelectedLayerBackward,
    'bring-layer-forward': bringSelectedLayerForward,
    'rotate-layer': rotateSelectedLayer,
    'remove-logo-background': removeSelectedLogoBackground,
    'trim-logo-whitespace': trimSelectedLogoWhitespace,
    'open-logo-editor': openLogoEditor,
    'close-logo-editor': closeLogoEditor,
    'logo-editor-apply-background-removal': applyLogoEditorBackgroundRemoval,
    'logo-editor-remove-semi': applyLogoEditorRemoveSemiTransparency,
    'logo-editor-remove-color': applyLogoEditorRemovePickedColor,
    'logo-editor-replace-color': applyLogoEditorReplacePickedColor,
    'logo-editor-apply-tone': applyLogoEditorToneAdjustments,
    'logo-editor-pick-source-color': () => pickLogoEditorSourceColor(id),
    'reset-prices': resetPriceOverrides,
    'add-bat-option': addBatOption,
    'add-quality-option': () => addQualityQuoteOption(id),
    'add-recommended-option': () => addRecommendedQuoteOption(id),
    'toggle-rush-option': toggleRushOption,
    'set-pickup-mode': () => setPickupInStore(id === 'pickup'),
    'use-suggested-unit-price': useSuggestedUnitPrice,
    'remove-bat-option': () => removeBatOption(id),
    'add-other-cost': addProfitabilityOtherCost,
    'remove-other-cost': () => removeProfitabilityOtherCost(id),
    'reset-packaging-cost': resetPackagingCost,
    'open-admin': openAdmin,
    'toggle-price-settings': togglePriceSettings,
    'toggle-price-hidden': togglePriceHidden,
    'coming-soon': showComingSoon,
    'save-bat-draft': saveBatDraft,
    'close-admin': closeAdmin,
    'save-admin-defaults': saveAdminDefaults,
    'reset-admin-defaults': resetAdminDefaults,
    'remove-admin-logo': removeAdminLogo,
    'export-production-order': exportProductionOrder,
    'export-profitability': exportProfitability,
    'export-quote': exportQuote,
    'export-quote-bat': exportQuoteBat,
    'copy-quote-email': copyQuoteEmail,
    'email-quote': emailQuote,
    'export-logos-texts': () => {
      exportLogosTextsPackage().catch((error) => {
        console.error(error);
        alert(error?.message || 'Impossible de générer le ZIP logos & textes.');
      });
    },
    'export-download-package': () => {
      exportDownloadPackage().catch((error) => {
        console.error(error);
        alert(error?.message || 'Impossible de générer le dossier ZIP.');
      });
    },
    'reset-design': resetDesign,
    'export-pdf': exportPdf,
  };
  actions[action]?.();
}

function showComingSoon() {
  alert('Bientôt disponible');
}

// True only when the user intentionally clicked the small header eye button
// (not a huge/misplaced hit-box covering the stage grey area).
function isHeaderPriceEyeClick(event, actionEl) {
  const eye = actionEl?.closest?.('[data-price-eye], .bat-price-eye-header') || actionEl;
  if (!eye || !eye.matches?.('[data-price-eye], .bat-price-eye-header, .bat-price-eye')) return false;
  // Must live in the topbar actions — never accept a toggle floating over the stage.
  if (!eye.closest?.('.bat-actions, .bat-topbar')) return false;
  const rect = eye.getBoundingClientRect();
  // Reject clearly broken layouts (eye covering the stage).
  if (rect.width > 64 || rect.height > 64 || rect.width < 8 || rect.height < 8) return false;
  const x = event.clientX;
  const y = event.clientY;
  return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}

function togglePriceHidden() {
  state.priceHidden = !state.priceHidden;
  renderSummary();
}

function togglePriceSettings() {
  state.priceSettingsOpen = !state.priceSettingsOpen;
  renderSummary();
  if (state.priceSettingsOpen) {
    requestAnimationFrame(() => {
      const input = document.querySelector('[data-pricing-setting="poseCentsPerZone"]');
      if (input) {
        input.focus();
        input.select?.();
        input.closest('.bat-pricing-settings-card')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }
}

function openLogoEditor() {
  const layer = getSelectedLayer();
  const asset = layer ? getAssetForLayer(layer) : null;
  if (!layer || layer.type !== 'image' || !asset) {
    alert('Sélectionnez un logo pour l’ouvrir dans l’éditeur.');
    return;
  }
  state.logoEditorOpen = true;
  renderAll();
  refreshAssetLogoPalette(asset);
}

function closeLogoEditor() {
  state.logoEditorOpen = false;
  renderLogoEditorModal();
}

function renderLogoEditorModal() {
  if (!els.logoEditorModal) return;
  const layer = getSelectedLayer();
  const asset = layer ? getAssetForLayer(layer) : null;
  const isOpen = Boolean(state.logoEditorOpen && layer?.type === 'image' && asset);
  els.logoEditorModal.classList.toggle('is-hidden', !isOpen);
  if (!isOpen) {
    els.logoEditorModal.innerHTML = '';
    return;
  }

  const report = getLayerQualityReport(layer);
  const metrics = report.metrics.slice(0, 5);
  const palette = Array.isArray(asset.palette) ? asset.palette.slice(0, 10) : [];
  const defaultSourceColor = palette[0]?.hex || '#111827';
  const hasPalette = palette.length > 0;
  els.logoEditorModal.innerHTML = `
    <button class="bat-modal-backdrop" type="button" data-action="close-logo-editor" aria-label="Fermer l'éditeur de logo"></button>
    <div class="bat-logo-editor-dialog" role="dialog" aria-modal="true" aria-label="Éditeur de logo">
      <div class="bat-logo-editor-head">
        <div>
          <strong>Éditeur de logo</strong>
          <small>${escapeHtml(layer.name || asset.name || 'Logo sélectionné')}</small>
        </div>
        <button class="bat-modal-close" type="button" data-action="close-logo-editor" aria-label="Fermer">×</button>
      </div>
      <div class="bat-logo-editor-body">
        <div class="bat-logo-editor-preview-panel">
          <div class="bat-logo-editor-preview">
            <img src="${layer.src}" alt="">
          </div>
          <div class="bat-logo-editor-preview-caption">
            <strong>${escapeHtml(formatSize(layer.w, layer.h))}</strong>
            <span>${escapeHtml(assetMetaLabel(asset))}</span>
          </div>
        </div>
        <div class="bat-logo-editor-side">
          <div class="bat-logo-editor-status is-${report.tone}">
            <strong>${escapeHtml(report.overall)}</strong>
            <span>${escapeHtml(report.summary)}</span>
          </div>
          ${asset.isVector ? `
            <div class="bat-logo-editor-note-card">
              Les outils de nettoyage pixel peuvent transformer ce fichier en image PNG dans le BAT. Les dimensions et le contrôle qualité restent conservés.
            </div>
          ` : ''}
          <section class="bat-logo-editor-panel">
            <div class="bat-logo-editor-panel-head">
              <strong>Dimensions & recadrage</strong>
              <button class="bat-mini-btn" type="button" data-action="trim-logo-whitespace">Recadrer</button>
            </div>
            <div class="bat-logo-editor-fields">
              <label class="bat-logo-editor-field bat-logo-editor-field-wide">
                <span>Nom</span>
                <input class="bat-input" type="text" value="${escapeHtml(layer.name || asset.name || '')}" data-logo-editor-field="name">
              </label>
              <label class="bat-logo-editor-field">
                <span>Largeur cm</span>
                <input class="bat-input" type="number" min="1" step="0.1" value="${formatDecimalInput(layer.w)}" data-logo-editor-field="width">
              </label>
              <label class="bat-logo-editor-field">
                <span>Hauteur cm</span>
                <input class="bat-input" type="number" min="1" step="0.1" value="${formatDecimalInput(layer.h)}" data-logo-editor-field="height">
              </label>
              <label class="bat-logo-editor-field bat-logo-editor-field-wide">
                <span>Rotation</span>
                <input class="bat-input" type="range" min="-45" max="45" step="1" value="${Number(layer.rotation) || 0}" data-logo-editor-field="rotation">
              </label>
            </div>
          </section>
          <section class="bat-logo-editor-panel">
            <div class="bat-logo-editor-panel-head">
              <strong>Fond & nettoyage</strong>
            </div>
            <div class="bat-logo-editor-control-grid">
              <label class="bat-logo-editor-field">
                <span>Couleur du fond</span>
                <input class="bat-input bat-color-input" type="color" value="#ffffff" data-logo-editor-bg-color>
              </label>
              <label class="bat-logo-editor-field">
                <span>Tolérance</span>
                <input class="bat-input" type="number" min="0" max="180" step="1" value="46" data-logo-editor-bg-tolerance>
              </label>
              <label class="bat-logo-editor-field">
                <span>Contour doux</span>
                <input class="bat-input" type="number" min="0" max="120" step="1" value="28" data-logo-editor-bg-feather>
              </label>
              <label class="bat-logo-editor-check">
                <input type="checkbox" data-logo-editor-bg-global>
                <span>Toute l’image</span>
              </label>
            </div>
            <div class="bat-logo-editor-actions">
              <button class="bat-btn bat-btn-primary" type="button" data-action="logo-editor-apply-background-removal">Retirer le fond</button>
              <button class="bat-btn" type="button" data-action="trim-logo-whitespace">Recadrer les espaces vides</button>
            </div>
            <div class="bat-logo-editor-inline">
              <label class="bat-logo-editor-field">
                <span>Pixels semi-transparents</span>
                <input class="bat-input" type="number" min="1" max="254" step="1" value="245" data-logo-editor-semi-threshold>
              </label>
              <button class="bat-mini-btn" type="button" data-action="logo-editor-remove-semi">Nettoyer</button>
            </div>
          </section>
          <section class="bat-logo-editor-panel">
            <div class="bat-logo-editor-panel-head">
              <strong>Retrait d’une couleur</strong>
            </div>
            <div class="bat-logo-editor-inline">
              <label class="bat-logo-editor-field">
                <span>Couleur</span>
                <input class="bat-input bat-color-input" type="color" value="${escapeHtml(defaultSourceColor)}" data-logo-editor-remove-color>
              </label>
              <label class="bat-logo-editor-field">
                <span>Tolérance</span>
                <input class="bat-input" type="number" min="0" max="180" step="1" value="38" data-logo-editor-remove-tolerance>
              </label>
              <button class="bat-mini-btn" type="button" data-action="logo-editor-remove-color">Retirer</button>
            </div>
          </section>
          <section class="bat-logo-editor-panel">
            <div class="bat-logo-editor-panel-head">
              <strong>Couleurs</strong>
              <span>${hasPalette ? `${palette.length} détectées` : 'Analyse en cours'}</span>
            </div>
            <div class="bat-logo-editor-palette">
              ${hasPalette ? palette.map((color) => `
                <button class="bat-logo-editor-swatch" type="button" data-action="logo-editor-pick-source-color" data-id="${escapeHtml(color.hex)}" title="${escapeHtml(color.hex)}">
                  <span style="background:${escapeHtml(color.hex)}"></span>
                  <em>${Math.round(color.percent)}%</em>
                </button>
              `).join('') : '<p>La palette sera disponible dans quelques secondes.</p>'}
            </div>
            <div class="bat-logo-editor-control-grid">
              <label class="bat-logo-editor-field">
                <span>Couleur source</span>
                <input class="bat-input bat-color-input" type="color" value="${escapeHtml(defaultSourceColor)}" data-logo-editor-source-color>
              </label>
              <label class="bat-logo-editor-field">
                <span>Nouvelle couleur</span>
                <input class="bat-input bat-color-input" type="color" value="#d8357d" data-logo-editor-target-color>
              </label>
              <label class="bat-logo-editor-field">
                <span>Tolérance</span>
                <input class="bat-input" type="number" min="0" max="180" step="1" value="36" data-logo-editor-color-tolerance>
              </label>
              <button class="bat-mini-btn" type="button" data-action="logo-editor-replace-color">Remplacer</button>
            </div>
          </section>
          <section class="bat-logo-editor-panel">
            <div class="bat-logo-editor-panel-head">
              <strong>Contraste & luminosité</strong>
            </div>
            <div class="bat-logo-editor-control-grid">
              <label class="bat-logo-editor-field">
                <span>Luminosité</span>
                <input class="bat-input" type="number" min="-100" max="100" step="1" value="0" data-logo-editor-brightness>
              </label>
              <label class="bat-logo-editor-field">
                <span>Contraste</span>
                <input class="bat-input" type="number" min="-100" max="100" step="1" value="0" data-logo-editor-contrast>
              </label>
              <label class="bat-logo-editor-field">
                <span>Saturation</span>
                <input class="bat-input" type="number" min="-100" max="100" step="1" value="0" data-logo-editor-saturation>
              </label>
              <button class="bat-mini-btn" type="button" data-action="logo-editor-apply-tone">Appliquer</button>
            </div>
          </section>
          <section class="bat-logo-editor-panel">
            <div class="bat-logo-editor-panel-head">
              <strong>Contrôle qualité</strong>
            </div>
            <div class="bat-logo-editor-metrics">
              ${metrics.map((metric) => `
                <div class="bat-quality-row is-${metric.tone}">
                  <span>${escapeHtml(metric.label)}</span>
                  <strong>${escapeHtml(metric.value)}</strong>
                </div>
              `).join('')}
            </div>
          </section>
          <p class="bat-logo-editor-note">Les changements appliqués ici mettent à jour le logo sélectionné dans le BAT.</p>
        </div>
      </div>
    </div>
  `;
}

function getBatDraftCustomerId() {
  const id = String(els.app?.dataset.customerId || '').trim();
  return id && id !== 'null' && id !== 'undefined' ? id : '';
}

function getBatDraftStorageKey() {
  const customerId = getBatDraftCustomerId();
  return customerId ? `${BAT_DRAFTS_STORAGE_PREFIX}:${customerId}` : '';
}

function readBatDrafts() {
  const key = getBatDraftStorageKey();
  if (!key) return [];
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn('Unable to read BAT drafts', error);
    return [];
  }
}

function writeBatDrafts(drafts) {
  const key = getBatDraftStorageKey();
  if (!key) return false;
  localStorage.setItem(key, JSON.stringify(drafts));
  return true;
}

function createBatDraftId() {
  return `bat_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}

function getBatDraftBaseUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete('bat_draft');
  url.hash = '';
  return `${url.pathname}${url.search}`;
}

function syncTextileDossierFieldsFromDom() {
  const activeInput = document.activeElement;
  const field = activeInput?.dataset?.productionField;
  if ((field === 'orderReference' || field === 'clientName') && Object.prototype.hasOwnProperty.call(state.productionConfig, field)) {
    state.productionConfig[field] = String(activeInput.value || '').trim();
  }
}

function saveBatDraft() {
  // Online draft save is temporarily unavailable — nudge the client to download.
  const goDownload = window.confirm(
    'La sauvegarde en ligne sera bientôt disponible.\n\nEn attendant, téléchargez votre devis / BAT pour le conserver sur votre appareil.\n\nOuvrir le menu Télécharger ?'
  );
  if (!goDownload) return;
  const menu = document.querySelector('[data-download-menu]');
  if (!menu) return;
  menu.setAttribute('open', '');
  menu.querySelector('summary')?.focus?.();
}

function restoreBatDraftFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const id = params.get('bat_draft');
  if (!id) return;
  const draft = readBatDrafts().find((item) => item.id === id);
  if (!draft?.snapshot) return;
  state.currentDraftId = id;
  restoreEditorSnapshot(draft.snapshot);
  const wantsDownload = params.get('bat_download') === '1';
  openEditor();
  // Login redirect aborts before the editor stays open — resume after return.
  if (!wantsDownload || !isEditorOpen()) return;
  params.delete('bat_download');
  const clean = `${window.location.pathname}${params.toString() ? `?${params}` : ''}${window.location.hash}`;
  window.history.replaceState({}, '', clean);
  window.setTimeout(() => {
    exportDownloadPackage().catch((error) => {
      console.error(error);
      alert(error?.message || 'Impossible de générer le dossier ZIP.');
    });
  }, 250);
}

function hasLoadedLogo() {
  return state.assets.length > 0;
}

function isWorkspaceLocked(id) {
  if (id === 'production' && !isProductionOrderAvailable()) return true;
  // "Tarifs & marges" is always reachable, even without a logo.
  return id === 'production' && !hasLoadedLogo();
}

function ensureWorkspaceAvailable() {
  if (!WORKSPACE_MODES.some((mode) => mode.id === state.workspaceMode)) {
    state.workspaceMode = 'compose';
    return;
  }
  if (state.workspaceMode === 'production' && !isProductionOrderAvailable()) {
    state.workspaceMode = isWorkspaceLocked('profitability') ? 'compose' : 'profitability';
    return;
  }
  if (isWorkspaceLocked(state.workspaceMode)) {
    state.workspaceMode = 'compose';
  }
}

function isProductionOrderAvailable() {
  return true;
}

function getProductionWorkspaceLabel() {
  return 'Ordre de fabrication';
}

function getProductionDownloadLabel() {
  return "Télécharger l'ordre de fabrication";
}

function getProductionFilePrefix() {
  return 'Ordre-fabrication';
}

function updateProductionShellLabels() {
  const title = getProductionWorkspaceLabel();
  if (els.productionPanelTitle) els.productionPanelTitle.textContent = title;
  if (els.productionDossierTitle) els.productionDossierTitle.textContent = 'Dossier atelier';
  if (els.productionDossierTone) els.productionDossierTone.textContent = 'Interne';
  if (els.productionNotesTitle) els.productionNotesTitle.textContent = 'Consignes opérateur';
  if (els.productionNotesTone) els.productionNotesTone.textContent = 'Atelier';
  document.querySelectorAll('[data-action="export-production-order"]').forEach((button) => {
    button.textContent = getProductionDownloadLabel();
  });
}

function normalizeProfitabilityStep(id) {
  return PROFITABILITY_STEPS.some((step) => step.id === id) ? id : PROFITABILITY_STEPS[0].id;
}

function getProfitabilityStepIndex(id = state.profitabilityStep) {
  return Math.max(0, PROFITABILITY_STEPS.findIndex((step) => step.id === normalizeProfitabilityStep(id)));
}

function selectProfitabilityStep(id) {
  state.profitabilityStep = normalizeProfitabilityStep(id);
  renderSummary();
}

function nextProfitabilityStep() {
  const index = getProfitabilityStepIndex();
  state.profitabilityStep = PROFITABILITY_STEPS[Math.min(PROFITABILITY_STEPS.length - 1, index + 1)].id;
  renderSummary();
}

function previousProfitabilityStep() {
  const index = getProfitabilityStepIndex();
  state.profitabilityStep = PROFITABILITY_STEPS[Math.max(0, index - 1)].id;
  renderSummary();
}

function closeDownloadMenu() {
  document.querySelectorAll('[data-download-menu][open]').forEach((menu) => {
    menu.removeAttribute('open');
  });
}

function cssValue(value) {
  if (window.CSS?.escape) return window.CSS.escape(String(value));
  return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

function captureActiveInput() {
  const element = document.activeElement;
  if (!element || !els.app?.contains(element) || !element.matches('input, textarea, select')) return null;
  const selectors = [];
  const optionId = element.closest('[data-option-id]')?.dataset.optionId;
  const otherCostId = element.closest('[data-other-cost-id]')?.dataset.otherCostId;
  if (optionId) selectors.push(`[data-option-id="${cssValue(optionId)}"]`);
  if (otherCostId) selectors.push(`[data-other-cost-id="${cssValue(otherCostId)}"]`);
  const dataAttrs = [
    'sizeQty',
    'totalQty',
    'batField',
    'pricingSetting',
    'priceOverride',
    'profitabilityField',
    'productionField',
    'optionLabel',
    'optionPrice',
    'optionPricingMode',
    'otherCostLabel',
    'otherCostPrice',
    'otherCostPricingMode',
    'projectTextileName',
    'projectTextileQty',
    'textilePricingField',
  ];
  const dataSelector = dataAttrs
    .map((key) => {
      const attr = `data-${key.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}`;
      if (!element.hasAttribute(attr)) return '';
      const value = element.getAttribute(attr);
      return value ? `[${attr}="${cssValue(value)}"]` : `[${attr}]`;
    })
    .find(Boolean);
  if (dataSelector) selectors.push(dataSelector);
  // Pin textile pricing / qty inputs to their row id so restore doesn't jump to line 1.
  if (element.hasAttribute('data-textile-pricing-field') && element.dataset.id) {
    const field = element.getAttribute('data-textile-pricing-field') || '';
    selectors.length = 0;
    selectors.push(`[data-textile-pricing-field="${cssValue(field)}"][data-id="${cssValue(element.dataset.id)}"]`);
  } else if (element.hasAttribute('data-project-textile-qty')) {
    const qtyId = element.getAttribute('data-project-textile-qty');
    if (qtyId) {
      selectors.length = 0;
      selectors.push(`[data-project-textile-qty="${cssValue(qtyId)}"]`);
    }
  }
  if (!selectors.length && element.name) {
    selectors.push(`[name="${cssValue(element.name)}"]`);
    if (element.value) selectors.push(`[value="${cssValue(element.value)}"]`);
  }
  if (!selectors.length) return null;
  let start = null;
  let end = null;
  try {
    start = element.selectionStart;
    end = element.selectionEnd;
  } catch (error) {
    start = null;
    end = null;
  }
  return {
    selector: selectors.join(' '),
    start,
    end,
  };
}

function restoreActiveInput(snapshot) {
  if (!snapshot?.selector) return;
  const element = els.app?.querySelector(snapshot.selector);
  if (!element) return;
  element.focus({ preventScroll: true });
  if (
    typeof snapshot.start === 'number'
    && typeof snapshot.end === 'number'
    && typeof element.setSelectionRange === 'function'
  ) {
    try {
      element.setSelectionRange(snapshot.start, snapshot.end);
    } catch (error) {
      // Some input types, such as number fields, do not support text selection.
    }
  }
}

function renderAll() {
  const activeInput = captureActiveInput();
  ensureProjectTextiles();
  const product = getProduct();
  state.colorId = getColor(product).id;
  ensureCurrentViewIsActive(product);
  syncActiveTextileFromState();
  ensureWorkspaceAvailable();
  const color = getColor();
  const view = getView();
  const previewMode = isPreviewWorkspace();
  const selectedLayer = getSelectedLayer();
  els.app.classList.toggle('is-compose', state.workspaceMode === 'compose');
  els.app.classList.toggle('is-preview', previewMode);
  els.app.classList.toggle('is-production', state.workspaceMode === 'production');
  els.app.classList.toggle('is-profitability', state.workspaceMode === 'profitability');
  els.app.classList.toggle('has-selected-layer', Boolean(selectedLayer));
  els.app.classList.toggle('has-quality-panel', Boolean(selectedLayer?.type === 'image' && state.workspaceMode === 'compose'));
  els.stepItems.forEach((item) => item.classList.toggle('is-active', item.dataset.step === state.workspaceMode));
  els.app.classList.toggle('is-left-collapsed', state.leftCollapsed);
  els.app.classList.toggle('is-right-collapsed', state.rightCollapsed);
  if (els.rightPanel) els.rightPanel.dataset.activeTab = state.rightColumnTab;
  els.productLabel.textContent = product.fullLabel || product.label;
  els.colorLabel.textContent = color.label;
  if (els.activeViewLabel) els.activeViewLabel.textContent = view.label;
  renderProducts();
  renderColors();
  renderTextileDossier();
  renderWorkspaceTabs();
  renderViews();
  renderSurfaceTabs();
  renderStage();
  renderLogoList();
  renderInspector();
  renderQualityReport();
  renderSummary();
  updateProductionShellLabels();
  renderAdminModal();
  renderLogoEditorModal();
  restoreActiveInput(activeInput);
}

function renderTextileDossier() {
  if (!els.textileDossier) return;
  ensureProjectTextiles();
  ensureProjectTextileQuantities();
  const production = getProductionConfig();
  els.textileDossier.innerHTML = `
    <div class="bat-project-fields">
      <label class="bat-config-field">
        <span>N° dossier</span>
        <input class="bat-input" type="text" value="${escapeHtml(production.orderReference)}" data-production-field="orderReference" aria-label="Numéro de dossier">
      </label>
      <label class="bat-config-field">
        <span>Nom client</span>
        <input class="bat-input" type="text" value="${escapeHtml(production.clientName)}" data-production-field="clientName" aria-label="Nom client">
      </label>
    </div>
    <div class="bat-textile-project-list">
      ${state.textiles.map((textile, index) => textileProjectCardMarkup(textile, index)).join('')}
    </div>
    <button class="bat-btn bat-btn-primary bat-textile-add" type="button" data-action="add-project-textile">Ajouter un textile</button>
  `;
}

function textileProjectCardMarkup(textile, index) {
  const product = getProductById(textile.productId) || products[0];
  const active = textile.id === state.activeTextileId;
  const zones = textileZonesLabel(textile);
  const layerCount = textile.layers?.length || 0;
  const quantity = getProjectTextileQuantity(textile);
  const firstViewId = normalizeZoneIds(textile.activeZoneIds)[0] || getActiveViews(product)[0]?.id || 'front';
  return `
    <article class="bat-textile-project-card ${active ? 'is-active' : ''}">
      <div class="bat-textile-project-main" role="button" tabindex="0" data-action="select-project-textile" data-id="${textile.id}">
        <span class="bat-textile-project-thumb">${productMediaMarkup(product, firstViewId, textile.colorId || getColor(product).id, { includeCustom: false })}</span>
        <span class="bat-textile-project-copy">
          <input class="bat-textile-project-name" type="text" value="${escapeHtml(textileDisplayName(textile))}" data-project-textile-name="${escapeHtml(textile.id)}" aria-label="Nom du textile">
          <small>${escapeHtml(zones)}</small>
          <em>${layerCount} marquage${layerCount > 1 ? 's' : ''} · ${quantity} pc${quantity > 1 ? 's' : ''}</em>
        </span>
      </div>
      <div class="bat-textile-project-actions">
        <button type="button" data-action="duplicate-project-textile" data-id="${textile.id}" aria-label="Dupliquer ${escapeHtml(textileDisplayName(textile))}">Copier</button>
        <button type="button" data-action="remove-project-textile" data-id="${textile.id}" ${state.textiles.length <= 1 ? 'disabled' : ''} aria-label="Supprimer ${escapeHtml(textileDisplayName(textile))}">Suppr.</button>
      </div>
    </article>
  `;
}

function ensureProjectTextiles() {
  if (!Array.isArray(state.textiles)) state.textiles = [];
  if (!state.textiles.length) {
    const first = createTextileSnapshotFromCurrent({ id: makeId('textile') });
    state.textiles = [first];
    state.activeTextileId = first.id;
    return;
  }
  if (!state.textiles.some((textile) => textile.id === state.activeTextileId)) {
    state.activeTextileId = state.textiles[0].id;
    applyTextileSnapshotToState(state.textiles[0]);
  }
}

function getActiveTextile() {
  ensureProjectTextiles();
  return state.textiles.find((textile) => textile.id === state.activeTextileId) || state.textiles[0] || null;
}

function syncActiveTextileFromState() {
  if (!Array.isArray(state.textiles) || !state.textiles.length || !state.activeTextileId) return;
  const index = state.textiles.findIndex((textile) => textile.id === state.activeTextileId);
  if (index < 0) return;
  state.textiles[index] = createTextileSnapshotFromCurrent(state.textiles[index]);
}

function createTextileSnapshotFromCurrent(previous = {}) {
  const product = getProductById(state.productId) || products[0];
  const color = getColor(product, state.colorId);
  return normalizeTextileSnapshot({
    ...previous,
    id: previous.id || makeId('textile'),
    productId: product.id,
    productCategoryId: getProductCategoryId(product),
    productChoiceId: state.productChoiceId || '',
    colorId: color.id,
    viewId: state.viewId,
    activeZoneIds: cloneForHistory(state.activeZoneIds),
    zoneMarkings: cloneForHistory(state.zoneMarkings),
    customZoneSize: cloneForHistory(state.customZoneSize),
    layers: cloneForHistory(state.layers.filter((layer) => layer.productId === product.id)),
    previewAdjustments: cloneForHistory(state.previewAdjustments),
    customProductPhotos: cloneForHistory(state.customProductPhotos),
    // Only carry `quantity` when it was actually set: forcing the key (even as
    // undefined) made normalizeTextileSnapshot coerce it to 0 and wrongly flag
    // the textile as "has quantity", blocking the fallback from the order total.
    ...(textileHasQuantity(previous) ? { quantity: previous.quantity } : {}),
  });
}

function createBlankTextileSnapshot() {
  const defaultChoiceId = PRODUCT_QUICK_CHOICE_MAP.has(activeAdminDefaults.compose.productChoiceId)
    ? activeAdminDefaults.compose.productChoiceId
    : 'quick-tshirt';
  const defaultProductId = PRODUCT_QUICK_CHOICE_MAP.get(defaultChoiceId)?.witnessProductId || products[0]?.id;
  const product = getProductById(defaultProductId) || products[0];
  const colorId = getWhiteColorId(product);
  return normalizeTextileSnapshot({
    id: makeId('textile'),
    productId: product.id,
    productCategoryId: getProductCategoryId(product),
    productChoiceId: defaultChoiceId,
    colorId,
    viewId: getActiveViews(product)[0]?.id || 'front',
    activeZoneIds: cloneForHistory(activeAdminDefaults.compose.activeZoneIds),
    zoneMarkings: cloneForHistory(activeAdminDefaults.compose.zoneMarkings),
    customZoneSize: cloneForHistory(activeAdminDefaults.compose.customZoneSize),
    layers: [],
    previewAdjustments: {},
    customProductPhotos: {},
    // A freshly added textile defaults to 50 units (same as the per-textile
    // default) instead of 0, so quantities don't need to be re-entered.
    quantity: state.textiles?.length ? 50 : createDefaultTotalQuantity(),
  });
}

function normalizeTextileSnapshot(textile) {
  const product = getProductById(textile?.productId) || products[0];
  const color = getColor(product, textile?.colorId);
  const activeZoneIds = normalizeZoneIds(textile?.activeZoneIds);
  const viewId = activeZoneIds.includes(textile?.viewId) ? textile.viewId : activeZoneIds[0] || getActiveViews(product)[0]?.id || 'front';
  const normalized = {
    id: textile?.id || makeId('textile'),
    productId: product.id,
    productCategoryId: textile?.productCategoryId || getProductCategoryId(product),
    productChoiceId: textile?.productChoiceId || '',
    customName: String(textile?.customName || '').trim(),
    colorId: color.id,
    viewId,
    activeZoneIds,
    zoneMarkings: normalizeZoneMarkings(textile?.zoneMarkings),
    customZoneSize: normalizeCustomZoneSize(textile?.customZoneSize),
    layers: cloneForHistory(textile?.layers || []).map((layer) => normalizeLayerSnapshot(layer, product.id)),
    previewAdjustments: cloneForHistory(textile?.previewAdjustments || {}),
    customProductPhotos: cloneForHistory(textile?.customProductPhotos || {}),
    pricing: normalizeTextilePricing(textile?.pricing),
  };
  if (textileHasQuantity(textile)) normalized.quantity = parseQuantityInput(textile.quantity);
  return normalized;
}

function createDefaultLayerMarking() {
  return {
    technique: getEnabledMarkingTechniques()[0] || MARKING_TECHNIQUES[0],
    techniqueCustom: '',
    markingCents: null,
    // Legacy split fields kept only for draft migration.
    materialCents: null,
    poseCents: null,
  };
}

function isCustomMarkingTechnique(technique) {
  return String(technique || '').trim() === CUSTOM_MARKING_TECHNIQUE;
}

function resolveMarkingTechniqueLabel(marking) {
  const normalized = normalizeLayerMarking(marking);
  if (isCustomMarkingTechnique(normalized.technique)) {
    return normalized.techniqueCustom || CUSTOM_MARKING_TECHNIQUE;
  }
  return normalized.technique;
}

function normalizeLayerMarking(marking) {
  const source = marking && typeof marking === 'object' ? marking : {};
  const custom = String(source.techniqueCustom || '').trim();
  const rawTechnique = String(source.technique || '').trim();
  const base = {
    techniqueCustom: custom,
    markingCents: normalizeOverrideCents(source.markingCents),
    // Legacy split fields: resolved into markingCents at pricing time.
    materialCents: normalizeOverrideCents(source.materialCents),
    poseCents: normalizeOverrideCents(source.poseCents),
  };
  // Free-text techniques (or explicit "Autre") stay out of the admin catalogue.
  if (isCustomMarkingTechnique(rawTechnique) || (rawTechnique && !MARKING_TECHNIQUES.includes(rawTechnique))) {
    return {
      ...base,
      technique: CUSTOM_MARKING_TECHNIQUE,
      techniqueCustom: custom || (isCustomMarkingTechnique(rawTechnique) ? '' : rawTechnique),
    };
  }
  return {
    ...base,
    technique: normalizeAvailableMarkingTechnique(rawTechnique),
  };
}

function normalizeLayerSnapshot(layer, productId) {
  const next = { ...(layer || {}), productId: productId || layer?.productId };
  next.marking = normalizeLayerMarking(layer?.marking || createDefaultLayerMarking());
  return next;
}

// Per-textile pricing overrides. Every field is nullable: null means "inherit the
// global default" so a change to the global settings still flows through until the
// user sets an explicit value on that textile.
function normalizeTextilePricing(pricing) {
  const p = pricing && typeof pricing === 'object' ? pricing : {};
  const marginRaw = p.marginPercent;
  return {
    achatCents: normalizeOverrideCents(p.achatCents),
    // Single "transfert / matière" override (meaning depends on production mode).
    // Legacy transfertCents/matieresCents are kept as fallbacks for old drafts.
    transfertMatiereCents: normalizeOverrideCents(p.transfertMatiereCents),
    transfertCents: normalizeOverrideCents(p.transfertCents),
    matieresCents: normalizeOverrideCents(p.matieresCents),
    salePriceCents: normalizeOverrideCents(p.salePriceCents),
    marginPercent: (marginRaw === null || marginRaw === undefined || marginRaw === '')
      ? null
      : clamp(Number(marginRaw) || 0, 0, 95),
  };
}

// Number of marking zones (surfaces that actually carry a logo/text) for a
// single textile — drives the per-textile pose cost.
function getTextileMarkingZoneCount(textile) {
  const zoneIds = normalizeZoneIds(textile?.activeZoneIds);
  const layers = Array.isArray(textile?.layers) ? textile.layers : [];
  return zoneIds.filter((viewId) => layers.some((layer) => viewIdMatches(layer.viewId, viewId))).length;
}

function getTextileMarkingLayers(textile) {
  return (Array.isArray(textile?.layers) ? textile.layers : [])
    .filter((layer) => layer && (layer.type === 'image' || layer.type === 'text'));
}

function defaultMaterialCentsPerMarking(textile, achatCents) {
  const layers = getTextileMarkingLayers(textile);
  if (!layers.length) return 0;
  const zoneCount = getTextileMarkingZoneCount(textile);
  const materialZoneCount = zoneCount || normalizeZoneIds(textile?.activeZoneIds).length || 1;
  const pool = Math.round(achatCents * 0.10) * materialZoneCount;
  return Math.round(pool / layers.length);
}

function defaultMarkingCentsPerLayer(textile, achatCents) {
  const settings = normalizePricingSettings(state.pricingSettings);
  const poseUnitCents = settings.usePose ? (settings.poseCentsPerZone || 0) : 0;
  return defaultMaterialCentsPerMarking(textile, achatCents) + poseUnitCents;
}

function resolveLayerMarkingCostCents(marking, defaults) {
  const normalized = normalizeLayerMarking(marking);
  if (normalized.markingCents !== null) return normalized.markingCents;
  // Legacy drafts stored matière / pose separately.
  if (normalized.materialCents !== null || normalized.poseCents !== null) {
    return (normalized.materialCents ?? defaults.materialCents) + (normalized.poseCents ?? defaults.poseCents);
  }
  return defaults.markingCents;
}

function resolveLayerMarkingLine(textile, layer, defaults) {
  const marking = normalizeLayerMarking(layer?.marking);
  const product = getProductById(textile?.productId) || products[0];
  const name = layer?.type === 'text'
    ? String(layer.text || layer.name || 'Texte').trim() || 'Texte'
    : String(layer.name || 'Logo').trim() || 'Logo';
  const markingCents = resolveLayerMarkingCostCents(marking, defaults);
  const asset = layer?.type === 'image' ? getAssetForLayer(layer) : null;
  return {
    layerId: layer.id,
    textileId: textile?.id,
    name,
    type: layer.type === 'text' ? 'text' : 'image',
    technique: resolveMarkingTechniqueLabel(marking),
    techniqueValue: marking.technique,
    techniqueCustom: marking.techniqueCustom,
    isCustomTechnique: isCustomMarkingTechnique(marking.technique),
    markingCents,
    viewLabel: surfaceDisplayLabel(layer.viewId, product),
    thumbSrc: asset?.src || layer?.src || '',
    textPreview: layer?.type === 'text' ? String(layer.text || layer.name || 'T').trim() || 'T' : '',
    textColor: normalizeHexColor(layer?.color, '#111827'),
    markingIsOverride: marking.markingCents !== null
      || marking.materialCents !== null
      || marking.poseCents !== null,
  };
}

// Resolves the effective per-textile prices/margins, inheriting global defaults
// for any field the user hasn't overridden. Marquage is the sum of per-marking
// sub-lines (matière + pose combined per logo/texte).
function resolveTextilePricing(textile) {
  const product = getProductById(textile?.productId) || products[0];
  const color = getColor(product, textile?.colorId);
  const overrides = normalizeTextilePricing(textile?.pricing);
  const settings = normalizePricingSettings(state.pricingSettings);

  const achatCents = overrides.achatCents ?? getTextileVariantPriceCents(product, color);
  const zoneCount = getTextileMarkingZoneCount(textile);
  const poseUnitCents = settings.usePose ? (settings.poseCentsPerZone || 0) : 0;
  const materialDefault = defaultMaterialCentsPerMarking(textile, achatCents);
  const markingDefaults = {
    materialCents: materialDefault,
    poseCents: poseUnitCents,
    markingCents: materialDefault + poseUnitCents,
  };
  const markingLines = getTextileMarkingLayers(textile).map((layer) => (
    resolveLayerMarkingLine(textile, layer, markingDefaults)
  ));
  const markingCents = markingLines.reduce((total, line) => total + (Number(line.markingCents) || 0), 0);
  const costCents = achatCents + markingCents;

  const defaultMargin = clamp(Number(settings.marginPercent) || 0, 0, 95);
  const marginPercent = overrides.marginPercent ?? defaultMargin;
  let autoSaleCents;
  if (marginPercent >= 95) {
    autoSaleCents = Math.round(costCents / 0.05);
  } else if (marginPercent <= -999) {
    autoSaleCents = 0;
  } else {
    // Works for negative margins too (sale below cost when marginPercent < 0).
    autoSaleCents = Math.max(0, Math.round(costCents / (1 - marginPercent / 100)));
  }
  const saleCents = overrides.salePriceCents ?? autoSaleCents;
  const marginCents = saleCents - costCents;
  const marginRate = saleCents > 0 ? (marginCents / saleCents) * 100 : 0;
  const quantity = getProjectTextileQuantity(textile);
  return {
    id: textile?.id,
    label: textileDisplayName(textile),
    colorLabel: color?.label || '',
    achatCents,
    markingCents,
    // Legacy aliases kept for any leftover consumers.
    transfertMatiereCents: markingCents,
    transfertMatiereLabel: 'Marquage',
    zoneCount,
    poseUnitCents,
    poseCents: 0,
    markingLines,
    costCents,
    saleCents,
    hasExplicitSale: overrides.salePriceCents !== null,
    marginPercent,
    marginCents,
    marginRate,
    quantity,
    costTotalCents: costCents * quantity,
    saleTotalCents: saleCents * quantity,
    marginTotalCents: marginCents * quantity,
  };
}

// Aggregates every textile plus the global order costs (delivery, file prep,
// other costs, rush surcharge) into an order-wide margin.
function getOrderPricingBreakdown() {
  ensureProjectTextiles();
  ensureProjectTextileQuantities();
  syncActiveTextileFromState();
  const rows = state.textiles.map((textile) => resolveTextilePricing(textile));
  const config = normalizeProfitabilityConfig(state.profitabilityConfig);
  const settings = normalizePricingSettings(state.pricingSettings);
  const quantityTotal = rows.reduce((total, row) => total + (Number(row.quantity) || 0), 0);
  const textileSaleTotalCents = rows.reduce((total, row) => total + row.saleTotalCents, 0);
  const textileCostTotalCents = rows.reduce((total, row) => total + row.costTotalCents, 0);
  const rawDeliveryCents = config.shippingPurchaseCents
    ?? normalizeOverrideCents(state.batConfig.shippingCents)
    ?? normalizeOverrideCents(activeAdminDefaults.bat.shippingCents)
    ?? 0;
  // Delivery charged to the client (revenue), defaults to the paid amount. When
  // in-store pickup is selected, nothing is charged AND the internal transport
  // cost is zeroed out (there is no transport when the client picks up).
  const pickupInStore = Boolean(config.pickupInStore);
  const deliveryCents = pickupInStore ? 0 : rawDeliveryCents;
  const deliverySaleCents = pickupInStore ? 0 : (config.deliverySaleCents ?? rawDeliveryCents);
  const fileSetupCents = config.fileSetupCents || 0;
  const otherCosts = getProfitabilityOtherCostsPricing(config.otherCosts, quantityTotal);
  const otherCostsCents = otherCosts.totalCents;
  const rushCents = settings.useUrgentOrder
    ? (normalizeOverrideCents(settings.urgentOrderCents)
      ?? normalizeOverrideCents(config.rushSupplementCents)
      ?? Math.round(textileSaleTotalCents * 0.30))
    : 0;
  const saleTotalCents = textileSaleTotalCents + rushCents + deliverySaleCents;
  // Packaging cost defaults to a percentage of the order sale total HT, but can
  // be explicitly overridden (stored in cents). No override => use the computed
  // percentage-based value.
  const packagingPercent = clamp(Number(config.packagingPercent ?? 1) || 0, 0, 100);
  const packagingDefaultCents = Math.round(saleTotalCents * packagingPercent / 100);
  const packagingIsOverridden = normalizeOverrideCents(config.packagingCents) !== null;
  const packagingCents = packagingIsOverridden ? normalizeOverrideCents(config.packagingCents) : packagingDefaultCents;
  const globalCostCents = deliveryCents + fileSetupCents + packagingCents + otherCostsCents;
  const costTotalCents = textileCostTotalCents + globalCostCents;
  const marginCents = saleTotalCents - costTotalCents;
  const marginRate = saleTotalCents > 0 ? (marginCents / saleTotalCents) * 100 : 0;
  return {
    rows,
    quantityTotal,
    textileSaleTotalCents,
    textileCostTotalCents,
    deliveryCents,
    deliverySaleCents,
    pickupInStore,
    fileSetupCents,
    packagingCents,
    packagingDefaultCents,
    packagingIsOverridden,
    packagingPercent,
    otherCosts: otherCosts.rows,
    otherCostsCents,
    globalCostCents,
    rushCents,
    rushEnabled: settings.useUrgentOrder,
    saleTotalCents,
    costTotalCents,
    marginCents,
    marginRate,
    marginPerPieceCents: quantityTotal > 0 ? Math.round(marginCents / quantityTotal) : marginCents,
  };
}

// Margin color code used everywhere (UI + PDF):
// < 5% (or negative €) → red · 5–20% → orange · ≥ 20% → green.
function orderMarginTone(rate, marginCents = 0) {
  const numericRate = Number(rate) || 0;
  if ((Number(marginCents) || 0) < 0 || numericRate < 5) return 'negative';
  if (numericRate < 20) return 'warning';
  return 'positive';
}

function orderMarginToneInk(tone) {
  if (tone === 'negative') return '#e11d48';
  if (tone === 'warning') return '#b45309';
  return '#039855';
}

function textileHasQuantity(textile) {
  return textile && Object.prototype.hasOwnProperty.call(textile, 'quantity');
}

function getProjectTextileQuantity(textile) {
  return parseQuantityInput(textile?.quantity);
}

function getProjectTextileQuantityTotal(textiles = state.textiles) {
  return (Array.isArray(textiles) ? textiles : [])
    .reduce((total, textile) => total + getProjectTextileQuantity(textile), 0);
}

function ensureProjectTextileQuantities() {
  ensureProjectTextiles();
  const hasQuantityData = state.textiles.some((textile) => textileHasQuantity(textile));
  if (!hasQuantityData) {
    const fallback = normalizeQuantityMode(state.quantityMode) === 'sizes'
      ? getSizeQuantityTotal()
      : getTotalQuantityFromTotalMode();
    state.textiles.forEach((textile, index) => {
      textile.quantity = index === 0 ? fallback : 0;
    });
  } else {
    state.textiles.forEach((textile) => {
      textile.quantity = getProjectTextileQuantity(textile);
    });
  }
  state.totalQuantity = getProjectTextileQuantityTotal();
  return state.totalQuantity;
}

function applyTextileSnapshotToState(textile) {
  const normalized = normalizeTextileSnapshot(textile);
  const product = getProductById(normalized.productId) || products[0];
  state.productId = product.id;
  state.productCategoryId = normalized.productCategoryId || getProductCategoryId(product);
  state.productChoiceId = normalized.productChoiceId || '';
  const resolvedColor = getColor(product, normalized.colorId);
  state.colorId = resolvedColor.id;
  if (isCustomColorId(resolvedColor.id)) {
    state.customColorHex = resolvedColor.hex;
  }
  state.viewId = normalized.viewId;
  state.activeZoneIds = cloneForHistory(normalized.activeZoneIds);
  state.zoneMarkings = cloneForHistory(normalized.zoneMarkings);
  state.customZoneSize = cloneForHistory(normalized.customZoneSize);
  state.layers = cloneForHistory(normalized.layers);
  state.previewAdjustments = cloneForHistory(normalized.previewAdjustments);
  state.customProductPhotos = cloneForHistory(normalized.customProductPhotos);
  state.selectedLayerId = null;
  ensureCurrentViewIsActive(product);
}

function selectProjectTextile(id) {
  if (!id || id === state.activeTextileId) return;
  syncActiveTextileFromState();
  const textile = state.textiles.find((item) => item.id === id);
  if (!textile) return;
  state.activeTextileId = id;
  applyTextileSnapshotToState(textile);
  renderAll();
}

function addProjectTextile() {
  pushHistory();
  syncActiveTextileFromState();
  const textile = createBlankTextileSnapshot();
  state.textiles.push(textile);
  state.activeTextileId = textile.id;
  applyTextileSnapshotToState(textile);
  renderAll();
}

function duplicateProjectTextile(id) {
  const sourceIndex = state.textiles.findIndex((textile) => textile.id === id);
  if (sourceIndex < 0) return;
  pushHistory();
  syncActiveTextileFromState();
  const source = state.textiles[sourceIndex];
  const duplicate = normalizeTextileSnapshot({
    ...cloneForHistory(source),
    id: makeId('textile'),
    layers: cloneForHistory(source.layers || []).map((layer) => ({ ...layer, id: makeId('layer') })),
  });
  state.textiles.splice(sourceIndex + 1, 0, duplicate);
  state.activeTextileId = duplicate.id;
  applyTextileSnapshotToState(duplicate);
  renderAll();
}

function removeProjectTextile(id) {
  if (!id || state.textiles.length <= 1) return;
  pushHistory();
  syncActiveTextileFromState();
  const index = state.textiles.findIndex((textile) => textile.id === id);
  if (index < 0) return;
  state.textiles.splice(index, 1);
  if (state.activeTextileId === id) {
    const next = state.textiles[Math.max(0, index - 1)] || state.textiles[0];
    state.activeTextileId = next.id;
    applyTextileSnapshotToState(next);
  }
  renderAll();
}

function textileColorDisplayLabel(color) {
  if (!color) return '';
  if (isCustomColorId(color.id)) return 'personnalisée';
  if (TEXTILE_COLOR_LABELS_FR[color.id]) return TEXTILE_COLOR_LABELS_FR[color.id];
  const normalized = normalizeSearchText(color.label)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  if (TEXTILE_COLOR_LABELS_FR[normalized]) return TEXTILE_COLOR_LABELS_FR[normalized];
  if (normalized.includes('white') || normalized.includes('blanc')) return 'Blanc';
  if (normalized.includes('black') || normalized.includes('noir')) return 'Noir';
  if (normalized.includes('navy') || normalized.includes('marine')) return 'Marine';
  const raw = String(color.label || '').trim();
  if (!raw) return '';
  return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
}

function textileDisplayName(textile) {
  const customName = String(textile?.customName || '').trim();
  if (customName) return customName;
  const product = getProductById(textile?.productId) || products[0];
  const color = getColor(product, textile?.colorId);
  const choice = PRODUCT_QUICK_CHOICE_MAP.get(textile?.productChoiceId || '');
  const base = choice?.label
    || PRODUCT_CATEGORY_MAP.get(getProductCategoryId(product))?.label
    || product.label
    || 'Textile';
  const colorLabel = textileColorDisplayLabel(color).toLowerCase();
  return `${base} ${colorLabel}`.trim();
}

function updateProjectTextileName(input, options = {}) {
  const textileId = input?.dataset.projectTextileName;
  if (!textileId) return;
  const textile = state.textiles.find((item) => item.id === textileId);
  if (!textile) return;
  textile.customName = String(input.value || '').trim();
  if (!textile.customName && options.commit) input.value = textileDisplayName(textile);
  if (options.render) renderAll();
}

function textileZonesLabel(textile) {
  const zoneIds = normalizeZoneIds(textile?.activeZoneIds);
  return zoneIds.map((id) => surfaceDisplayLabel(id, getProductById(textile?.productId) || products[0])).join(' + ');
}

function getProjectLayerRows() {
  ensureProjectTextiles();
  syncActiveTextileFromState();
  return state.textiles.flatMap((textile) => {
    const product = getProductById(textile.productId) || products[0];
    const zoneIds = normalizeZoneIds(textile.activeZoneIds);
    return zoneIds.flatMap((viewId) => {
      const view = getProductView(product, viewId);
      return (textile.layers || [])
        .filter((layer) => viewIdMatches(layer.viewId, viewId))
        .map((layer) => ({ textile, product, view, layer }));
      });
  });
}

function projectHasLayers() {
  ensureProjectTextiles();
  syncActiveTextileFromState();
  return state.textiles.some((textile) => Array.isArray(textile.layers) && textile.layers.length > 0);
}

function getProjectExportSnapshots() {
  ensureProjectTextiles();
  syncActiveTextileFromState();
  return state.textiles.map((textile) => normalizeTextileSnapshot(cloneForHistory(textile)));
}

async function withProjectExportState(callback) {
  const originalTextiles = getProjectExportSnapshots();
  const originalActiveTextileId = state.activeTextileId;
  const originalSelectedLayerId = state.selectedLayerId;

  try {
    return await callback(originalTextiles);
  } finally {
    state.textiles = originalTextiles.map((textile) => normalizeTextileSnapshot(cloneForHistory(textile)));
    state.activeTextileId = originalActiveTextileId || state.textiles[0]?.id || '';
    const restoredTextile = state.textiles.find((textile) => textile.id === state.activeTextileId) || state.textiles[0];
    if (restoredTextile) {
      state.activeTextileId = restoredTextile.id;
      applyTextileSnapshotToState(restoredTextile);
      if (originalSelectedLayerId && state.layers.some((layer) => layer.id === originalSelectedLayerId)) {
        state.selectedLayerId = originalSelectedLayerId;
      }
    }
  }
}

function applyExportTextileSnapshot(textile) {
  state.activeTextileId = textile.id;
  applyTextileSnapshotToState(textile);
}

function getProjectFileSlug() {
  const production = getProductionConfig();
  const label = [production.orderReference, production.clientName]
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .join('-');
  return safeFileSlug(label || 'dossier-bat');
}

function getProjectTextileSummary(rows = getProjectProductionRows()) {
  return rows.map((row) => {
    const colorLabel = row.color?.label ? ` ${row.color.label}` : '';
    return `${row.label}${colorLabel}`.trim();
  }).join(' · ');
}

function getProjectZoneSummary(rows = getProjectProductionRows()) {
  return rows.map((row) => {
    const zones = row.zones.map((zone) => zone.label).join(' + ') || 'Aucune zone';
    return `${row.label}: ${zones}`;
  }).join(' / ');
}

function getProjectTextilePriceRows(level = getCustomerLevel()) {
  ensureProjectTextiles();
  ensureProjectTextileQuantities();
  syncActiveTextileFromState();
  const textileMultiplier = Number.isFinite(Number(level?.textileMultiplier)) ? Number(level.textileMultiplier) : 1;
  return state.textiles.map((textile) => {
    const product = getProductById(textile.productId) || products[0];
    const color = getColor(product, textile.colorId);
    const baseCents = getTextileVariantPriceCents(product, color);
    const costCents = Math.round(baseCents * textileMultiplier);
    const quantity = getProjectTextileQuantity(textile);
    return {
      id: textile.id,
      label: textileDisplayName(textile),
      colorLabel: color?.label || '',
      baseCents,
      costCents,
      quantity,
      baseTotalCents: baseCents * quantity,
      costTotalCents: costCents * quantity,
    };
  });
}

function getProjectTextileBaseCents(rows = null) {
  const textileRows = rows || getProjectTextilePriceRows({ textileMultiplier: 1 });
  return textileRows.reduce((total, textile) => total + textile.baseCents, 0);
}

function getProjectTextileQuantityLabel(rows = null) {
  const textileRows = rows || getProjectTextilePriceRows();
  const quantity = textileRows.reduce((total, row) => total + (Number(row.quantity) || 0), 0);
  return `${quantity} pièce${quantity > 1 ? 's' : ''}`;
}

function textilePriceBreakdownMarkup(rows = [], options = {}) {
  const textileRows = Array.isArray(rows) ? rows.filter(Boolean) : [];
  if (textileRows.length <= 1) return '';
  const valueKey = options.valueKey || 'costCents';
  const totalCents = normalizeOverrideCents(options.totalCents)
    ?? textileRows.reduce((total, row) => {
      const unit = normalizeOverrideCents(row[valueKey]) ?? 0;
      const quantity = Number(row.quantity) || 0;
      return total + unit * quantity;
    }, 0);
  return `
    <div class="bat-textile-price-breakdown">
      <div class="bat-textile-price-breakdown-head">
        <strong>${escapeHtml(options.title || 'Textiles du projet')}</strong>
        <span>${formatMoneyCents(totalCents)} total</span>
      </div>
      <div class="bat-textile-price-breakdown-list">
        ${textileRows.map((row) => {
          const amount = normalizeOverrideCents(row[valueKey]) ?? 0;
          const color = row.colorLabel ? ` · ${row.colorLabel}` : '';
          const quantity = Number(row.quantity) || 0;
          return `
            <div class="bat-textile-price-breakdown-row">
              <span>${escapeHtml(row.label)}${escapeHtml(color)} · ${quantity} pc${quantity > 1 ? 's' : ''}</span>
              <strong>${formatMoneyCents(amount * quantity)}</strong>
            </div>
          `;
        }).join('')}
      </div>
      ${options.note ? `<p>${escapeHtml(options.note)}</p>` : ''}
    </div>
  `;
}

function getProjectProductionRows() {
  ensureProjectTextiles();
  syncActiveTextileFromState();
  return state.textiles.map((textile) => {
    const product = getProductById(textile.productId) || products[0];
    const color = getColor(product, textile.colorId);
    const zones = normalizeZoneIds(textile.activeZoneIds).map((viewId) => {
      const view = getProductView(product, viewId);
      const printSize = getPrintSize(product, viewId);
      const layers = (textile.layers || []).filter((layer) => viewIdMatches(layer.viewId, viewId));
      return {
        id: viewId,
        label: surfaceDisplayLabel(viewId, product),
        size: `${formatCm(printSize.width)} x ${formatCm(printSize.height)} cm`,
        layers,
      };
    });
    return {
      id: textile.id,
      label: textileDisplayName(textile),
      product,
      color,
      zones,
    };
  });
}

function renderProducts() {
  els.productList.innerHTML = `
    <div class="bat-product-helper">
      <strong>Choix rapide</strong>
      <span>Choisissez un type de textile pour une prévisualisation standard.</span>
    </div>
    <div class="bat-category-grid">
      ${PRODUCT_QUICK_CHOICES.map((item) => categoryCardMarkup(item)).join('')}
    </div>
  `;
}

function productReferenceModalMarkup(visibleProducts, totalCount, remainingCount, hasSearch) {
  return `
    <div class="bat-reference-modal" role="dialog" aria-modal="true" aria-label="Choisir une référence textile">
      <button class="bat-modal-backdrop" type="button" data-action="close-product-reference-modal" aria-label="Fermer"></button>
      <div class="bat-reference-dialog">
        <div class="bat-reference-dialog-head">
          <span>
            <strong>Utiliser une référence précise</strong>
            <small>${totalCount} référence${totalCount > 1 ? 's' : ''} disponible${totalCount > 1 ? 's' : ''}</small>
          </span>
          <button class="bat-modal-close" type="button" data-action="close-product-reference-modal" aria-label="Fermer">×</button>
        </div>
        <label class="bat-product-search">
          <span>Rechercher</span>
          <input class="bat-input" type="search" value="${escapeHtml(state.productSearch)}" placeholder="Ex : BC01B, AT207, hoodie, softshell..." data-product-modal-search>
          ${hasSearch ? '<button class="bat-search-clear" type="button" data-action="clear-product-search" aria-label="Effacer la recherche">×</button>' : ''}
        </label>
        <div class="bat-reference-list bat-reference-list-modal">
          ${visibleProducts.length ? visibleProducts.map((product) => referenceCardMarkup(product)).join('') : '<div class="bat-reference-more">Aucune référence trouvée.</div>'}
          ${remainingCount ? `<div class="bat-reference-more">+ ${remainingCount} autres références. Affinez la recherche pour les afficher.</div>` : ''}
        </div>
      </div>
    </div>
  `;
}

function categoryCardMarkup(category) {
  const product = getProductById(category.witnessProductId) || getProduct();
  const active = category.id === state.productChoiceId || product.id === state.productId;
  return `
    <button class="bat-category-card ${active ? 'is-active' : ''}" type="button" data-action="select-category" data-id="${category.id}">
      <span class="bat-category-thumb">${categoryImageMarkup(category, product)}</span>
      <span>
        <strong>${escapeHtml(category.label)}</strong>
      </span>
    </button>
  `;
}

function categoryImageMarkup(category, product) {
  if (category.imageUrl) {
    return `<img src="${category.imageUrl}" alt="" crossorigin="anonymous">`;
  }
  return productMediaMarkup(product, 'front', 'white', { includeCustom: false, preferColorOnly: true, fallbackColorHex: '#f8fafc' });
}

function referenceCardMarkup(product) {
  const reference = getProductReference(product);
  const category = PRODUCT_CATEGORY_MAP.get(reference?.categoryId) || getProductCategory();
  const selected = product.id === state.productId;
  return `
    <button class="bat-reference-card ${selected ? 'is-active' : ''} ${reference?.witness ? 'is-witness' : ''}" type="button" data-action="select-product" data-id="${product.id}">
      <span class="bat-reference-thumb">${productMediaMarkup(product, 'front', getColor(product).id, { includeCustom: false })}</span>
      <span class="bat-reference-copy">
        <strong>${escapeHtml(product.fullLabel || product.label)}</strong>
        <small>${escapeHtml(category.label)}${reference?.witness ? ' · référence témoin' : ''}</small>
      </span>
    </button>
  `;
}

function getFilteredCatalogProducts(options = {}) {
  const term = normalizeSearchText(state.productSearch);
  const catalogProducts = ALL_PRODUCT_REFERENCES.map((reference) => getProductById(reference.id)).filter(Boolean);
  const productsInScope = term || options.all
    ? catalogProducts
    : catalogProducts.filter((product) => getProductCategoryId(product) === state.productCategoryId);
  return productsInScope.filter((product) => {
    if (!term) return true;
    return productSearchHaystack(product).includes(term);
  });
}

function productSearchHaystack(product) {
  const reference = getProductReference(product);
  const category = PRODUCT_CATEGORY_MAP.get(reference?.categoryId);
  return normalizeSearchText([
    product.id,
    product.label,
    product.fullLabel,
    reference?.code,
    reference?.handle,
    reference?.vendor,
    category?.label,
    category?.handle,
  ].filter(Boolean).join(' '));
}

function normalizeSearchText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function renderColors() {
  const selectedColor = getColor();
  const product = getProduct();
  const colors = getProductColors();
  const customHex = isCustomColorId(state.colorId)
    ? selectedColor.hex
    : normalizeHexColor(state.customColorHex, DEFAULT_CUSTOM_TEXTILE_HEX);
  const customActive = isCustomColorId(state.colorId);
  els.colorList.innerHTML = `
    ${colors.map((color) => {
      const label = textileColorDisplayLabel(color);
      return `
      <button class="bat-color-card ${color.id === state.colorId ? 'is-active' : ''}" type="button" title="${escapeHtml(label)}" aria-label="${escapeHtml(label)}" data-action="select-color" data-id="${color.id}">
        ${productMediaMarkup(product, 'front', color.id, { includeCustom: false })}
        <span>${escapeHtml(label)}</span>
      </button>
    `;
    }).join('')}
    <label class="bat-color-card bat-color-custom ${customActive ? 'is-active' : ''}" title="Choisir une autre couleur">
      <span class="bat-color-custom-swatch" style="--swatch:${escapeHtml(customHex)}">
        <input type="color" value="${escapeHtml(customHex)}" data-custom-textile-color aria-label="Sélecteur de couleur textile">
      </span>
      <span class="bat-color-custom-meta">
        <em>Autre couleur</em>
        <input class="bat-input bat-color-hex-input" type="text" spellcheck="false" maxlength="7" value="${escapeHtml(customHex)}" data-custom-textile-hex aria-label="Code HEX de la couleur textile">
      </span>
    </label>
  `;
  els.colorLabel.textContent = textileColorDisplayLabel(selectedColor);
}

function syncCustomTextileColorControls(sourceInput = null) {
  const hex = normalizeHexColor(state.customColorHex, DEFAULT_CUSTOM_TEXTILE_HEX);
  document.querySelectorAll('[data-custom-textile-color]').forEach((input) => {
    if (input !== sourceInput) input.value = hex;
    input.closest('.bat-color-custom-swatch')?.style.setProperty('--swatch', hex);
    input.closest('.bat-color-custom')?.classList.add('is-active');
  });
  document.querySelectorAll('[data-custom-textile-hex]').forEach((input) => {
    if (input !== sourceInput && document.activeElement !== input) input.value = hex;
  });
  if (els.colorLabel) els.colorLabel.textContent = 'Personnalisée';
}

function renderWorkspaceTabs() {
  const profitability = getProfitabilityBreakdown(getPricingBreakdown());
  const profitabilityTone = orderMarginTone(profitability.grossMarginRate, profitability.grossMarginCents);
  const modes = WORKSPACE_MODES.filter((mode) => mode.id !== 'production' || isProductionOrderAvailable());
  els.workspaceTabs.innerHTML = modes.map((mode) => {
    const locked = isWorkspaceLocked(mode.id);
    const label = mode.id === 'production' ? `3. ${getProductionWorkspaceLabel()}` : mode.label;
    return `
      <button class="bat-view-tab ${mode.id === state.workspaceMode ? 'is-active' : ''} ${locked ? 'is-disabled' : ''}" type="button" data-action="select-workspace" data-id="${mode.id}" ${locked ? 'disabled aria-disabled="true"' : ''}>
        <span>${escapeHtml(label)}</span>
        ${mode.id === 'profitability' ? `<small class="bat-tab-rate is-${profitabilityTone}">${formatProfitRate(profitability.grossMarginRate)}</small>` : ''}
      </button>
    `;
  }).join('');
}

function renderAdminModal(options = {}) {
  if (!els.adminModal) return;
  els.adminModal.classList.toggle('is-hidden', !state.adminOpen);
  if (!state.adminOpen) {
    els.adminModal.innerHTML = '';
    return;
  }
  const draft = normalizeAdminDefaults(state.adminDraft);
  els.adminModal.innerHTML = `
    <button class="bat-admin-backdrop" type="button" data-action="close-admin" aria-label="Fermer"></button>
    <section class="bat-admin-dialog" role="dialog" aria-modal="true" aria-label="Paramètres des valeurs par défaut">
      <div class="bat-admin-head">
        <span>
          <strong>Paramètres par défaut</strong>
          <small>Valeurs appliquées automatiquement aux nouveaux projets.</small>
        </span>
        <button class="bat-modal-close" type="button" data-action="close-admin" aria-label="Fermer">×</button>
      </div>
      <div class="bat-admin-body">
        <div class="bat-admin-card bat-admin-card-wide">
          <header class="bat-admin-card-head">
            <span class="bat-admin-card-eyebrow">Société</span>
            <strong>Identité</strong>
            <small>Affichée par défaut sur les BAT et devis.</small>
          </header>
          <div class="bat-admin-field-grid">
          <label class="bat-config-field">
            <span>Nom de société</span>
            <input class="bat-input" type="text" value="${escapeHtml(draft.identity.companyName)}" data-admin-field="identity.companyName">
          </label>
          <div class="bat-config-field">
            <span>Logo société</span>
            <div class="bat-company-logo-control">
              <label class="bat-company-logo-upload ${draft.identity.companyLogoSrc ? 'has-logo' : ''}">
                <input type="file" accept="image/png,image/jpeg,image/svg+xml,.png,.jpg,.jpeg,.svg" data-admin-logo-input>
                ${draft.identity.companyLogoSrc ? `<img src="${escapeHtml(draft.identity.companyLogoSrc)}" alt="">` : '<em aria-hidden="true">+</em>'}
                <span>
                  <strong>${draft.identity.companyLogoName ? escapeHtml(draft.identity.companyLogoName) : 'Ajouter un logo'}</strong>
                  <small>Utilisé par défaut dans les BAT</small>
                </span>
              </label>
              ${draft.identity.companyLogoSrc ? '<button class="bat-company-logo-remove" type="button" data-action="remove-admin-logo">Retirer le logo</button>' : ''}
            </div>
          </div>
          </div>
        </div>

        <div class="bat-admin-card">
          <header class="bat-admin-card-head">
            <span class="bat-admin-card-eyebrow">Documents</span>
            <strong>BAT &amp; tarifs</strong>
            <small>Valeurs pré-remplies à la création d'un projet.</small>
          </header>
          <label class="bat-config-field">
            <span>Délai de fabrication</span>
            <input class="bat-input" type="text" value="${escapeHtml(draft.bat.leadTime)}" data-admin-field="bat.leadTime">
          </label>
          <label class="bat-config-field">
            <span>Coût de transport / livraison par défaut</span>
            <span class="bat-price-edit">
              <input class="bat-price-input" type="number" min="0" step="0.01" value="${formatMoneyInput(draft.bat.shippingCents)}" data-admin-field="bat.shippingCents" data-admin-money>
              <em>€ global</em>
            </span>
          </label>
          <div class="bat-price-internal">
            <div class="bat-price-internal-title">Tarifs par défaut</div>
            <label class="bat-price-setting-row">
              <span>Marge (%)</span>
              <span class="bat-percent-field">
                <input class="bat-price-input" type="number" min="0" max="500" step="1" value="${formatPercentInput(draft.bat.pricingSettings.marginPercent)}" data-admin-field="bat.pricingSettings.marginPercent">
                <em>%</em>
              </span>
            </label>
          </div>
        </div>

        <div class="bat-admin-card">
          <header class="bat-admin-card-head">
            <span class="bat-admin-card-eyebrow">Marges</span>
            <strong>Rentabilité</strong>
            <small>Coûts internes par défaut.</small>
          </header>
          <div class="bat-price-internal">
            <div class="bat-price-internal-title">Coûts internes</div>
            <label class="bat-price-setting-row">
              <span>Coût à la pose</span>
              <span class="bat-price-edit">
                <input class="bat-price-input" type="number" min="0" step="0.01" value="${formatMoneyInput(draft.profitability.poseLaborCents)}" data-admin-field="profitability.poseLaborCents" data-admin-money>
                <em>€ / zone</em>
              </span>
            </label>
            <label class="bat-price-setting-row">
              <span>Coût de préparation de dossier</span>
              <span class="bat-price-edit">
                <input class="bat-price-input" type="number" min="0" step="0.01" value="${formatMoneyInput(draft.profitability.fileSetupCents)}" data-admin-field="profitability.fileSetupCents" data-admin-money>
                <em>€ global</em>
              </span>
            </label>
            <label class="bat-price-setting-row bat-packaging-row">
              <span>
                Coût d'emballage
                <small class="bat-packaging-hint">% des ventes HT (auto)</small>
              </span>
              <span class="bat-percent-field">
                <input class="bat-price-input" type="number" min="0" max="100" step="0.1" value="${formatPercentInput(draft.profitability.packagingPercent)}" data-admin-field="profitability.packagingPercent">
                <em>%</em>
              </span>
            </label>
          </div>
        </div>

        <div class="bat-admin-card">
          <header class="bat-admin-card-head">
            <span class="bat-admin-card-eyebrow">Devis</span>
            <strong>Options &amp; frais récurrents</strong>
            <small>Montants par défaut des options ajoutables en un clic.</small>
          </header>
          <div class="bat-price-internal">
            <div class="bat-price-internal-title">Frais récurrents</div>
            <label class="bat-price-setting-row">
              <span>Frais de programme de broderie</span>
              <span class="bat-price-edit">
                <input class="bat-price-input" type="number" min="0" step="0.01" value="${formatMoneyInput(draft.profitability.embroideryProgramCents)}" data-admin-field="profitability.embroideryProgramCents" data-admin-money>
                <em>€ global</em>
              </span>
            </label>
            <label class="bat-price-setting-row">
              <span>Frais techniques</span>
              <span class="bat-price-edit">
                <input class="bat-price-input" type="number" min="0" step="0.01" value="${formatMoneyInput(draft.profitability.technicalFeeCents)}" data-admin-field="profitability.technicalFeeCents" data-admin-money>
                <em>€ global</em>
              </span>
            </label>
            <label class="bat-price-setting-row">
              <span>Pliage unitaire</span>
              <span class="bat-price-edit">
                <input class="bat-price-input" type="number" min="0" step="0.01" value="${formatMoneyInput(draft.profitability.foldingUnitCents)}" data-admin-field="profitability.foldingUnitCents" data-admin-money>
                <em>€ / unité</em>
              </span>
            </label>
            <label class="bat-price-setting-row">
              <span>Emballages individuels</span>
              <span class="bat-price-edit">
                <input class="bat-price-input" type="number" min="0" step="0.01" value="${formatMoneyInput(draft.profitability.individualPackagingCents)}" data-admin-field="profitability.individualPackagingCents" data-admin-money>
                <em>€ / unité</em>
              </span>
            </label>
            <label class="bat-price-setting-row">
              <span>Retrait étiquette</span>
              <span class="bat-price-edit">
                <input class="bat-price-input" type="number" min="0" step="0.01" value="${formatMoneyInput(draft.profitability.labelRemovalCents)}" data-admin-field="profitability.labelRemovalCents" data-admin-money>
                <em>€ / unité</em>
              </span>
            </label>
            <label class="bat-price-setting-row bat-packaging-row">
              <span>
                Supplément urgence
                <small class="bat-packaging-hint">Laisser à 0 pour appliquer +30% automatiquement</small>
              </span>
              <span class="bat-price-edit">
                <input class="bat-price-input" type="number" min="0" step="0.01" value="${formatMoneyInput(draft.profitability.rushSupplementCents)}" data-admin-field="profitability.rushSupplementCents" data-admin-money>
                <em>€ global</em>
              </span>
            </label>
          </div>
        </div>

      </div>
      <div class="bat-admin-footer">
        <button class="bat-btn" type="button" data-action="reset-admin-defaults">Réinitialiser les paramètres</button>
        <span></span>
        <button class="bat-btn" type="button" data-action="close-admin">Annuler</button>
        <button class="bat-btn bat-btn-primary" type="button" data-action="save-admin-defaults">Sauvegarder les paramètres</button>
      </div>
    </section>
  `;
  if (Number.isFinite(options.restoreScrollTop)) {
    const adminBody = els.adminModal.querySelector('.bat-admin-body');
    if (adminBody) {
      requestAnimationFrame(() => {
        adminBody.scrollTop = options.restoreScrollTop;
      });
    }
  }
}

function renderViews() {
  if (state.workspaceMode !== 'compose') {
    els.viewTabs.innerHTML = '';
  } else {
    els.viewTabs.innerHTML = `
      <div class="bat-zone-picker">
        ${ZONE_OPTIONS.map((option) => {
          const checked = state.activeZoneIds.includes(option.id);
          return `
            <div class="bat-zone-card ${checked ? 'is-active' : ''}">
              <button class="bat-zone-toggle" type="button" data-action="toggle-zone" data-id="${option.id}" aria-pressed="${checked ? 'true' : 'false'}">
                <span class="bat-zone-check" aria-hidden="true"></span>
                <span class="bat-zone-copy">
                  <strong>${option.label}</strong>
                  <small>${zoneDimensionLabel(option.id, getProduct())}</small>
                </span>
                <span class="bat-zone-thumb" aria-hidden="true">${zoneThumbnailSvg(option.id)}</span>
              </button>
            </div>
          `;
        }).join('')}
      </div>
    `;
  }

  if (els.viewList) {
    const product = getProduct();
    els.viewList.innerHTML = getActiveViews().map((view) => {
      const count = viewLayers(view.id).length;
      return `
        <button class="bat-view-card ${view.id === state.viewId ? 'is-active' : ''}" type="button" data-action="select-surface" data-id="${view.id}">
          ${productMediaMarkup(product, view.id, state.colorId)}
          <strong>${surfaceDisplayLabel(view.id, product)} · ${count}</strong>
        </button>
      `;
    }).join('');
  }
}

function renderSurfaceTabs() {
  // Surface tabs removed: zones are edited directly via the preview cards.
  if (els.surfaceTabs) els.surfaceTabs.innerHTML = '';
}

function renderStage() {
  const product = getProduct();
  const previewMode = isPreviewWorkspace();
  const textileChoiceMode = state.workspaceMode === 'compose';
  const area = { left: 0, top: 0, width: 100, height: 100 };
  els.stage.classList.toggle('is-compose', state.workspaceMode === 'compose');
  els.stage.classList.toggle('is-preview', (previewMode || textileChoiceMode) && state.workspaceMode !== 'profitability');
  els.stage.classList.toggle('is-profitability', state.workspaceMode === 'profitability');
  els.productArt.innerHTML = '';
  els.printArea.style.left = `${area.left}%`;
  els.printArea.style.top = `${area.top}%`;
  els.printArea.style.width = `${area.width}%`;
  els.printArea.style.height = 'auto';

  if (state.workspaceMode === 'profitability') {
    els.printArea.innerHTML = '<div class="bat-profitability-dashboard" data-profitability-dashboard></div>';
    return;
  }

  els.printArea.innerHTML = (previewMode || textileChoiceMode)
    ? renderPreviewBoard(product)
    : renderCompositionBoard(product);
  fitTextLayers();
}

function renderCompositionBoard(product) {
  ensureCurrentViewIsActive(product);
  const activeViews = getActiveViews(product);
  const view = activeViews.find((item) => item.id === state.viewId) || activeViews[0];
  if (!view) return '';
  const layers = viewLayers(view.id);
  return `
    <div class="bat-composition-board">
      <div class="bat-composition-card is-active" data-compose-view-id="${view.id}">
        <div class="bat-preview-card-title">
          <strong>${surfaceDisplayLabel(view.id, product)}</strong>
          <span>${layers.length} élément${layers.length > 1 ? 's' : ''}</span>
        </div>
        <div class="bat-composition-workspace" data-compose-view-id="${view.id}">
          <div class="bat-composition-measure" style="${compositionMeasureStyle(product, view.id)}">
            ${compositionRulerMarkup(product, view.id, 'x')}
            ${compositionRulerMarkup(product, view.id, 'y')}
            <div class="bat-composition-sheet" data-composition-sheet data-compose-view-id="${view.id}" style="${compositionSheetStyle(product, view.id)}">
              ${layers.map((layer) => compositionLayerMarkup(layer, view.id)).join('')}
              ${selectedLayerUiMarkup(layers, product, view.id)}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

function compositionLayerMarkup(layer, viewId, styleStr) {
  const selected = layer.id === state.selectedLayerId;
  const style = styleStr || layerStyle(layer, viewId);
  return `
    <div class="bat-layer ${layer.type === 'text' ? 'bat-layer-text' : ''} ${selected ? 'is-selected' : ''}" data-layer-id="${layer.id}" style="${style}">
      ${layerMarkup(layer)}
      <span class="bat-resize-handle" data-resize-handle></span>
    </div>
  `;
}

function compositionRulerMarkup(product, viewId, axis) {
  const size = getPrintSize(product, viewId);
  const max = axis === 'x' ? size.width : size.height;
  const marks = compositionRulerMarks(max);
  return `
    <div class="bat-composition-ruler bat-composition-ruler-${axis}" aria-hidden="true">
      ${marks.map((mark) => `
        <span class="${mark.major ? 'is-major' : ''}" style="${axis === 'x' ? `left:${mark.position}%` : `top:${mark.position}%`}">
          ${mark.label ? `<em>${mark.label}</em>` : ''}
        </span>
      `).join('')}
    </div>
  `;
}

function compositionRulerMarks(maxCm) {
  const max = Math.max(1, Number(maxCm) || 1);
  const interval = max <= 15 ? 2.5 : 5;
  const marks = [{ value: 0, label: '0', major: true }];
  for (let value = interval; value < max; value += interval) {
    const rounded = Math.round(value * 10) / 10;
    marks.push({ value: rounded, label: formatCm(rounded), major: true });
  }
  marks.push({ value: max, label: `${formatCm(max)} cm`, major: true });
  return marks.map((mark) => ({
    ...mark,
    position: (mark.value / max) * 100,
  }));
}

function selectedLayerUiMarkup(layers, product, viewId, styleFn = selectionUiStyle) {
  const layer = layers.find((item) => item.id === state.selectedLayerId);
  if (!layer) return '';
  return `
    <div class="bat-layer-ui" style="${styleFn(layer, product, viewId)}">
      <div class="bat-layer-toolbar" data-layer-toolbar>
        <button type="button" title="Dupliquer" data-action="duplicate-layer">${toolbarIcon('duplicate')}</button>
        <button type="button" title="Arrière-plan" data-action="send-layer-backward">${toolbarIcon('backward')}</button>
        <button type="button" title="Premier plan" data-action="bring-layer-forward">${toolbarIcon('forward')}</button>
        <button type="button" title="Rotation" data-action="rotate-layer">${toolbarIcon('rotate')}</button>
        <button type="button" title="Supprimer" data-action="delete-layer">${toolbarIcon('trash')}</button>
      </div>
      <div class="bat-layer-info">${selectedLayerInfoLabel(layer)}</div>
    </div>
  `;
}

function renderPreviewBoard(product) {
  const activeViews = getActiveViews(product);
  const isTextileChoice = state.workspaceMode === 'compose';
  const isMarking = state.workspaceMode === 'compose';
  ensureCurrentViewIsActive(product);
  const views = activeViews;
  const quantityPanel = '';
  return `
    ${quantityPanel}
    <div class="bat-preview-board" data-preview-count="${views.length}">
      ${views.map((view) => `
        <div class="bat-preview-card ${view.id === state.viewId ? 'is-active' : ''}" data-preview-view-id="${view.id}">
          <div class="bat-preview-card-title">
            <strong>${surfaceDisplayLabel(view.id, product)}</strong>
            <span>${isTextileChoice ? `${zoneMarkingLabel(view.id)} · ${viewLayers(view.id).length} élément${viewLayers(view.id).length > 1 ? 's' : ''}` : `${viewLayers(view.id).length} élément${viewLayers(view.id).length > 1 ? 's' : ''}`}</span>
          </div>
          <div class="bat-preview-canvas" data-preview-canvas data-preview-view-id="${view.id}">
            <div class="bat-product">${productMediaMarkup(product, view.id, state.colorId)}</div>
            ${customProductPhotoControl(product, view.id)}
            ${renderPreviewComposition(viewLayers(view.id), product, view.id)}
            ${isMarking && !viewLayers(view.id).length ? renderLogoPlaceholder(product, view.id) : ''}
          </div>
          ${isTextileChoice ? `
            <div class="bat-preview-card-actions">
              <button class="bat-btn bat-btn-primary" type="button" data-action="trigger-logo-upload" data-id="${view.id}">Ajouter un marquage</button>
              <button class="bat-btn" type="button" data-action="add-text-layer" data-id="${view.id}">Ajouter du texte</button>
            </div>
          ` : ''}
        </div>
      `).join('')}
    </div>
  `;
}

function renderLogoPlaceholder(product, viewId) {
  const placeholderRect = getLogoPlaceholderRect(product, viewId);
  return `
    <button class="bat-logo-placeholder" type="button" data-action="trigger-logo-upload" data-id="${viewId}" style="${previewGroupStyle(placeholderRect)}">
      <span class="bat-logo-placeholder__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 15.5V4.5M12 4.5L8 8.5M12 4.5L16 8.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.5 14.5V17.5C4.5 18.6046 5.39543 19.5 6.5 19.5H17.5C18.6046 19.5 19.5 18.6046 19.5 17.5V14.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="bat-logo-placeholder__title">Votre logo ici</span>
      <small class="bat-logo-placeholder__hint">Cliquer pour importer</small>
    </button>
  `;
}

function renderPreviewQuantityPanel() {
  ensureProjectTextileQuantities();
  const textileRows = getProjectTextilePriceRows();
  const total = getProjectTextileQuantityTotal();
  return `
    <div class="bat-preview-qty-card">
      <div class="bat-preview-qty-head">
        <strong>Quantités par textile</strong>
        <span data-preview-qty-total>${total} pc${total > 1 ? 's' : ''}</span>
      </div>
      <div class="bat-textile-quantity-list">
        ${textileRows.map((row) => `
          <label class="bat-textile-quantity-row">
            <span>
              <strong>${escapeHtml(row.label)}</strong>
              <small>${escapeHtml(row.colorLabel || 'Couleur textile')} · ${formatMoneyCents(row.costCents)} achat textile</small>
            </span>
            <input type="number" min="0" step="1" inputmode="numeric" value="${row.quantity || ''}" data-project-textile-qty="${escapeHtml(row.id)}" aria-label="Quantité ${escapeHtml(row.label)}">
          </label>
        `).join('')}
      </div>
      ${textileRows.length > 1 ? `
        <div class="bat-textile-quantity-summary">
          ${textileRows.map((row) => `
            <span>${escapeHtml(row.label)} : <strong>${row.quantity || 0}</strong></span>
          `).join('')}
        </div>
      ` : ''}
    </div>
  `;
}

function customProductPhotoControl(product, viewId) {
  const hasCustomPhoto = Boolean(getCustomProductPhoto(product, viewId, state.colorId));
  return `
    <label class="bat-photo-upload ${hasCustomPhoto ? 'has-photo' : ''}" title="${hasCustomPhoto ? 'Remplacer la photo textile' : 'Charger une photo textile'}" aria-label="${hasCustomPhoto ? 'Remplacer la photo textile' : 'Charger une photo textile'}">
      <input type="file" accept="image/png,image/jpeg,.png,.jpg,.jpeg" data-product-photo-input data-view-id="${viewId}">
      <span aria-hidden="true">${photoUploadIcon()}</span>
      <em>Changer la photo</em>
    </label>
  `;
}

function renderPreviewComposition(layers, product, viewId = state.viewId) {
  if (!layers.length) return '';
  if (state.workspaceMode === 'compose') return renderMarkingComposition(layers, product, viewId);
  const rect = getSurfacePreviewRect(product, viewId);
  const locked = state.workspaceMode === 'production';
  return `
    <div class="bat-preview-group ${locked ? 'is-locked' : ''}" ${locked ? '' : 'data-preview-group'} data-view-id="${viewId}" style="${previewGroupStyle(rect)}">
      ${layers.map((layer) => `
        <div class="bat-layer ${layer.type === 'text' ? 'bat-layer-text' : ''}" data-layer-id="${layer.id}" style="${layerStyleInPreviewGroup(layer, product, viewId)}">
          ${layerMarkup(layer)}
        </div>
      `).join('')}
      ${locked ? '' : '<span class="bat-resize-handle" data-resize-handle></span>'}
    </div>
  `;
}

function renderMarkingComposition(layers, product, viewId = state.viewId) {
  const rect = getMarkingWorkspaceRect(product, viewId);
  return `
    <div class="bat-marking-area" data-marking-area data-view-id="${viewId}" style="${previewGroupStyle(rect)}">
      ${layers.map((layer) => compositionLayerMarkup(layer, viewId, markingLayerStyle(layer, product, viewId))).join('')}
      ${selectedLayerUiMarkup(layers, product, viewId, markingSelectionUiStyle)}
    </div>
  `;
}

function assetQualityBadge(asset) {
  if (asset?.isVector) return { label: 'Vectoriel', tone: 'positive' };
  const minEdge = Math.min(Number(asset?.width) || 0, Number(asset?.height) || 0);
  if (minEdge >= 1200) return { label: 'Haute définition', tone: 'positive' };
  if (minEdge >= 600) return { label: 'Qualité correcte', tone: 'warning' };
  return { label: 'Basse définition', tone: 'negative' };
}

function renderLogoList() {
  els.logoCount.textContent = String(state.assets.length);
  if (!state.assets.length) {
    els.logoList.innerHTML = '<p class="bat-logo-empty">Aucun logo importé. Glissez vos fichiers dans la zone ci-dessus.</p>';
    return;
  }
  els.logoList.innerHTML = state.assets.map((asset) => {
    const badge = assetQualityBadge(asset);
    return `
    <div class="bat-logo-item">
      <span class="bat-logo-thumb"><img src="${asset.src}" alt=""></span>
      <div class="bat-logo-copy">
        <strong title="${escapeHtml(asset.name)}">${escapeHtml(asset.name)}</strong>
        <span>${escapeHtml(assetMetaLabel(asset))}</span>
        <em class="bat-logo-badge is-${badge.tone}">${escapeHtml(badge.label)}</em>
      </div>
      <div class="bat-logo-actions">
        <button class="bat-btn bat-btn-primary" type="button" data-action="add-asset" data-id="${asset.id}">Placer</button>
        <button class="bat-btn bat-btn-ghost" type="button" data-action="remove-asset" data-id="${asset.id}" aria-label="Supprimer ${escapeHtml(asset.name)}">Retirer</button>
      </div>
    </div>`;
  }).join('');
}

function renderInspector() {
  const layer = getSelectedLayer();
  const previewMode = isPreviewWorkspace();
  const layerLocked = state.workspaceMode === 'production';
  els.inspector.classList.toggle('is-empty', !layer);
  els.inspector.classList.toggle('is-preview-adjust', Boolean(layer && previewMode && state.workspaceMode !== 'bat'));
  els.textOnlyFields.forEach((field) => field.classList.toggle('is-hidden', layer?.type !== 'text'));
  els.imageOnlyFields.forEach((field) => field.classList.toggle('is-hidden', layer?.type === 'text'));
  if (els.layerToolsTitle) els.layerToolsTitle.textContent = layer?.type === 'text' ? 'Texte' : 'Logo';
  els.selectedLabel.textContent = layer ? layerTypeLabel(layer) : 'Aucun';
  if (layer?.type === 'text') layer.name = String(layer.text || '').trim() || 'Votre texte';
  els.layerName.value = layer?.type === 'text' ? '' : (layer?.name || '');
  els.layerText.value = layer?.type === 'text' ? layer.text : '';
  els.layerFont.value = layer?.font || 'Arial';
  els.layerColor.value = layer?.color || '#111827';
  els.layerWidth.value = layer ? round(layer.w) : '';
  els.layerHeight.value = layer ? round(layer.h) : '';
  els.layerRotation.value = layer ? layer.rotation : 0;
  els.layerWidth.disabled = layerLocked;
  els.layerHeight.disabled = layerLocked;
  els.layerRotation.disabled = layerLocked;

  // Image (logo) layers now use the same universal Taille (Largeur/Hauteur)
  // and Rotation controls as text layers. The only image-specific inline tool
  // left is the one-click background removal for raster logos.
  const isImageLayer = layer?.type === 'image';
  const asset = layer ? getAssetForLayer(layer) : null;
  els.logoTools?.classList.toggle('is-hidden', !isImageLayer);
  if (els.logoInlineBg) {
    // Background removal is a pixel operation: keep it visible for raster
    // logos and lock it while the workspace is in production mode.
    els.logoInlineBg.classList.toggle('is-hidden', !isImageLayer || Boolean(asset?.isVector));
    els.logoInlineBg.disabled = layerLocked;
  }
}

function renderQualityReport() {
  const layer = getSelectedLayer();
  if (!layer) {
    els.qualityStatus.textContent = 'En attente';
    els.qualityReport.innerHTML = '<div class="bat-quality-empty">Sélectionnez un logo pour voir sa qualité à la taille demandée.</div>';
    return;
  }

  const report = getLayerQualityReport(layer);
  const asset = getAssetForLayer(layer);
  const hasVectorizationOption = state.batConfig.options.some((option) => option.label === 'Vectorisation du logo');
  const hasPrintImprovementOption = state.batConfig.options.some((option) => option.label === "Amélioration du logo pour l'impression");
  els.qualityStatus.textContent = report.overall;
  els.qualityReport.innerHTML = `
    <div class="bat-quality-overall is-${report.tone}">
      <strong>${escapeHtml(report.overall)}</strong>
      <span>${escapeHtml(report.summary)}</span>
    </div>
    ${report.metrics.map((metric) => `
      <div class="bat-quality-row is-${metric.tone}">
        <span>${escapeHtml(metric.label)}</span>
        <strong>${escapeHtml(metric.value)}</strong>
      </div>
    `).join('')}
    ${report.recommendations?.length ? `
      <div class="bat-quality-actions">
        <strong>Recommandations</strong>
        ${report.recommendations.map((item) => `
          <div class="bat-quality-action">
            <span>${escapeHtml(item.title)}</span>
            <em>${escapeHtml(item.importance)}</em>
            <p>${escapeHtml(item.text)}</p>
          </div>
        `).join('')}
      </div>
    ` : ''}
    ${report.tone !== 'good' ? `
      <div class="bat-quality-quote-options">
        <strong>Options à proposer au devis</strong>
        <button type="button" data-action="add-quality-option" data-id="vectorization" class="${hasVectorizationOption ? 'is-added' : ''}" ${hasVectorizationOption ? 'disabled' : ''}>
          <span class="bat-quality-quote-label">Vectorisation du logo</span>
          <b>${hasVectorizationOption ? 'Ajouté' : 'Ajouter'}</b>
        </button>
        <button type="button" data-action="add-quality-option" data-id="print-improvement" class="${hasPrintImprovementOption ? 'is-added' : ''}" ${hasPrintImprovementOption ? 'disabled' : ''}>
          <span class="bat-quality-quote-label">Amélioration du logo pour l'impression</span>
          <b>${hasPrintImprovementOption ? 'Ajouté' : 'Ajouter'}</b>
        </button>
      </div>
    ` : ''}
  `;
}

function batOptionsMarkup(pricing) {
  const hasOptions = pricing.options.length > 0;
  return `
    <div class="bat-options-card bat-options-selected-card">
      <div class="bat-options-custom-head">
        <div>
          <strong>Options sélectionnées</strong>
          <span>Options ajoutées depuis les recommandations ou créées librement</span>
        </div>
      </div>
      ${hasOptions ? `
        <div class="bat-option-list">
          ${pricing.options.map((option) => `
            <div class="bat-option-row" data-option-id="${option.id}">
              <input class="bat-input" type="text" value="${escapeHtml(option.label)}" data-option-label aria-label="Nom de l'option">
              <span class="bat-option-price-cell">
                <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(option.amountCents)}" data-option-price aria-label="Tarif de l'option">
                <em>€</em>
              </span>
              <select class="bat-input bat-option-mode" data-option-pricing-mode aria-label="Type de coût de l'option">
                <option value="unit" ${option.pricingMode === 'unit' ? 'selected' : ''}>/ unité</option>
                <option value="global" ${option.pricingMode === 'global' ? 'selected' : ''}>global</option>
              </select>
              <button class="bat-option-remove" type="button" data-action="remove-bat-option" data-id="${option.id}" aria-label="Supprimer l'option">×</button>
            </div>
          `).join('')}
        </div>
      ` : `
        <p class="bat-options-custom-empty">Aucune option sélectionnée pour le moment.</p>
      `}
    </div>
    <div class="bat-options-card bat-options-custom-card">
      <div class="bat-options-custom-head">
        <div>
          <strong>Ajouter une option personnalisée</strong>
          <span>Créez un frais libre (nom, montant, /unité ou global)</span>
        </div>
        <button class="bat-btn bat-btn-primary bat-option-add-cta" type="button" data-action="add-bat-option">
          Ajouter une option
        </button>
      </div>
    </div>
  `;
}

function pricingCardMarkup(pricing) {
  const config = getBatConfig(getProduct());
  const profitability = getProfitabilityBreakdown(pricing);
  const marginTone = orderMarginTone(profitability.grossMarginRate, profitability.grossMarginCents);
  const salePriceMode = pricing.settings.salePriceMode === 'margin' ? 'margin' : 'amount';
  const isManualPrice = salePriceMode === 'amount';
  const suggestedUnitCents = pricing.targetMarginUnitCents ?? pricing.totalCents;
  const textileRows = pricing.textile?.rows || getProjectTextilePriceRows(pricing.level);
  const textileBreakdown = textilePriceBreakdownMarkup(textileRows, {
    totalCents: pricing.textile.costCents,
    title: 'Textiles du projet',
    note: 'Somme textile utilisée dans le calcul du prix pour une unité projet.',
  });
  return `
    <div class="bat-price-card bat-price-card-quote bat-price-card-minimal">
      <div class="bat-price-simple-grid">
      <div class="bat-quote-section bat-quote-section-flat">
        <div class="bat-quote-section-head">
          <strong>Dossier</strong>
        </div>
        <div class="bat-quote-meta-grid">
          <label class="bat-config-field">
            <span>Numéro de dossier</span>
            <input class="bat-input" type="text" value="${escapeHtml(config.orderReference)}" data-production-field="orderReference" aria-label="Numéro de dossier">
          </label>
          <label class="bat-config-field">
            <span>Nom client</span>
            <input class="bat-input" type="text" value="${escapeHtml(config.clientName)}" data-production-field="clientName" aria-label="Nom client">
          </label>
          <label class="bat-config-field">
            <span>Délai de fabrication</span>
            <input class="bat-input" type="text" value="${escapeHtml(config.leadTime)}" data-bat-field="leadTime" aria-label="Délai de fabrication" placeholder="Ex : 3 semaines, 10 jours ouvrés...">
          </label>
        </div>
      </div>

      <div class="bat-quote-section bat-quote-section-flat">
        <div class="bat-quote-section-head">
          <strong>Calcul du prix</strong>
        </div>
        ${textileBreakdown}
        <div class="bat-quote-calc-grid">
          <label class="bat-price-control">
            <span>Marge cible</span>
            <div class="bat-price-edit">
              <input class="bat-price-input" type="number" min="0" max="95" step="1" inputmode="decimal" value="${formatPercentInput(pricing.settings.targetGrossMarginPercent)}" data-pricing-setting="targetGrossMarginPercent" aria-label="Taux de marge brute cible">
              <em>%</em>
            </div>
          </label>
          <div class="bat-price-insight">
            <span>Prix unitaire suggéré</span>
            <strong>${formatMoneyCents(suggestedUnitCents)} HT</strong>
            <button type="button" data-action="use-suggested-unit-price">Modifier</button>
          </div>
        </div>
        ${isManualPrice ? `
        <label class="bat-price-control">
          <span>Prix unitaire saisi</span>
          <div class="bat-price-edit">
            <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(pricing.totalCents)}" data-price-override="total" aria-label="Prix de vente unitaire">
            <em>€ HT / unité</em>
          </div>
        </label>
        ` : ''}
      </div>

      <div class="bat-quote-section bat-quote-section-flat">
        <div class="bat-quote-section-head">
          <strong>Frais et options</strong>
        </div>
        <div class="bat-quote-fees-grid">
          <label class="bat-price-control" title="Coût global ajouté au budget HT.">
            <span>Livraison</span>
            <div class="bat-price-edit">
              <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(pricing.shipping.finalCents)}" data-bat-field="shippingCents" aria-label="Frais de livraison HT">
              <em>€ HT global</em>
            </div>
          </label>
          <label class="bat-price-toggle bat-urgent-toggle" title="Ajoute un surcoût global pour une commande urgente.">
            <input type="checkbox" ${pricing.settings.useUrgentOrder ? 'checked' : ''} data-pricing-setting="useUrgentOrder">
            <span>
              <strong>Commande urgente</strong>
              <em>${formatMoneyCents(pricing.urgentOrder.totalCents)}</em>
            </span>
          </label>
        </div>
        ${pricing.settings.useUrgentOrder ? `
          <div class="bat-price-row" title="Surcoût calculé par défaut à +30% du total, modifiable.">
            <span>Surcoût urgence</span>
            <span class="bat-price-edit">
              <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(pricing.urgentOrder.totalCents)}" data-pricing-setting="urgentOrderCents" aria-label="Surcoût urgence global">
              <em>€ HT global</em>
            </span>
            <small>Calculé à +30% par défaut, modifiable.</small>
          </div>
        ` : ''}
        ${batOptionsMarkup(pricing)}
      </div>
      </div>

      <div class="bat-margin-badge is-${marginTone}">
        <span>Marge brute estimée</span>
        <strong>${formatProfitRate(profitability.grossMarginRate)}</strong>
        <em>${formatMoneyCents(profitability.grossMarginCents)} HT · ${formatMoneyCents(profitability.grossMarginPerPieceCents)} / pièce</em>
      </div>

      <div class="bat-quote-total-row">
        <div class="bat-budget-card bat-budget-card-total" title="${escapeHtml(pricing.quantityTotal ? budgetDetailLabel(pricing) : 'Renseignez les quantités pour calculer le budget global.')}">
          <span>Prix total HT</span>
          <strong>${formatMoneyCents(pricing.globalTotalCents)}</strong>
          <small>${pricing.quantityTotal ? `${formatMoneyCents(pricing.totalCents)} / unité x ${pricing.quantityTotal}` : 'Quantité à renseigner'}</small>
        </div>
        <button class="bat-btn bat-btn-primary bat-production-export" type="button" data-action="export-pdf">Télécharger le BAT</button>
      </div>
    </div>
  `;
}

// Sale-price calculation switches (which cost components feed the sale price and
// the default margin). These map to `pricingSettings` and were previously only
// reachable from the admin panel; they are surfaced here so the "Tarifs & marges"
// step exposes every field consumed by getPricingBreakdown.
function pricingSettingsCardMarkup(pricing) {
  const s = pricing.settings;
  return `
    <div class="bat-order-card bat-pricing-settings-card">
      <div class="bat-order-card-head">
        <strong>Réglages de calcul du prix</strong>
        <span>Composants inclus dans le prix de vente et marge par défaut</span>
      </div>
      <label class="bat-price-toggle">
        <input type="checkbox" ${s.usePrint ? 'checked' : ''} data-pricing-setting="usePrint">
        <span><strong>Inclure l'impression / transfert</strong></span>
      </label>
      <label class="bat-price-toggle">
        <input type="checkbox" ${s.usePose ? 'checked' : ''} data-pricing-setting="usePose">
        <span><strong>Inclure la pose</strong></span>
      </label>
      ${s.usePose ? `
        <label class="bat-price-setting-row">
          <span>Coût de pose / zone</span>
          <span class="bat-price-edit">
            <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(s.poseCentsPerZone)}" data-pricing-setting="poseCentsPerZone" aria-label="Coût de pose par zone">
            <em>€</em>
          </span>
        </label>
      ` : ''}
      <label class="bat-price-toggle">
        <input type="checkbox" ${s.useMargin ? 'checked' : ''} data-pricing-setting="useMargin">
        <span><strong>Appliquer une marge par défaut</strong></span>
      </label>
      ${s.useMargin ? `
        <label class="bat-price-setting-row">
          <span>Marge par défaut</span>
          <span class="bat-price-edit">
            <input class="bat-price-input" type="number" min="0" max="500" step="1" inputmode="decimal" value="${formatPercentInput(s.marginPercent)}" data-pricing-setting="marginPercent" aria-label="Marge par défaut">
            <em>%</em>
          </span>
        </label>
      ` : ''}
    </div>
  `;
}

// Header Total HT / Marge pill + eye were removed from the topbar.
// Keep a cleanup pass so cached theme HTML cannot reinject them.
function updateHeaderPriceIndicator() {
  document.querySelectorAll('.bat-actions .bat-header-price, .bat-actions .bat-price-eye-header, .bat-actions [data-header-price], .bat-actions [data-price-eye]').forEach((node) => {
    node.remove();
  });
  els.headerPrice = null;
  els.headerPriceTotal = null;
  els.headerPriceLabel = null;
  els.headerMargin = null;
  els.headerMarginValue = null;
  els.priceEye = null;
}

function renderSummary() {
  const activeInput = captureActiveInput();
  const product = getProduct();
  const rows = getProjectLayerRows();
  const pricing = getPricingBreakdown(rows);
  const config = getBatConfig(product);
  els.batStatus.textContent = pricing.quantityTotal ? formatMoneyCents(pricing.globalTotalCents) : formatMoneyCents(pricing.totalCents);
  updateHeaderPriceIndicator(pricing);
  const configMarkup = `
    <div class="bat-config-card">
      <div class="bat-config-field">
        <span>N° dossier</span>
        <input class="bat-input" type="text" value="${escapeHtml(config.orderReference)}" data-production-field="orderReference" aria-label="N° dossier ou commande">
      </div>
      <div class="bat-config-field">
        <span>Nom client</span>
        <input class="bat-input" type="text" value="${escapeHtml(config.clientName)}" data-production-field="clientName" aria-label="Nom client">
      </div>
      <div class="bat-config-field">
        <span>Référence textile</span>
        <input class="bat-input" type="text" value="${escapeHtml(config.textileReference)}" data-bat-field="textileReference" aria-label="Référence textile">
      </div>
      <div class="bat-config-field">
        <span>Délai de fabrication</span>
        <input class="bat-input" type="text" value="${escapeHtml(config.leadTime)}" data-bat-field="leadTime" aria-label="Délai de fabrication" placeholder="Ex : 3 semaines, 10 jours ouvrés...">
      </div>
    </div>
  `;
  const pricingMarkup = `${pricingCardMarkup(pricing)}${pricingSettingsCardMarkup(pricing)}`;
  if (els.pricingStatus) {
    els.pricingStatus.textContent = pricing.quantityTotal
      ? formatMoneyCents(pricing.globalTotalCents)
      : 'À préparer';
  }
  if (els.pricingControls) {
    els.pricingControls.innerHTML = pricingMarkup;
  }
  const batDownloadMarkup = `
    <button class="bat-btn bat-btn-primary bat-production-export" type="button" data-action="export-pdf">
      Télécharger le BAT
    </button>
  `;
  if (!rows.length) {
    els.summary.innerHTML = `${configMarkup}${batDownloadMarkup}`;
    renderProductionOrder({ product, rows, pricing, config });
    renderProfitability({ pricing });
    restoreActiveInput(activeInput);
    return;
  }

  const layerMarkupRows = rows.map(({ layer }) => `
    <div class="bat-summary-row">
      <strong>${escapeHtml(layer.name)}</strong>
      <span>${formatCm(layer.w)} x ${formatCm(layer.h)} cm</span>
    </div>
  `).join('');
  els.summary.innerHTML = `${configMarkup}${layerMarkupRows}${batDownloadMarkup}`;
  renderProductionOrder({ product, rows, pricing, config });
  renderProfitability({ pricing });
  restoreActiveInput(activeInput);
}

function renderProductionOrder({ product, rows, pricing, config }) {
  if (!els.productionSummary && !els.productionDossier && !els.productionNotes) return;
  const production = getProductionConfig(product, config);
  const quantityTotal = pricing.quantityTotal;
  const productionRows = getProjectProductionRows();
  if (els.productionStatus) {
    els.productionStatus.textContent = quantityTotal ? `${quantityTotal} pièce${quantityTotal > 1 ? 's' : ''}` : 'À préparer';
  }

  if (els.productionDossier) {
    els.productionDossier.innerHTML = productionDossierMarkup(production);
  }
  if (els.productionNotes) {
    els.productionNotes.innerHTML = productionNotesMarkup(production);
  }
  if (!els.productionSummary) return;
  const quantityMode = normalizeQuantityMode(state.quantityMode);
  els.productionSummary.innerHTML = `
    <div class="bat-production-card">
      <div class="bat-production-title">${quantityMode === 'sizes' ? 'Quantités par taille' : 'Quantité totale'}</div>
      <div class="bat-production-total">
        <span>Total</span>
        <strong>${quantityTotal || 0} pièce${quantityTotal > 1 ? 's' : ''}</strong>
      </div>
      ${quantityMode === 'sizes' ? `
        <div class="bat-production-size-grid">
          ${SIZE_OPTIONS.map((size) => {
            const quantity = Number(state.sizeQuantities[size]) || 0;
            return `<span class="${quantity ? 'is-filled' : ''}"><strong>${size}</strong><em>${quantity}</em></span>`;
          }).join('')}
        </div>
      ` : `
        <div class="bat-production-size-grid bat-production-size-grid-total">
          <span class="${quantityTotal ? 'is-filled' : ''}"><strong>Total</strong><em>${quantityTotal || 0}</em></span>
        </div>
      `}
    </div>

    <div class="bat-production-card">
      <div class="bat-production-title">Zones et fichiers</div>
      <div class="bat-production-zone-list">
        ${productionRows.map((textile) => `
          <div class="bat-production-zone bat-production-zone-textile">
            <div>
              <strong>${escapeHtml(textile.label)}</strong>
              <span>${textile.zones.length} zone${textile.zones.length > 1 ? 's' : ''} prévue${textile.zones.length > 1 ? 's' : ''}</span>
            </div>
            ${textile.zones.map((zone) => `
              <p><strong>${escapeHtml(zone.label)}</strong> · zone utile ${escapeHtml(zone.size)}</p>
              ${zone.layers.length ? zone.layers.map((layer) => `
                <p>${escapeHtml(layer.name)} · ${formatCm(layer.w)} x ${formatCm(layer.h)} cm${layer.rotation ? ` · rotation ${formatCm(layer.rotation)}°` : ''}</p>
              `).join('') : '<p>Aucun marquage prévu</p>'}
            `).join('')}
          </div>
        `).join('')}
      </div>
    </div>

    <button class="bat-btn bat-btn-primary bat-production-export" type="button" data-action="export-production-order">
      ${escapeHtml(getProductionDownloadLabel())}
    </button>
  `;
}

function profitabilityPriceSideSummaryMarkup(profitability, pricing, marginTone) {
  return `
    <div class="bat-profitability-card bat-profitability-side-summary">
      <div class="bat-production-title">Synthèse</div>
      <div class="bat-profitability-side-kpis">
        <div><span>Quantité</span><strong>${profitability.realQuantity || 0} pièces</strong></div>
        <div><span>Prix de vente</span><strong>${formatMoneyCents(profitability.saleTotalCents)}</strong></div>
        <div><span>Coûts</span><strong>${formatMoneyCents(profitability.costTotalCents)}</strong></div>
        <div class="is-${marginTone}"><span>Marge brute</span><strong>${formatProfitRate(profitability.grossMarginRate)}</strong></div>
      </div>
    </div>
    <button class="bat-btn bat-btn-primary bat-production-export" type="button" data-action="export-profitability">
      Télécharger la rentabilité
    </button>
  `;
}

// --- "Tarifs & marges" guided assistant (5 steps) ------------------------
// A single centered wizard mounted in the stage. Each step reuses the existing
// markup/handlers so no new calculation engine is introduced.
const PROFITABILITY_STEP_COPY = {
  quantity: {
    title: 'Quantités par textile',
    subtitle: 'Indiquez combien de pièces vous produisez pour chaque textile du projet.',
  },
  price: {
    title: 'Prix de vente',
    subtitle: 'Coûts pré-remplis et marge de 30 % appliquée. Ajustez librement chaque ligne.',
  },
  options: {
    title: 'Options & livraison',
    subtitle: 'Options facturées au client et frais de livraison refacturés. Certaines options sont recommandées selon la qualité des logos.',
  },
  costs: {
    title: 'Coûts internes',
    subtitle: 'Vos coûts réels : livraison payée, préparation de dossier, autres coûts et supplément urgence.',
  },
  quote: {
    title: 'Devis client',
    subtitle: 'Vérifiez et ajustez le devis, puis exportez-le en PDF.',
  },
  production: {
    title: 'Instructions de production',
    subtitle: 'Ajoutez les consignes atelier pour la fabrication des produits. Elles apparaissent sur le PDF de production.',
  },
};

function profitabilityStepTitle(stepId) {
  return PROFITABILITY_STEP_COPY[stepId]?.title || '';
}

function profitabilityStepSubtitle(stepId) {
  return PROFITABILITY_STEP_COPY[stepId]?.subtitle || '';
}

function canAdvanceProfitabilityStep(stepId, order) {
  if (stepId === 'quantity') return (order?.quantityTotal || 0) > 0;
  return true;
}

function profitabilityStepHint(stepId, order) {
  if (stepId === 'quantity' && !(order?.quantityTotal > 0)) return 'Renseignez au moins une quantité pour continuer.';
  return '';
}

function profitabilityAssistantMarkup(order, pricing, profitability, tone) {
  const activeStep = normalizeProfitabilityStep(state.profitabilityStep);
  const activeIndex = getProfitabilityStepIndex(activeStep);
  const isFirst = activeIndex === 0;
  const isLast = activeIndex === PROFITABILITY_STEPS.length - 1;
  const canAdvance = canAdvanceProfitabilityStep(activeStep, order);
  const hint = profitabilityStepHint(activeStep, order);
  return `
    <div class="bat-assistant ${state.priceHidden ? 'is-price-hidden' : ''}">
      <ol class="bat-assistant-steps">
        ${PROFITABILITY_STEPS.map((step, index) => {
          const done = index < activeIndex;
          const current = index === activeIndex;
          return `
            <li class="bat-assistant-step ${current ? 'is-active' : ''} ${done ? 'is-done' : ''}">
              <button type="button" data-action="select-profitability-step" data-id="${step.id}">
                <span class="bat-assistant-step-index">${done ? '✓' : index + 1}</span>
                <span class="bat-assistant-step-label">${escapeHtml(step.label)}</span>
              </button>
            </li>
          `;
        }).join('')}
      </ol>
      <section class="bat-assistant-card">
        <header class="bat-assistant-head">
          <span class="bat-assistant-progress">Étape ${activeIndex + 1} sur ${PROFITABILITY_STEPS.length}</span>
          <strong>${escapeHtml(profitabilityStepTitle(activeStep))}</strong>
          <p>${escapeHtml(profitabilityStepSubtitle(activeStep))}</p>
        </header>
        <div class="bat-assistant-body">
          ${profitabilityStepBodyMarkup(activeStep, order, pricing, profitability, tone)}
        </div>
        <footer class="bat-assistant-nav">
          <button class="bat-btn" type="button" data-action="profitability-prev" ${isFirst ? 'disabled' : ''}>Retour</button>
          <span class="bat-assistant-hint">${escapeHtml(hint)}</span>
          ${isLast
            ? '<span class="bat-assistant-nav-actions"><button class="bat-btn" type="button" data-action="export-profitability">Fiche marges (interne)</button><button class="bat-btn bat-btn-primary" type="button" data-action="export-quote-bat">Télécharger devis + BAT</button></span>'
            : `<button class="bat-btn bat-btn-primary" type="button" data-action="profitability-next" ${canAdvance ? '' : 'disabled'}>Continuer</button>`}
        </footer>
      </section>
    </div>
  `;
}

function profitabilityStepBodyMarkup(stepId, order, pricing, profitability, tone) {
  if (stepId === 'quantity') return profitabilityQuantityStepMarkup();
  if (stepId === 'price') return profitabilityPriceStepMarkup(order, tone);
  if (stepId === 'options') return profitabilityOptionsStepMarkup(order, pricing);
  if (stepId === 'costs') return profitabilityCostsStepMarkup(order);
  if (stepId === 'quote') return profitabilityQuoteStepMarkup(order, pricing, tone);
  if (stepId === 'production') return profitabilityProductionStepMarkup();
  return profitabilityQuoteStepMarkup(order, pricing, tone);
}

function profitabilityProductionStepMarkup() {
  const production = getProductionConfig();
  return `
    <div class="bat-order-card bat-production-instructions-card">
      <div class="bat-order-card-head">
        <strong>Instructions de production</strong>
        <span>Champ libre repris sur l'ordre de fabrication</span>
      </div>
      <label class="bat-config-field">
        <span>Consignes pour l'atelier</span>
        <textarea class="bat-textarea bat-production-instructions-input" rows="10" data-production-field="fabricationInstructions" aria-label="Instructions de production">${escapeHtml(production.fabricationInstructions || '')}</textarea>
      </label>
    </div>
  `;
}

function profitabilityQuantityStepMarkup() {
  return `
    ${renderPreviewQuantityPanel()}
    <div class="bat-assistant-actions">
      <button class="bat-btn" type="button" data-action="add-project-textile">+ Ajouter un textile</button>
    </div>
  `;
}

// Global order-margin recap (moved to the Devis step). `withToggle` controls
// whether the HT/TTC switch is rendered inside the block.
function orderMarginHeroMarkup(order, tone, { withToggle = true } = {}) {
  const qtyLabel = `${order.quantityTotal} pièce${order.quantityTotal > 1 ? 's' : ''}`;
  return `
    <div class="bat-order-hero is-${tone}">
      <div class="bat-order-hero-main">
        <span>Marge globale de commande</span>
        <strong>${formatProfitRate(order.marginRate)}</strong>
        <em>${escapeHtml(qtyLabel)}</em>
        ${withToggle ? priceDisplayToggleMarkup() : ''}
      </div>
      <div class="bat-order-hero-side">
        <div><span>Ventes ${salePriceSuffix()}</span><b>${formatSaleMoneyCents(order.saleTotalCents)}</b></div>
        <div><span>Coûts HT</span><b>${formatMoneyCents(order.costTotalCents)}</b></div>
        <div class="bat-order-hero-margin"><span>Marge HT</span><b>${formatMoneyCents(order.marginCents)}</b></div>
        <div class="bat-order-hero-margin"><span>Marge / pièce</span><b>${formatMoneyCents(order.marginPerPieceCents)}</b></div>
      </div>
    </div>
  `;
}

function profitabilityPriceStepMarkup(order, tone) {
  const settingsOpen = Boolean(state.priceSettingsOpen);
  return `
    <div class="bat-order-pricing">
      <div class="bat-order-card">
        <div class="bat-order-card-head">
          <strong>Prix de vente par textile</strong>
          <span>Coûts pré-remplis et éditables · marge cible par ligne</span>
        </div>
        ${orderTextileTableMarkup(order)}
      </div>
      ${settingsOpen ? pricingSettingsCardMarkup(getPricingBreakdown()) : ''}
    </div>
  `;
}

function profitabilityOptionsStepMarkup(order, pricing) {
  const qualityRecos = getProjectQualityOptionRecommendations();
  return `
    ${profitabilityDeliveryChargeCardMarkup(order)}
    <div class="bat-options-category">
      <div class="bat-options-category-head">
        <strong>Options récurrentes</strong>
        <span>Frais récurrents et suppléments fréquemment facturés</span>
      </div>
      ${profitabilityRecommendedOptionsMarkup(order)}
    </div>
    ${qualityRecos.length ? `
      <div class="bat-options-category">
        <div class="bat-options-category-head">
          <strong>Options graphiques recommandées</strong>
          <span>Basées sur l'analyse qualité des logos du projet</span>
        </div>
        ${profitabilityQualityRecommendationsMarkup(qualityRecos)}
      </div>
    ` : ''}
    ${batOptionsMarkup(pricing)}
  `;
}

// One-click "recommended options" the user often bills on top of a quote.
// Amounts are stored in cents; pricingMode drives global (one-off) vs unit
// (multiplied by the total quantity) exactly like manual options. Amounts are
// read from the editable profitability defaults (see Paramètres).
function getRecommendedQuoteOptionTemplates() {
  const config = normalizeProfitabilityConfig(state.profitabilityConfig);
  return [
    { id: 'broderie-program', label: 'Frais de programme de broderie', cents: config.embroideryProgramCents, pricingMode: 'global' },
    { id: 'frais-techniques', label: 'Frais techniques', cents: config.technicalFeeCents, pricingMode: 'global' },
    { id: 'pliage-unitaire', label: 'Pliage unitaire', cents: config.foldingUnitCents, pricingMode: 'unit' },
    { id: 'emballages-individuels', label: 'Emballages individuels', cents: config.individualPackagingCents, pricingMode: 'unit' },
    { id: 'retrait-etiquette', label: 'Retrait étiquette', cents: config.labelRemovalCents, pricingMode: 'unit' },
  ];
}

function getRecommendedQuoteOptions() {
  return getRecommendedQuoteOptionTemplates().map((template) => ({
    ...template,
    added: state.batConfig.options.some((option) => option.label === template.label),
  }));
}

function profitabilityRecommendedOptionsMarkup(order) {
  const recos = getRecommendedQuoteOptions();
  const rushEnabled = Boolean(order?.rushEnabled);
  const rushCents = Number(order?.rushCents) || 0;
  return `
    <div class="bat-options-card bat-quality-reco-card">
      <div class="bat-quality-reco-list">
        <div class="bat-quality-reco ${rushEnabled ? 'is-added' : ''}">
          <div class="bat-quality-reco-copy">
            <strong>Supplément urgence</strong>
            <small>${rushEnabled ? `${formatMoneyCents(rushCents)} · ` : ''}+30% · facturé au client</small>
          </div>
          <button class="bat-btn ${rushEnabled ? '' : 'bat-btn-primary'}" type="button" data-action="toggle-rush-option">
            ${rushEnabled ? 'Retirer' : 'Ajouter'}
          </button>
        </div>
        ${rushEnabled ? `
          <label class="bat-price-setting-row bat-rush-amount-row">
            <span>Surcoût urgence</span>
            <span class="bat-price-edit">
              <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(rushCents)}" data-pricing-setting="urgentOrderCents" aria-label="Surcoût urgence">
              <em>€</em>
            </span>
          </label>
        ` : ''}
        ${recos.map((reco) => `
          <div class="bat-quality-reco ${reco.added ? 'is-added' : ''}">
            <div class="bat-quality-reco-copy">
              <strong>${escapeHtml(reco.label)}</strong>
              <small>${formatMoneyCents(reco.cents)}${reco.pricingMode === 'global' ? ' · forfait global' : ' / unité'}</small>
            </div>
            <button class="bat-btn ${reco.added ? '' : 'bat-btn-primary'}" type="button" data-action="add-recommended-option" data-id="${reco.id}">${reco.added ? 'Retirer' : 'Ajouter'}</button>
          </div>
        `).join('')}
      </div>
    </div>
  `;
}

// Client-billed delivery / workshop pickup, with a mode toggle first.
function profitabilityDeliveryChargeCardMarkup(order) {
  const pickup = Boolean(order.pickupInStore);
  return `
    <div class="bat-order-card bat-order-costs-card bat-delivery-option-card">
      <div class="bat-order-card-head">
        <strong>Livraison / retrait atelier</strong>
        <span>Choisissez le mode, puis le montant facturé</span>
      </div>
      <div class="bat-delivery-mode-switch" role="group" aria-label="Mode de livraison">
        <button type="button" class="bat-delivery-mode ${pickup ? '' : 'is-active'}" data-action="set-pickup-mode" data-id="delivery" aria-pressed="${pickup ? 'false' : 'true'}">
          <strong>Livraison</strong>
          <small>Refacturée sur le devis</small>
        </button>
        <button type="button" class="bat-delivery-mode ${pickup ? 'is-active' : ''}" data-action="set-pickup-mode" data-id="pickup" aria-pressed="${pickup ? 'true' : 'false'}">
          <strong>Retrait atelier</strong>
          <small>Pas de livraison</small>
        </button>
      </div>
      ${pickup ? `
        <p class="bat-delivery-mode-note">Retrait sur place : aucun frais de livraison n’est facturé au client.</p>
      ` : `
        <div class="bat-order-cost-fields">
          ${profitabilityMoneyField('Livraison facturée', 'deliverySaleCents', order.deliverySaleCents, 'global')}
        </div>
      `}
    </div>
  `;
}

// Internal cost side: delivery actually paid, file prep, other costs, rush.
function profitabilityCostsStepMarkup(order) {
  return `
    ${orderGlobalCostsCardMarkup(order)}
  `;
}

// Aggregate the quality report of every image logo in the project and surface the
// billable options that address the detected issues, addable in one click.
function getProjectQualityOptionRecommendations() {
  const templates = {
    vectorization: { label: 'Vectorisation du logo', cents: 5000 },
    'print-improvement': { label: "Amélioration du logo pour l'impression", cents: 5000 },
  };
  const reasons = { vectorization: new Set(), 'print-improvement': new Set() };
  getProjectLayerRows().forEach(({ layer }) => {
    if (!layer || layer.type !== 'image') return;
    const report = getLayerQualityReport(layer);
    if (!report || report.tone === 'good') return;
    (report.recommendations || []).forEach((rec) => {
      const optionId = mapQualityRecommendationToOption(rec.title);
      if (optionId) reasons[optionId].add(rec.title);
    });
  });
  return Object.keys(templates)
    .filter((id) => reasons[id].size)
    .map((id) => ({
      id,
      label: templates[id].label,
      cents: templates[id].cents,
      reason: Array.from(reasons[id]).join(' · '),
      added: state.batConfig.options.some((option) => option.label === templates[id].label),
    }));
}

function mapQualityRecommendationToOption(title) {
  const t = String(title || '').toLowerCase();
  if (t.includes('vector') || t.includes('redessin')) return 'vectorization';
  if (t.includes('fond') || t.includes('semi') || t.includes('espaces') || t.includes('zones fines') || t.includes('épaissir') || t.includes('remplacer')) {
    return 'print-improvement';
  }
  return null;
}

function profitabilityQualityRecommendationsMarkup(recos = getProjectQualityOptionRecommendations()) {
  if (!recos.length) return '';
  return `
    <div class="bat-options-card bat-quality-reco-card">
      <div class="bat-quality-reco-list">
        ${recos.map((reco) => `
          <div class="bat-quality-reco ${reco.added ? 'is-added' : ''}">
            <div class="bat-quality-reco-copy">
              <strong>${escapeHtml(reco.label)}</strong>
              <small>${escapeHtml(reco.reason)}</small>
            </div>
            <button class="bat-btn ${reco.added ? '' : 'bat-btn-primary'}" type="button" data-action="add-quality-option" data-id="${reco.id}">${reco.added ? 'Retirer' : 'Ajouter'}</button>
          </div>
        `).join('')}
      </div>
    </div>
  `;
}

function normalizeSimplifiedUnitPriceMode(value, legacyIncludeOptions = false) {
  const raw = String(value || '').trim().toLowerCase();
  if (SIMPLIFIED_UNIT_PRICE_MODES.includes(raw)) return raw;
  // Backward-compat: older drafts stored a boolean "include unit options".
  if (value === true || legacyIncludeOptions) return 'partial';
  return 'off';
}

function getSimplifiedUnitPriceExtras(pricing, order, mode = 'off') {
  const quantityTotal = Math.max(1, Number(order?.quantityTotal) || 0);
  const unitOptions = (pricing?.options || []).filter((option) => option.pricingMode === 'unit');
  const globalOptions = (pricing?.options || []).filter((option) => option.pricingMode === 'global');
  const unitOptionsPerPieceCents = unitOptions.reduce((total, option) => total + (option.unitCents || 0), 0);
  const globalOptionsTotalCents = globalOptions.reduce((total, option) => total + (option.globalCents || 0), 0);
  const deliveryHtCents = order?.pickupInStore ? 0 : (Number(order?.deliverySaleCents) || 0);
  const globalPerPieceCents = Math.round(globalOptionsTotalCents / quantityTotal);
  const deliveryPerPieceCents = Math.round(deliveryHtCents / quantityTotal);
  if (mode === 'partial') {
    return {
      perPieceCents: unitOptionsPerPieceCents,
      unitOptionsPerPieceCents,
      globalPerPieceCents: 0,
      deliveryPerPieceCents: 0,
      labels: unitOptions.map((option) => option.label).filter(Boolean),
    };
  }
  if (mode === 'total' || mode === 'totalExDelivery') {
    const includeDelivery = mode === 'total';
    const labels = [
      ...unitOptions.map((option) => option.label),
      ...globalOptions.map((option) => option.label),
      ...(includeDelivery && deliveryHtCents > 0 ? ['port'] : []),
    ].filter(Boolean);
    return {
      perPieceCents: unitOptionsPerPieceCents + globalPerPieceCents + (includeDelivery ? deliveryPerPieceCents : 0),
      unitOptionsPerPieceCents,
      globalPerPieceCents,
      deliveryPerPieceCents: includeDelivery ? deliveryPerPieceCents : 0,
      labels,
    };
  }
  return {
    perPieceCents: 0,
    unitOptionsPerPieceCents,
    globalPerPieceCents: 0,
    deliveryPerPieceCents: 0,
    labels: [],
  };
}

function textileMarkingDesignationParts(row) {
  return (Array.isArray(row?.markingLines) ? row.markingLines : []).map((line) => {
    const name = String(line.name || (line.type === 'text' ? 'Texte' : 'Logo')).trim() || 'Marquage';
    const technique = String(line.technique || '').trim();
    return technique ? `${name} (${technique})` : name;
  });
}

function buildTextileDesignationDetail(row, quote = {}) {
  const color = String(row?.colorLabel || 'Textile').trim() || 'Textile';
  const markingParts = textileMarkingDesignationParts(row);
  let detail = markingParts.length ? `${color} · ${markingParts.join(', ')}` : color;
  const mode = quote?.simplifiedUnitPriceMode || 'off';
  if (mode === 'off' || !quote?.simplifiedExtras?.perPieceCents) return detail;
  const included = (quote.simplifiedExtras.labels || []).join(', ');
  if (mode === 'partial') {
    return included
      ? `${detail} · compris : ${included}`
      : `${detail} · options unitaires comprises`;
  }
  return included
    ? `${detail} · compris : ${included}`
    : `${detail} · options et port compris`;
}

function simplifiedUnitPriceDesignation(quote, colorLabel = '') {
  return buildTextileDesignationDetail({ colorLabel, markingLines: [] }, quote);
}

// Coherent client-quote figures derived from the same per-textile order engine
// the user edits in step 3, plus options / delivery / urgency.
function getQuoteBreakdown(order = getOrderPricingBreakdown(), pricing = getPricingBreakdown()) {
  const settings = normalizePricingSettings(pricing.settings || state.pricingSettings);
  const simplifiedUnitPriceMode = normalizeSimplifiedUnitPriceMode(
    settings.simplifiedUnitPriceMode,
    settings.includeOptionsInUnitPrice,
  );
  const quantityTotal = order.quantityTotal;
  const extras = getSimplifiedUnitPriceExtras(pricing, order, simplifiedUnitPriceMode);
  const unitOptionsPerPieceCents = extras.unitOptionsPerPieceCents;
  const quoteMeta = { simplifiedUnitPriceMode, simplifiedExtras: extras };
  const textileRows = order.rows.map((row) => {
    if (!extras.perPieceCents) {
      return { ...row, designationDetail: buildTextileDesignationDetail(row, quoteMeta) };
    }
    const saleCents = (row.saleCents || 0) + extras.perPieceCents;
    return {
      ...row,
      saleCents,
      saleTotalCents: saleCents * (row.quantity || 0),
      baseSaleCents: row.saleCents,
      optionsIncludedInUnitPrice: extras.perPieceCents,
      designationDetail: buildTextileDesignationDetail(row, quoteMeta),
    };
  });
  const textileHtCents = extras.perPieceCents
    ? textileRows.reduce((total, row) => total + (row.saleTotalCents || 0), 0)
    : order.textileSaleTotalCents;
  const optionRows = pricing.options
    .filter((option) => {
      if (simplifiedUnitPriceMode === 'partial' && option.pricingMode === 'unit') return false;
      if (simplifiedUnitPriceMode === 'total' || simplifiedUnitPriceMode === 'totalExDelivery') return false;
      return true;
    })
    .map((option) => ({
      id: option.id,
      label: option.label,
      pricingMode: option.pricingMode,
      quantity: option.pricingMode === 'global' ? 1 : quantityTotal,
      unitCents: option.pricingMode === 'global' ? option.globalCents : option.unitCents,
      totalCents: option.totalCents,
    }));
  const optionsHtCents = optionRows.reduce((total, row) => total + row.totalCents, 0);
  // Delivery + urgency come from the same order engine used in step 3 so the
  // quote total stays consistent with the margin figures shown earlier. The
  // client is billed the *charged* delivery (0 for in-store pickup). In "total"
  // simplified mode the port is folded into the unit price; "totalExDelivery"
  // keeps delivery as its own quote line.
  const deliveryHtCents = simplifiedUnitPriceMode === 'total' ? 0 : order.deliverySaleCents;
  const deliveryIncludedInUnitPrice = simplifiedUnitPriceMode === 'total';
  const rushHtCents = order.rushCents;
  const totalHtCents = textileHtCents + optionsHtCents + deliveryHtCents + rushHtCents;
  const vatCents = Math.round(totalHtCents * getVatRate());
  const totalTtcCents = totalHtCents + vatCents;
  return {
    quantityTotal,
    textileRows,
    textileHtCents,
    optionRows,
    optionsHtCents,
    deliveryHtCents,
    deliveryIncludedInUnitPrice,
    rushHtCents,
    totalHtCents,
    vatCents,
    totalTtcCents,
    simplifiedUnitPriceMode,
    includeOptionsInUnitPrice: simplifiedUnitPriceMode !== 'off',
    unitOptionsPerPieceCents,
    simplifiedExtras: extras,
  };
}

function profitabilityQuoteStepMarkup(order, pricing, tone) {
  const quote = getQuoteBreakdown(order, pricing);
  const config = getBatConfig(getProduct());
  const production = getProductionConfig();
  const suffix = salePriceSuffix();
  const simplifiedAttr = quote.simplifiedUnitPriceMode !== 'off'
    ? ` data-quote-simplified-mode="${escapeHtml(quote.simplifiedUnitPriceMode)}"`
    : '';
  const quoteMarginCell = (row) => {
    if (!row) return '<span class="bat-quote-line-margin is-empty">—</span>';
    const rowTone = orderMarginTone(row.marginRate, row.marginCents);
    return `
      <span class="bat-quote-line-margin is-${rowTone}">
        <b>${formatMoneyCents(row.marginTotalCents)}</b>
        <em>${formatProfitRate(row.marginRate)}</em>
      </span>
    `;
  };
  const lineRows = quote.textileRows.map((row) => `
    <div class="bat-quote-line" data-quote-textile-id="${escapeHtml(row.id)}">
      <span class="bat-quote-line-label">
        <strong>${escapeHtml(row.label)}</strong>
        <small>${escapeHtml(row.designationDetail || row.colorLabel || 'Textile')}</small>
      </span>
      <span class="bat-quote-line-qty">
        <input class="bat-price-input" type="number" min="0" step="1" inputmode="numeric" value="${row.quantity || 0}" data-project-textile-qty="${escapeHtml(row.id)}" aria-label="Quantité ${escapeHtml(row.label)}">
      </span>
      <span class="bat-price-edit">
        <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatSaleMoneyInput(row.saleCents)}" data-textile-pricing-field="salePriceCents" data-id="${escapeHtml(row.id)}"${simplifiedAttr} aria-label="Prix unitaire ${escapeHtml(row.label)}">
        <em>€ ${suffix}</em>
      </span>
      <span class="bat-quote-line-total">${formatSaleMoneyCents(row.saleTotalCents)}</span>
      ${quoteMarginCell(row)}
    </div>
  `).join('');
  const optionLines = quote.optionRows.map((row) => `
    <div class="bat-quote-line is-secondary">
      <span class="bat-quote-line-label"><strong>${escapeHtml(row.label)}</strong><small>Option${row.pricingMode === 'global' ? ' · forfait' : ''}</small></span>
      <span class="bat-quote-line-qty">${row.quantity}</span>
      <span class="bat-quote-line-unit">${formatSaleMoneyCents(row.unitCents)}</span>
      <span class="bat-quote-line-total">${formatSaleMoneyCents(row.totalCents)}</span>
      ${quoteMarginCell(null)}
    </div>
  `).join('');
  return `
    <div class="bat-quote">
      <div class="bat-quote-client">
        <div class="bat-order-card-head"><strong>Informations client</strong></div>
        <div class="bat-quote-client-grid">
          <label class="bat-config-field">
            <span>Nom client</span>
            <input class="bat-input" type="text" value="${escapeHtml(config.clientName)}" data-production-field="clientName" aria-label="Nom client">
          </label>
          <label class="bat-config-field">
            <span>N° de devis / dossier</span>
            <input class="bat-input" type="text" value="${escapeHtml(config.orderReference)}" data-production-field="orderReference" aria-label="Numéro de devis">
          </label>
          <label class="bat-config-field">
            <span>Délai de fabrication</span>
            <input class="bat-input" type="text" value="${escapeHtml(config.leadTime)}" data-bat-field="leadTime" aria-label="Délai de fabrication">
          </label>
          <label class="bat-config-field bat-quote-comment-field">
            <span>Commentaire devis</span>
            <textarea class="bat-textarea" data-production-field="quoteComment" aria-label="Commentaire devis">${escapeHtml(production.quoteComment || '')}</textarea>
          </label>
        </div>
      </div>

      <div class="bat-quote-lines-card">
        <div class="bat-order-card-head bat-quote-lines-head">
          <strong>Lignes du devis</strong>
          <div class="bat-quote-price-toolbar">
            ${priceDisplayToggleMarkup()}
            ${simplifiedUnitPriceToggleMarkup(quote.simplifiedUnitPriceMode)}
          </div>
        </div>
        <div class="bat-quote-lines">
          <div class="bat-quote-line bat-quote-line-head">
            <span>Désignation</span>
            <span>Qté</span>
            <span>PU ${suffix}</span>
            <span>Total ${suffix}</span>
            <span>Marge</span>
          </div>
          ${lineRows || '<p class="bat-option-empty">Aucun textile.</p>'}
          ${optionLines}
          ${quote.deliveryIncludedInUnitPrice ? '' : (order.pickupInStore ? `
            <div class="bat-quote-line is-secondary">
              <span class="bat-quote-line-label"><strong>Livraison sur place</strong><small>Retrait sur place · pas de frais de port</small></span>
              <span class="bat-quote-line-qty">1</span>
              <span class="bat-quote-line-unit">${formatSaleMoneyCents(0)}</span>
              <span class="bat-quote-line-total">${formatSaleMoneyCents(0)}</span>
              ${quoteMarginCell(null)}
            </div>
          ` : `
            <div class="bat-quote-line is-secondary">
              <span class="bat-quote-line-label"><strong>Livraison</strong><small>Frais de port facturés</small></span>
              <span class="bat-quote-line-qty">1</span>
              <span class="bat-quote-line-unit">
                <span class="bat-price-edit">
                  <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(order.deliverySaleCents)}" data-profitability-field="deliverySaleCents" aria-label="Frais de livraison facturés">
                  <em>€ HT</em>
                </span>
              </span>
              <span class="bat-quote-line-total">${formatSaleMoneyCents(order.deliverySaleCents)}</span>
              ${quoteMarginCell(null)}
            </div>
          `)}
          ${quote.rushHtCents ? `
            <div class="bat-quote-line is-secondary">
              <span class="bat-quote-line-label"><strong>Commande urgente</strong><small>Supplément</small></span>
              <span class="bat-quote-line-qty">1</span>
              <span class="bat-quote-line-unit">${formatSaleMoneyCents(quote.rushHtCents)}</span>
              <span class="bat-quote-line-total">${formatSaleMoneyCents(quote.rushHtCents)}</span>
              ${quoteMarginCell(null)}
            </div>
          ` : ''}
        </div>
      </div>

      <div class="bat-quote-totals">
        <div><span>Total HT</span><strong>${formatMoneyCents(quote.totalHtCents)}</strong></div>
        <div><span>TVA (${Math.round(getVatRate() * 100)} %)</span><strong>${formatMoneyCents(quote.vatCents)}</strong></div>
        <div class="bat-quote-total-ttc"><span>Total TTC</span><strong>${formatMoneyCents(quote.totalTtcCents)}</strong></div>
      </div>

      ${orderMarginHeroMarkup(order, tone, { withToggle: false })}

      ${quoteClientEmailMarkup(quote, config)}
    </div>
  `;
}

// Ready-to-send message the user can copy or open in their mail client to
// forward the quote to their own customer. mailto cannot carry attachments,
// so the PDF is added manually by the user.
function getClientEmailContent(quote, config) {
  const company = String(config.companyName || '').trim();
  const clientName = String(config.clientName || '').trim();
  const reference = String(config.orderReference || '').trim();
  const leadTime = String(config.leadTime || '').trim();
  // Follow the HT/TTC toggle so the email wording matches the price mode in use.
  const totalAmount = formatSaleMoneyCents(quote.totalHtCents);
  const totalSuffix = salePriceSuffix();
  const subject = ['Votre devis', reference && `n°${reference}`, company && `— ${company}`]
    .filter(Boolean)
    .join(' ');
  const lines = [
    `Bonjour${clientName ? ` ${clientName}` : ''},`,
    '',
    `Veuillez trouver ci-joint votre devis${reference ? ` n°${reference}` : ''} d'un montant de ${totalAmount} ${totalSuffix}.`,
  ];
  if (leadTime) lines.push(`Délai de fabrication indicatif : ${leadTime}.`);
  lines.push(
    '',
    'Le BAT (bon à tirer) est également joint : merci de le valider pour que nous puissions lancer la production.',
    '',
    'Restant à votre disposition pour toute question.',
    '',
    'Bien cordialement,',
    company || 'Votre atelier',
  );
  return { subject, body: lines.join('\n') };
}

function quoteClientEmailMarkup(quote, config) {
  const { body } = getClientEmailContent(quote, config);
  return `
    <div class="bat-quote-email">
      <div class="bat-order-card-head">
        <strong>Message pour votre client</strong>
        <span>Texte prêt à envoyer avec le devis</span>
      </div>
      <textarea class="bat-quote-email-body" data-quote-email-body rows="9" readonly aria-label="Message email pour le client">${escapeHtml(body)}</textarea>
      <div class="bat-quote-email-actions">
        <button class="bat-btn" type="button" data-action="copy-quote-email">Copier le texte</button>
        <button class="bat-btn bat-btn-primary" type="button" data-action="email-quote">Envoyer par email</button>
      </div>
      <p class="bat-quote-email-note">Le client mail s'ouvre avec l'objet et le texte pré-remplis. Pensez à joindre le PDF téléchargé.</p>
    </div>
  `;
}

function renderProfitability() {
  const dashboardEl = document.querySelector('[data-profitability-dashboard]');
  if (!els.profitabilityControls && !els.profitabilitySummary && !dashboardEl) return;
  const pricing = getPricingBreakdown();
  const order = getOrderPricingBreakdown();
  const tone = orderMarginTone(order.marginRate, order.marginCents);
  const profitability = getProfitabilityBreakdown(pricing);

  if (els.profitabilityStatus) {
    els.profitabilityStatus.textContent = order.saleTotalCents
      ? `${formatProfitRate(order.marginRate)} marge`
      : 'À calculer';
  }

  // The whole "Tarifs & marges" step is now a single centered assistant mounted
  // in the stage. The former side panels are hidden in profitability mode (CSS),
  // so we only need to fill the central dashboard.
  if (dashboardEl) dashboardEl.innerHTML = profitabilityAssistantMarkup(order, pricing, profitability, tone);
}

// Eye toggle that blurs every monetary value in the assistant (handy to present
// the screen to a client without revealing costs / margins).
function priceHideToggleMarkup() {
  const hidden = Boolean(state.priceHidden);
  const label = hidden ? 'Afficher les prix' : 'Masquer les prix';
  return `
    <button type="button" class="bat-price-eye ${hidden ? 'bat-price-eye-active' : ''}" data-action="toggle-price-hidden" title="${label}" aria-label="${label}" aria-pressed="${hidden}">
      ${hidden ? eyeOffIconSvg() : eyeIconSvg()}
    </button>
  `;
}

function eyeIconSvg() {
  return `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3-8 10-8 10 8 10 8-3 8-10 8-10-8-10-8Z"/><circle cx="12" cy="12" r="3"/></svg>`;
}

function eyeOffIconSvg() {
  return `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 10 8 10 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><path d="M6.61 6.61A18.5 18.5 0 0 0 2 12s3 8 10 8a9.12 9.12 0 0 0 5.39-1.61"/><line x1="2" y1="2" x2="22" y2="22"/></svg>`;
}

function priceDisplayToggleMarkup() {
  const mode = isTtcPriceMode() ? 'TTC' : 'HT';
  return `
    <div class="bat-price-mode-toggle" role="group" aria-label="Affichage des prix de vente" data-price-mode="${mode}">
      <span class="bat-price-mode-caption">Prix affichés</span>
      <button class="bat-price-mode-btn ${mode === 'HT' ? 'is-active' : ''}" type="button" data-action="toggle-price-display" data-id="HT" aria-pressed="${mode === 'HT'}">HT</button>
      <button class="bat-price-mode-btn ${mode === 'TTC' ? 'is-active' : ''}" type="button" data-action="toggle-price-display" data-id="TTC" aria-pressed="${mode === 'TTC'}">TTC</button>
    </div>
  `;
}

// Non = separate lines · Partiel = unit options in PU · Total = options + port in PU ·
// Total (hors livraison) = options in PU, delivery kept as its own line.
function simplifiedUnitPriceToggleMarkup(mode = 'off') {
  const current = normalizeSimplifiedUnitPriceMode(mode);
  const options = [
    { id: 'off', label: 'Non' },
    { id: 'partial', label: 'Partiel' },
    { id: 'total', label: 'Total' },
    { id: 'totalExDelivery', label: 'Total (hors livr.)' },
  ];
  return `
    <div class="bat-price-mode-toggle" role="group" aria-label="Prix unitaire simplifié" data-simplified-unit="${current}">
      <span class="bat-price-mode-caption">Prix unitaire simplifié</span>
      ${options.map((option) => `
        <button class="bat-price-mode-btn ${current === option.id ? 'is-active' : ''}" type="button" data-action="toggle-include-options-in-unit-price" data-id="${option.id}" aria-pressed="${current === option.id}">${option.label}</button>
      `).join('')}
    </div>
  `;
}

function orderPricingDashboardMarkup(order, tone) {
  return `
    <div class="bat-order-pricing">
      ${orderMarginHeroMarkup(order, tone, { withToggle: true })}

      <div class="bat-order-card">
        <div class="bat-order-card-head">
          <strong>Tarifs & marges par textile</strong>
          <span>Achat, transfert, matières et prix de vente éditables par ligne</span>
        </div>
        ${orderTextileTableMarkup(order)}
      </div>

      <button class="bat-btn bat-btn-primary bat-order-export" type="button" data-action="export-profitability">
        Télécharger les tarifs & marges
      </button>
    </div>
  `;
}

function fieldTipMarkup(text) {
  return `<span class="bat-field-tip" title="${escapeHtml(text)}" aria-label="${escapeHtml(text)}">?</span>`;
}

function orderTextileTableMarkup(order) {
  return `
    <div class="bat-order-table">
      <div class="bat-order-row bat-order-row-head">
        <span>Textile</span>
        <span>Qté</span>
        <span>Textile vierge${fieldTipMarkup('Prix catalogue Sherpa pour la référence et la couleur sélectionnées.')}</span>
        <span>Marquage${fieldTipMarkup('Somme des coûts de marquage (matière + pose) des logos et textes de ce textile.')}</span>
        <span>Coût de revient</span>
        <span>Marge</span>
        <span>Prix vente ${salePriceSuffix()}</span>
      </div>
      ${order.rows.map((row) => orderTextileBlockMarkup(row)).join('')}
    </div>
  `;
}

function markingTechniqueOptionsMarkup(selectedValue, isCustom = false) {
  const catalog = getEnabledMarkingTechniques().map((technique) => (
    `<option value="${escapeHtml(technique)}" ${!isCustom && technique === selectedValue ? 'selected' : ''}>${escapeHtml(technique)}</option>`
  )).join('');
  return `${catalog}<option value="${escapeHtml(CUSTOM_MARKING_TECHNIQUE)}" ${isCustom ? 'selected' : ''}>Autre…</option>`;
}

function orderMarkingThumbMarkup(line) {
  if (line.type === 'text') {
    const initial = String(line.textPreview || line.name || 'T').trim().charAt(0).toUpperCase() || 'T';
    return `<span class="bat-order-thumb bat-order-thumb-text" style="--thumb:${escapeHtml(line.textColor || '#111827')}" aria-hidden="true">${escapeHtml(initial)}</span>`;
  }
  if (line.thumbSrc) {
    return `<span class="bat-order-thumb" aria-hidden="true"><img src="${escapeHtml(line.thumbSrc)}" alt=""></span>`;
  }
  return '<span class="bat-order-thumb bat-order-thumb-empty" aria-hidden="true"></span>';
}

function orderTextileThumbMarkup(row) {
  const textile = state.textiles.find((item) => item.id === row.id);
  const product = getProductById(textile?.productId) || getProduct();
  const colorId = textile?.colorId || getColor(product).id;
  const firstViewId = normalizeZoneIds(textile?.activeZoneIds)[0]
    || getActiveViews(product)[0]?.id
    || 'front';
  return `<span class="bat-order-thumb" aria-hidden="true">${productMediaMarkup(product, firstViewId, colorId, { includeCustom: false })}</span>`;
}

function orderMarkingSubrowMarkup(line) {
  const isCustom = Boolean(line.isCustomTechnique);
  return `
    <div class="bat-order-subrow ${isCustom ? 'has-custom-technique' : ''}" data-layer-id="${escapeHtml(line.layerId)}" data-textile-id="${escapeHtml(line.textileId)}">
      <span class="bat-order-subrow-label">
        ${orderMarkingThumbMarkup(line)}
        <span class="bat-order-thumb-copy">
          <strong>${escapeHtml(line.name)}</strong>
          <small>${escapeHtml(line.viewLabel || 'Zone')} · ${line.type === 'text' ? 'Texte' : 'Logo'}</small>
        </span>
      </span>
      <div class="bat-order-subrow-technique">
        <select class="bat-input" data-layer-marking-field="technique" data-layer-id="${escapeHtml(line.layerId)}" data-textile-id="${escapeHtml(line.textileId)}" aria-label="Technique ${escapeHtml(line.name)}">
          ${markingTechniqueOptionsMarkup(line.techniqueValue || line.technique, isCustom)}
        </select>
        ${isCustom ? `
          <input class="bat-input bat-order-subrow-technique-custom" type="text" maxlength="80" placeholder="Précisez la technique" value="${escapeHtml(line.techniqueCustom || '')}" data-layer-marking-field="techniqueCustom" data-layer-id="${escapeHtml(line.layerId)}" data-textile-id="${escapeHtml(line.textileId)}" aria-label="Technique personnalisée ${escapeHtml(line.name)}">
        ` : ''}
      </div>
      <span class="bat-price-edit bat-order-subrow-cost">
        <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(line.markingCents)}" data-layer-marking-field="markingCents" data-layer-id="${escapeHtml(line.layerId)}" data-textile-id="${escapeHtml(line.textileId)}" aria-label="Coût de marquage ${escapeHtml(line.name)}">
        <em>€</em>
      </span>
      <span class="bat-order-subrow-gap" aria-hidden="true"></span>
      <span class="bat-order-subrow-gap" aria-hidden="true"></span>
      <span class="bat-order-subrow-gap" aria-hidden="true"></span>
    </div>
  `;
}

function orderTextileBlockMarkup(row) {
  const lines = Array.isArray(row.markingLines) ? row.markingLines : [];
  return `
    <div class="bat-order-textile-block" data-textile-block="${escapeHtml(row.id)}">
      ${orderTextileRowMarkup(row)}
      <div class="bat-order-subrows">
        ${lines.length
          ? lines.map((line) => orderMarkingSubrowMarkup(line)).join('')
          : '<p class="bat-order-subrows-empty">Aucun logo ou texte placé sur ce textile.</p>'}
      </div>
    </div>
  `;
}

function textilePriceInput(field, id, cents, label) {
  const isSale = field === 'salePriceCents';
  const value = isSale ? formatSaleMoneyInput(cents) : formatMoneyInput(cents);
  const suffix = isSale ? `€ ${salePriceSuffix()}` : '€';
  return `
    <span class="bat-price-edit">
      <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${value}" data-textile-pricing-field="${field}" data-id="${escapeHtml(id)}" aria-label="${escapeHtml(label)}">
      <em>${suffix}</em>
    </span>
  `;
}

function orderTextileRowMarkup(row) {
  const rowTone = orderMarginTone(row.marginRate, row.marginCents);
  const markingCount = Array.isArray(row.markingLines) ? row.markingLines.length : 0;
  const markingDetail = markingCount > 0
    ? `${markingCount} marquage${markingCount > 1 ? 's' : ''}`
    : 'Aucun marquage';
  // Show achieved margin (can be negative) when a fixed sale price is set.
  const marginInputValue = row.hasExplicitSale ? row.marginRate : row.marginPercent;
  return `
    <div class="bat-order-row">
      <span class="bat-order-cell-label">
        ${orderTextileThumbMarkup(row)}
        <span class="bat-order-thumb-copy">
          <strong>${escapeHtml(row.label)}</strong>
          <small>${escapeHtml(row.colorLabel || 'Textile')} · ${row.quantity} pc${row.quantity > 1 ? 's' : ''}</small>
        </span>
      </span>
      <span class="bat-order-cell-qty">${row.quantity}</span>
      ${textilePriceInput('achatCents', row.id, row.achatCents, `Textile vierge ${row.label}`)}
      <span class="bat-order-cell-stack bat-order-cell-marking" title="Somme des coûts de marquage des sous-lignes">
        <b>${formatMoneyCents(row.markingCents)}</b>
        <em>${escapeHtml(markingDetail)}</em>
      </span>
      <span class="bat-order-cell-cost bat-order-cell-costprice">${formatMoneyCents(row.costCents)}</span>
      <span class="bat-order-cell-margin is-${rowTone}">
        <span class="bat-price-edit">
          <input class="bat-price-input" type="number" min="-999" max="95" step="1" inputmode="decimal" value="${formatPercentInput(marginInputValue)}" data-textile-pricing-field="marginPercent" data-id="${escapeHtml(row.id)}" aria-label="Marge ${escapeHtml(row.label)}">
          <em>%</em>
        </span>
      </span>
      <span class="bat-order-cell-sale">
        ${textilePriceInput('salePriceCents', row.id, row.saleCents, `Prix de vente ${row.label}`)}
      </span>
    </div>
  `;
}

function orderTextilePriceListMarkup(order) {
  return `
    <div class="bat-order-side-list">
      ${order.rows.map((row) => {
        const rowTone = orderMarginTone(row.marginRate, row.marginCents);
        return `
          <div class="bat-order-side-row is-${rowTone}">
            <div>
              <strong>${escapeHtml(row.label)}</strong>
              <small>${row.quantity} pc${row.quantity > 1 ? 's' : ''} · coût ${formatMoneyCents(row.costCents)}</small>
            </div>
            <span>
              <b>${formatMoneyCents(row.saleCents)}</b>
              <em>${formatProfitRate(row.marginRate)}</em>
            </span>
          </div>
        `;
      }).join('')}
    </div>
  `;
}

function orderGlobalCostsCardMarkup(order) {
  return `
    <div class="bat-order-card bat-order-costs-card">
      <div class="bat-order-card-head">
        <strong>Coûts globaux de commande</strong>
        <span>Appliqués une fois sur l'ensemble</span>
      </div>
      <div class="bat-order-cost-fields">
        ${order.pickupInStore ? '' : profitabilityMoneyField('Coût de transport', 'shippingPurchaseCents', order.deliveryCents, 'global')}
        ${profitabilityMoneyField('Coût de préparation de dossier', 'fileSetupCents', order.fileSetupCents, 'global')}
        ${profitabilityPackagingField(order)}
      </div>
      ${profitabilityOtherCostsMarkup(state.profitabilityConfig.otherCosts)}
    </div>
  `;
}

// Packaging cost defaults to a % of the order sale total HT. The input is bound
// to the explicit override (packagingCents); while no override is set we show
// the computed auto value.
function profitabilityPackagingField(order) {
  return `
    <label class="bat-price-setting-row bat-packaging-row">
      <span>Coût d'emballage</span>
      <span class="bat-price-edit">
        <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(order.packagingCents)}" data-profitability-field="packagingCents" aria-label="Coût d'emballage">
        <em>${escapeHtml(moneySuffixLabel('global'))}</em>
      </span>
    </label>
  `;
}

function setPickupInStore(enabled) {
  state.profitabilityConfig.pickupInStore = Boolean(enabled);
  renderSummary();
}

function toggleRushOption() {
  const next = normalizePricingSettings(state.pricingSettings);
  next.useUrgentOrder = !next.useUrgentOrder;
  if (!next.useUrgentOrder) next.urgentOrderCents = null;
  state.pricingSettings = next;
  renderSummary();
}

function orderSummaryCardMarkup(order, tone) {
  return `
    <div class="bat-order-card bat-order-summary-card is-${tone}">
      <div class="bat-order-card-head">
        <strong>Synthèse de la commande</strong>
        <span class="bat-order-margin-pill is-${tone}">${formatProfitRate(order.marginRate)} de marge</span>
      </div>
      <div class="bat-order-summary-lines">
        <div><span>Ventes textiles ${salePriceSuffix()}</span><strong>${formatSaleMoneyCents(order.textileSaleTotalCents)}</strong></div>
        ${order.rushCents ? `<div><span>Surcoût urgence</span><strong>${formatMoneyCents(order.rushCents)}</strong></div>` : ''}
        <div><span>Coûts textiles HT</span><strong>${formatMoneyCents(order.textileCostTotalCents)}</strong></div>
        <div><span>Coûts globaux HT</span><strong>${formatMoneyCents(order.globalCostCents)}</strong></div>
        <div class="bat-order-summary-total is-${tone}"><span>Marge nette HT</span><strong>${formatMoneyCents(order.marginCents)}</strong></div>
      </div>
      <p class="bat-order-summary-note">${escapeHtml(orderMarginGuidance(order))}</p>
    </div>
  `;
}

function orderMarginGuidance(order) {
  if (!order.saleTotalCents) return 'Renseignez les quantités et les prix pour lancer le calcul.';
  const tone = orderMarginTone(order.marginRate, order.marginCents);
  if (tone === 'negative') {
    return order.marginCents < 0
      ? 'La commande est déficitaire : ajustez les coûts ou les prix de vente par textile.'
      : 'Marge sous 5 % : vérifiez les coûts textile / marquage et les prix de vente.';
  }
  if (tone === 'warning') return 'Marge entre 5 % et 20 % : surveillez la rentabilité avant de valider.';
  return 'Rentabilité confortable (≥ 20 %) avec les tarifs actuels.';
}

function profitabilityStepCardMarkup(step, title, detail, status = '', variant = '') {
  return `
    <div class="bat-profitability-step-card ${variant ? `is-${variant}` : ''}">
      <span class="bat-profitability-step-index">${step}</span>
      <span class="bat-profitability-step-copy">
        <strong>${escapeHtml(title)}</strong>
        <small>${escapeHtml(detail)}</small>
      </span>
      ${status ? `<em>${escapeHtml(status)}</em>` : ''}
    </div>
  `;
}

function profitabilityMoneyField(label, field, cents, suffix) {
  return `
    <label class="bat-price-setting-row">
      <span>${escapeHtml(label)}</span>
      <span class="bat-price-edit">
        <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(cents)}" data-profitability-field="${field}" aria-label="${escapeHtml(label)}">
        <em>${escapeHtml(moneySuffixLabel(suffix))}</em>
      </span>
    </label>
  `;
}

function moneySuffixLabel(suffix) {
  const label = String(suffix || '').trim();
  if (!label) return '€';
  return label.includes('€') ? label : `€ ${label}`;
}

function profitabilityOtherCostsMarkup(costs) {
  const rows = normalizeProfitabilityOtherCosts(costs);
  return `
    <div class="bat-options-card bat-other-costs-card">
      <div class="bat-qty-head">
        <strong>Autres coûts</strong>
        <button class="bat-option-add" type="button" data-action="add-other-cost">Ajouter</button>
      </div>
      ${rows.length ? `
        <div class="bat-option-list">
          ${rows.map((cost) => `
            <div class="bat-option-row" data-other-cost-id="${cost.id}">
              <input class="bat-input" type="text" value="${escapeHtml(cost.label)}" data-other-cost-label aria-label="Nom du coût">
              <span class="bat-option-price-cell">
                <input class="bat-price-input" type="number" min="0" step="0.01" inputmode="decimal" value="${formatMoneyInput(cost.cents)}" data-other-cost-price aria-label="Montant du coût">
                <em>€</em>
              </span>
              <select class="bat-input bat-option-mode" data-other-cost-pricing-mode aria-label="Type de coût">
                <option value="unit" ${cost.pricingMode === 'unit' ? 'selected' : ''}>quantité</option>
                <option value="global" ${cost.pricingMode === 'global' ? 'selected' : ''}>global</option>
              </select>
              <button class="bat-option-remove" type="button" data-action="remove-other-cost" data-id="${cost.id}" aria-label="Supprimer le coût">×</button>
            </div>
          `).join('')}
        </div>
      ` : '<p class="bat-option-empty">Aucun coût.</p>'}
    </div>
  `;
}

function profitabilityCheckboxField(label, field, checked, help) {
  return `
    <label class="bat-price-toggle bat-profitability-toggle" title="${escapeHtml(help)}">
      <input type="checkbox" ${checked ? 'checked' : ''} data-profitability-field="${escapeHtml(field)}">
      <span>
        <strong>${escapeHtml(label)}</strong>
      </span>
    </label>
  `;
}

function profitabilityNumberField(label, field, value, suffix) {
  return `
    <label class="bat-price-setting-row">
      <span>${escapeHtml(label)}</span>
      <span class="bat-price-edit">
        <input class="bat-price-input" type="number" min="0" step="0.5" inputmode="decimal" value="${formatDecimalInput(value)}" data-profitability-field="${field}" aria-label="${escapeHtml(label)}">
        <em>${escapeHtml(suffix)}</em>
      </span>
    </label>
  `;
}

function profitabilityKpiMarkup(label, value, tone = 'neutral', isText = false) {
  return `
    <div class="bat-profitability-kpi is-${tone}">
      <span>${escapeHtml(label)}</span>
      <strong>${isText ? escapeHtml(value) : formatMoneyCents(value)}</strong>
    </div>
  `;
}

function profitabilityTileMarkup(label, value, detail = '', tone = 'neutral') {
  return `
    <div class="bat-profitability-tile is-${tone}">
      <span>${escapeHtml(label)}</span>
      <strong>${escapeHtml(value)}</strong>
      ${detail ? `<em>${escapeHtml(detail)}</em>` : ''}
    </div>
  `;
}

function profitabilityDetailTiles(rows) {
  return rows.map((row) => `
    <div class="bat-profitability-detail-tile">
      <span>${escapeHtml(row.label)}</span>
      <strong>${formatMoneyCents(row.amountCents)}</strong>
      <em>${escapeHtml(row.detail || '')}</em>
    </div>
  `).join('');
}

function productionDossierMarkup(production) {
  return `
    <div class="bat-production-card">
      <div class="bat-config-field">
        <span>N° dossier / commande</span>
        <input class="bat-input" type="text" value="${escapeHtml(production.orderReference)}" data-production-field="orderReference" aria-label="N° dossier ou commande">
      </div>
      <div class="bat-config-field">
        <span>Client final / projet</span>
        <input class="bat-input" type="text" value="${escapeHtml(production.clientName)}" data-production-field="clientName" aria-label="Client final ou projet">
      </div>
      <div class="bat-config-field">
        <span>Référence textile</span>
        <input class="bat-input" type="text" value="${escapeHtml(production.textileReference)}" data-production-field="textileReference" aria-label="Référence textile pour production">
      </div>
      <div class="bat-config-field">
        <span>Couleur textile</span>
        <input class="bat-input" type="text" value="${escapeHtml(production.textileColor)}" data-production-field="textileColor" aria-label="Couleur textile">
      </div>
      <div class="bat-config-field">
        <span>Transporteur / retrait atelier</span>
        ${carrierPickupSelect(production.carrierPickup, 'production')}
      </div>
      <div class="bat-config-field">
        <span>Délai / date de fabrication</span>
        <input class="bat-input" type="text" value="${escapeHtml(production.productionDeadline)}" data-production-field="productionDeadline" aria-label="Délai ou date de fabrication">
      </div>
    </div>
  `;
}

function carrierPickupSelect(value, scope) {
  const normalized = normalizeCarrierPickup(value);
  const dataAttr = scope === 'admin'
    ? 'data-admin-field="production.carrierPickup"'
    : 'data-production-field="carrierPickup"';
  return `
    <select class="bat-input" ${dataAttr} aria-label="Transporteur ou retrait atelier">
      ${CARRIER_PICKUP_OPTIONS.map((option) => `
        <option value="${escapeHtml(option)}" ${option === normalized ? 'selected' : ''}>${escapeHtml(option)}</option>
      `).join('')}
    </select>
  `;
}

function productionNotesMarkup(production) {
  return `
    <div class="bat-production-card">
      <div class="bat-config-field">
        <span>Instructions de fabrication</span>
        <textarea class="bat-textarea" data-production-field="fabricationInstructions" aria-label="Instructions de fabrication">${escapeHtml(production.fabricationInstructions || '')}</textarea>
      </div>
      <div class="bat-config-field">
        <span>Préparation fichiers</span>
        <textarea class="bat-textarea" data-production-field="filePrep" aria-label="Préparation fichiers">${escapeHtml(production.filePrep)}</textarea>
      </div>
      <div class="bat-config-field">
        <span>Pose / placement</span>
        <textarea class="bat-textarea" data-production-field="placementNotes" aria-label="Consignes de pose ou placement">${escapeHtml(production.placementNotes)}</textarea>
      </div>
      <div class="bat-config-field">
        <span>Contrôle qualité atelier</span>
        <textarea class="bat-textarea" data-production-field="qualityNotes" aria-label="Contrôle qualité atelier">${escapeHtml(production.qualityNotes)}</textarea>
      </div>
      <div class="bat-config-field">
        <span>Conditionnement / livraison</span>
        <textarea class="bat-textarea" data-production-field="packingNotes" aria-label="Conditionnement et livraison">${escapeHtml(production.packingNotes)}</textarea>
      </div>
    </div>
  `;
}

function getTargetMarginUnitPriceCents({
  quantityTotal,
  textileCostCents,
  textileCostTotalCents,
  printCostCents,
  largeSizeQuantity,
  shippingSaleCents,
  targetGrossMarginPercent,
  poseZoneCount = 0,
  useProjectTextileCost = false,
}) {
  const config = normalizeProfitabilityConfig(state.profitabilityConfig);
  const calculationQuantity = Math.max(1, quantityTotal);
  const textilePurchaseCents = useProjectTextileCost ? textileCostCents : (config.textilePurchaseCents ?? textileCostCents);
  const printPurchaseCents = config.printPurchaseCents ?? printCostCents;
  const shippingPurchaseCents = config.shippingPurchaseCents ?? shippingSaleCents;
  const hasManualTextilePurchase = !useProjectTextileCost
    && config.textilePurchaseCents !== null
    && config.textilePurchaseCents !== undefined;
  const textilePurchaseTotalCents = hasManualTextilePurchase
    ? textilePurchaseCents * calculationQuantity
    : Number.isFinite(Number(textileCostTotalCents))
      ? Number(textileCostTotalCents)
      : textilePurchaseCents * calculationQuantity;
  const poseLaborTotalCents = (config.poseLaborCents || 0) * Math.max(0, poseZoneCount) * calculationQuantity;
  const productionCostCents = (printPurchaseCents * calculationQuantity) + poseLaborTotalCents + (config.fileSetupCents || 0);
  const costTotalCents =
    textilePurchaseTotalCents +
    productionCostCents +
    shippingPurchaseCents;
  const targetRate = clamp(Number(targetGrossMarginPercent) || 0, 0, 95) / 100;
  const targetTotalCents = targetRate >= 0.95
    ? costTotalCents / 0.05
    : costTotalCents / (1 - targetRate);
  return Math.max(0, Math.ceil(targetTotalCents / calculationQuantity));
}

function getPricingBreakdown(rows = null) {
  const activeRows = rows || getProjectLayerRows();
  const level = getCustomerLevel();
  const quantityTotal = getTotalQuantity();
  const pricingQuantity = Math.max(1, quantityTotal);
  const settings = normalizePricingSettings(state.pricingSettings);
  state.pricingSettings = settings;
  const textileRows = getProjectTextilePriceRows(level);
  const textileQuantityTotal = textileRows.reduce((total, row) => total + (Number(row.quantity) || 0), 0);
  const textileBaseTotalCents = textileRows.reduce((total, row) => total + (Number(row.baseCents) || 0) * (Number(row.quantity) || 0), 0);
  const textileCostTotalCents = textileRows.reduce((total, row) => total + (Number(row.costCents) || 0) * (Number(row.quantity) || 0), 0);
  const textileBaseCents = textileQuantityTotal
    ? Math.round(textileBaseTotalCents / textileQuantityTotal)
    : getProjectTextileBaseCents(textileRows);
  const textileCostCents = textileQuantityTotal
    ? Math.round(textileCostTotalCents / textileQuantityTotal)
    : textileRows.reduce((total, row) => total + row.costCents, 0);
  const textileCalculatedTotalCents = textileQuantityTotal
    ? applyPricingMargin(textileCostTotalCents, settings)
    : applyPricingMargin(textileCostCents, settings);
  const textileCalculatedCents = textileQuantityTotal
    ? Math.round(textileCalculatedTotalCents / textileQuantityTotal)
    : textileCalculatedTotalCents;
  const textileOverrideCents = normalizeOverrideCents(state.priceOverrides.textileCents);
  const textileFinalCents = textileOverrideCents ?? textileCalculatedCents;
  const textileFinalTotalCents = textileOverrideCents !== null
    ? textileFinalCents * quantityTotal
    : textileCalculatedTotalCents;
  const print = getPrintPricing(activeRows, level, pricingQuantity);
  const printCostCents = print.cents;
  const printCalculatedCents = settings.usePrint ? applyPricingMargin(printCostCents, settings) : 0;
  const printOverrideCents = settings.usePrint ? normalizeOverrideCents(state.priceOverrides.printCents) : null;
  const printFinalCents = settings.usePrint ? (printOverrideCents ?? printCalculatedCents) : 0;
  const poseZoneCount = getPoseZoneCount(activeRows);
  const poseCalculatedCents = settings.usePose ? poseZoneCount * settings.poseCentsPerZone : 0;
  const poseOverrideCents = settings.usePose ? normalizeOverrideCents(state.priceOverrides.poseCents) : null;
  const poseFinalCents = settings.usePose ? (poseOverrideCents ?? poseCalculatedCents) : 0;
  const largeSizeQuantity = 0;
  const largeSizeUnitCents = 0;
  const largeSizeTotalCents = largeSizeQuantity * largeSizeUnitCents;
  const options = getBatOptionsPricing();
  const optionsUnitCents = options.reduce((total, option) => total + option.unitCents, 0);
  const optionsGlobalCents = options.reduce((total, option) => total + option.globalCents, 0);
  const shippingCents = normalizeOverrideCents(state.batConfig.shippingCents) ?? normalizeOverrideCents(activeAdminDefaults.bat.shippingCents) ?? 5000;
  const detailedTotalCents = textileFinalCents + printFinalCents + poseFinalCents + optionsUnitCents;
  const totalOverrideCents = settings.splitSalePrice ? null : normalizeOverrideCents(state.priceOverrides.totalCents);
  const targetMarginUnitCents = !settings.splitSalePrice && settings.salePriceMode === 'margin'
    ? getTargetMarginUnitPriceCents({
      quantityTotal,
      textileCostCents,
      textileCostTotalCents,
      printCostCents,
      largeSizeQuantity,
      shippingSaleCents: shippingCents,
      targetGrossMarginPercent: settings.targetGrossMarginPercent,
      poseZoneCount,
      useProjectTextileCost: textileRows.length > 1,
    })
    : null;
  const totalCents = settings.splitSalePrice
    ? detailedTotalCents
    : (targetMarginUnitCents ?? totalOverrideCents ?? detailedTotalCents);
  const globalSubtotalCents = settings.splitSalePrice
    ? textileFinalTotalCents + ((printFinalCents + poseFinalCents + optionsUnitCents) * quantityTotal) + largeSizeTotalCents + optionsGlobalCents + shippingCents
    : totalCents * quantityTotal + largeSizeTotalCents + optionsGlobalCents + shippingCents;
  const calculatedUrgentOrderCents = Math.round(globalSubtotalCents * 0.30);
  const urgentOrderTotalCents = settings.useUrgentOrder
    ? (normalizeOverrideCents(settings.urgentOrderCents) ?? calculatedUrgentOrderCents)
    : 0;
  const globalTotalCents = globalSubtotalCents + urgentOrderTotalCents;

  return {
    level,
    settings,
    quantityTotal,
    pricingQuantity,
    sizeSummary: getSizeQuantitySummary(),
    textile: {
      rows: textileRows,
      baseCents: textileBaseCents,
      costCents: textileCostCents,
      baseTotalCents: textileBaseTotalCents,
      costTotalCents: textileCostTotalCents,
      calculatedCents: textileCalculatedCents,
      calculatedTotalCents: textileCalculatedTotalCents,
      overrideCents: textileOverrideCents,
      finalCents: textileFinalCents,
      finalTotalCents: textileFinalTotalCents,
      quantityTotal: textileQuantityTotal,
      detail: `${textileRows.length} textile${textileRows.length > 1 ? 's' : ''} · ${getProjectTextileQuantityLabel(textileRows)} · ${level.label}${level.textileDiscount ? ` (-${level.textileDiscount}%)` : ''}${settings.useMargin ? ` · marge ${formatPercent(settings.marginPercent)}` : ''}${textileOverrideCents !== null ? ` · modifié · calcul unitaire ${formatMoneyCents(textileCalculatedCents)}` : ''}`,
    },
    print: {
      ...print,
      costCents: printCostCents,
      calculatedCents: printCalculatedCents,
      overrideCents: printOverrideCents,
      finalCents: printFinalCents,
      detail: `${settings.usePrint ? `${print.detail}${settings.useMargin ? ` · marge ${formatPercent(settings.marginPercent)}` : ''}${printOverrideCents !== null ? ` · modifié · calcul unitaire ${formatMoneyCents(printCalculatedCents)}` : ''}` : 'Impression désactivée'}`,
    },
    pose: {
      zoneCount: poseZoneCount,
      unitPerZoneCents: settings.poseCentsPerZone,
      calculatedCents: poseCalculatedCents,
      overrideCents: poseOverrideCents,
      finalCents: poseFinalCents,
      detail: `${settings.usePose ? `${poseZoneCount} zone${poseZoneCount > 1 ? 's' : ''} x ${formatMoneyCents(settings.poseCentsPerZone)} / zone · sans marge` : 'Pose désactivée'}${poseOverrideCents !== null ? ` · modifié · calcul ${formatMoneyCents(poseCalculatedCents)}` : ''}`,
    },
    options,
    optionsUnitCents,
    optionsGlobalCents,
    largeSizes: {
      quantity: largeSizeQuantity,
      unitCents: largeSizeUnitCents,
      totalCents: largeSizeTotalCents,
      detail: '',
    },
    shipping: {
      finalCents: shippingCents,
      totalCents: shippingCents,
      detail: 'Frais de livraison HT globaux',
    },
    urgentOrder: {
      enabled: settings.useUrgentOrder,
      rate: 30,
      totalCents: urgentOrderTotalCents,
      detail: '30% du total commande',
    },
    hasOverrides: totalOverrideCents !== null || textileOverrideCents !== null || printOverrideCents !== null || poseOverrideCents !== null,
    totalOverrideCents,
    targetMarginUnitCents,
    detailedTotalCents,
    totalCents,
    globalSubtotalCents,
    globalTotalCents,
  };
}

function getProfitabilityBreakdown(pricing = getPricingBreakdown()) {
  const config = normalizeProfitabilityConfig(state.profitabilityConfig);
  state.profitabilityConfig = config;
  const batConfig = getBatConfig(getProduct());
  const quantity = pricing.quantityTotal;
  const hasQuantity = quantity > 0;
  const calculationQuantity = hasQuantity ? quantity : 1;
  const quantityDetail = hasQuantity
    ? `${quantity} pièce${quantity > 1 ? 's' : ''}`
    : '1 unité BAT';
  const zoneCount = pricing.pose.zoneCount;
  const textileRows = pricing.textile?.rows || getProjectTextilePriceRows(pricing.level);
  const hasMultiTextiles = textileRows.length > 1;
  const hasManualTextilePurchase = !hasMultiTextiles
    && config.textilePurchaseCents !== null
    && config.textilePurchaseCents !== undefined;
  const textilePurchaseCents = hasManualTextilePurchase ? config.textilePurchaseCents : pricing.textile.costCents;
  const textilePurchaseTotalCents = hasManualTextilePurchase
    ? textilePurchaseCents * calculationQuantity
    : pricing.textile.costTotalCents;
  const printPurchaseCents = config.printPurchaseCents ?? pricing.print.costCents;
  const shippingPurchaseCents = config.shippingPurchaseCents ?? (hasQuantity ? pricing.shipping.finalCents : 0);
  const poseLaborCents = config.poseLaborCents || 0;
  const fileSetupCents = config.fileSetupCents || 0;
  const poseLaborTotalCents = poseLaborCents * zoneCount * calculationQuantity;
  const optionsSaleCents = hasQuantity
    ? pricing.options.reduce((total, option) => total + option.totalCents, 0)
    : pricing.optionsUnitCents;
  const saleRows = pricing.settings.splitSalePrice
    ? [
      { label: hasMultiTextiles ? 'Textiles' : 'Textile', detail: hasMultiTextiles ? `${textileRows.length} textiles · ${quantityDetail}` : quantityDetail, amountCents: pricing.textile.finalTotalCents ?? pricing.textile.finalCents * calculationQuantity },
      { label: 'Impression', detail: quantityDetail, amountCents: pricing.settings.usePrint ? pricing.print.finalCents * calculationQuantity : 0 },
      { label: 'Pose', detail: `${zoneCount} zone${zoneCount > 1 ? 's' : ''} x ${calculationQuantity}`, amountCents: pricing.settings.usePose ? pricing.pose.finalCents * calculationQuantity : 0 },
      { label: 'Options', detail: hasQuantity ? 'Unitaires et globales' : 'Unitaires BAT', amountCents: optionsSaleCents },
      { label: 'Livraison', detail: 'Global', amountCents: hasQuantity ? pricing.shipping.totalCents : 0 },
      ...(pricing.urgentOrder.enabled ? [{ label: 'Commande urgente', detail: '+30% ajustable', amountCents: pricing.urgentOrder.totalCents }] : []),
    ]
    : [
      { label: 'Prix de vente', detail: quantityDetail, amountCents: pricing.totalCents * calculationQuantity },
      { label: 'Livraison', detail: 'Global', amountCents: hasQuantity ? pricing.shipping.totalCents : 0 },
      ...(pricing.urgentOrder.enabled ? [{ label: 'Commande urgente', detail: '+30% ajustable', amountCents: pricing.urgentOrder.totalCents }] : []),
    ];
  const costRows = [
    { label: hasMultiTextiles ? 'Achat textiles' : 'Achat textile', detail: hasMultiTextiles ? `${textileRows.length} textiles · ${quantityDetail}` : `${formatMoneyCents(textilePurchaseCents)} / unité`, amountCents: textilePurchaseTotalCents },
    { label: 'Transfert / matière', detail: `${formatMoneyCents(printPurchaseCents)} / unité`, amountCents: printPurchaseCents * calculationQuantity },
    { label: 'Coût à la pose', detail: `${zoneCount} zone${zoneCount > 1 ? 's' : ''} x ${formatMoneyCents(poseLaborCents)}`, amountCents: poseLaborTotalCents },
    { label: 'Préparation dossier', detail: 'Global', amountCents: fileSetupCents },
    { label: 'Livraison', detail: 'Global', amountCents: shippingPurchaseCents },
  ];
  const saleTotalCents = hasQuantity ? pricing.globalTotalCents : pricing.totalCents;
  const costTotalCents = costRows.reduce((total, row) => total + row.amountCents, 0);
  const grossMarginCents = saleTotalCents - costTotalCents;
  return {
    inputs: {
      technique: batConfig.technique,
      textilePurchaseCents,
      textilePurchaseTotalCents,
      textileRows,
      printPurchaseCents,
      shippingPurchaseCents,
      otherCosts: [],
      otherCostsCents: 0,
      poseLaborCents,
      fileSetupCents,
      laborHourlyCents: config.laborHourlyCents,
      laborSetupMinutes: config.laborSetupMinutes,
      laborPerPieceMinutes: config.laborPerPieceMinutes,
    },
    quantity: calculationQuantity,
    realQuantity: quantity,
    hasQuantity,
    saleRows,
    costRows,
    saleTotalCents,
    costTotalCents,
    grossMarginCents,
    grossMarginPerPieceCents: Math.round(grossMarginCents / calculationQuantity),
    grossMarginRate: saleTotalCents ? (grossMarginCents / saleTotalCents) * 100 : 0,
  };
}

function getBatConfig(product = getProduct()) {
  return {
    companyName: activeAdminDefaults.identity.companyName || '',
    companyLogoSrc: activeAdminDefaults.identity.companyLogoSrc || '',
    companyLogoName: activeAdminDefaults.identity.companyLogoName || '',
    orderReference: state.productionConfig.orderReference || '',
    clientName: state.productionConfig.clientName || '',
    textileReference: state.batConfig.textileReference || defaultTextileReferenceLabel(product),
    technique: normalizeAvailableMarkingTechnique(state.batConfig.technique || activeAdminDefaults.bat.technique),
    leadTime: state.batConfig.leadTime || activeAdminDefaults.bat.leadTime || '3 semaines',
    shippingCents: normalizeOverrideCents(state.batConfig.shippingCents) ?? normalizeOverrideCents(activeAdminDefaults.bat.shippingCents) ?? 5000,
    quoteComment: state.productionConfig.quoteComment || '',
  };
}

function getProductionConfig(product = getProduct(), batConfig = getBatConfig(product)) {
  const color = getColor(product);
  const technique = normalizeAvailableMarkingTechnique(state.productionConfig.technique || activeAdminDefaults.production.technique);
  return {
    orderReference: state.productionConfig.orderReference || '',
    clientName: state.productionConfig.clientName || '',
    textileReference: state.productionConfig.textileReference || batConfig.textileReference || product.fullLabel || product.label,
    textileColor: state.productionConfig.textileColor || color.label,
    technique,
    textileSupplier: state.productionConfig.textileSupplier || activeAdminDefaults.production.textileSupplier || 'Sherpa Transfert',
    transferSupplier: state.productionConfig.transferSupplier || transferSupplierForTechnique(technique, activeAdminDefaults),
    carrierPickup: normalizeCarrierPickup(state.productionConfig.carrierPickup || activeAdminDefaults.production.carrierPickup),
    productionDeadline: state.productionConfig.productionDeadline || defaultProductionDateLabel(activeAdminDefaults.production.productionDelayWeeks),
    quoteComment: state.productionConfig.quoteComment || '',
    fabricationInstructions: state.productionConfig.fabricationInstructions || '',
    filePrep: state.productionConfig.filePrep || activeAdminDefaults.production.filePrep || '',
    placementNotes: state.productionConfig.placementNotes || activeAdminDefaults.production.placementNotes || '',
    qualityNotes: state.productionConfig.qualityNotes || activeAdminDefaults.production.qualityNotes || '',
    packingNotes: state.productionConfig.packingNotes || activeAdminDefaults.production.packingNotes || '',
  };
}

function normalizeMarkingTechnique(value) {
  const raw = String(value || '').trim();
  if (!raw) return MARKING_TECHNIQUES[0];
  return MARKING_TECHNIQUES.includes(raw) ? raw : MARKING_TECHNIQUES[0];
}

function getEnabledMarkingTechniques(markingSuppliers = activeAdminDefaults?.production?.markingSuppliers) {
  const normalized = normalizeMarkingSuppliers(markingSuppliers);
  const enabled = MARKING_TECHNIQUES.filter((technique) => normalized[techniqueSupplierKey(technique)]?.enabled);
  return enabled.length ? enabled : [MARKING_TECHNIQUES[0]];
}

function normalizeAvailableMarkingTechnique(value, markingSuppliers = activeAdminDefaults?.production?.markingSuppliers) {
  const normalized = normalizeMarkingTechnique(value);
  const enabled = getEnabledMarkingTechniques(markingSuppliers);
  return enabled.includes(normalized) ? normalized : enabled[0];
}

function isTransferMarkingTechnique(value) {
  return normalizeMarkingTechnique(value).toLowerCase().startsWith(TRANSFER_MARKING_PREFIX);
}

function normalizeCarrierPickup(value) {
  const raw = String(value || '').trim();
  return CARRIER_PICKUP_OPTIONS.includes(raw) ? raw : 'Retrait atelier';
}

function transferSupplierForTechnique(technique, defaults = activeAdminDefaults) {
  return formatTechniqueSupplierLabel(getTechniqueSupplierConfig(technique, defaults?.production?.markingSuppliers));
}

function techniqueSupplierKey(technique) {
  return String(technique || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/gi, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();
}

function defaultTechniqueSupplierConfig() {
  return {
    enabled: true,
    mode: 'supplier',
    supplier: 'Sherpa Transfert',
  };
}

function createDefaultMarkingSuppliers() {
  return MARKING_TECHNIQUES.reduce((acc, technique) => {
    acc[techniqueSupplierKey(technique)] = defaultTechniqueSupplierConfig();
    return acc;
  }, {});
}

function normalizeTechniqueSupplierConfig(config = {}) {
  const defaults = defaultTechniqueSupplierConfig();
  const mode = MARKING_SUPPLIER_MODES.some((item) => item.id === config.mode)
    ? config.mode
    : defaults.mode;
  return {
    enabled: config.enabled ?? defaults.enabled,
    mode,
    supplier: String(config.supplier || defaults.supplier).trim(),
  };
}

function normalizeMarkingSuppliers(markingSuppliers = {}) {
  const source = markingSuppliers && typeof markingSuppliers === 'object' ? markingSuppliers : {};
  const normalized = MARKING_TECHNIQUES.reduce((acc, technique) => {
    const key = techniqueSupplierKey(technique);
    acc[key] = normalizeTechniqueSupplierConfig(source[key]);
    return acc;
  }, {});
  const hasEnabledTechnique = MARKING_TECHNIQUES.some((technique) => normalized[techniqueSupplierKey(technique)]?.enabled);
  if (!hasEnabledTechnique) {
    normalized[techniqueSupplierKey(MARKING_TECHNIQUES[0])].enabled = true;
  }
  return normalized;
}

function getTechniqueSupplierConfig(technique, markingSuppliers = activeAdminDefaults?.production?.markingSuppliers) {
  const normalized = normalizeMarkingSuppliers(markingSuppliers);
  return normalized[techniqueSupplierKey(normalizeMarkingTechnique(technique))] || defaultTechniqueSupplierConfig();
}

function formatTechniqueSupplierLabel(config = defaultTechniqueSupplierConfig()) {
  const normalized = normalizeTechniqueSupplierConfig(config);
  const supplier = normalized.supplier || 'Sherpa Transfert';
  if (normalized.mode === 'internal') return 'Fabrication interne';
  if (normalized.mode === 'both') return `${supplier} + fabrication interne`;
  return supplier;
}

function defaultProductionDateLabel(weeks = activeAdminDefaults?.production?.productionDelayWeeks ?? 3) {
  const date = new Date();
  date.setDate(date.getDate() + Math.max(0, Number(weeks) || 0) * 7);
  const label = date.toLocaleDateString('fr-FR', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
  return label.charAt(0).toLocaleUpperCase('fr-FR') + label.slice(1);
}

function defaultTextileReferenceLabel(product = getProduct()) {
  const color = getColor(product);
  const colorLabel = colorLabelFr(color);
  const quickChoice = PRODUCT_QUICK_CHOICE_MAP.get(state.productChoiceId);
  const baseLabel = quickChoice && quickChoice.witnessProductId === product.id
    ? quickChoice.label
    : product.fullLabel || product.label;
  return [baseLabel, colorLabel].filter(Boolean).join(' - ');
}

function colorLabelFr(color) {
  const label = String(color?.label || '').trim();
  if (!label) return '';
  const normalized = label.toUpperCase().replace(/\s+/g, ' ');
  const labels = {
    'ASH GREY': 'Gris cendré',
    BEIGE: 'Beige',
    BLACK: 'Noir',
    'BLACK PURE': 'Noir pur',
    BURGUNDY: 'Bordeaux',
    'FIRE RED': 'Rouge feu',
    'FOREST GREEN': 'Vert forêt',
    GREY: 'Gris',
    'GREY/BLACK': 'Gris / noir',
    HEATHER: 'Gris chiné',
    'HEATHER GREY': 'Gris chiné',
    'LIGHT GREY MELANGE': 'Gris clair chiné',
    LIME: 'Vert citron',
    MASTIC: 'Mastic',
    'MILLENNIAL MINT': 'Menthe',
    MUSTARD: 'Moutarde',
    NATURAL: 'Naturel',
    NAVY: 'Bleu marine',
    'NAVY BLUE': 'Bleu marine',
    ORANGE: 'Orange',
    'PURE ORANGE': 'Orange pur',
    RED: 'Rouge',
    ROYAL: 'Bleu royal',
    SAGE: 'Sauge',
    'SKY BLUE': 'Bleu ciel',
    'SOFT ROSE': 'Rose doux',
    WHITE: 'Blanc',
    YELLOW: 'Jaune',
    'YELLOW FIZZ': 'Jaune fizz',
  };
  return labels[normalized] || label.toLocaleLowerCase('fr-FR').replace(/(^|[\s/-])\p{L}/gu, (match) => match.toLocaleUpperCase('fr-FR'));
}

function createDefaultAdminDefaults() {
  return {
    identity: {
      companyName: '',
      companyLogoSrc: '',
      companyLogoName: '',
    },
    compose: {
      productChoiceId: 'quick-tshirt',
      // Apparel textiles expose exactly these 5 zones, in this order.
      activeZoneIds: ['front', 'back', 'collar', 'right-side', 'left-side'],
      zoneMarkings: normalizeZoneMarkings(),
      customZoneSize: { width: 20, height: 15 },
    },
    bat: {
      technique: MARKING_TECHNIQUES[0],
      leadTime: '3 semaines',
      shippingCents: 5000,
      pricingSettings: {
        splitSalePrice: false,
        usePrint: true,
        usePose: true,
        poseCentsPerZone: 100,
        useLargeSizeSurcharge: true,
        largeSizeSurchargeCents: 25,
        useMargin: true,
        marginPercent: 30,
        salePriceMode: 'margin',
        targetGrossMarginPercent: 30,
      },
    },
    production: {
      technique: MARKING_TECHNIQUES[0],
      productionDelayWeeks: 3,
      textileSupplier: 'Sherpa Transfert',
      transferSupplier: 'Sherpa Transfert',
      markingSuppliers: createDefaultMarkingSuppliers(),
      carrierPickup: 'Retrait atelier',
      filePrep: '',
      placementNotes: '',
      qualityNotes: '',
      packingNotes: '',
    },
    profitability: createBaseProfitabilityDefaults(),
  };
}

function normalizeAdminDefaults(rawDefaults = {}) {
  const defaults = createDefaultAdminDefaults();
  const raw = rawDefaults && typeof rawDefaults === 'object' ? rawDefaults : {};
  const identity = raw.identity && typeof raw.identity === 'object' ? raw.identity : {};
  const compose = raw.compose && typeof raw.compose === 'object' ? raw.compose : {};
  const bat = raw.bat && typeof raw.bat === 'object' ? raw.bat : {};
  const pricing = bat.pricingSettings && typeof bat.pricingSettings === 'object' ? bat.pricingSettings : {};
  const production = raw.production && typeof raw.production === 'object' ? raw.production : {};
  const profitability = raw.profitability && typeof raw.profitability === 'object' ? raw.profitability : {};
  const productChoiceId = PRODUCT_QUICK_CHOICE_MAP.has(compose.productChoiceId)
    ? compose.productChoiceId
    : defaults.compose.productChoiceId;
  const normalizedMarkingSuppliers = normalizeMarkingSuppliers(production.markingSuppliers || defaults.production.markingSuppliers);
  const batTechnique = normalizeAvailableMarkingTechnique(bat.technique || defaults.bat.technique, normalizedMarkingSuppliers);
  const productionTechnique = normalizeAvailableMarkingTechnique(production.technique || defaults.production.technique, normalizedMarkingSuppliers);
  return {
    identity: {
      companyName: String(identity.companyName || defaults.identity.companyName).trim(),
      companyLogoSrc: String(identity.companyLogoSrc || defaults.identity.companyLogoSrc),
      companyLogoName: String(identity.companyLogoName || defaults.identity.companyLogoName).trim(),
    },
    compose: {
      productChoiceId,
      activeZoneIds: normalizeZoneIds(compose.activeZoneIds || defaults.compose.activeZoneIds),
      zoneMarkings: normalizeZoneMarkings(compose.zoneMarkings || defaults.compose.zoneMarkings),
      customZoneSize: normalizeCustomZoneSize(compose.customZoneSize || defaults.compose.customZoneSize),
    },
    bat: {
      technique: batTechnique,
      leadTime: String(bat.leadTime || defaults.bat.leadTime).trim(),
      shippingCents: normalizeOverrideCents(bat.shippingCents) ?? defaults.bat.shippingCents,
      pricingSettings: {
        splitSalePrice: pricing.splitSalePrice ?? defaults.bat.pricingSettings.splitSalePrice,
        usePrint: pricing.usePrint ?? defaults.bat.pricingSettings.usePrint,
        usePose: pricing.usePose ?? defaults.bat.pricingSettings.usePose,
        poseCentsPerZone: normalizeOverrideCents(pricing.poseCentsPerZone) ?? defaults.bat.pricingSettings.poseCentsPerZone,
        useLargeSizeSurcharge: pricing.useLargeSizeSurcharge ?? defaults.bat.pricingSettings.useLargeSizeSurcharge,
        largeSizeSurchargeCents: normalizeOverrideCents(pricing.largeSizeSurchargeCents) ?? defaults.bat.pricingSettings.largeSizeSurchargeCents,
        useMargin: pricing.useMargin ?? defaults.bat.pricingSettings.useMargin,
        marginPercent: clamp(Number(pricing.marginPercent ?? defaults.bat.pricingSettings.marginPercent) || 0, 0, 500),
        salePriceMode: pricing.salePriceMode === 'margin' ? 'margin' : defaults.bat.pricingSettings.salePriceMode,
        targetGrossMarginPercent: clamp(Number(pricing.targetGrossMarginPercent ?? defaults.bat.pricingSettings.targetGrossMarginPercent) || 0, 0, 95),
      },
    },
    production: {
      technique: productionTechnique,
      productionDelayWeeks: clamp(Math.round(Number(production.productionDelayWeeks ?? defaults.production.productionDelayWeeks) || 0), 0, 52),
      textileSupplier: String(production.textileSupplier || defaults.production.textileSupplier).trim(),
      transferSupplier: String(production.transferSupplier || defaults.production.transferSupplier).trim(),
      markingSuppliers: normalizedMarkingSuppliers,
      carrierPickup: normalizeCarrierPickup(production.carrierPickup || defaults.production.carrierPickup),
      filePrep: String(production.filePrep || defaults.production.filePrep).trim(),
      placementNotes: String(production.placementNotes || defaults.production.placementNotes).trim(),
      qualityNotes: String(production.qualityNotes || defaults.production.qualityNotes).trim(),
      packingNotes: String(production.packingNotes || defaults.production.packingNotes).trim(),
    },
    profitability: normalizeProfitabilityConfig(profitability, defaults.profitability),
  };
}

function loadAdminDefaults() {
  try {
    const stored = window.localStorage?.getItem(ADMIN_DEFAULTS_STORAGE_KEY);
    return normalizeAdminDefaults(stored ? JSON.parse(stored) : null);
  } catch (error) {
    return createDefaultAdminDefaults();
  }
}

function saveAdminDefaultsToStorage(defaults) {
  try {
    window.localStorage?.setItem(ADMIN_DEFAULTS_STORAGE_KEY, JSON.stringify(normalizeAdminDefaults(defaults)));
  } catch (error) {
    // Le prototype reste utilisable même si le navigateur bloque le stockage local.
  }
}

function setAdminValue(target, path, value) {
  const parts = String(path || '').split('.').filter(Boolean);
  if (!parts.length) return;
  let cursor = target;
  parts.slice(0, -1).forEach((part) => {
    if (!cursor[part] || typeof cursor[part] !== 'object') cursor[part] = {};
    cursor = cursor[part];
  });
  cursor[parts[parts.length - 1]] = value;
}

function getBatOptionsPricing(quantity = getTotalQuantity()) {
  return state.batConfig.options.map((option) => {
    const pricingMode = option.pricingMode === 'global' ? 'global' : 'unit';
    const amountCents = normalizeOverrideCents(option.cents) ?? 0;
    const safeQuantity = Math.max(0, Number(quantity) || 0);
    const unitCents = pricingMode === 'unit' ? amountCents : 0;
    const globalCents = pricingMode === 'global' ? amountCents : 0;
    return {
      id: option.id,
      label: option.label || 'Option',
      pricingMode,
      amountCents,
      unitCents,
      globalCents,
      totalCents: pricingMode === 'unit' ? unitCents * safeQuantity : globalCents,
    };
  });
}

function getTextileVariantPriceCents(product = getProduct(), color = getColor(product)) {
  return Number(color?.priceCents ?? product?.textilePriceCents ?? 0) || 0;
}

function getPrintPricing(rows, level = getCustomerLevel(), quantity = 1) {
  const unitAreaCm2 = rows.reduce((total, row) => total + Math.max(0, Number(row.layer.w) || 0) * Math.max(0, Number(row.layer.h) || 0), 0);
  const pricingQuantity = Math.max(1, Math.floor(Number(quantity) || 1));
  const pricedAreaCm2 = unitAreaCm2 * pricingQuantity;
  if (unitAreaCm2 <= 0) {
    return {
      cents: 0,
      unitAreaCm2: 0,
      pricedAreaCm2: 0,
      pricePerCm2: 0,
      detail: 'Aucun marquage',
    };
  }

  const ranges = getEasyOrderRanges();
  const pricePerCm2 = findPricePerCm2(ranges.prices, pricedAreaCm2, level.easyOrderSegment) ?? 0;
  const deliveryMultiplier = getDeliveryMultiplier(ranges.delivery_delay, 'Standard', level.easyOrderSegment);
  const unitEuros = unitAreaCm2 * pricePerCm2 * deliveryMultiplier;

  return {
    cents: Math.round(unitEuros * 100),
    unitAreaCm2,
    pricedAreaCm2,
    quantity: pricingQuantity,
    pricePerCm2,
    deliveryMultiplier,
    detail: `Easy Order · ${formatCm(unitAreaCm2)} cm² / unité · palier ${pricingQuantity} pièce${pricingQuantity > 1 ? 's' : ''} · ${formatEuroRate(pricePerCm2)}/cm²`,
  };
}

function getCustomerLevel() {
  return CUSTOMER_LEVELS.find((level) => level.id === state.customerLevel) || CUSTOMER_LEVELS[0];
}

function detectInitialCustomerLevel() {
  const rawLevel = [
    window.sherpaCustomerLevel,
    window.customerLevel,
    window.sherpaCustomerTags,
    window.customerTags,
    document.documentElement.dataset.customerLevel,
    document.documentElement.dataset.customerTags,
    document.body.dataset.customerLevel,
    document.body.dataset.customerTags,
  ].filter(Boolean).join(' ');

  const match = String(rawLevel).match(/(?:niveau|level|vip|sherpa)[_\s-]*([1-5])/i)
    || String(rawLevel).match(/\b([1-5])\b/);
  return match ? Number(match[1]) : 1;
}

function getEasyOrderRanges() {
  return normalizeEasyOrderRanges(window.dtfEasyOrderAuLogoRanges)
    || normalizeEasyOrderRanges(window.priceRangesAll?.logo)
    || FALLBACK_EASY_ORDER_RANGES;
}

function normalizeEasyOrderRanges(raw) {
  if (!raw) return null;
  if (typeof raw === 'string') {
    try {
      return normalizeEasyOrderRanges(JSON.parse(raw));
    } catch (error) {
      return null;
    }
  }
  if (Array.isArray(raw.prices)) return raw;
  if (raw.value) return normalizeEasyOrderRanges(raw.value);
  return null;
}

function findPricePerCm2(prices, areaCm2, segment) {
  if (!Array.isArray(prices) || !prices.length) return null;
  const sorted = prices.slice().sort((a, b) => (Number(a.area) || 0) - (Number(b.area) || 0));
  let selected = sorted[0];
  for (const range of sorted) {
    if (areaCm2 >= (Number(range.area) || 0)) selected = range;
  }
  return pickConfiguredValue(selected, segment, 'price');
}

function getDeliveryMultiplier(deliveryDelays, plan, segment) {
  if (!Array.isArray(deliveryDelays) || !deliveryDelays.length) return 1;
  const selected = deliveryDelays.find((delay) => delay.plan === plan) || deliveryDelays[0];
  return pickConfiguredValue(selected, segment, 'price') ?? 1;
}

function pickConfiguredValue(config, segment, fallbackKey) {
  if (!config) return null;
  const keyBySegment = {
    top: 'price_for_top',
    niveau_5: 'price_for_niveau_5',
    niveau_4: 'price_for_niveau_4',
    niveau_a: 'price_for_niveau_1_2_3',
  };
  const preferredKey = keyBySegment[segment];
  const preferredValue = preferredKey ? Number(config[preferredKey]) : NaN;
  if (Number.isFinite(preferredValue)) return preferredValue;
  const fallbackValue = Number(config[fallbackKey]);
  return Number.isFinite(fallbackValue) ? fallbackValue : null;
}

function selectProduct(id, source = 'reference') {
  const product = products.find((item) => item.id === id);
  if (!product) return;
  const quickChoice = PRODUCT_QUICK_CHOICES.find((choice) => choice.witnessProductId === id);
  state.productId = id;
  state.productCategoryId = getProductCategoryId(product);
  state.productChoiceId = source === 'quick' ? quickChoice?.id || '' : '';
  state.productReferenceModalOpen = false;
  state.productSearch = '';
  state.colorId = getProductColors(product)[0]?.id || state.colorId;
  state.viewId = getActiveViews(product)[0]?.id || 'front';
  state.selectedLayerId = null;
  state.layers = state.layers.filter((layer) => layer.productId === id);
  renderAll();
}

function selectProductPickerMode() {
  /* Catalogue précis retiré — choix rapide uniquement. */
}

function openProductReferenceModal() {
  /* Catalogue précis retiré. */
}

function closeProductReferenceModal() {
  state.productReferenceModalOpen = false;
  state.productSearch = '';
}

function selectProductCategory(id) {
  const choice = PRODUCT_QUICK_CHOICE_MAP.get(id);
  if (!choice) return;
  state.productPickerMode = 'quick';
  state.productChoiceId = id;
  state.productSearch = '';
  selectProduct(choice.witnessProductId, 'quick');
}

function setSimplifiedUnitPriceMode(id) {
  const next = normalizeSimplifiedUnitPriceMode(
    id === 'on' ? 'partial' : id,
    id === 'on',
  );
  const current = normalizeSimplifiedUnitPriceMode(
    state.pricingSettings.simplifiedUnitPriceMode,
    state.pricingSettings.includeOptionsInUnitPrice,
  );
  if (current === next) return;
  state.pricingSettings = normalizePricingSettings({
    ...state.pricingSettings,
    simplifiedUnitPriceMode: next,
    includeOptionsInUnitPrice: next !== 'off',
  });
  renderAll();
}

function clearProductSearch() {
  state.productSearch = '';
  renderProducts();
}

function updatePriceOverride(input) {
  const field = input.dataset.priceOverride;
  const cents = parseMoneyInput(input.value);
  if (field === 'total') {
    state.priceOverrides.totalCents = cents;
  } else if (field === 'textile') {
    state.priceOverrides.textileCents = cents;
  } else if (field === 'print') {
    state.priceOverrides.printCents = cents;
  } else if (field === 'pose') {
    state.priceOverrides.poseCents = cents;
  }
  renderSummary();
}

function updatePricingSetting(input) {
  const setting = input.dataset.pricingSetting;
  const next = normalizePricingSettings(state.pricingSettings);
  if (setting === 'usePrint') {
    next.usePrint = Boolean(input.checked);
  } else if (setting === 'usePose') {
    next.usePose = Boolean(input.checked);
  } else if (setting === 'poseCentsPerUnit' || setting === 'poseCentsPerZone') {
    next.poseCentsPerZone = parseMoneyInput(input.value) ?? 0;
  } else if (setting === 'useLargeSizeSurcharge') {
    next.useLargeSizeSurcharge = false;
  } else if (setting === 'largeSizeSurchargeCents') {
    next.largeSizeSurchargeCents = parseMoneyInput(input.value) ?? 0;
  } else if (setting === 'useMargin') {
    next.useMargin = Boolean(input.checked);
  } else if (setting === 'marginPercent') {
    next.marginPercent = parsePercentInput(input.value);
  } else if (setting === 'salePriceMode') {
    next.salePriceMode = input.value === 'margin' ? 'margin' : 'amount';
  } else if (setting === 'targetGrossMarginPercent') {
    next.targetGrossMarginPercent = clamp(parsePercentInput(input.value), 0, 95);
  } else if (setting === 'useUrgentOrder') {
    next.useUrgentOrder = Boolean(input.checked);
    if (!next.useUrgentOrder) next.urgentOrderCents = null;
  } else if (setting === 'urgentOrderCents') {
    next.urgentOrderCents = parseMoneyInput(input.value) ?? 0;
  } else if (setting === 'splitSalePrice') {
    next.splitSalePrice = Boolean(input.checked);
  }
  state.pricingSettings = next;
  renderSummary();
}

function updateSizeQuantity(input, options = {}) {
  const { render = true } = options;
  const size = input.dataset.sizeQty;
  if (!SIZE_OPTIONS.includes(size)) return;
  state.sizeQuantities[size] = parseQuantityInput(input.value);
  updatePreviewQuantityTotal();
  if (render) renderSummary();
}

function updateQuantityMode(value) {
  const nextMode = normalizeQuantityMode(value);
  if (nextMode === state.quantityMode) return;
  if (nextMode === 'total' && !getTotalQuantityFromTotalMode()) {
    state.totalQuantity = getSizeQuantityTotal();
  }
  state.quantityMode = nextMode;
  state.totalLargeSizeQuantity = Math.min(getLargeSizeQuantityFromTotalMode(), getTotalQuantity());
  renderAll();
}

function updateTotalQuantity(input, options = {}) {
  const { render = true } = options;
  state.totalQuantity = parseQuantityInput(input.value);
  state.totalLargeSizeQuantity = Math.min(getLargeSizeQuantityFromTotalMode(), state.totalQuantity);
  ensureProjectTextiles();
  if (state.textiles.length === 1) state.textiles[0].quantity = state.totalQuantity;
  updatePreviewQuantityTotal();
  if (render) renderSummary();
}

function updateProjectTextileQuantity(input, options = {}) {
  const { render = true } = options;
  const textileId = input?.dataset.projectTextileQty;
  if (!textileId) return;
  const textile = state.textiles.find((item) => item.id === textileId);
  if (!textile) return;
  textile.quantity = parseQuantityInput(input.value);
  state.totalQuantity = getProjectTextileQuantityTotal();
  updatePreviewQuantityTotal();
  if (render) renderSummary();
}

function updateLargeSizeQuantity(input, options = {}) {
  const { render = true } = options;
  state.totalLargeSizeQuantity = Math.min(parseQuantityInput(input.value), getTotalQuantity());
  updatePreviewQuantityTotal();
  if (render) renderSummary();
}

function updateTextilePricingField(input, options = {}) {
  const { render = true } = options;
  const textileId = input?.dataset.id;
  const field = input?.dataset.textilePricingField;
  if (!textileId || !field) return;
  const textile = state.textiles.find((item) => item.id === textileId);
  if (!textile) return;
  const pricing = normalizeTextilePricing(textile.pricing);
  const raw = String(input.value ?? '').trim();
  if (field === 'marginPercent') {
    pricing.marginPercent = raw === '' ? null : clamp(parsePercentInput(raw), -999, 95);
    // Editing the target margin re-derives the suggested sale price.
    pricing.salePriceCents = null;
  } else if (field === 'salePriceCents') {
    let nextCents = raw === '' ? null : fromDisplaySaleCents(parseMoneyInput(raw) ?? 0);
    const simplifiedMode = normalizeSimplifiedUnitPriceMode(input.dataset.quoteSimplifiedMode);
    if (nextCents !== null && simplifiedMode !== 'off') {
      const extras = getQuoteBreakdown().simplifiedExtras?.perPieceCents || 0;
      nextCents = Math.max(0, nextCents - extras);
    }
    pricing.salePriceCents = nextCents;
  } else if (field === 'achatCents') {
    pricing.achatCents = raw === '' ? null : (parseMoneyInput(raw) ?? 0);
  } else {
    return;
  }
  textile.pricing = pricing;
  // Keep the target margin % in sync with the achieved margin whenever a fixed
  // sale price is in force (including negative margins when sale < cost).
  if (pricing.salePriceCents !== null && field !== 'marginPercent') {
    const resolved = resolveTextilePricing(textile);
    pricing.marginPercent = clamp(Math.round(resolved.marginRate), -999, 95);
    textile.pricing = pricing;
  }
  if (render) renderSummary();
}

function findTextileLayer(textileId, layerId) {
  const textile = state.textiles.find((item) => item.id === textileId);
  if (!textile) return { textile: null, layer: null };
  const layer = (textile.layers || []).find((item) => item.id === layerId) || null;
  return { textile, layer };
}

function syncLayerMarkingToActiveState(layerId, marking) {
  if (!layerId) return;
  const active = state.layers.find((item) => item.id === layerId);
  if (active) active.marking = cloneForHistory(marking);
}

function updateLayerMarkingField(input, options = {}) {
  const { render = true } = options;
  const textileId = input?.dataset.textileId;
  const layerId = input?.dataset.layerId;
  const field = input?.dataset.layerMarkingField;
  if (!textileId || !layerId || !field) return;
  const { textile, layer } = findTextileLayer(textileId, layerId);
  if (!textile || !layer) return;
  const marking = normalizeLayerMarking(layer.marking);
  const raw = String(input.value ?? '').trim();
  if (field === 'technique') {
    if (isCustomMarkingTechnique(raw)) {
      marking.technique = CUSTOM_MARKING_TECHNIQUE;
    } else {
      marking.technique = normalizeAvailableMarkingTechnique(raw);
    }
  } else if (field === 'techniqueCustom') {
    marking.technique = CUSTOM_MARKING_TECHNIQUE;
    marking.techniqueCustom = String(input.value ?? '').slice(0, 80);
  } else if (field === 'markingCents') {
    marking.markingCents = raw === '' ? null : (parseMoneyInput(raw) ?? 0);
    marking.materialCents = null;
    marking.poseCents = null;
  } else {
    return;
  }
  layer.marking = marking;
  syncLayerMarkingToActiveState(layerId, marking);
  if (textile.pricing?.salePriceCents !== null && textile.pricing?.salePriceCents !== undefined) {
    const resolved = resolveTextilePricing(textile);
    textile.pricing = {
      ...normalizeTextilePricing(textile.pricing),
      marginPercent: clamp(Math.round(resolved.marginRate), 0, 95),
    };
  }
  if (render) renderSummary();
}

function liveRefreshTextileBlockTotals(textileId) {
  if (!textileId) return;
  const textile = state.textiles.find((item) => item.id === textileId);
  if (!textile) return;
  const row = resolveTextilePricing(textile);
  const block = document.querySelector(`[data-textile-block="${String(textileId).replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"]`);
  if (!block) return;
  const markingEl = block.querySelector('.bat-order-cell-marking b');
  if (markingEl) markingEl.textContent = formatMoneyCents(row.markingCents);
  const markingDetail = block.querySelector('.bat-order-cell-marking em');
  if (markingDetail) {
    const count = row.markingLines.length;
    markingDetail.textContent = count > 0 ? `${count} marquage${count > 1 ? 's' : ''}` : 'Aucun marquage';
  }
  const costEl = block.querySelector('.bat-order-cell-costprice');
  if (costEl) costEl.textContent = formatMoneyCents(row.costCents);
  const marginCell = block.querySelector('.bat-order-cell-margin');
  if (marginCell) {
    marginCell.classList.remove('is-positive', 'is-warning', 'is-negative');
    marginCell.classList.add(`is-${orderMarginTone(row.marginRate, row.marginCents)}`);
  }
  const saleInput = block.querySelector('[data-textile-pricing-field="salePriceCents"]');
  if (saleInput && document.activeElement !== saleInput) {
    saleInput.value = formatSaleMoneyInput(row.saleCents);
  }
  const marginInput = block.querySelector('[data-textile-pricing-field="marginPercent"]');
  if (marginInput && document.activeElement !== marginInput) {
    marginInput.value = formatPercentInput(row.marginPercent);
  }
}

// Live (per-keystroke) refresh of a single pricing row without a full re-render,
// so the counterpart field (price ⇄ margin), the cost of goods and the margin
// amount all update instantly while the user keeps typing.
function liveUpdateTextilePricingRow(input) {
  const textileId = input?.dataset.id;
  const field = input?.dataset.textilePricingField;
  if (!textileId || !field) return;
  updateTextilePricingField(input, { render: false });
  const textile = state.textiles.find((item) => item.id === textileId);
  if (!textile) return;
  const row = resolveTextilePricing(textile);
  const orderRowEl = input.closest('.bat-order-row');
  const quoteLineEl = input.closest('.bat-quote-line');

  if (orderRowEl) {
    const costEl = orderRowEl.querySelector('.bat-order-cell-costprice');
    if (costEl) costEl.textContent = formatMoneyCents(row.costCents);

    const marginCell = orderRowEl.querySelector('.bat-order-cell-margin');
    if (marginCell) {
      marginCell.classList.remove('is-positive', 'is-warning', 'is-negative');
      marginCell.classList.add(`is-${orderMarginTone(row.marginRate, row.marginCents)}`);
      const marginValueEl = marginCell.querySelector('b');
      if (marginValueEl) marginValueEl.textContent = formatMoneyCents(row.marginCents);
    }

    const saleInput = orderRowEl.querySelector('[data-textile-pricing-field="salePriceCents"]');
    if (field !== 'salePriceCents' && saleInput && document.activeElement !== saleInput) {
      saleInput.value = formatSaleMoneyInput(row.saleCents);
    }
    const marginInput = orderRowEl.querySelector('[data-textile-pricing-field="marginPercent"]');
    if (field !== 'marginPercent' && marginInput && document.activeElement !== marginInput) {
      const marginValue = row.hasExplicitSale ? row.marginRate : row.marginPercent;
      marginInput.value = formatPercentInput(marginValue);
    }
  }

  if (quoteLineEl) {
    const quote = getQuoteBreakdown();
    const quoteRow = quote.textileRows.find((item) => item.id === textileId);
    const totalEl = quoteLineEl.querySelector('.bat-quote-line-total');
    if (totalEl && quoteRow) totalEl.textContent = formatSaleMoneyCents(quoteRow.saleTotalCents);
    const marginEl = quoteLineEl.querySelector('.bat-quote-line-margin');
    if (marginEl && quoteRow) {
      marginEl.classList.remove('is-positive', 'is-warning', 'is-negative', 'is-empty');
      marginEl.classList.add(`is-${orderMarginTone(quoteRow.marginRate, quoteRow.marginCents)}`);
      const amountEl = marginEl.querySelector('b');
      const rateEl = marginEl.querySelector('em');
      if (amountEl) amountEl.textContent = formatMoneyCents(quoteRow.marginTotalCents);
      if (rateEl) rateEl.textContent = formatProfitRate(quoteRow.marginRate);
    }
    const saleInput = quoteLineEl.querySelector('[data-textile-pricing-field="salePriceCents"]');
    if (field !== 'salePriceCents' && saleInput && document.activeElement !== saleInput && quoteRow) {
      saleInput.value = formatSaleMoneyInput(quoteRow.saleCents);
    }
  }
}

function updatePreviewQuantityTotal() {
  const total = getTotalQuantity();
  document.querySelectorAll('[data-preview-qty-total]').forEach((item) => {
    item.textContent = `${total} pièce${total > 1 ? 's' : ''}`;
  });
}

function updateBatField(input) {
  const field = input.dataset.batField;
  if (field === 'shippingCents' && !Object.prototype.hasOwnProperty.call(state.batConfig, field)) {
    state.batConfig.shippingCents = 0;
  }
  if (!Object.prototype.hasOwnProperty.call(state.batConfig, field)) return;
  if (field === 'technique') {
    state.batConfig[field] = normalizeAvailableMarkingTechnique(input.value);
  } else if (field === 'shippingCents') {
    state.batConfig[field] = parseMoneyInput(input.value) ?? 0;
  } else {
    state.batConfig[field] = String(input.value || '').trim();
  }
  renderSummary();
}

function updateProductionField(input) {
  const field = input.dataset.productionField;
  if (field === 'carrierPickup' && !Object.prototype.hasOwnProperty.call(state.productionConfig, field)) {
    state.productionConfig.carrierPickup = activeAdminDefaults.production.carrierPickup || 'Retrait atelier';
  }
  if (!Object.prototype.hasOwnProperty.call(state.productionConfig, field)) {
    if (field === 'quoteComment' || field === 'fabricationInstructions') {
      state.productionConfig[field] = '';
    } else {
      return;
    }
  }
  if (field === 'technique') {
    state.productionConfig.technique = normalizeAvailableMarkingTechnique(input.value);
    state.productionConfig.transferSupplier = transferSupplierForTechnique(state.productionConfig.technique, activeAdminDefaults);
  } else if (field === 'carrierPickup') {
    state.productionConfig.carrierPickup = normalizeCarrierPickup(input.value);
  } else {
    state.productionConfig[field] = String(input.value || '').trim();
  }
  renderSummary();
}

function updateProfitabilityField(input) {
  const field = input.dataset.profitabilityField;
  if (!Object.prototype.hasOwnProperty.call(state.profitabilityConfig, field)) return;
  if (input.type === 'checkbox') {
    state.profitabilityConfig[field] = Boolean(input.checked);
  } else if (field.endsWith('Cents')) {
    state.profitabilityConfig[field] = parseMoneyInput(input.value) ?? 0;
  } else if (field.endsWith('Minutes')) {
    state.profitabilityConfig[field] = parsePositiveDecimalInput(input.value);
  }
  renderSummary();
}

function openAdmin() {
  state.adminDraft = cloneForHistory(state.adminDefaults);
  state.adminOpen = true;
  renderAll();
}

function closeAdmin() {
  state.adminOpen = false;
  state.adminDraft = cloneForHistory(state.adminDefaults);
  renderAll();
}

function updateAdminDraftField(input) {
  const path = input.dataset.adminField;
  if (!path) return;
  const restoreScrollTop = input.closest('.bat-admin-body')?.scrollTop;
  const draft = normalizeAdminDefaults(state.adminDraft);
  let value;
  if (input.type === 'checkbox') {
    value = Boolean(input.checked);
  } else if (input.matches('[data-admin-money]')) {
    value = parseMoneyInput(input.value) ?? 0;
  } else if (input.type === 'number') {
    value = Number(input.value);
  } else if (path.endsWith('technique')) {
    value = normalizeAvailableMarkingTechnique(input.value, draft.production.markingSuppliers);
  } else if (path.endsWith('carrierPickup')) {
    value = normalizeCarrierPickup(input.value);
  } else {
    value = String(input.value || '').trim();
  }
  setAdminValue(draft, path, value);
  state.adminDraft = normalizeAdminDefaults(draft);
  const shouldRender = input.type === 'checkbox'
    || input.tagName === 'SELECT'
    || input.type === 'number'
    || input.matches('[data-admin-money]');
  if (shouldRender) renderAdminModal({ restoreScrollTop });
}

function updateAdminDraftZone(input) {
  const draft = normalizeAdminDefaults(state.adminDraft);
  const zoneId = input.value;
  const next = input.checked
    ? [...draft.compose.activeZoneIds, zoneId]
    : draft.compose.activeZoneIds.filter((id) => id !== zoneId);
  draft.compose.activeZoneIds = normalizeZoneIds(next);
  state.adminDraft = normalizeAdminDefaults(draft);
  renderAdminModal();
}

async function updateAdminLogo(input) {
  const file = input.files?.[0];
  if (!file) return;
  const isAcceptedImage = file.type.startsWith('image/') || /\.(png|jpe?g|svg)$/i.test(file.name);
  if (!isAcceptedImage) {
    alert('Ajoutez un logo au format PNG, JPEG ou SVG.');
    input.value = '';
    return;
  }
  const draft = normalizeAdminDefaults(state.adminDraft);
  draft.identity.companyLogoSrc = await readFileAsDataUrl(file);
  draft.identity.companyLogoName = file.name;
  state.adminDraft = normalizeAdminDefaults(draft);
  renderAdminModal();
}

function removeAdminLogo() {
  const draft = normalizeAdminDefaults(state.adminDraft);
  draft.identity.companyLogoSrc = '';
  draft.identity.companyLogoName = '';
  state.adminDraft = normalizeAdminDefaults(draft);
  renderAdminModal();
}

function saveAdminDefaults() {
  const previousDefaults = state.adminDefaults;
  const defaults = normalizeAdminDefaults(state.adminDraft);
  activeAdminDefaults = defaults;
  state.adminDefaults = cloneForHistory(defaults);
  state.adminDraft = cloneForHistory(defaults);
  saveAdminDefaultsToStorage(defaults);
  applyAdminDefaultsToEmptyCurrentFields(defaults, previousDefaults);
  state.adminOpen = false;
  renderAll();
}

function resetAdminDefaults() {
  state.adminDraft = createDefaultAdminDefaults();
  renderAdminModal();
}

function applyAdminDefaultsToEmptyCurrentFields(defaults, previousDefaults = null) {
  if (!state.batConfig.shippingCents) state.batConfig.shippingCents = defaults.bat.shippingCents;
  if (!state.productionConfig.textileSupplier) state.productionConfig.textileSupplier = defaults.production.textileSupplier;
  state.batConfig.technique = normalizeAvailableMarkingTechnique(state.batConfig.technique || defaults.bat.technique, defaults.production.markingSuppliers);
  state.productionConfig.technique = normalizeAvailableMarkingTechnique(state.productionConfig.technique || defaults.production.technique, defaults.production.markingSuppliers);
  const technique = state.productionConfig.technique;
  const previousAutoSupplier = previousDefaults ? transferSupplierForTechnique(technique, previousDefaults) : '';
  if (!state.productionConfig.transferSupplier || state.productionConfig.transferSupplier === previousAutoSupplier) {
    state.productionConfig.transferSupplier = transferSupplierForTechnique(technique, defaults);
  }
  if (!state.productionConfig.carrierPickup) state.productionConfig.carrierPickup = defaults.production.carrierPickup;
  applyProfitabilityDefaultsToCurrent(defaults, previousDefaults);
}

function applyProfitabilityDefaultsToCurrent(defaults, previousDefaults = null) {
  const next = normalizeProfitabilityConfig(defaults.profitability);
  const previous = normalizeProfitabilityConfig(previousDefaults?.profitability || createBaseProfitabilityDefaults());
  const current = normalizeProfitabilityConfig(state.profitabilityConfig);
  Object.keys(next).forEach((key) => {
    if (current[key] === previous[key]) current[key] = next[key];
  });
  state.profitabilityConfig = current;
}

function addBatOption() {
  state.batConfig.options.push({
    id: makeId('option'),
    label: 'Option',
    cents: 0,
    pricingMode: 'unit',
  });
  renderSummary();
}

function toggleBatOptionByLabel(template) {
  if (!template?.label) return;
  const existing = state.batConfig.options.find((option) => option.label === template.label);
  if (existing) {
    state.batConfig.options = state.batConfig.options.filter((option) => option.id !== existing.id);
    return;
  }
  state.batConfig.options.push({
    id: makeId('option'),
    label: template.label,
    cents: template.cents,
    pricingMode: template.pricingMode || 'global',
  });
}

function addQualityQuoteOption(id) {
  const templates = {
    vectorization: { label: 'Vectorisation du logo', cents: 5000, pricingMode: 'global' },
    'print-improvement': { label: "Amélioration du logo pour l'impression", cents: 5000, pricingMode: 'global' },
  };
  const template = templates[id];
  if (!template) return;
  toggleBatOptionByLabel(template);
  renderSummary();
  renderQualityReport();
}

function addRecommendedQuoteOption(id) {
  const template = getRecommendedQuoteOptionTemplates().find((option) => option.id === id);
  if (!template) return;
  toggleBatOptionByLabel(template);
  renderSummary();
}

function useSuggestedUnitPrice() {
  const pricing = getPricingBreakdown();
  const suggestedCents = pricing.targetMarginUnitCents ?? pricing.totalCents;
  state.priceOverrides.totalCents = suggestedCents;
  state.pricingSettings = {
    ...normalizePricingSettings(state.pricingSettings),
    splitSalePrice: false,
    salePriceMode: 'amount',
  };
  renderSummary();
}

function removeBatOption(id) {
  if (!id) return;
  state.batConfig.options = state.batConfig.options.filter((option) => option.id !== id);
  renderSummary();
}

function addProfitabilityOtherCost() {
  state.profitabilityConfig = normalizeProfitabilityConfig(state.profitabilityConfig);
  state.profitabilityConfig.otherCosts.push({
    id: makeId('cost'),
    label: 'Coût',
    cents: 0,
    pricingMode: 'global',
  });
  renderSummary();
}

function resetPackagingCost() {
  state.profitabilityConfig = normalizeProfitabilityConfig(state.profitabilityConfig);
  state.profitabilityConfig.packagingCents = null;
  renderSummary();
}

function removeProfitabilityOtherCost(id) {
  if (!id) return;
  state.profitabilityConfig = normalizeProfitabilityConfig(state.profitabilityConfig);
  state.profitabilityConfig.otherCosts = state.profitabilityConfig.otherCosts.filter((cost) => cost.id !== id);
  renderSummary();
}

function updateBatOption(input) {
  const optionId = input.closest('[data-option-id]')?.dataset.optionId;
  const option = state.batConfig.options.find((item) => item.id === optionId);
  if (!option) return;
  if (input.matches('[data-option-label]')) {
    option.label = String(input.value || '').trim() || 'Option';
  }
  if (input.matches('[data-option-price]')) {
    option.cents = parseMoneyInput(input.value) ?? 0;
  }
  if (input.matches('[data-option-pricing-mode]')) {
    option.pricingMode = input.value === 'global' ? 'global' : 'unit';
  }
  renderSummary();
}

function updateProfitabilityOtherCost(input) {
  state.profitabilityConfig = normalizeProfitabilityConfig(state.profitabilityConfig);
  const costId = input.closest('[data-other-cost-id]')?.dataset.otherCostId;
  const cost = state.profitabilityConfig.otherCosts.find((item) => item.id === costId);
  if (!cost) return;
  if (input.matches('[data-other-cost-label]')) {
    cost.label = String(input.value || '').trim() || 'Coût';
  }
  if (input.matches('[data-other-cost-price]')) {
    cost.cents = parseMoneyInput(input.value) ?? 0;
  }
  if (input.matches('[data-other-cost-pricing-mode]')) {
    cost.pricingMode = input.value === 'unit' ? 'unit' : 'global';
  }
  renderSummary();
}

function resetPriceOverrides() {
  state.priceOverrides.totalCents = null;
  state.priceOverrides.textileCents = null;
  state.priceOverrides.printCents = null;
  state.priceOverrides.poseCents = null;
  renderSummary();
}

function selectColor(id) {
  if (isCustomColorId(id)) {
    setCustomTextileColor(customColorHexFromId(id));
    return;
  }
  if (!getProductColors().some((item) => item.id === id)) return;
  state.colorId = id;
  renderAll();
}

function setCustomTextileColor(hex, options = {}) {
  const { render = true } = options;
  const normalized = normalizeHexColor(hex, DEFAULT_CUSTOM_TEXTILE_HEX);
  state.customColorHex = normalized;
  state.colorId = makeCustomColorId(normalized);
  if (!render) return;
  renderAll();
}

function selectWorkspace(id) {
  if (!WORKSPACE_MODES.some((mode) => mode.id === id)) return;
  if (isWorkspaceLocked(id)) return;
  state.workspaceMode = id;
  renderAll();
}

function selectRightColumnTab(id) {
  const tab = id === 'textile' ? 'textile' : 'logos';
  if (state.rightColumnTab === tab) return;
  state.rightColumnTab = tab;
  if (els.rightPanel) els.rightPanel.dataset.activeTab = state.rightColumnTab;
}

function toggleLeftPanel() {
  state.leftCollapsed = !state.leftCollapsed;
  applyPanelCollapseState();
}

function toggleRightPanel() {
  state.rightCollapsed = !state.rightCollapsed;
  applyPanelCollapseState();
}

function applyPanelCollapseState() {
  if (!els.app) return;
  els.app.classList.toggle('is-left-collapsed', state.leftCollapsed);
  els.app.classList.toggle('is-right-collapsed', state.rightCollapsed);
}

function setPriceDisplayMode(mode) {
  const next = mode === 'TTC' ? 'TTC' : 'HT';
  if (state.priceDisplayMode === next) return;
  state.priceDisplayMode = next;
  renderAll();
}

function isPreviewWorkspace() {
  return state.workspaceMode !== 'compose';
}

function toggleZone(id) {
  if (!ZONE_OPTIONS.some((option) => option.id === id)) return;
  const active = state.activeZoneIds.includes(id);
  if (active && state.activeZoneIds.length <= 1) return;
  state.activeZoneIds = active
    ? state.activeZoneIds.filter((zoneId) => zoneId !== id)
    : normalizeZoneIds([...state.activeZoneIds, id]);
  ensureCurrentViewIsActive();
  const selected = getSelectedLayer();
  if (selected && !state.activeZoneIds.includes(selected.viewId)) state.selectedLayerId = null;
  clearProductPreviewAdjustments();
  renderAll();
}

function updateZoneMarking(input) {
  const zoneId = input.dataset.zoneMarking;
  if (!ZONE_OPTIONS.some((option) => option.id === zoneId)) return;
  const value = ZONE_MARKING_TYPES.some((type) => type.id === input.value) ? input.value : 'print';
  state.zoneMarkings = normalizeZoneMarkings({
    ...state.zoneMarkings,
    [zoneId]: value,
  });
  renderViews();
  renderStage();
}

function updateCustomZoneSize(input) {
  const key = input.dataset.customZoneSize;
  if (!['width', 'height'].includes(key)) return;
  const next = normalizeCustomZoneSize({
    ...state.customZoneSize,
    [key]: Number(String(input.value || '').replace(',', '.')),
  });
  state.customZoneSize = next;
  state.layers
    .filter((layer) => layer.productId === state.productId && layer.viewId === 'custom')
    .forEach((layer) => fitLayerInsidePrintSize(layer, next));
  clearSurfacePreviewAdjustment('custom');
  renderAll();
}

function selectView(id) {
  if (!getActiveViews().some((view) => view.id === id)) return;
  state.viewId = id;
  const selected = getSelectedLayer();
  if (selected?.viewId !== id) state.selectedLayerId = null;
  renderAll();
  scrollPreviewViewIntoView(id);
}

function scrollPreviewViewIntoView(viewId) {
  requestAnimationFrame(() => {
    const frame = document.querySelector('.bat-stage-frame');
    const card = document.querySelector(`.bat-preview-card[data-preview-view-id="${viewId}"]`);
    if (!frame || !card) return;
    const frameRect = frame.getBoundingClientRect();
    const cardRect = card.getBoundingClientRect();
    const fullyVisible = cardRect.top >= frameRect.top - 2 && cardRect.bottom <= frameRect.bottom + 2;
    if (fullyVisible) return;
    card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  });
}

function triggerLogoUpload(viewId) {
  if (viewId && getActiveViews().some((view) => view.id === viewId)) {
    state.viewId = viewId;
    state.pendingUploadViewId = viewId;
  }
  const input = els.logoInput || document.querySelector('[data-logo-input]');
  if (!input) return;
  // Open the picker first while the user gesture is still active. Switching the
  // right-column tab before click() can cancel the dialog in Safari/Chrome.
  try {
    if (typeof input.showPicker === 'function') input.showPicker();
    else input.click();
  } catch {
    input.click();
  }
  requestAnimationFrame(() => selectRightColumnTab('logos'));
}

async function importFiles(files, options = {}) {
  const logoFiles = files.filter(isAcceptedLogoFile);
  if (files.length && !logoFiles.length) {
    alert('Formats acceptés : PNG, JPEG, AI ou PDF.');
    return;
  }

  if (logoFiles.length) pushHistory();
  const targetViewId = options.viewId || state.pendingUploadViewId;
  if (targetViewId && getActiveViews().some((view) => view.id === targetViewId)) {
    state.viewId = targetViewId;
  }
  for (const file of logoFiles) {
    let asset;
    if (isRasterLogoFile(file)) {
      asset = await createRasterLogoAsset(file);
    } else {
      try {
        asset = await createPdfLogoAsset(file);
      } catch (error) {
        console.error(error);
        alert(`${file.name} : lecture PDF/AI impossible. J'affiche une vignette de secours.`);
        asset = createVectorDocumentAsset(file);
      }
    }
    state.assets.push(asset);
    addAssetToView(asset.id, false, false, options.dropPoint || null);
  }
  state.pendingUploadViewId = null;
  renderAll();
}

async function importFilesAtClientPoint(files, canvasEl, clientX, clientY, viewId) {
  if (!files?.length) return;
  const product = getProduct();
  const dropPoint = printPositionFromClientPoint(clientX, clientY, canvasEl, product, viewId);
  await importFiles(files, { viewId, dropPoint });
}

function printPositionFromClientPoint(clientX, clientY, canvasEl, product = getProduct(), viewId = state.viewId) {
  const rect = canvasEl.getBoundingClientRect();
  const pctX = ((clientX - rect.left) / Math.max(1, rect.width)) * 100;
  const pctY = ((clientY - rect.top) / Math.max(1, rect.height)) * 100;
  const area = getPrintAreaPreviewRect(product, viewId);
  const inArea = pctX >= area.x
    && pctX <= area.x + area.w
    && pctY >= area.y
    && pctY <= area.y + area.h;
  if (!inArea) return null;
  const printSize = getPrintSize(product, viewId);
  return {
    x: ((pctX - area.x) / Math.max(1, area.w)) * printSize.width,
    y: ((pctY - area.y) / Math.max(1, area.h)) * printSize.height,
  };
}

function isAcceptedLogoFile(file) {
  return ACCEPTED_LOGO_EXTENSIONS.includes(fileExtension(file.name));
}

function isRasterLogoFile(file) {
  return RASTER_LOGO_EXTENSIONS.includes(fileExtension(file.name));
}

async function createRasterLogoAsset(file) {
  const src = await readFileAsDataUrl(file);
  const img = await loadImage(src);
  const width = img.naturalWidth || img.width;
  const height = img.naturalHeight || img.height;
  const prepared = await prepareLogoAsset(src, width, height, false);
  return createPreparedAsset(file, prepared);
}

async function createPdfLogoAsset(file) {
  if (!window.pdfjsLib) throw new Error('Lecteur PDF indisponible');
  const canvas = await importPdfLike(file);
  const prepared = await prepareLogoAsset(canvas.toDataURL('image/png'), canvas.width, canvas.height, true);
  return createPreparedAsset(file, prepared, {
    isVector: true,
    renderedFromPdf: true,
  });
}

async function importPdfLike(file) {
  const buffer = await file.arrayBuffer();
  const doc = await window.pdfjsLib.getDocument({ data: buffer }).promise;
  if (!doc.numPages) throw new Error('PDF vide');
  const page = await doc.getPage(1);
  const viewportBase = page.getViewport({ scale: 1 });
  const renderScale = Math.min(300 / 72, MAX_IMPORT_EDGE / Math.max(viewportBase.width, viewportBase.height));
  const viewport = page.getViewport({ scale: renderScale });
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(viewport.width));
  canvas.height = Math.max(1, Math.round(viewport.height));
  const ctx = canvas.getContext('2d', { alpha: true });
  await page.render({ canvasContext: ctx, viewport, background: 'rgba(0,0,0,0)' }).promise;
  return canvas;
}

async function createPreparedAsset(file, prepared, overrides = {}) {
  const normalized = await cropPreparedAssetToDetectedContent(prepared);
  const quality = await analyzeImageQuality(normalized.src, normalized.width, normalized.height);
  const palette = await detectLogoPalette(normalized.src, normalized.width, normalized.height);
  return {
    id: makeId('asset'),
    name: file.name.replace(/\.[^.]+$/, ''),
    src: normalized.src,
    width: normalized.width,
    height: normalized.height,
    isVector: overrides.isVector ?? normalized.isVector,
    sourceFormat: fileFormatLabel(file),
    renderedFromPdf: Boolean(overrides.renderedFromPdf),
    trimmed: normalized.trimmed,
    quality,
    palette,
  };
}

async function cropPreparedAssetToDetectedContent(prepared) {
  const quality = await analyzeImageQuality(prepared.src, prepared.width, prepared.height);
  if (!quality.boundsOriginal) {
    return prepared;
  }

  const pad = Math.max(3, Math.round(Math.max(prepared.width, prepared.height) * 0.006));
  const sourceX = clamp(Math.floor(quality.boundsOriginal.x - pad), 0, prepared.width - 1);
  const sourceY = clamp(Math.floor(quality.boundsOriginal.y - pad), 0, prepared.height - 1);
  const sourceRight = clamp(Math.ceil(quality.boundsOriginal.x + quality.boundsOriginal.w + pad), sourceX + 1, prepared.width);
  const sourceBottom = clamp(Math.ceil(quality.boundsOriginal.y + quality.boundsOriginal.h + pad), sourceY + 1, prepared.height);
  const sourceW = sourceRight - sourceX;
  const sourceH = sourceBottom - sourceY;
  const cropIsMeaningful = sourceW < prepared.width * 0.985 || sourceH < prepared.height * 0.985;
  if (!cropIsMeaningful) return prepared;

  const image = await loadImage(prepared.src);
  const canvas = document.createElement('canvas');
  canvas.width = sourceW;
  canvas.height = sourceH;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, sourceW, sourceH);
  ctx.drawImage(image, sourceX, sourceY, sourceW, sourceH, 0, 0, sourceW, sourceH);
  return {
    src: canvas.toDataURL('image/png'),
    width: sourceW,
    height: sourceH,
    isVector: false,
    trimmed: true,
  };
}

function fileExtension(name) {
  return String(name || '').split('.').pop().toLowerCase();
}

function fileFormatLabel(file) {
  const extension = fileExtension(file.name);
  if (extension === 'jpg' || extension === 'jpeg') return 'JPEG';
  return extension.toUpperCase();
}

function createVectorDocumentAsset(file) {
  const format = fileFormatLabel(file);
  const name = file.name.replace(/\.[^.]+$/, '');
  const width = 1200;
  const height = 1200;
  return {
    id: makeId('asset'),
    name,
    src: vectorDocumentPreview(name, format),
    width,
    height,
    isVector: true,
    sourceFormat: format,
    trimmed: false,
    quality: vectorDocumentQuality(),
    palette: [{ hex: '#111827', percent: 100 }],
  };
}

function vectorDocumentPreview(name, format) {
  return svgToDataUrl(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200">
      <rect width="1200" height="1200" rx="96" fill="#f8fafc"/>
      <rect x="176" y="142" width="848" height="916" rx="56" fill="#ffffff" stroke="#d0d5dd" stroke-width="18"/>
      <path d="M808 142v244h216" fill="#f1f5f9"/>
      <path d="M808 142v244h216" fill="none" stroke="#d0d5dd" stroke-width="18" stroke-linejoin="round"/>
      <rect x="312" y="462" width="576" height="156" rx="36" fill="#d8357d"/>
      <text x="600" y="565" text-anchor="middle" font-family="Arial, sans-serif" font-size="94" font-weight="900" fill="#ffffff">${escapeHtml(format)}</text>
      <text x="600" y="742" text-anchor="middle" font-family="Arial, sans-serif" font-size="58" font-weight="800" fill="#111827">${escapeHtml(name.slice(0, 22))}</text>
      <text x="600" y="832" text-anchor="middle" font-family="Arial, sans-serif" font-size="44" font-weight="700" fill="#667085">Fichier vectoriel</text>
    </svg>
  `);
}

function vectorDocumentQuality() {
  return {
    hasContent: true,
    hasWhitespace: false,
    whitespaceRatio: 0,
    transparentBackground: true,
    transparentPixels: 1,
    transparentRatio: 1,
    semiPixels: 0,
    semiRatio: 0,
    hasSemiTransparency: false,
    backgroundStatus: 'none',
    boundsCanvas: { x: 0, y: 0, w: 1200, h: 1200 },
    boundsOriginal: { x: 0, y: 0, w: 1200, h: 1200 },
    originalWidth: 1200,
    originalHeight: 1200,
    analysisWidth: 1200,
    analysisHeight: 1200,
    renderScale: 1,
    mask: null,
    contentRatio: 1,
    colorBucketCount: 1,
  };
}

function getAssetNativeSizeCm(asset, printSize) {
  const aspect = asset.width / Math.max(1, asset.height) || 1;
  const hasPixels = Number(asset.width) > 0 && Number(asset.height) > 0 && !asset.isVector;
  let w;
  let h;
  if (hasPixels) {
    w = (asset.width / QUALITY_DPI) * CM_PER_INCH;
    h = (asset.height / QUALITY_DPI) * CM_PER_INCH;
  } else {
    w = printSize.width * 0.48;
    h = w / aspect;
  }
  const maxW = Math.max(1, printSize.width);
  const maxH = Math.max(1, printSize.height);
  if (w > maxW || h > maxH) {
    const scale = Math.min(maxW / w, maxH / h);
    w *= scale;
    h *= scale;
  }
  return {
    w: Math.max(0.5, w),
    h: Math.max(0.5, h),
    aspect,
  };
}

function addAssetToView(assetId, shouldRender = true, shouldSaveHistory = true, dropPoint = null) {
  const asset = state.assets.find((item) => item.id === assetId);
  if (!asset) return;
  if (shouldSaveHistory) pushHistory();
  const product = getProduct();
  ensureCurrentViewIsActive(product);
  const printSize = getPrintSize(product, state.viewId);
  const { w, h, aspect } = getAssetNativeSizeCm(asset, printSize);
  let centerX;
  let centerY;
  if (dropPoint && Number.isFinite(dropPoint.x) && Number.isFinite(dropPoint.y)) {
    centerX = dropPoint.x;
    centerY = dropPoint.y;
  } else {
    const startRect = getLogoPlaceholderRect(product, state.viewId);
    const startPosition = previewRectCenterToPrintPosition(startRect, product, state.viewId);
    centerX = startPosition.x;
    centerY = startPosition.y;
  }
  const layer = {
    id: makeId('layer'),
    type: 'image',
    assetId: asset.id,
    productId: product.id,
    viewId: state.viewId,
    name: nextLogoName(),
    src: asset.src,
    aspect,
    x: centerX - w / 2,
    y: centerY - h / 2,
    w,
    h,
    rotation: 0,
    marking: createDefaultLayerMarking(),
  };
  state.layers.push(layer);
  state.selectedLayerId = layer.id;
  clearSurfacePreviewAdjustment(state.viewId, product);
  if (shouldRender) renderAll();
}

function removeAsset(assetId) {
  if (!assetId) return;
  pushHistory();
  state.assets = state.assets.filter((asset) => asset.id !== assetId);
  state.layers = state.layers.filter((layer) => layer.assetId !== assetId);
  clearProductPreviewAdjustments();
  if (!getSelectedLayer()) state.selectedLayerId = null;
  ensureWorkspaceAvailable();
  renderAll();
}

async function updateCustomProductPhoto(input) {
  const file = input.files?.[0];
  input.value = '';
  if (!file) return;
  if (!/^image\/(png|jpeg)$/.test(file.type) && !/\.(png|jpe?g)$/i.test(file.name)) {
    alert('Formats acceptés : PNG ou JPEG.');
    return;
  }
  pushHistory();
  const product = getProduct();
  const viewId = input.dataset.viewId || state.viewId;
  const src = await readFileAsDataUrl(file);
  state.customProductPhotos[customProductPhotoKey(product, viewId, state.colorId)] = {
    name: file.name,
    src,
  };
  renderStage();
}

function addTextLayer(viewId = state.viewId) {
  const product = getProduct();
  const targetViewId = viewId && getActiveViews(product).some((view) => view.id === viewId)
    ? viewId
    : state.viewId;
  if (targetViewId && getActiveViews(product).some((view) => view.id === targetViewId)) {
    state.viewId = targetViewId;
  }
  pushHistory();
  const printSize = getPrintSize(product, targetViewId);
  const text = (els.textContent?.value || '').trim() || 'Votre texte';
  const w = Math.min(printSize.width * 0.64, 20);
  const h = Math.min(printSize.height * 0.12, 4.8);
  const layer = {
    id: makeId('layer'),
    type: 'text',
    productId: product.id,
    viewId: targetViewId,
    name: text,
    text,
    font: els.textFont?.value || 'Arial',
    color: getDefaultTextLayerColor(product),
    aspect: w / h,
    x: (printSize.width - w) / 2,
    y: printSize.height * 0.34,
    w,
    h,
    rotation: 0,
    marking: createDefaultLayerMarking(),
  };
  state.layers.push(layer);
  state.selectedLayerId = layer.id;
  clearSurfacePreviewAdjustment(targetViewId, product);
  selectRightColumnTab('logos');
  renderAll();
  scrollPreviewViewIntoView(targetViewId);
}

// Picks the text colour: honours an explicit picker choice, but when the picker
// is still on the default dark colour and the textile is dark, defaults to white
// so freshly added text stays legible on dark garments.
function getDefaultTextLayerColor(product = getProduct()) {
  const picked = normalizeHexColor(els.textColor?.value, '#111827');
  if (picked.toLowerCase() !== '#111827') return picked;
  const color = getColor(product);
  return colorIsDark(color?.hex || '#ffffff') ? '#ffffff' : '#111827';
}

async function addSampleLogo() {
  const src = svgToDataUrl(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 260">
      <rect width="600" height="260" rx="32" fill="none"/>
      <path d="M86 183 170 52l84 131h-51l-33-58-34 58H86Z" fill="#111827"/>
      <path d="M282 83h188c31 0 56 25 56 56s-25 56-56 56H282V83Z" fill="#d8357d"/>
      <text x="304" y="152" font-family="Arial, sans-serif" font-size="58" font-weight="900" fill="#fff">LOGO</text>
    </svg>
  `);
  const img = await loadImage(src);
  const prepared = await prepareLogoAsset(src, img.width, img.height, true);
  const asset = {
    id: makeId('asset'),
    name: 'logo-demo',
    src: prepared.src,
    width: prepared.width,
    height: prepared.height,
    isVector: prepared.isVector,
    trimmed: prepared.trimmed,
    quality: await analyzeImageQuality(prepared.src, prepared.width, prepared.height),
    palette: await detectLogoPalette(prepared.src, prepared.width, prepared.height),
  };
  state.assets.push(asset);
  addAssetToView(asset.id);
}

function duplicateSelectedLayer() {
  const layer = getSelectedLayer();
  if (!layer) return;
  pushHistory();
  const product = getProduct();
  const ref = getGarmentReferenceSizeCm(product, layer.viewId);
  const duplicate = {
    ...layer,
    id: makeId('layer'),
    name: `${layer.name} copie`,
    x: clamp(layer.x + 1.2, -ref.width, ref.width),
    y: clamp(layer.y + 1.2, -ref.height, ref.height),
    marking: normalizeLayerMarking(layer.marking || createDefaultLayerMarking()),
  };
  state.layers.push(duplicate);
  state.selectedLayerId = duplicate.id;
  clearSurfacePreviewAdjustment(layer.viewId, product);
  renderAll();
}

function fitLayerInsidePrintSize(layer, printSize) {
  const aspect = layer.aspect || layer.w / Math.max(1, layer.h) || 1;
  if (layer.w > printSize.width) {
    layer.w = printSize.width;
    layer.h = layer.w / aspect;
  }
  if (layer.h > printSize.height) {
    layer.h = printSize.height;
    layer.w = layer.h * aspect;
  }
  layer.w = clamp(layer.w, 1, printSize.width);
  layer.h = clamp(layer.h, 1, printSize.height);
  layer.x = clamp(layer.x, 0, printSize.width - layer.w);
  layer.y = clamp(layer.y, 0, printSize.height - layer.h);
}

function sendSelectedLayerBackward() {
  moveSelectedLayerOrder(-1);
}

function bringSelectedLayerForward() {
  moveSelectedLayerOrder(1);
}

function moveSelectedLayerOrder(direction) {
  const layer = getSelectedLayer();
  if (!layer) return;
  const currentIndex = state.layers.findIndex((item) => item.id === layer.id);
  const siblings = state.layers
    .map((item, index) => ({ item, index }))
    .filter(({ item }) => item.productId === layer.productId && item.viewId === layer.viewId);
  const siblingIndex = siblings.findIndex(({ item }) => item.id === layer.id);
  const target = siblings[siblingIndex + direction];
  if (!target || currentIndex < 0) return;
  pushHistory();
  const current = state.layers[currentIndex];
  state.layers[currentIndex] = state.layers[target.index];
  state.layers[target.index] = current;
  renderAll();
}

function rotateSelectedLayer() {
  const layer = getSelectedLayer();
  if (!layer) return;
  pushHistory();
  layer.rotation = (Number(layer.rotation) || 0) + 15;
  if (layer.rotation > 180) layer.rotation -= 360;
  renderAll();
}

function nudgeSelectedLayer(dx, dy, shouldSaveHistory = true) {
  const layer = getSelectedLayer();
  if (!layer) return;
  if (shouldSaveHistory) pushHistory();
  const product = getProduct();
  // Free placement: allow the layer to travel across the whole garment, not just
  // the (removed) print zone. Bounds mirror updateSelectedLayerFromInputs.
  const ref = getGarmentReferenceSizeCm(product, layer.viewId);
  layer.x = clamp(layer.x + dx, -ref.width, ref.width);
  layer.y = clamp(layer.y + dy, -ref.height, ref.height);
  clearSurfacePreviewAdjustment(layer.viewId, product);
  renderAll();
}

function deleteSelectedLayer() {
  if (!state.selectedLayerId) return;
  const layer = getSelectedLayer();
  pushHistory();
  state.layers = state.layers.filter((layer) => layer.id !== state.selectedLayerId);
  if (layer) clearSurfacePreviewAdjustment(layer.viewId, getProduct());
  state.selectedLayerId = null;
  renderAll();
}

async function removeSelectedLogoBackground() {
  const layer = getSelectedLayer();
  const asset = getAssetForLayer(layer);
  if (!layer || layer.type !== 'image' || !asset) return;
  pushHistory();
  const prepared = await removeLogoBackground(asset.src, asset.width, asset.height);
  await applyPreparedLogoToAsset(asset, prepared);
}

async function trimSelectedLogoWhitespace() {
  const layer = getSelectedLayer();
  const asset = getAssetForLayer(layer);
  if (!layer || layer.type !== 'image' || !asset) return;
  pushHistory();
  const prepared = await prepareLogoAsset(asset.src, asset.width, asset.height, asset.isVector);
  await applyPreparedLogoToAsset(asset, prepared);
}

function getLogoEditorSelection() {
  const layer = getSelectedLayer();
  const asset = layer ? getAssetForLayer(layer) : null;
  if (!layer || layer.type !== 'image' || !asset) return null;
  return { layer, asset };
}

function logoEditorRoot() {
  return els.logoEditorModal;
}

function logoEditorNumber(selector, fallback) {
  const raw = logoEditorRoot()?.querySelector(selector)?.value;
  const value = Number(String(raw ?? '').replace(',', '.'));
  return Number.isFinite(value) ? value : fallback;
}

function logoEditorColor(selector, fallback) {
  return normalizeHexColor(logoEditorRoot()?.querySelector(selector)?.value, fallback);
}

async function mutateSelectedLogoPixels(mutator, options = {}) {
  const selection = getLogoEditorSelection();
  if (!selection) return;
  const { asset } = selection;
  pushHistory();
  const image = await loadImage(asset.src);
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, asset.width);
  canvas.height = Math.max(1, asset.height);
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  mutator(imageData.data, imageData.width, imageData.height);
  ctx.putImageData(imageData, 0, 0);
  const src = canvas.toDataURL('image/png');
  const prepared = options.trimAfter
    ? await prepareLogoAsset(src, canvas.width, canvas.height, false)
    : { src, width: canvas.width, height: canvas.height, isVector: false, trimmed: asset.trimmed };
  await applyPreparedLogoToAsset(asset, prepared);
}

function clearLogoPixelByDistance(data, idx, color, hardTolerance, feather) {
  if (data[idx + 3] < 8) return false;
  const distance = colorDistanceAt(data, idx, color);
  const softTolerance = hardTolerance + Math.max(0, feather);
  if (distance > softTolerance) return false;
  if (distance <= hardTolerance || feather <= 0) {
    data[idx + 3] = 0;
  } else {
    const keep = (distance - hardTolerance) / Math.max(1, softTolerance - hardTolerance);
    data[idx + 3] = Math.round(data[idx + 3] * keep);
  }
  return true;
}

function applyConnectedBackgroundRemoval(data, width, height, color, tolerance, feather) {
  const visited = new Uint8Array(width * height);
  const queue = [];
  const enqueue = (x, y) => {
    if (x < 0 || y < 0 || x >= width || y >= height) return;
    const p = y * width + x;
    if (visited[p]) return;
    const idx = p * 4;
    if (data[idx + 3] < 8) return;
    if (colorDistanceAt(data, idx, color) > tolerance + feather) return;
    visited[p] = 1;
    queue.push(p);
  };

  for (let x = 0; x < width; x += 1) {
    enqueue(x, 0);
    enqueue(x, height - 1);
  }
  for (let y = 0; y < height; y += 1) {
    enqueue(0, y);
    enqueue(width - 1, y);
  }

  for (let cursor = 0; cursor < queue.length; cursor += 1) {
    const p = queue[cursor];
    const x = p % width;
    const y = Math.floor(p / width);
    clearLogoPixelByDistance(data, p * 4, color, tolerance, feather);
    enqueue(x + 1, y);
    enqueue(x - 1, y);
    enqueue(x, y + 1);
    enqueue(x, y - 1);
  }
}

async function applyLogoEditorBackgroundRemoval() {
  const bg = hexToRgb(logoEditorColor('[data-logo-editor-bg-color]', '#ffffff'));
  const tolerance = clamp(logoEditorNumber('[data-logo-editor-bg-tolerance]', 46), 0, 180);
  const feather = clamp(logoEditorNumber('[data-logo-editor-bg-feather]', 28), 0, 120);
  const global = Boolean(logoEditorRoot()?.querySelector('[data-logo-editor-bg-global]')?.checked);
  await mutateSelectedLogoPixels((data, width, height) => {
    if (!global) {
      applyConnectedBackgroundRemoval(data, width, height, bg, tolerance, feather);
      return;
    }
    for (let i = 0; i < data.length; i += 4) {
      clearLogoPixelByDistance(data, i, bg, tolerance, feather);
    }
  }, { trimAfter: true });
}

async function applyLogoEditorRemoveSemiTransparency() {
  const threshold = clamp(logoEditorNumber('[data-logo-editor-semi-threshold]', 245), 1, 254);
  await mutateSelectedLogoPixels((data) => {
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] > 0 && data[i + 3] < threshold) data[i + 3] = 0;
    }
  }, { trimAfter: true });
}

async function applyLogoEditorRemovePickedColor() {
  const color = hexToRgb(logoEditorColor('[data-logo-editor-remove-color]', '#ffffff'));
  const tolerance = clamp(logoEditorNumber('[data-logo-editor-remove-tolerance]', 38), 0, 180);
  await mutateSelectedLogoPixels((data) => {
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] > 0 && colorDistanceAt(data, i, color) <= tolerance) data[i + 3] = 0;
    }
  }, { trimAfter: true });
}

async function applyLogoEditorReplacePickedColor() {
  const source = hexToRgb(logoEditorColor('[data-logo-editor-source-color]', '#111827'));
  const target = hexToRgb(logoEditorColor('[data-logo-editor-target-color]', '#d8357d'));
  const tolerance = clamp(logoEditorNumber('[data-logo-editor-color-tolerance]', 36), 0, 180);
  await mutateSelectedLogoPixels((data) => {
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] <= 0 || colorDistanceAt(data, i, source) > tolerance) continue;
      data[i] = target[0];
      data[i + 1] = target[1];
      data[i + 2] = target[2];
    }
  });
}

async function applyLogoEditorToneAdjustments() {
  const brightness = clamp(logoEditorNumber('[data-logo-editor-brightness]', 0), -100, 100) * 2.55;
  const contrastValue = clamp(logoEditorNumber('[data-logo-editor-contrast]', 0), -100, 100) * 2.55;
  const saturation = 1 + clamp(logoEditorNumber('[data-logo-editor-saturation]', 0), -100, 100) / 100;
  const contrast = (259 * (contrastValue + 255)) / (255 * (259 - contrastValue));
  await mutateSelectedLogoPixels((data) => {
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] <= 0) continue;
      let r = contrast * (data[i] - 128) + 128 + brightness;
      let g = contrast * (data[i + 1] - 128) + 128 + brightness;
      let b = contrast * (data[i + 2] - 128) + 128 + brightness;
      const gray = r * 0.299 + g * 0.587 + b * 0.114;
      r = gray + (r - gray) * saturation;
      g = gray + (g - gray) * saturation;
      b = gray + (b - gray) * saturation;
      data[i] = clamp(Math.round(r), 0, 255);
      data[i + 1] = clamp(Math.round(g), 0, 255);
      data[i + 2] = clamp(Math.round(b), 0, 255);
    }
  });
}

function pickLogoEditorSourceColor(hex) {
  const color = normalizeHexColor(hex, '');
  if (!color) return;
  const sourceInput = logoEditorRoot()?.querySelector('[data-logo-editor-source-color]');
  const removeInput = logoEditorRoot()?.querySelector('[data-logo-editor-remove-color]');
  if (sourceInput) sourceInput.value = color;
  if (removeInput) removeInput.value = color;
}

async function applyPreparedLogoToAsset(asset, prepared) {
  const aspect = prepared.width / Math.max(1, prepared.height);
  asset.src = prepared.src;
  asset.width = prepared.width;
  asset.height = prepared.height;
  asset.isVector = prepared.isVector;
  asset.trimmed = prepared.trimmed;
  asset.quality = await analyzeImageQuality(prepared.src, prepared.width, prepared.height);
  asset.palette = await detectLogoPalette(prepared.src, prepared.width, prepared.height);

  state.layers
    .filter((layer) => layer.assetId === asset.id)
    .forEach((layer) => {
      const product = products.find((item) => item.id === layer.productId) || getProduct();
      const printSize = getPrintSize(product, layer.viewId);
      const centerX = layer.x + layer.w / 2;
      const centerY = layer.y + layer.h / 2;
      layer.src = prepared.src;
      layer.aspect = aspect;
      layer.h = layer.w / Math.max(0.01, aspect);
      if (layer.h > printSize.height) {
        layer.h = printSize.height;
        layer.w = layer.h * aspect;
      }
      layer.x = clamp(centerX - layer.w / 2, 0, printSize.width - layer.w);
      layer.y = clamp(centerY - layer.h / 2, 0, printSize.height - layer.h);
      clearSurfacePreviewAdjustment(layer.viewId, product);
    });

  renderAll();
}

function resetDesign() {
  pushHistory();
  const defaultChoiceId = PRODUCT_QUICK_CHOICE_MAP.has(activeAdminDefaults.compose.productChoiceId)
    ? activeAdminDefaults.compose.productChoiceId
    : 'quick-tshirt';
  const defaultProductId = PRODUCT_QUICK_CHOICE_MAP.get(defaultChoiceId)?.witnessProductId || 'tshirt';
  const defaultProduct = getProductById(defaultProductId) || products[0];
  state.productId = defaultProduct.id;
  state.productCategoryId = getProductCategoryId(defaultProduct);
  state.productChoiceId = defaultChoiceId;
  state.colorId = getProductColors(defaultProduct)[0]?.id || state.colorId;
  state.viewId = getActiveViews(defaultProduct)[0]?.id || 'front';
  state.assets = [];
  state.layers = [];
  state.previewAdjustments = {};
  state.customProductPhotos = {};
  state.priceOverrides.totalCents = null;
  state.priceOverrides.textileCents = null;
  state.priceOverrides.printCents = null;
  state.priceOverrides.poseCents = null;
  state.pricingSettings = createDefaultPricingSettings();
  state.quantityMode = 'total';
  state.totalQuantity = createDefaultTotalQuantity();
  state.totalLargeSizeQuantity = 0;
  state.sizeQuantities = createEmptySizeQuantities();
  state.batConfig = createDefaultBatConfig();
  state.productionConfig = createDefaultProductionConfig();
  state.profitabilityConfig = createDefaultProfitabilityConfig();
  state.activeZoneIds = normalizeZoneIds(activeAdminDefaults.compose.activeZoneIds);
  state.zoneMarkings = normalizeZoneMarkings(activeAdminDefaults.compose.zoneMarkings);
  state.customZoneSize = normalizeCustomZoneSize(activeAdminDefaults.compose.customZoneSize);
  state.textiles = [];
  state.activeTextileId = '';
  ensureProjectTextiles();
  state.selectedLayerId = null;
  renderAll();
}

function captureEditorSnapshot() {
  syncActiveTextileFromState();
  return cloneForHistory({
    productId: state.productId,
    colorId: state.colorId,
    customColorHex: state.customColorHex,
    viewId: state.viewId,
    workspaceMode: state.workspaceMode,
    activeZoneIds: state.activeZoneIds,
    zoneMarkings: state.zoneMarkings,
    customZoneSize: state.customZoneSize,
    customerLevel: state.customerLevel,
    assets: state.assets,
    layers: state.layers,
    previewAdjustments: state.previewAdjustments,
    customProductPhotos: state.customProductPhotos,
    priceOverrides: state.priceOverrides,
    pricingSettings: state.pricingSettings,
    quantityMode: state.quantityMode,
    totalQuantity: state.totalQuantity,
    totalLargeSizeQuantity: state.totalLargeSizeQuantity,
    sizeQuantities: state.sizeQuantities,
    batConfig: state.batConfig,
    productionConfig: state.productionConfig,
    profitabilityConfig: state.profitabilityConfig,
    textiles: state.textiles,
    activeTextileId: state.activeTextileId,
    selectedLayerId: state.selectedLayerId,
  });
}

function restoreEditorSnapshot(snapshot) {
  if (!snapshot) return;
  state.productId = snapshot.productId;
  state.customColorHex = normalizeHexColor(snapshot.customColorHex, DEFAULT_CUSTOM_TEXTILE_HEX);
  state.colorId = isCustomColorId(snapshot.colorId)
    ? makeCustomColorId(customColorHexFromId(snapshot.colorId, state.customColorHex))
    : snapshot.colorId;
  state.viewId = snapshot.viewId;
  state.workspaceMode = snapshot.workspaceMode === 'bat' ? 'compose' : snapshot.workspaceMode;
  state.activeZoneIds = normalizeZoneIds(snapshot.activeZoneIds || placementToZoneIds(snapshot.placementId));
  state.zoneMarkings = normalizeZoneMarkings(snapshot.zoneMarkings);
  state.customZoneSize = normalizeCustomZoneSize(snapshot.customZoneSize);
  state.customerLevel = snapshot.customerLevel;
  state.assets = cloneForHistory(snapshot.assets || []);
  state.layers = cloneForHistory(snapshot.layers || []);
  state.previewAdjustments = cloneForHistory(snapshot.previewAdjustments || {});
  state.customProductPhotos = cloneForHistory(snapshot.customProductPhotos || {});
  state.priceOverrides = normalizePriceOverrides(snapshot.priceOverrides);
  state.pricingSettings = normalizePricingSettings(snapshot.pricingSettings || createDefaultPricingSettings());
  state.quantityMode = normalizeQuantityMode(snapshot.quantityMode);
  state.totalQuantity = parseQuantityInput(snapshot.totalQuantity ?? createDefaultTotalQuantity());
  state.totalLargeSizeQuantity = Math.min(
    parseQuantityInput(snapshot.totalLargeSizeQuantity),
    state.totalQuantity,
  );
  state.sizeQuantities = cloneForHistory(snapshot.sizeQuantities || createEmptySizeQuantities());
  state.batConfig = cloneForHistory(snapshot.batConfig || createDefaultBatConfig());
  state.productionConfig = cloneForHistory(snapshot.productionConfig || createDefaultProductionConfig());
  state.profitabilityConfig = normalizeProfitabilityConfig(snapshot.profitabilityConfig || createDefaultProfitabilityConfig());
  state.textiles = Array.isArray(snapshot.textiles)
    ? cloneForHistory(snapshot.textiles).map((textile) => normalizeTextileSnapshot(textile))
    : [];
  state.activeTextileId = snapshot.activeTextileId || state.textiles[0]?.id || '';
  ensureProjectTextiles();
  const activeTextile = getActiveTextile();
  if (activeTextile) applyTextileSnapshotToState(activeTextile);
  state.selectedLayerId = snapshot.selectedLayerId || null;
  state.drag = null;
  renderAll();
}

function pushHistory() {
  const snapshot = captureEditorSnapshot();
  state.history.push(snapshot);
  if (state.history.length > 40) state.history.shift();
  state.redoStack = [];
}

function undoLastChange() {
  const snapshot = state.history.pop();
  if (!snapshot) return;
  state.redoStack.push(captureEditorSnapshot());
  restoreEditorSnapshot(snapshot);
}

function redoLastChange() {
  const snapshot = state.redoStack.pop();
  if (!snapshot) return;
  state.history.push(captureEditorSnapshot());
  restoreEditorSnapshot(snapshot);
}

function cloneForHistory(value) {
  if (typeof structuredClone === 'function') return structuredClone(value);
  return JSON.parse(JSON.stringify(value));
}

function onLayerPointerDown(event) {
  const target = eventElement(event);
  if (!target) return;
  // Ignore UI controls (incl. zone action buttons). Use eventElement so text
  // nodes inside buttons don't throw and fall through to a destructive re-render.
  if (target.closest('input, textarea, select, button, a, label, .bat-preview-card-actions, .bat-photo-upload, [data-layer-toolbar]')) return;
  if (state.workspaceMode === 'production') {
    const previewViewEl = target.closest('[data-preview-view-id]');
    if (previewViewEl?.dataset.previewViewId) {
      state.viewId = previewViewEl.dataset.previewViewId;
    }
    renderAll();
    return;
  }
  if (state.workspaceMode === 'compose') {
    const previewViewEl = target.closest('[data-preview-view-id]');
    if (previewViewEl?.dataset.previewViewId) {
      state.viewId = previewViewEl.dataset.previewViewId;
    }

    const markingAreaEl = target.closest('[data-marking-area]');
    const layerEl = target.closest('.bat-layer');
    if (!layerEl || !markingAreaEl) {
      // Empty zones have no selection: skip renderAll so we don't rebuild the
      // DOM between pointerdown and click (which made the action buttons look dead).
      if (state.selectedLayerId) {
        state.selectedLayerId = null;
        renderAll();
      }
      return;
    }

    event.preventDefault();
    const layer = state.layers.find((item) => item.id === layerEl.dataset.layerId);
    if (!layer) return;
    pushHistory();
    const targetViewId = markingAreaEl.dataset.viewId || layer.viewId;
    if (layer.viewId !== targetViewId && viewIdMatches(layer.viewId, targetViewId)) {
      layer.viewId = targetViewId;
    }
    const wasSelected = state.selectedLayerId === layer.id;
    state.selectedLayerId = layer.id;
    state.viewId = layer.viewId;
    const areaRect = markingAreaEl.getBoundingClientRect();
    const dragProduct = getProductById(layer.productId) || getProduct();
    const refSize = getGarmentReferenceSizeCm(dragProduct, layer.viewId);
    state.drag = {
      mode: target.matches('[data-resize-handle]') ? 'resize' : 'move',
      scope: 'print',
      free: true,
      refWidthCm: refSize.width,
      refHeightCm: refSize.height,
      pointerId: event.pointerId,
      layerId: layer.id,
      startX: event.clientX,
      startY: event.clientY,
      areaWidth: areaRect.width,
      areaHeight: areaRect.height,
      initial: { ...layer },
      moved: false,
      selectedChanged: !wasSelected,
    };
    layerEl.setPointerCapture(event.pointerId);
    return;
  }
  if (isPreviewWorkspace()) {
    const groupEl = target.closest('[data-preview-group]');
    const previewViewEl = target.closest('[data-preview-view-id]');
    if (previewViewEl?.dataset.previewViewId) {
      state.viewId = previewViewEl.dataset.previewViewId;
    }
    if (!groupEl) {
      if (state.selectedLayerId) {
        state.selectedLayerId = null;
        renderAll();
      }
      return;
    }
    event.preventDefault();
    const product = getProduct();
    const viewId = groupEl.dataset.viewId || state.viewId;
    pushHistory();
    state.viewId = viewId;
    const areaRect = groupEl.closest('[data-preview-canvas]')?.getBoundingClientRect() || els.printArea.getBoundingClientRect();
    state.selectedLayerId = null;
    state.drag = {
      mode: target.matches('[data-resize-handle]') ? 'resize' : 'move',
      scope: 'preview',
      pointerId: event.pointerId,
      viewId,
      startX: event.clientX,
      startY: event.clientY,
      areaWidth: areaRect.width,
      areaHeight: areaRect.height,
      initialPreview: getSurfacePreviewRect(product, viewId),
    };
    groupEl.setPointerCapture(event.pointerId);
    return;
  }

  const composeViewEl = target.closest('[data-compose-view-id]');
  if (composeViewEl?.dataset.composeViewId) {
    state.viewId = composeViewEl.dataset.composeViewId;
  }

  const layerEl = target.closest('.bat-layer');
  if (!layerEl) {
    if (state.selectedLayerId) {
      state.selectedLayerId = null;
      renderAll();
    }
    return;
  }
  event.preventDefault();
  const layer = state.layers.find((item) => item.id === layerEl.dataset.layerId);
  if (!layer) return;
  pushHistory();
  const targetViewId = composeViewEl?.dataset.composeViewId || layer.viewId;
  if (layer.viewId !== targetViewId && viewIdMatches(layer.viewId, targetViewId)) {
    layer.viewId = targetViewId;
  }
  const wasSelected = state.selectedLayerId === layer.id;
  state.selectedLayerId = layer.id;
  state.viewId = layer.viewId;
  const areaRect = layerEl.closest('[data-composition-sheet]')?.getBoundingClientRect() || els.printArea.getBoundingClientRect();
  state.drag = {
    mode: target.matches('[data-resize-handle]') ? 'resize' : 'move',
    scope: 'print',
    pointerId: event.pointerId,
    layerId: layer.id,
    startX: event.clientX,
    startY: event.clientY,
    areaWidth: areaRect.width,
    areaHeight: areaRect.height,
    initial: { ...layer },
    moved: false,
    selectedChanged: !wasSelected,
  };
  layerEl.setPointerCapture(event.pointerId);
}

function onPointerMove(event) {
  if (!state.drag || event.pointerId !== state.drag.pointerId) return;
  state.drag.moved = true;
  if (state.drag.scope === 'preview') {
    updateSurfacePreviewFromPointer(event);
    renderStage();
    renderSummary();
    return;
  }
  const layer = getSelectedLayer();
  if (!layer) return;
  const product = getProductById(layer.productId) || getProduct();
  const printSize = getPrintSize(product, layer.viewId);
  const free = Boolean(state.drag.free);
  const refWidthCm = state.drag.refWidthCm || printSize.width;
  const refHeightCm = state.drag.refHeightCm || printSize.height;
  const dxCm = ((event.clientX - state.drag.startX) / Math.max(1, state.drag.areaWidth)) * refWidthCm;
  const dyCm = ((event.clientY - state.drag.startY) / Math.max(1, state.drag.areaHeight)) * refHeightCm;

  if (state.drag.mode === 'move') {
    if (free) {
      // No clamp: fully free placement across (and beyond) the whole textile.
      layer.x = state.drag.initial.x + dxCm;
      layer.y = state.drag.initial.y + dyCm;
    } else {
      layer.x = clamp(state.drag.initial.x + dxCm, 0, printSize.width - layer.w);
      layer.y = clamp(state.drag.initial.y + dyCm, 0, printSize.height - layer.h);
    }
  } else {
    const aspect = layer.aspect || state.drag.initial.w / Math.max(1, state.drag.initial.h) || 1;
    const scaleFromX = (state.drag.initial.w + dxCm) / Math.max(1, state.drag.initial.w);
    const scaleFromY = (state.drag.initial.h + dyCm) / Math.max(1, state.drag.initial.h);
    const dominantScale = Math.abs(dxCm / Math.max(1, state.drag.initial.w)) >= Math.abs(dyCm / Math.max(1, state.drag.initial.h))
      ? scaleFromX
      : scaleFromY;
    const maxW = free ? refWidthCm * 2 : Math.max(1, printSize.width - state.drag.initial.x);
    const maxH = free ? refHeightCm * 2 : Math.max(1, printSize.height - state.drag.initial.y);
    let nextW = Math.max(1, state.drag.initial.w * dominantScale);
    let nextH = nextW / aspect;
    if (nextH > maxH) {
      nextH = maxH;
      nextW = nextH * aspect;
    }
    if (nextW > maxW) {
      nextW = maxW;
      nextH = nextW / aspect;
    }
    layer.w = clamp(nextW, 1, maxW);
    layer.h = clamp(nextH, 1, maxH);
  }
  clearSurfacePreviewAdjustment(layer.viewId, product);
  updateCompositionLayerDom(layer, product);
  renderInspector();
  renderQualityReport();
  renderSummary();
}

function updateSurfacePreviewFromPointer(event) {
  const product = getProduct();
  const viewId = state.drag.viewId || state.viewId;
  const dx = ((event.clientX - state.drag.startX) / Math.max(1, state.drag.areaWidth)) * 100;
  const dy = ((event.clientY - state.drag.startY) / Math.max(1, state.drag.areaHeight)) * 100;
  const initial = state.drag.initialPreview || getSurfacePreviewRect(product, viewId);
  let next = { ...initial };
  if (state.drag.mode === 'move') {
    next.x = clamp(initial.x + dx, 0, 100 - initial.w);
    next.y = clamp(initial.y + dy, 0, 100 - initial.h);
  } else {
    const ratio = initial.h / Math.max(1, initial.w);
    let width = clamp(initial.w + dx, 2, 100 - initial.x);
    let height = width * ratio;
    if (height > 100 - initial.y) {
      height = 100 - initial.y;
      width = height / Math.max(0.01, ratio);
    }
    next.w = clamp(width, 2, 100 - initial.x);
    next.h = clamp(height, 2, 100 - initial.y);
  }
  state.previewAdjustments[previewAdjustmentKey(product, viewId)] = normalizePreviewRect(next);
}

function endDrag() {
  const drag = state.drag;
  state.drag = null;
  if (drag?.scope === 'print') {
    renderAll();
  }
}

function updateSelectedLayerFromInputs(event) {
  const layer = getSelectedLayer();
  if (!layer) return;
  const product = getProductById(layer.productId) || getProduct();
  const printSize = getPrintSize(product, layer.viewId);
  if (event.target === els.layerName && layer.type !== 'text') {
    layer.name = els.layerName.value || layerTypeLabel(layer);
  }
  if (event.target === els.layerText && layer.type === 'text') {
    layer.text = els.layerText.value || 'Votre texte';
    layer.name = layer.text;
  }
  if (event.target === els.layerFont && layer.type === 'text') layer.font = els.layerFont.value || 'Arial';
  if (event.target === els.layerColor && layer.type === 'text') layer.color = normalizeHexColor(els.layerColor.value, '#111827');
  const refSize = getGarmentReferenceSizeCm(product, layer.viewId);
  if (event.target === els.layerWidth) {
    layer.w = clamp(Number(els.layerWidth.value) || layer.w, 1, refSize.width);
    layer.h = layer.w / layer.aspect;
  }
  if (event.target === els.layerHeight) {
    layer.h = clamp(Number(els.layerHeight.value) || layer.h, 1, refSize.height);
    layer.w = layer.h * layer.aspect;
  }
  if (event.target === els.layerRotation) layer.rotation = Number(els.layerRotation.value) || 0;
  const ref = refSize;
  layer.w = clamp(layer.w, 1, ref.width);
  layer.h = clamp(layer.h, 1, ref.height);
  layer.x = clamp(layer.x, -ref.width, ref.width);
  layer.y = clamp(layer.y, -ref.height, ref.height);
  clearSurfacePreviewAdjustment(layer.viewId, product);
  renderStage();
  renderInspector();
  renderQualityReport();
  renderSummary();
}

function updateSelectedLayerFromLogoEditor(input) {
  const layer = getSelectedLayer();
  if (!layer) return;
  const product = getProductById(layer.productId) || getProduct();
  const printSize = getPrintSize(product, layer.viewId);
  const field = input.dataset.logoEditorField;
  const value = String(input.value || '').replace(',', '.');

  if (field === 'name') {
    layer.name = input.value || layerTypeLabel(layer);
  }

  const ref = getGarmentReferenceSizeCm(product, layer.viewId);
  if (field === 'width') {
    layer.w = clamp(Number(value) || layer.w, 1, ref.width);
    layer.h = layer.w / Math.max(0.01, layer.aspect || 1);
  }

  if (field === 'height') {
    layer.h = clamp(Number(value) || layer.h, 1, ref.height);
    layer.w = layer.h * Math.max(0.01, layer.aspect || 1);
  }

  if (field === 'rotation') {
    layer.rotation = Number(value) || 0;
  }

  layer.w = clamp(layer.w, 1, ref.width);
  layer.h = clamp(layer.h, 1, ref.height);
  layer.x = clamp(layer.x, -ref.width, ref.width);
  layer.y = clamp(layer.y, -ref.height, ref.height);
  clearSurfacePreviewAdjustment(layer.viewId, product);
  renderStage();
  renderInspector();
  renderQualityReport();
  renderSummary();
}

async function refreshCredits() {
  if (!creditConfig.required) {
    updateCreditUI();
    return null;
  }
  if (!creditConfig.isLoggedIn || !creditConfig.customerId) {
    creditState.ready = true;
    updateCreditUI();
    return null;
  }

  creditState.loading = true;
  updateCreditUI();
  const metafieldBalance = parseCreditBalance(els.app?.dataset.creditBalance);
  try {
    const response = await fetch(
      `${creditConfig.ledgerBase}/credit/balance?customer_id=${encodeURIComponent(creditConfig.customerId)}`
    );
    if (response.ok) {
      const data = await response.json().catch(() => ({}));
      const balance = parseCreditBalance(data.balance ?? data);
      if (balance !== null) creditState.balance = balance;
      else if (metafieldBalance !== null) creditState.balance = metafieldBalance;
    } else if (creditState.balance === null) {
      creditState.balance = metafieldBalance ?? creditConfig.initialBalance ?? 0;
    }
  } catch (error) {
    console.warn('Credit balance failed:', error);
    if (creditState.balance === null) {
      creditState.balance = metafieldBalance ?? creditConfig.initialBalance ?? 0;
    }
  }
  if (creditState.balance === null) creditState.balance = 0;
  creditState.ready = true;
  creditState.loading = false;
  if (els.app) els.app.dataset.creditBalance = String(creditState.balance);
  updateCreditUI();
  return creditState.balance;
}

function updateCreditUI() {
  if (!els.creditPill) return;
  if (!creditConfig.required) {
    els.creditPill.hidden = true;
    return;
  }

  const balance = Math.max(0, Number(creditState.balance) || 0);
  els.creditPill.hidden = false;
  els.creditPill.classList.toggle('is-loading', creditState.loading || creditState.consuming);
  els.creditPill.classList.toggle('is-empty', creditState.ready && balance <= 0);
  els.creditPill.classList.toggle('is-good', creditState.ready && balance > 0);

  if (!els.creditLabel || !els.creditCount) return;

  if (!creditConfig.isLoggedIn) {
    els.creditLabel.textContent = 'Connexion requise';
    els.creditCount.textContent = '-';
    return;
  }
  if (creditState.loading && !creditState.ready) {
    els.creditLabel.textContent = 'Crédits';
    els.creditCount.textContent = '...';
    return;
  }
  if (!creditState.ready) {
    els.creditLabel.textContent = 'Crédits';
    els.creditCount.textContent = '?';
    return;
  }
  els.creditLabel.textContent = balance > 1 ? 'Crédits' : 'Crédit';
  els.creditCount.textContent = String(balance);
}

function redirectToBuyCredits() {
  alert("Vous n'avez plus de crédits. Vous allez être redirigé pour en acheter.");
  window.setTimeout(() => {
    window.location.assign(creditConfig.buyUrl);
  }, 250);
}

function redirectToLoginForCredits() {
  alert('Connectez-vous pour télécharger avec vos crédits.');
  window.setTimeout(() => {
    window.location.href = getBatLoginRedirectUrl();
  }, 250);
}

function closeCreditModal(confirmed) {
  if (els.creditModal) els.creditModal.hidden = true;
  document.body.classList.remove('bat-credit-modal-open');
  if (creditModalResolve) {
    creditModalResolve(Boolean(confirmed));
    creditModalResolve = null;
  }
}

function bindCreditModalEvents() {
  els.creditModalCancel?.addEventListener('click', () => closeCreditModal(false));
  els.creditModalConfirm?.addEventListener('click', () => closeCreditModal(true));
  els.creditModal?.addEventListener('click', (event) => {
    if (event.target === els.creditModal) closeCreditModal(false);
  });
}

async function confirmDownloadCredit(formatLabel = 'BAT') {
  if (!creditConfig.required) return true;
  if (!creditConfig.isLoggedIn || !creditConfig.customerId) {
    redirectToLoginForCredits();
    return false;
  }

  await refreshCredits();
  if (!creditState.ready) {
    alert('Vérification des crédits impossible.');
    return false;
  }

  const balance = Math.max(0, Number(creditState.balance) || 0);
  if (balance <= 0) {
    redirectToBuyCredits();
    return false;
  }

  if (!els.creditModal) {
    return window.confirm('Ce téléchargement va consommer 1 crédit.');
  }

  if (els.creditModalTitle) {
    els.creditModalTitle.textContent = `Télécharger ${formatLabel}`;
  }
  if (els.creditModalText) {
    els.creditModalText.textContent = 'Ce téléchargement va consommer 1 crédit.';
  }
  if (els.creditModalBalance) {
    els.creditModalBalance.textContent = `Crédits disponibles : ${balance}. Après téléchargement : ${Math.max(0, balance - 1)}.`;
  }
  if (els.creditModalConfirm) {
    els.creditModalConfirm.textContent = 'Télécharger et utiliser 1 crédit';
  }

  try {
    closeDownloadMenu?.();
  } catch (error) {
    /* ignore */
  }
  els.creditModal.hidden = false;
  document.body.classList.add('bat-credit-modal-open');
  els.creditModalConfirm?.focus();

  return new Promise((resolve) => {
    creditModalResolve = resolve;
  });
}

async function consumeDownloadCredit() {
  if (!creditConfig.required) return true;
  if (!creditConfig.isLoggedIn || !creditConfig.customerId) {
    redirectToLoginForCredits();
    return false;
  }

  if (!creditState.ready) await refreshCredits();
  if (!creditState.ready) {
    alert('Vérification des crédits impossible.');
    return false;
  }
  if (Number(creditState.balance) <= 0) {
    redirectToBuyCredits();
    return false;
  }

  const beforeBalance = Number(creditState.balance) || 0;
  creditState.consuming = true;
  updateCreditUI();
  try {
    const response = await fetch(`${creditConfig.ledgerBase}/credit/use`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: creditConfig.customerId }),
    });
    if (!response.ok) {
      if (response.status >= 400 && response.status < 500) redirectToBuyCredits();
      else alert('Vérification des crédits impossible.');
      return false;
    }
    const data = await response.json().catch(() => ({}));
    const responseBalance = parseCreditBalance(data.balance ?? data);
    creditState.balance =
      responseBalance !== null ? responseBalance : Math.max(0, beforeBalance - 1);
    creditState.ready = true;
    if (els.app) els.app.dataset.creditBalance = String(creditState.balance);
    updateCreditUI();
    return true;
  } catch (error) {
    console.warn('Credit use failed:', error);
    alert('Vérification des crédits impossible.');
    return false;
  } finally {
    creditState.consuming = false;
    updateCreditUI();
  }
}

async function prepareDownloadCredit(formatLabel) {
  if (!(await confirmDownloadCredit(formatLabel))) return false;
  return consumeDownloadCredit();
}

async function exportPdf() {
  if (!projectHasLayers()) {
    alert('Ajoutez au moins un logo ou un texte avant de générer le BAT.');
    return;
  }
  if (!(await prepareDownloadCredit('le BAT'))) return;
  const pdf = await generateBatPdf();
  downloadBlob(pdf, `BAT-${getProjectFileSlug()}.pdf`);
}

async function exportProductionOrder() {
  if (!projectHasLayers()) {
    alert('Ajoutez au moins un logo ou un texte avant de générer le document de production.');
    return;
  }
  const pdf = await generateProductionOrderPdf();
  downloadBlob(pdf, `${getProductionFilePrefix()}-${getProjectFileSlug()}.pdf`);
}

async function exportProfitability() {
  const pdf = await generateProfitabilityPdf();
  downloadBlob(pdf, `Tarifs-marges-${getProjectFileSlug()}.pdf`);
}

async function exportQuote() {
  const pdf = await generateQuotePdf();
  downloadBlob(pdf, `Devis-${getProjectFileSlug()}.pdf`);
}

function getCurrentClientEmailContent() {
  const order = getOrderPricingBreakdown();
  const pricing = getPricingBreakdown();
  const quote = getQuoteBreakdown(order, pricing);
  const config = getBatConfig(getProduct());
  return getClientEmailContent(quote, config);
}

async function copyQuoteEmail() {
  const button = document.querySelector('[data-action="copy-quote-email"]');
  const textarea = document.querySelector('[data-quote-email-body]');
  const text = textarea ? textarea.value : getCurrentClientEmailContent().body;
  let copied = false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      copied = true;
    }
  } catch (error) {
    copied = false;
  }
  if (!copied && textarea) {
    textarea.focus();
    textarea.select();
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }
    window.getSelection?.()?.removeAllRanges?.();
  }
  if (button) {
    const original = button.textContent;
    button.textContent = copied ? 'Copié !' : 'Copie impossible';
    button.classList.toggle('is-done', copied);
    window.setTimeout(() => {
      button.textContent = original;
      button.classList.remove('is-done');
    }, 1600);
  }
}

function emailQuote() {
  const { subject, body } = getCurrentClientEmailContent();
  const href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = href;
}

async function generateQuotePdf() {
  return withProjectExportState(async () => buildPdfFromCanvases([await renderQuotePdfPage()]));
}

// Single client document: the quote first, then the BAT visual proof pages.
async function exportQuoteBat() {
  if (!projectHasLayers()) {
    alert('Ajoutez au moins un logo ou un texte avant de générer le devis + BAT.');
    return;
  }
  if (!(await prepareDownloadCredit('le Devis + BAT'))) return;
  const pdf = await generateQuoteBatPdf();
  downloadBlob(pdf, `Devis-BAT-${getProjectFileSlug()}.pdf`);
}

async function generateQuoteBatPdf() {
  // The BAT summary page already carries the price table, so we don't prepend a
  // separate quote page (that would duplicate the table for the client).
  return withProjectExportState(async (textiles) => {
    const canvases = [];
    for (const textile of textiles) {
      applyExportTextileSnapshot(textile);
      canvases.push(await renderBatTextilePage());
    }
    canvases.push(await renderBatSummaryPage());
    return buildPdfFromCanvases(canvases);
  });
}

async function exportLogosTextsPackage() {
  if (!projectHasLayers()) {
    alert('Ajoutez au moins un logo ou un texte avant de télécharger.');
    return;
  }
  if (!(await prepareDownloadCredit('les logos & textes'))) return;
  const slug = getProjectFileSlug();
  const files = await getClientAssetZipFiles();
  if (!files.length) {
    alert('Aucun logo ou texte à télécharger.');
    return;
  }
  const zip = await buildZip(files);
  downloadBlob(zip, `Logos-textes-${slug}.zip`);
}

async function exportDownloadPackage() {
  if (!projectHasLayers()) {
    alert('Ajoutez au moins un logo ou un texte avant de générer le dossier.');
    return;
  }
  if (!(await prepareDownloadCredit('le dossier BAT'))) return;
  const slug = getProjectFileSlug();
  const [quoteBatPdf, productionPdf, profitabilityPdf, assetFiles] = await Promise.all([
    generateQuoteBatPdf(),
    isProductionOrderAvailable() ? generateProductionOrderPdf() : Promise.resolve(null),
    generateProfitabilityPdf(),
    getClientAssetZipFiles(),
  ]);
  const files = [
    { name: `Devis-BAT-${slug}.pdf`, blob: quoteBatPdf },
    ...(productionPdf ? [{ name: `${getProductionFilePrefix()}-${slug}.pdf`, blob: productionPdf }] : []),
    { name: `Tarifs-marges-${slug}.pdf`, blob: profitabilityPdf },
    ...assetFiles,
  ];
  const zip = await buildZip(files);
  downloadBlob(zip, `Dossier-BAT-${slug}.zip`);
}

async function getClientAssetZipFiles() {
  const used = new Set();
  const uniqueName = (base, ext) => {
    let fileName = `${base}.${ext}`;
    let suffix = 2;
    while (used.has(fileName.toLowerCase())) {
      fileName = `${base}-${suffix}.${ext}`;
      suffix += 1;
    }
    used.add(fileName.toLowerCase());
    return fileName;
  };

  const logoFiles = [];
  const imageLayers = state.layers.filter((layer) => layer?.type === 'image' && getAssetForLayer(layer)?.src);
  for (let index = 0; index < imageLayers.length; index += 1) {
    const layer = imageLayers[index];
    const asset = getAssetForLayer(layer);
    const base = safeFileSlug(layer.name || asset.name || `logo-${index + 1}`);
    logoFiles.push({
      name: `logos/${uniqueName(base, 'png')}`,
      blob: await buildSizedLogoBlob(layer, asset),
    });
  }

  const textLayers = state.layers.filter((layer) => layer?.type === 'text' && String(layer.text || layer.name || '').trim());
  const textFiles = [];
  for (let index = 0; index < textLayers.length; index += 1) {
    const layer = textLayers[index];
    const base = safeFileSlug(layer.text || layer.name || `texte-${index + 1}`);
    textFiles.push({
      name: `logos/${uniqueName(base, 'pdf')}`,
      blob: await buildTextVectorPdf(layer),
    });
  }

  return [...logoFiles, ...textFiles];
}

const BAT_TEXT_EXPORT_FONTS = {
  Arial: { family: 'Roboto', weight: 800, localKey: 'Roboto' },
  Helvetica: { family: 'Roboto', weight: 800, localKey: 'Roboto' },
  Montserrat: { family: 'Montserrat', weight: 800, localKey: 'Roboto' },
  Inter: { family: 'Inter', weight: 800, localKey: 'Roboto' },
  Poppins: { family: 'Poppins', weight: 800, localKey: 'Poppins' },
  Roboto: { family: 'Roboto', weight: 800, localKey: 'Roboto' },
  Avenir: { family: 'Nunito', weight: 800, localKey: 'Roboto' },
  Futura: { family: 'Josefin Sans', weight: 700, localKey: 'Roboto' },
  Impact: { family: 'Anton', weight: 400, localKey: 'Anton' },
  'Trebuchet MS': { family: 'Cabin', weight: 700, localKey: 'Roboto' },
  Verdana: { family: 'Open Sans', weight: 700, localKey: 'Roboto' },
  Georgia: { family: 'Merriweather', weight: 700, localKey: 'Roboto' },
  'Times New Roman': { family: 'Libre Baskerville', weight: 700, localKey: 'Roboto' },
  'Courier New': { family: 'Roboto Mono', weight: 700, localKey: 'Roboto' },
};
const BAT_LOGO_EXPORT_MAX_EDGE = 8000;
const PT_PER_MM = 72 / 25.4;

function getPdfLib() {
  return typeof PDFLib !== 'undefined' ? PDFLib : window.PDFLib || null;
}

function getPdfFontkit() {
  return window.fontkit || window.Fontkit || window.PDFFontkit || null;
}

function batTextExportFont(fontName) {
  return BAT_TEXT_EXPORT_FONTS[fontName] || BAT_TEXT_EXPORT_FONTS.Arial;
}

function googleFontCssUrl(family, weight = 400) {
  const familyParam = String(family).trim().replace(/\s+/g, '+');
  // Never pass `&text=` here: Google already returns a tiny subset, and pdf-lib
  // subsetting that again produces Acrobat "unable to extract embedded font" errors.
  return `https://fonts.googleapis.com/css2?family=${familyParam}:wght@${weight}&display=swap`;
}

function batUnicodeRangeCovers(rangeText, codePoint) {
  const range = String(rangeText || '').trim();
  if (!range) return true; // no unicode-range ⇒ full face
  return range.split(',').some((part) => {
    const match = part.trim().match(/^U\+([0-9A-Fa-f]+)(?:-([0-9A-Fa-f]+))?$/i);
    if (!match) return false;
    const start = parseInt(match[1], 16);
    const end = match[2] ? parseInt(match[2], 16) : start;
    return codePoint >= start && codePoint <= end;
  });
}

function pickGoogleFontFileUrl(css, sampleText = 'A') {
  const faces = [];
  const faceRe = /@font-face\s*\{([\s\S]*?)\}/g;
  let faceMatch;
  while ((faceMatch = faceRe.exec(css))) {
    const block = faceMatch[1];
    const url = (block.match(/url\((['"]?)(https?:\/\/[^)'"]+)\1\)/) || [])[2] || '';
    if (!url) continue;
    const format = String((block.match(/format\((['"]?)([^)'"]+)\1\)/) || [])[2] || '').toLowerCase();
    const range = String((block.match(/unicode-range:\s*([^;]+)/i) || [])[1] || '');
    faces.push({ url, format, range });
  }
  if (!faces.length) {
    // Fallback: bare url() list (older CSS shape).
    const re = /url\((['"]?)(https?:\/\/[^)'"]+)\1\)(?:\s*format\((['"]?)([^)'"]+)\3\))?/g;
    let match;
    while ((match = re.exec(css))) {
      faces.push({ url: match[2], format: String(match[4] || '').toLowerCase(), range: '' });
    }
  }
  if (!faces.length) return '';

  const codePoints = [...String(sampleText || 'A')].map((ch) => ch.codePointAt(0) || 0x41);
  const needed = codePoints.length ? codePoints : [0x41];
  const rank = (format) => {
    if (format.includes('truetype') || format.includes('ttf')) return 0;
    if (format.includes('opentype') || format.includes('otf')) return 1;
    if (format.includes('woff2')) return 2;
    if (format.includes('woff')) return 3;
    return 4;
  };
  // Critical: Chrome CSS returns many unicode-range subsets. Picking the first
  // file often yields Cyrillic-only bytes → every Latin glyph becomes .notdef.
  const covering = faces.filter((face) => needed.every((cp) => batUnicodeRangeCovers(face.range, cp)));
  const pool = covering.length ? covering : faces.filter((face) => batUnicodeRangeCovers(face.range, 0x41));
  const ranked = (pool.length ? pool : faces).slice().sort((a, b) => rank(a.format) - rank(b.format));
  return ranked[0].url;
}

async function fetchGoogleFontBytes(family, weight = 400, sampleText = 'A') {
  // Browser fetch cannot override User-Agent; Google serves multi-face WOFF2 CSS.
  // pickGoogleFontFileUrl must select the latin (or covering) face — not the first URL.
  const cssRes = await fetch(googleFontCssUrl(family, weight), {
    mode: 'cors',
    headers: { Accept: 'text/css,*/*;q=0.1' },
  });
  if (!cssRes.ok) throw new Error(`Police Google indisponible : ${family}`);
  const css = await cssRes.text();
  const fontUrl = pickGoogleFontFileUrl(css, sampleText);
  if (!fontUrl) throw new Error(`Fichier de police introuvable : ${family}`);
  const fontRes = await fetch(fontUrl, { mode: 'cors' });
  if (!fontRes.ok) throw new Error(`Chargement de police impossible : ${family}`);
  return fontRes.arrayBuffer();
}

function batLocalTextFontUrl(exportFont) {
  const urls = (typeof window !== 'undefined' && window.SHERPA_BAT_TEXT_FONT_URLS) || {};
  const key = exportFont.localKey || exportFont.family || 'Roboto';
  return urls[key] || urls.Roboto || '';
}

async function getBatTextFontBytes(layer, fontCache) {
  const exportFont = batTextExportFont(layer.font || 'Arial');
  const sampleText = String(layer.text || layer.name || 'Aa').trim() || 'Aa';
  const localUrl = batLocalTextFontUrl(exportFont);
  const key = localUrl
    ? `local:${exportFont.localKey || exportFont.family}`
    : `google:${exportFont.family}:${exportFont.weight}:${sampleText}`;
  if (fontCache.has(key)) return fontCache.get(key);
  const fontPromise = (async () => {
    if (localUrl) {
      const res = await fetch(localUrl, { mode: 'cors' });
      if (!res.ok) throw new Error(`Police locale indisponible : ${exportFont.localKey || exportFont.family}`);
      return { bytes: new Uint8Array(await res.arrayBuffer()), exportFont };
    }
    const bytes = new Uint8Array(await fetchGoogleFontBytes(exportFont.family, exportFont.weight, sampleText));
    return { bytes, exportFont };
  })();
  fontCache.set(key, fontPromise);
  return fontPromise;
}

function pdfRgbFromHex(hex, rgbFn) {
  const [r, g, b] = pdfRgbChannelsFromHex(hex);
  return rgbFn(r, g, b);
}

function pdfRgbChannelsFromHex(hex) {
  const clean = String(hex || '#111827').replace('#', '');
  const value = /^[0-9a-fA-F]{6}$/i.test(clean) ? clean : '111827';
  return [
    parseInt(value.slice(0, 2), 16) / 255,
    parseInt(value.slice(2, 4), 16) / 255,
    parseInt(value.slice(4, 6), 16) / 255,
  ];
}

// Same approach as Lettres & Numéros: normalize fontkit path commands, then emit
// pdf-lib operators (outlines only — no embedded font in the PDF).
function normalizeBatGlyphCommands(rawCommands) {
  if (!Array.isArray(rawCommands)) return [];
  const result = [];
  rawCommands.forEach((cmd) => {
    const name = String(cmd?.command || cmd?.type || cmd?.cmd || cmd?.op || '')
      .replace(/[\s_-]+/g, '')
      .toLowerCase();
    let args = Array.isArray(cmd?.args) ? cmd.args.map((value) => Number(value) || 0) : [];
    if (!args.length && Array.isArray(cmd?.points)) {
      args = cmd.points.reduce((list, point) => {
        list.push(Number(point?.x) || 0, Number(point?.y) || 0);
        return list;
      }, []);
    }
    if (name === 'moveto' || name === 'move' || name === 'm') {
      result.push({ type: 'M', args: [args[0] || 0, args[1] || 0] });
    } else if (name === 'lineto' || name === 'line' || name === 'l') {
      result.push({ type: 'L', args: [args[0] || 0, args[1] || 0] });
    } else if (name === 'quadraticcurveto' || name === 'quadraticcurve' || name === 'quadratic' || name === 'q') {
      result.push({ type: 'Q', args: [args[0] || 0, args[1] || 0, args[2] || 0, args[3] || 0] });
    } else if (
      name === 'beziercurveto' || name === 'beziercurve' || name === 'curveto'
      || name === 'cubiccurveto' || name === 'cubiccurve' || name === 'cubic' || name === 'curve' || name === 'c'
    ) {
      result.push({
        type: 'C',
        args: [args[0] || 0, args[1] || 0, args[2] || 0, args[3] || 0, args[4] || 0, args[5] || 0],
      });
    } else if (name === 'closepath' || name === 'close' || name === 'z') {
      result.push({ type: 'Z', args: [] });
    }
  });
  return result;
}

// Port of Lettres & Numéros `glyphCommandsToPdfOperators` (src/render/pdfGlyphOps.ts).
function batGlyphCommandsToPdfOps(lib, commands, transform) {
  const ops = [];
  let current = { x: 0, y: 0 };
  let start = { x: 0, y: 0 };
  commands.forEach((cmd) => {
    const a = cmd.args;
    if (cmd.type === 'M') {
      current = { x: a[0] || 0, y: a[1] || 0 };
      start = { ...current };
      const p = transform(current.x, current.y);
      ops.push(lib.moveTo(p.x, p.y));
    } else if (cmd.type === 'L') {
      current = { x: a[0] || 0, y: a[1] || 0 };
      const p = transform(current.x, current.y);
      ops.push(lib.lineTo(p.x, p.y));
    } else if (cmd.type === 'Q') {
      const q1 = { x: a[0] || 0, y: a[1] || 0 };
      const q2 = { x: a[2] || 0, y: a[3] || 0 };
      const c1 = {
        x: current.x + (2 / 3) * (q1.x - current.x),
        y: current.y + (2 / 3) * (q1.y - current.y),
      };
      const c2 = {
        x: q2.x + (2 / 3) * (q1.x - q2.x),
        y: q2.y + (2 / 3) * (q1.y - q2.y),
      };
      const p1 = transform(c1.x, c1.y);
      const p2 = transform(c2.x, c2.y);
      const p3 = transform(q2.x, q2.y);
      ops.push(lib.appendBezierCurve(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y));
      current = q2;
    } else if (cmd.type === 'C') {
      const p1 = transform(a[0] || 0, a[1] || 0);
      const p2 = transform(a[2] || 0, a[3] || 0);
      const p3 = transform(a[4] || 0, a[5] || 0);
      ops.push(lib.appendBezierCurve(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y));
      current = { x: a[4] || 0, y: a[5] || 0 };
    } else if (cmd.type === 'Z') {
      ops.push(lib.closePath());
      current = { ...start };
    }
  });
  return ops;
}

function ensureBatBuffer() {
  if (typeof globalThis.Buffer !== 'undefined') return;
  // Minimal Buffer polyfill — fontkit expects Node's Buffer in the browser (LN does the same).
  class BatBuffer extends Uint8Array {
    static from(value, byteOffset, length) {
      if (typeof value === 'string') {
        const encoded = new TextEncoder().encode(value);
        return new BatBuffer(encoded.buffer, encoded.byteOffset, encoded.byteLength);
      }
      if (value instanceof ArrayBuffer) {
        const view = new Uint8Array(value, byteOffset || 0, length ?? value.byteLength);
        return new BatBuffer(view);
      }
      if (ArrayBuffer.isView(value)) {
        return new BatBuffer(value.buffer, value.byteOffset, value.byteLength);
      }
      return new BatBuffer(Uint8Array.from(value || []));
    }
    static isBuffer(value) {
      return value instanceof BatBuffer || value instanceof Uint8Array;
    }
  }
  globalThis.Buffer = BatBuffer;
}

function createBatFontkitFont(kit, fontBytes) {
  ensureBatBuffer();
  const bytes = fontBytes instanceof Uint8Array ? fontBytes : new Uint8Array(fontBytes || []);
  const buffer = typeof Buffer !== 'undefined' && typeof Buffer.from === 'function'
    ? Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength)
    : bytes;
  return kit.create(buffer);
}

function measureTextRunWidthMm(font, text, scaleMm) {
  const run = font.layout(text || ' ');
  let width = 0;
  run.positions.forEach((pos, index) => {
    width += pos.xAdvance || run.glyphs[index]?.advanceWidth || 0;
  });
  return width * scaleMm;
}

function fitTextFontSizeMm(font, lines, widthMm, heightMm) {
  const unitsPerEm = font.unitsPerEm || 1000;
  let sizeMm = Math.max(2, Math.min(heightMm / Math.max(1, lines.length) * 0.82, widthMm));
  while (sizeMm > 2) {
    const scaleMm = sizeMm / unitsPerEm;
    const tooWide = lines.some((line) => measureTextRunWidthMm(font, line, scaleMm) > widthMm * 0.96);
    const blockH = sizeMm * 1.08 * lines.length;
    if (!tooWide && blockH <= heightMm * 0.96) break;
    sizeMm -= 0.2;
  }
  return sizeMm;
}

function measureTextBlockInkMm(font, lines, fontSizeMm) {
  const unitsPerEm = font.unitsPerEm || 1000;
  const scaleMm = fontSizeMm / unitsPerEm;
  const lineHeightMm = fontSizeMm * 1.08;
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  const lineLayouts = lines.map((line, lineIndex) => {
    const run = font.layout(line || ' ');
    let cursorX = 0;
    // Fontkit y-up; first baseline at 0, next lines go down.
    const baselineY = -lineIndex * lineHeightMm;
    let hasInk = false;
    run.glyphs.forEach((glyph, glyphIndex) => {
      const pos = run.positions[glyphIndex] || {};
      const bbox = glyph.bbox;
      const originX = cursorX + (pos.xOffset || 0);
      const originY = baselineY / scaleMm + (pos.yOffset || 0);
      if (bbox && Number.isFinite(bbox.minX) && Number.isFinite(bbox.maxX)) {
        const x0 = (originX + bbox.minX) * scaleMm;
        const x1 = (originX + bbox.maxX) * scaleMm;
        const y0 = (originY + bbox.minY) * scaleMm;
        const y1 = (originY + bbox.maxY) * scaleMm;
        minX = Math.min(minX, x0);
        minY = Math.min(minY, y0);
        maxX = Math.max(maxX, x1);
        maxY = Math.max(maxY, y1);
        hasInk = true;
      }
      cursorX += pos.xAdvance || glyph.advanceWidth || 0;
    });
    if (!hasInk) {
      const advanceMm = measureTextRunWidthMm(font, line, scaleMm);
      minX = Math.min(minX, 0);
      maxX = Math.max(maxX, advanceMm);
      minY = Math.min(minY, baselineY - fontSizeMm * 0.2);
      maxY = Math.max(maxY, baselineY + fontSizeMm * 0.8);
    }
    return { text: line, baselineY, originX: 0 };
  });

  if (!Number.isFinite(minX) || !Number.isFinite(minY) || maxX <= minX || maxY <= minY) {
    const widthMm = Math.max(1, measureTextRunWidthMm(font, lines[0] || 'Texte', scaleMm));
    const heightMm = Math.max(1, fontSizeMm * Math.max(1, lines.length));
    return {
      widthMm,
      heightMm,
      minX: 0,
      minY: 0,
      fontSizeMm,
      lineHeightMm,
      lines: lineLayouts.map((item, index) => ({
        ...item,
        originX: 0,
        baselineY: heightMm - fontSizeMm * 0.82 - index * lineHeightMm,
      })),
    };
  }

  return {
    widthMm: maxX - minX,
    heightMm: maxY - minY,
    minX,
    minY,
    fontSizeMm,
    lineHeightMm,
    lines: lineLayouts,
  };
}

async function buildSizedLogoBlob(layer, asset) {
  const widthCm = Math.max(0.1, Number(layer.w) || 1);
  const heightCm = Math.max(0.1, Number(layer.h) || 1);
  let widthPx = Math.max(1, Math.round((widthCm / CM_PER_INCH) * QUALITY_DPI));
  let heightPx = Math.max(1, Math.round((heightCm / CM_PER_INCH) * QUALITY_DPI));
  const edgeScale = Math.min(1, BAT_LOGO_EXPORT_MAX_EDGE / Math.max(widthPx, heightPx));
  widthPx = Math.max(1, Math.round(widthPx * edgeScale));
  heightPx = Math.max(1, Math.round(heightPx * edgeScale));

  const image = await loadImage(asset.src || layer.src);
  const canvas = document.createElement('canvas');
  canvas.width = widthPx;
  canvas.height = heightPx;
  const ctx = canvas.getContext('2d', { alpha: true });
  ctx.clearRect(0, 0, widthPx, heightPx);
  ctx.drawImage(image, 0, 0, widthPx, heightPx);
  return canvasToPngBlob(canvas);
}

function canvasToPngBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) reject(new Error('Export PNG impossible'));
      else resolve(blob);
    }, 'image/png');
  });
}

async function buildTextVectorPdf(layer) {
  const lib = getPdfLib();
  const kit = getPdfFontkit();
  const requiredOps = [
    'rgb', 'moveTo', 'lineTo', 'appendBezierCurve', 'closePath',
    'fill', 'pushGraphicsState', 'popGraphicsState', 'setFillingColor',
  ];
  if (!kit?.create || !lib?.PDFDocument || requiredOps.some((name) => typeof lib[name] !== 'function')) {
    throw new Error('Export PDF texte indisponible (pdf-lib / fontkit).');
  }

  // Exact Lettres & Numéros pipeline: outline glyphs as PDF path operators
  // (no embedFont). Coordinates go through top-origin mm then flip to PDF space.
  const text = String(layer.text || layer.name || 'Texte').trim() || 'Texte';
  const lines = text.split(/\n+/).filter(Boolean);
  const safeLines = lines.length ? lines : ['Texte'];
  const boxWidthMm = Math.max(1, Number(layer.w) * 10 || 50);
  const boxHeightMm = Math.max(1, Number(layer.h) * 10 || 20);

  const fontCache = new Map();
  const { bytes: fontBytes } = await getBatTextFontBytes(layer, fontCache);
  const font = createBatFontkitFont(kit, fontBytes);
  // Guard: wrong Google unicode-range subset maps every letter to glyph 0 (.notdef boxes).
  const missingGlyphs = [];
  [...text].forEach((ch) => {
    if (/\s/.test(ch)) return;
    const codePoint = ch.codePointAt(0);
    const glyph = typeof font.glyphForCodePoint === 'function'
      ? font.glyphForCodePoint(codePoint)
      : null;
    if (!glyph || glyph.id === 0) missingGlyphs.push(ch);
  });
  if (missingGlyphs.length) {
    throw new Error(
      `Police incomplète pour « ${text} » (glyphes manquants : ${[...new Set(missingGlyphs)].join('')}).`,
    );
  }
  const fontSizeMm = fitTextFontSizeMm(font, safeLines, boxWidthMm, boxHeightMm);
  const unitsPerEm = font.unitsPerEm || 1000;
  const scaleMm = fontSizeMm / unitsPerEm;
  const lineHeightMm = fontSizeMm * 1.08;
  const [fillR, fillG, fillB] = pdfRgbChannelsFromHex(normalizeHexColor(layer.color, '#111827'));

  // Build placements in top-origin mm (same mental model as LN lineGlyphTransforms).
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  const drawnLines = safeLines.map((lineText, lineIndex) => {
    const run = font.layout(lineText || ' ');
    const baselineTopMm = lineIndex * lineHeightMm + fontSizeMm * 0.82;
    let cursorUnits = 0;
    const placements = [];
    run.glyphs.forEach((glyph, glyphIndex) => {
      if (glyph.id === 0) {
        cursorUnits += (run.positions[glyphIndex] || {}).xAdvance || glyph.advanceWidth || 0;
        return;
      }
      const pos = run.positions[glyphIndex] || {};
      const commands = normalizeBatGlyphCommands(glyph.path?.commands);
      const xUnits = cursorUnits + (pos.xOffset || 0);
      const yOffset = pos.yOffset || 0;
      const toMm = (x, y) => ({
        x: xUnits * scaleMm + x * scaleMm,
        y: baselineTopMm - yOffset * scaleMm - y * scaleMm,
      });
      if (commands.length) {
        let gMinX = Infinity;
        let gMinY = Infinity;
        let gMaxX = -Infinity;
        let gMaxY = -Infinity;
        const bbox = glyph.bbox;
        if (bbox && Number.isFinite(bbox.minX)) {
          const tl = toMm(bbox.minX, bbox.maxY);
          const br = toMm(bbox.maxX, bbox.minY);
          gMinX = Math.min(tl.x, br.x);
          gMaxX = Math.max(tl.x, br.x);
          gMinY = Math.min(tl.y, br.y);
          gMaxY = Math.max(tl.y, br.y);
        }
        if (Number.isFinite(gMinX)) {
          minX = Math.min(minX, gMinX);
          maxX = Math.max(maxX, gMaxX);
          minY = Math.min(minY, gMinY);
          maxY = Math.max(maxY, gMaxY);
        }
        placements.push({ commands, toMm });
      }
      cursorUnits += pos.xAdvance || glyph.advanceWidth || 0;
    });
    return placements;
  });

  if (!Number.isFinite(minX) || !Number.isFinite(minY) || maxX <= minX || maxY <= minY) {
    throw new Error(`Police non vectorisable pour « ${text} ».`);
  }

  const pageWidthMm = Math.max(1, maxX - minX);
  const pageHeightMm = Math.max(1, maxY - minY);
  const pdfDoc = await lib.PDFDocument.create();
  const page = pdfDoc.addPage([pageWidthMm * PT_PER_MM, pageHeightMm * PT_PER_MM]);

  const glyphPathOps = [];
  drawnLines.forEach((placements) => {
    placements.forEach(({ commands, toMm }) => {
      const transform = (x, y) => {
        const point = toMm(x, y);
        // LN: top-origin mm → PDF points with y flip from page height.
        return {
          x: (point.x - minX) * PT_PER_MM,
          y: (pageHeightMm - (point.y - minY)) * PT_PER_MM,
        };
      };
      glyphPathOps.push(...batGlyphCommandsToPdfOps(lib, commands, transform));
    });
  });

  if (!glyphPathOps.length) {
    throw new Error(`Police non vectorisable pour « ${text} ».`);
  }

  page.pushOperators(
    lib.pushGraphicsState(),
    lib.setFillingColor(lib.rgb(fillR, fillG, fillB)),
    ...glyphPathOps,
    lib.fill(),
    lib.popGraphicsState(),
  );

  // Object streams break some Illustrator placements; LN production PDFs stay compatible
  // when saved in classic xref mode.
  const bytes = await pdfDoc.save({ useObjectStreams: false });
  return new Blob([bytes], { type: 'application/pdf' });
}

function guessAssetFileExtension(asset) {
  const format = String(asset?.sourceFormat || '').toLowerCase();
  if (format === 'jpeg' || format === 'jpg') return 'jpg';
  if (format === 'png') return 'png';
  if (format === 'pdf') return 'pdf';
  const src = String(asset?.src || '');
  if (src.startsWith('data:image/jpeg')) return 'jpg';
  if (src.startsWith('data:image/png')) return 'png';
  if (src.startsWith('data:application/pdf')) return 'pdf';
  return 'png';
}

function dataUrlToBlob(dataUrl) {
  const header = String(dataUrl || '').split(',')[0] || '';
  const mime = /data:([^;]+)/.exec(header)?.[1] || 'application/octet-stream';
  return new Blob([dataUrlToBytes(dataUrl)], { type: mime });
}

async function generateBatPdf() {
  return withProjectExportState(async (textiles) => {
    const canvases = [];
    for (const textile of textiles) {
      applyExportTextileSnapshot(textile);
      canvases.push(await renderBatTextilePage());
    }
    canvases.push(await renderBatSummaryPage());
    return buildPdfFromCanvases(canvases);
  });
}

async function generateProductionOrderPdf() {
  return withProjectExportState(async (textiles) => {
    const canvases = [];
    for (const textile of textiles) {
      applyExportTextileSnapshot(textile);
      const product = getProduct();
      for (const view of getActiveViews(product)) {
        canvases.push(await renderProductionOrderPage(view.id));
      }
    }
    canvases.push(await renderProductionOrderSummaryPage());
    return buildPdfFromCanvases(canvases);
  });
}

async function generateProfitabilityPdf() {
  return withProjectExportState(async () => buildPdfFromCanvases([await renderProfitabilityPdfPage()]));
}

async function renderBatTextilePage() {
  const product = getProduct();
  const config = getBatConfig(product);
  const views = getActiveViews(product);
  const canvas = document.createElement('canvas');
  canvas.width = 1240;
  canvas.height = 1754;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#f5f7fa';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#ffffff';
  roundRect(ctx, 70, 70, 1100, 1614, 18);
  ctx.fill();

  ctx.fillStyle = '#171a22';
  ctx.font = '900 42px Arial';
  ctx.fillText('BAT - Simulation textile', 110, 145);
  ctx.font = '700 24px Arial';
  ctx.fillStyle = '#667085';
  drawPdfClippedText(ctx, product.fullLabel || product.label, 110, 188, 600);
  await drawPdfCompanyHeader(ctx, config, 760, 104, 370, 74);

  const gridX = 110;
  const gridY = 250;
  const gridWidth = 1020;
  const gridHeight = 1240;
  const columns = 2;
  const gap = 24;
  const rows = Math.max(1, Math.ceil(views.length / columns));
  const cardWidth = (gridWidth - gap) / columns;
  const cardHeight = Math.min(610, (gridHeight - gap * (rows - 1)) / rows);

  for (let index = 0; index < views.length; index += 1) {
    const view = views[index];
    const column = index % columns;
    const row = Math.floor(index / columns);
    const x = gridX + column * (cardWidth + gap);
    const y = gridY + row * (cardHeight + gap);
    await drawBatPreviewCard(ctx, view.id, x, y, cardWidth, cardHeight, product);
  }

  drawBatDisclaimer(ctx, 110, 1588, 900);
  ctx.fillStyle = '#667085';
  ctx.font = '700 18px Arial';
  ctx.fillText(new Date().toLocaleDateString('fr-FR'), 1010, 1606);
  return canvas;
}

async function drawBatPreviewCard(ctx, viewId, x, y, width, height, product = getProduct()) {
  const layers = viewLayers(viewId);
  ctx.fillStyle = '#ffffff';
  roundRect(ctx, x, y, width, height, 14);
  ctx.fill();
  ctx.strokeStyle = '#d9dee7';
  ctx.lineWidth = 2;
  roundRect(ctx, x, y, width, height, 14);
  ctx.stroke();

  ctx.fillStyle = '#f8fafc';
  roundRect(ctx, x, y, width, 64, 14);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(x, y + 48, width, 18);
  ctx.strokeStyle = '#e5e7eb';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(x, y + 64);
  ctx.lineTo(x + width, y + 64);
  ctx.stroke();

  ctx.fillStyle = '#171a22';
  ctx.font = '900 22px Arial';
  drawPdfClippedText(ctx, surfaceDisplayLabel(viewId, product), x + 22, y + 40, width * .46);
  ctx.fillStyle = '#667085';
  ctx.font = '800 17px Arial';
  drawPdfClippedText(ctx, layerCounterLabel(layers.length), x + width - 150, y + 39, 128);

  const detailHeight = layers.length ? Math.min(96, 34 + Math.min(layers.length, 2) * 28) : 46;
  const previewX = x + 24;
  const previewY = y + 86;
  const previewW = width - 48;
  const previewH = Math.max(120, height - 116 - detailHeight);
  await drawProductPreview(ctx, viewId, previewX, previewY, previewW, previewH, false);

  const detailsY = y + height - detailHeight + 12;
  if (!layers.length) {
    ctx.fillStyle = '#98a2b3';
    ctx.font = '800 17px Arial';
    ctx.fillText('Aucun marquage prévu', x + 24, detailsY + 16);
    return;
  }

  ctx.fillStyle = '#171a22';
  ctx.font = '900 16px Arial';
  ctx.fillText("Dimensions d'impression", x + 24, detailsY);
  layers.slice(0, 2).forEach((layer, index) => {
    ctx.fillStyle = '#667085';
    ctx.font = '700 15px Arial';
    const text = `${layer.name} · ${layerTypeLabel(layer)} · ${formatCm(layer.w)} x ${formatCm(layer.h)} cm`;
    drawPdfClippedText(ctx, text, x + 24, detailsY + 26 + index * 25, width - 48);
  });
  if (layers.length > 2) {
    ctx.fillStyle = '#98a2b3';
    ctx.font = '700 14px Arial';
    ctx.fillText(`+ ${layers.length - 2} autre${layers.length - 2 > 1 ? 's' : ''} marquage${layers.length - 2 > 1 ? 's' : ''}`, x + 24, y + height - 18);
  }
}

async function renderBatPage(viewId) {
  const product = getProduct();
  const config = getBatConfig(product);
  const view = getProductView(product, viewId);
  const canvas = document.createElement('canvas');
  canvas.width = 1240;
  canvas.height = 1754;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#f5f7fa';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#ffffff';
  roundRect(ctx, 70, 70, 1100, 1614, 18);
  ctx.fill();

  ctx.fillStyle = '#171a22';
  ctx.font = '900 42px Arial';
  ctx.fillText('BAT - Simulation textile', 110, 145);
  ctx.font = '700 24px Arial';
  ctx.fillStyle = '#667085';
  ctx.fillText(`${product.fullLabel || product.label} · ${surfaceDisplayLabel(view.id, product)}`, 110, 188);
  await drawPdfCompanyHeader(ctx, config, 760, 104, 370, 74);

  await drawProductPreview(ctx, viewId, 180, 240, 880, 880, false);

  ctx.fillStyle = '#171a22';
  ctx.font = '900 28px Arial';
  ctx.fillText("Dimensions d'impression", 110, 1200);
  const layers = viewLayers(viewId);
  let y = 1248;
  if (!layers.length) {
    ctx.font = '700 22px Arial';
    ctx.fillStyle = '#98a2b3';
    ctx.fillText('Aucun élément sur cette vue', 110, 1250);
  } else {
    layers.forEach((layer, index) => {
      ctx.fillStyle = index % 2 ? '#ffffff' : '#f3f5f8';
      roundRect(ctx, 110, y - 30, 1020, 54, 8);
      ctx.fill();
      ctx.fillStyle = '#171a22';
      ctx.font = '800 21px Arial';
      ctx.fillText(layer.name, 132, y + 7);
      ctx.fillStyle = '#667085';
      ctx.font = '700 19px Arial';
      ctx.fillText(`${layerTypeLabel(layer)} · ${formatCm(layer.w)} x ${formatCm(layer.h)} cm`, 620, y + 7);
      y += 64;
    });
  }

  drawBatDisclaimer(ctx, 110, 1588, 900);
  ctx.fillStyle = '#667085';
  ctx.font = '700 18px Arial';
  ctx.fillText(new Date().toLocaleDateString('fr-FR'), 1010, 1606);
  return canvas;
}

async function renderProductionOrderPage(viewId) {
  const product = getProduct();
  const config = getBatConfig(product);
  const production = getProductionConfig(product, config);
  const view = getProductView(product, viewId);
  const title = getProductionWorkspaceLabel();
  const isSubcontract = false;
  const canvas = document.createElement('canvas');
  canvas.width = 1240;
  canvas.height = 1754;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#f5f7fa';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#ffffff';
  roundRect(ctx, 70, 70, 1100, 1614, 18);
  ctx.fill();

  ctx.fillStyle = '#171a22';
  ctx.font = '900 42px Arial';
  ctx.fillText(title, 110, 145);
  ctx.font = '700 24px Arial';
  ctx.fillStyle = '#667085';
  ctx.fillText(`${production.textileReference} · ${surfaceDisplayLabel(view.id, product)}`, 110, 188);
  await drawPdfCompanyHeader(ctx, config, 760, 104, 370, 74);

  await drawProductPreview(ctx, viewId, 180, 240, 880, 880, false);

  ctx.fillStyle = '#171a22';
  ctx.font = '900 28px Arial';
  ctx.fillText(isSubcontract ? 'Fichiers et dimensions à commander' : 'Fichiers et dimensions à produire', 110, 1200);
  const layers = viewLayers(viewId);
  let y = 1248;
  if (!layers.length) {
    ctx.font = '700 22px Arial';
    ctx.fillStyle = '#98a2b3';
    ctx.fillText('Aucun marquage prévu sur cette zone', 110, 1250);
  } else {
    layers.forEach((layer, index) => {
      ctx.fillStyle = index % 2 ? '#ffffff' : '#f3f5f8';
      roundRect(ctx, 110, y - 30, 1020, 54, 8);
      ctx.fill();
      ctx.fillStyle = '#171a22';
      ctx.font = '800 21px Arial';
      drawPdfClippedText(ctx, layer.name, 132, y + 7, 420);
      ctx.fillStyle = '#667085';
      ctx.font = '700 19px Arial';
      ctx.fillText(`${layerTypeLabel(layer)} · ${formatCm(layer.w)} x ${formatCm(layer.h)} cm`, 620, y + 7);
      y += 64;
    });
  }

  ctx.fillStyle = '#667085';
  ctx.font = '700 18px Arial';
  ctx.fillText(isSubcontract ? 'Bon de commande fournisseur, sans information de marge.' : 'Document interne atelier, sans information tarifaire.', 110, 1606);
  ctx.fillText(new Date().toLocaleDateString('fr-FR'), 1010, 1606);
  return canvas;
}

async function renderBatSummaryPage() {
  const product = getProduct();
  const config = getBatConfig(product);
  const pricing = getPricingBreakdown();
  const order = getOrderPricingBreakdown();
  const projectRows = getProjectProductionRows();
  const canvas = document.createElement('canvas');
  canvas.width = 1240;
  canvas.height = 1754;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#f5f7fa';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#ffffff';
  roundRect(ctx, 70, 70, 1100, 1614, 18);
  ctx.fill();

  ctx.fillStyle = '#171a22';
  ctx.font = '900 42px Arial';
  ctx.fillText('Récapitulatif BAT', 110, 145);
  ctx.font = '700 24px Arial';
  ctx.fillStyle = '#667085';
  ctx.fillText(`${projectRows.length} textile${projectRows.length > 1 ? 's' : ''} dans le projet`, 110, 188);
  await drawPdfCompanyHeader(ctx, config, 760, 104, 370, 74);

  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText('Configuration', 110, 270);
  const configRows = [
    ['N° dossier', config.orderReference || '-'],
    ['Nom client', config.clientName || '-'],
    ['Textiles', getProjectTextileSummary(projectRows) || config.textileReference],
    ['Délai de fabrication', config.leadTime],
    ['Zones prévues', getProjectZoneSummary(projectRows)],
  ];
  let y = 315;
  configRows.forEach((row, index) => {
    drawPdfInfoRow(ctx, row[0], row[1], 110, y + index * 46, 1020);
  });

  y = 315 + configRows.length * 46 + 50;
  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText(normalizeQuantityMode(state.quantityMode) === 'sizes' ? 'Quantités par taille' : 'Quantité totale', 110, y);
  y += 34;
  y = drawPdfQuantitySummary(ctx, pricing, 110, y);

  // Dimensions per logo / marking (width × height in cm).
  const logoEntries = [];
  projectRows.forEach((textile) => {
    (textile.zones || []).forEach((zone) => {
      (zone.layers || []).forEach((layer) => {
        logoEntries.push({
          name: layer.name,
          detail: `${textile.label} · ${zone.label}`,
          dims: `${formatCm(layer.w)} × ${formatCm(layer.h)} cm`,
        });
      });
    });
  });
  y += 30;
  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText('Dimensions des logos (L × H)', 110, y);
  y += 14;
  if (!logoEntries.length) {
    ctx.fillStyle = '#98a2b3';
    ctx.font = '700 18px Arial';
    ctx.fillText('Aucun marquage positionné.', 132, y + 24);
    y += 40;
  } else {
    const maxLogos = 5;
    const shownLogos = logoEntries.slice(0, maxLogos);
    shownLogos.forEach((entry, index) => {
      const rowY = y + 24 + index * 32;
      ctx.fillStyle = index % 2 ? '#ffffff' : '#f8fafc';
      roundRect(ctx, 110, rowY - 22, 1020, 30, 8);
      ctx.fill();
      ctx.fillStyle = '#171a22';
      ctx.font = '800 16px Arial';
      drawPdfClippedText(ctx, entry.name, 132, rowY, 340);
      ctx.fillStyle = '#667085';
      ctx.font = '700 15px Arial';
      drawPdfClippedText(ctx, entry.detail, 490, rowY, 360);
      ctx.fillStyle = '#171a22';
      ctx.font = '800 16px Arial';
      ctx.fillText(entry.dims, 900, rowY);
    });
    y += 24 + shownLogos.length * 32;
    if (logoEntries.length > maxLogos) {
      ctx.fillStyle = '#98a2b3';
      ctx.font = '700 14px Arial';
      ctx.fillText(`+ ${logoEntries.length - maxLogos} autre(s) marquage(s)`, 132, y + 16);
      y += 26;
    }
  }

  y += 26;
  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText('Tableau de prix HT', 110, y);
  y += 36;
  const tableBottom = drawPdfPriceTable(ctx, pricing, 110, y, 1020, order);

  y = tableBottom + 36;
  const quoteComment = String(config.quoteComment || '').trim();
  if (quoteComment) {
    ctx.fillStyle = '#171a22';
    ctx.font = '900 27px Arial';
    ctx.fillText('Commentaire', 110, y);
    y += 28;
    ctx.fillStyle = '#667085';
    ctx.font = '700 17px Arial';
    y = drawPdfWrappedText(ctx, quoteComment, 110, y, 1020, 24) + 24;
  }

  y = Math.max(1268, y + 30);
  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText('Validation du BAT', 110, y);
  ctx.fillStyle = '#667085';
  ctx.font = '700 18px Arial';
  const validationTextBottom = drawPdfWrappedText(
    ctx,
    'En signant ce BAT, le client valide les références textile, quantités, dimensions, emplacements, tarifs HT et délai indiqués. Toute modification après validation peut entraîner un nouveau BAT et un ajustement tarifaire.',
    110,
    y + 38,
    1020,
    26,
  );

  y = Math.min(Math.max(1408, validationTextBottom + 38), 1428);
  drawPdfSignatureBox(ctx, 110, y, 1020, 170);

  drawBatDisclaimer(ctx, 110, 1624, 900);
  ctx.fillStyle = '#667085';
  ctx.font = '700 18px Arial';
  ctx.fillText(new Date().toLocaleDateString('fr-FR'), 1010, 1645);
  return canvas;
}

async function renderProductionOrderSummaryPage() {
  const product = getProduct();
  const batConfig = getBatConfig(product);
  const production = getProductionConfig(product, batConfig);
  const pricing = getPricingBreakdown();
  const title = getProductionWorkspaceLabel();
  const isSubcontract = false;
  const projectRows = getProjectProductionRows();
  const zoneRows = projectRows.flatMap((textile) => textile.zones.map((zone) => ({ textile, zone })));
  const canvas = document.createElement('canvas');
  canvas.width = 1240;
  canvas.height = 1754;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#f5f7fa';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#ffffff';
  roundRect(ctx, 70, 70, 1100, 1614, 18);
  ctx.fill();

  ctx.fillStyle = '#171a22';
  ctx.font = '900 42px Arial';
  ctx.fillText(title, 110, 145);
  ctx.font = '700 24px Arial';
  ctx.fillStyle = '#667085';
  ctx.fillText(isSubcontract ? 'Synthèse fournisseur' : 'Synthèse atelier', 110, 188);
  await drawPdfCompanyHeader(ctx, batConfig, 760, 104, 370, 74);

  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText('Dossier', 110, 270);
  const dossierRows = [
    ['N° dossier / commande', production.orderReference || '-'],
    ['Client final / projet', production.clientName || '-'],
    ['Textiles', getProjectTextileSummary(projectRows) || production.textileReference],
    ['Zones prévues', getProjectZoneSummary(projectRows)],
    ['Transporteur / retrait atelier', production.carrierPickup],
    ['Délai / date de fabrication', production.productionDeadline],
  ];
  let y = 315;
  const dossierRowStep = 42;
  dossierRows.forEach((row, index) => {
    drawPdfInfoRow(ctx, row[0], row[1], 110, y + index * dossierRowStep, 1020);
  });

  y = 315 + dossierRows.length * dossierRowStep + 46;
  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText(normalizeQuantityMode(state.quantityMode) === 'sizes' ? 'Quantités par taille' : 'Quantité totale', 110, y);
  y += 34;
  y = drawPdfQuantitySummary(ctx, pricing, 110, y);

  y += 26;
  const zonesStartY = y;
  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText('Zones, fichiers et dimensions', 110, y);
  y += 42;
  zoneRows.forEach(({ textile, zone }, index) => {
    const layers = zone.layers || [];
    const zoneY = y + index * 86;
    ctx.fillStyle = index % 2 ? '#ffffff' : '#f8fafc';
    roundRect(ctx, 110, zoneY - 28, 1020, 72, 8);
    ctx.fill();
    ctx.fillStyle = '#171a22';
    ctx.font = '900 18px Arial';
    drawPdfClippedText(ctx, `${textile.label} · ${zone.label}`, 132, zoneY, 450);
    ctx.fillStyle = '#667085';
    ctx.font = '800 15px Arial';
    ctx.fillText(`Zone utile ${zone.size}`, 880, zoneY);
    ctx.fillStyle = '#667085';
    ctx.font = '700 16px Arial';
    const layerText = layers.length
      ? layers.map((layer) => `${layer.name} ${formatCm(layer.w)} x ${formatCm(layer.h)} cm`).join(' · ')
      : 'Aucun marquage prévu';
    drawPdfClippedText(ctx, layerText, 132, zoneY + 28, 980);
  });

  y = zonesStartY + Math.max(1, zoneRows.length) * 86 + 34;
  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText(isSubcontract ? 'Consignes fournisseur' : 'Consignes opérateur', 110, y);
  y += 38;
  const notes = [
    ['Instructions de fabrication', production.fabricationInstructions],
    ['Préparation fichiers', production.filePrep],
    ['Pose / placement', production.placementNotes],
    ['Contrôle qualité atelier', production.qualityNotes],
    ['Conditionnement / livraison', production.packingNotes],
  ];
  notes.forEach(([label, value]) => {
    ctx.fillStyle = '#667085';
    ctx.font = '900 16px Arial';
    ctx.fillText(label, 110, y);
    ctx.fillStyle = '#171a22';
    ctx.font = '700 17px Arial';
    const nextY = drawPdfWrappedText(ctx, value || '-', 330, y, 780, 23);
    y = Math.max(y + 38, nextY + 24);
  });

  y = Math.min(Math.max(y + 16, 1420), 1480);
  ctx.fillStyle = '#171a22';
  ctx.font = '900 24px Arial';
  ctx.fillText(isSubcontract ? 'Checklist commande' : 'Checklist atelier', 110, y);
  y += 42;
  const checklistItems = isSubcontract
    ? [
      'Référence, couleur textile et quantités vérifiées',
      'Fichiers et dimensions joints au bon de commande',
      'Délai fournisseur confirmé',
      'Réception et contrôle prévus avant livraison client',
    ]
    : [
      'Référence, couleur textile et quantités vérifiées',
      'Dimensions et emplacements contrôlés avant production',
      'Test de pose / marquage validé',
      'Contrôle final et conditionnement réalisés',
    ];
  checklistItems.forEach((item) => {
    drawPdfChecklistLine(ctx, item, 110, y);
    y += 34;
  });

  ctx.fillStyle = '#667085';
  ctx.font = '700 18px Arial';
  ctx.fillText(isSubcontract ? 'Bon de commande fournisseur, sans information de marge.' : 'Document interne atelier, sans information tarifaire.', 110, 1645);
  ctx.fillText(`${pricing.quantityTotal || 0} pièce${pricing.quantityTotal > 1 ? 's' : ''}`, 950, 1645);
  return canvas;
}

async function renderProfitabilityPdfPage() {
  const product = getProduct();
  const config = getBatConfig(product);
  const pricing = getPricingBreakdown();
  const profitability = getProfitabilityBreakdown(pricing);
  const projectRows = getProjectProductionRows();
  const canvas = document.createElement('canvas');
  canvas.width = 1240;
  canvas.height = 1754;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#f5f7fa';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#ffffff';
  roundRect(ctx, 70, 70, 1100, 1614, 18);
  ctx.fill();

  ctx.fillStyle = '#171a22';
  ctx.font = '900 42px Arial';
  ctx.fillText('Tarifs & marges', 110, 145);
  ctx.font = '700 24px Arial';
  ctx.fillStyle = '#667085';
  ctx.fillText(`${projectRows.length} textile${projectRows.length > 1 ? 's' : ''} dans le projet`, 110, 188);
  await drawPdfCompanyHeader(ctx, config, 760, 104, 370, 74);

  const infoRows = [
    ['Textiles', getProjectTextileSummary(projectRows) || config.textileReference],
    ['Zones prévues', getProjectZoneSummary(projectRows)],
    ['Base de calcul', profitability.hasQuantity ? `${pricing.quantityTotal} pièce${pricing.quantityTotal > 1 ? 's' : ''}` : '1 unité BAT (aucune quantité renseignée)'],
    ['Date du calcul', new Date().toLocaleDateString('fr-FR')],
  ];
  let y = 260;
  infoRows.forEach((row, index) => {
    drawPdfInfoRow(ctx, row[0], row[1], 110, y + index * 46, 1020);
  });

  const order = getOrderPricingBreakdown();
  const kpi = {
    saleTotalCents: order.saleTotalCents,
    costTotalCents: order.costTotalCents,
    grossMarginCents: order.marginCents,
    grossMarginRate: order.marginRate,
    grossMarginPerPieceCents: order.marginPerPieceCents,
  };

  y += infoRows.length * 46 + 34;
  drawPdfProfitabilityKpis(ctx, kpi, 110, y, 1020);

  y += 238;
  y = drawPdfTextilePricingTable(ctx, order.rows, 110, y, 1020);

  y += 42;
  const globalRows = [
    { label: 'Livraison / transport', detail: 'Coût global commande', amountCents: order.deliveryCents },
    ...(order.fileSetupCents > 0
      ? [{ label: 'Préparation fichiers', detail: 'Mise en place / calage', amountCents: order.fileSetupCents }]
      : []),
    { label: 'Autres coûts', detail: 'Coûts additionnels', amountCents: order.otherCostsCents },
  ];
  if (order.rushEnabled) {
    globalRows.push({ label: 'Supplément urgence', detail: 'Majoration commande urgente', amountCents: order.rushCents });
  }
  y = drawPdfProfitabilityTable(ctx, 'Coûts globaux & suppléments HT', globalRows, 110, y, 1020);

  const selectedOptionRows = pricing.options.map((option) => ({
    label: option.label,
    detail: option.pricingMode === 'global'
      ? 'Option · forfait global'
      : `${formatMoneyCents(option.unitCents)} / unité × ${pricing.quantityTotal}`,
    amountCents: option.totalCents,
  }));
  if (selectedOptionRows.length) {
    y += 28;
    y = drawPdfProfitabilityTable(ctx, 'Options client sélectionnées HT', selectedOptionRows, 110, y, 1020);
  }

  y = Math.min(Math.max(y + 42, 1500), 1540);
  const marginTone = orderMarginTone(order.marginRate, order.marginCents);
  const toneBg = marginTone === 'negative' ? '#fef2f2' : marginTone === 'warning' ? '#fffbeb' : '#ecfdf3';
  const toneInk = orderMarginToneInk(marginTone);
  ctx.fillStyle = toneBg;
  roundRect(ctx, 110, y, 1020, 78, 10);
  ctx.fill();
  ctx.fillStyle = toneInk;
  ctx.font = '900 18px Arial';
  ctx.fillText('Marge globale de la commande', 132, y + 30);
  ctx.fillStyle = '#667085';
  ctx.font = '700 16px Arial';
  drawPdfWrappedText(
    ctx,
    'Cumul des marges par textile et des coûts globaux (livraison, préparation, urgence). Document interne, à ne pas transmettre au client final.',
    132,
    y + 58,
    720,
    22,
  );
  ctx.fillStyle = toneInk;
  ctx.font = '900 30px Arial';
  ctx.textAlign = 'right';
  ctx.fillText(formatMoneyCents(order.marginCents), 1108, y + 40);
  ctx.font = '900 18px Arial';
  ctx.fillText(formatProfitRate(order.marginRate), 1108, y + 66);
  ctx.textAlign = 'left';

  ctx.fillStyle = '#667085';
  ctx.font = '700 18px Arial';
  ctx.fillText('Rentabilité interne de la commande.', 110, 1645);
  ctx.fillText(formatProfitRate(order.marginRate), 1010, 1645);
  return canvas;
}

async function renderQuotePdfPage() {
  const product = getProduct();
  const config = getBatConfig(product);
  const order = getOrderPricingBreakdown();
  const pricing = getPricingBreakdown();
  const quote = getQuoteBreakdown(order, pricing);
  const projectRows = getProjectProductionRows();
  const canvas = document.createElement('canvas');
  canvas.width = 1240;
  canvas.height = 1754;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#f5f7fa';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#ffffff';
  roundRect(ctx, 70, 70, 1100, 1614, 18);
  ctx.fill();

  ctx.fillStyle = '#171a22';
  ctx.font = '900 42px Arial';
  ctx.fillText('Devis', 110, 145);
  ctx.font = '700 24px Arial';
  ctx.fillStyle = '#667085';
  ctx.fillText(`${quote.quantityTotal} pièce${quote.quantityTotal > 1 ? 's' : ''} · ${projectRows.length} textile${projectRows.length > 1 ? 's' : ''}`, 110, 188);
  await drawPdfCompanyHeader(ctx, config, 760, 104, 370, 74);

  const infoRows = [
    ['Client', config.clientName || '-'],
    ['N° de devis', config.orderReference || '-'],
    ['Délai de fabrication', config.leadTime || '-'],
    ['Date', new Date().toLocaleDateString('fr-FR')],
  ];
  let y = 260;
  infoRows.forEach((row, index) => {
    drawPdfInfoRow(ctx, row[0], row[1], 110, y + index * 46, 1020);
  });
  y += infoRows.length * 46 + 30;

  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText('Détail du devis (HT)', 110, y);
  y = drawPdfQuoteTable(ctx, quote, 110, y, 1020);

  y += 30;
  const boxW = 460;
  const boxX = 110 + 1020 - boxW;
  ctx.fillStyle = '#f8fafc';
  roundRect(ctx, boxX, y, boxW, 150, 12);
  ctx.fill();
  ctx.fillStyle = '#667085';
  ctx.font = '800 18px Arial';
  ctx.fillText('Total HT', boxX + 24, y + 38);
  ctx.fillText(`TVA (${Math.round(getVatRate() * 100)} %)`, boxX + 24, y + 80);
  ctx.fillStyle = '#171a22';
  ctx.font = '800 18px Arial';
  ctx.textAlign = 'right';
  ctx.fillText(formatMoneyCents(quote.totalHtCents), boxX + boxW - 24, y + 38);
  ctx.fillText(formatMoneyCents(quote.vatCents), boxX + boxW - 24, y + 80);
  ctx.textAlign = 'left';
  ctx.fillStyle = '#eff6ff';
  roundRect(ctx, boxX, y + 100, boxW, 50, 10);
  ctx.fill();
  ctx.fillStyle = '#171a22';
  ctx.font = '900 20px Arial';
  ctx.fillText('Total TTC', boxX + 24, y + 132);
  ctx.fillStyle = '#1d4ed8';
  ctx.font = '900 24px Arial';
  ctx.textAlign = 'right';
  ctx.fillText(formatMoneyCents(quote.totalTtcCents), boxX + boxW - 24, y + 132);
  ctx.textAlign = 'left';

  y += 170;
  const quoteComment = String(config.quoteComment || '').trim();
  if (quoteComment) {
    ctx.fillStyle = '#171a22';
    ctx.font = '900 24px Arial';
    ctx.fillText('Commentaire', 110, y);
    y += 26;
    ctx.fillStyle = '#667085';
    ctx.font = '700 17px Arial';
    y = drawPdfWrappedText(ctx, quoteComment, 110, y, 1020, 24) + 16;
  }

  const signatureY = Math.min(Math.max(y + 24, 1408), 1428);
  drawPdfSignatureBox(ctx, 110, signatureY, 1020, 170);

  ctx.fillStyle = '#667085';
  ctx.font = '700 18px Arial';
  ctx.fillText('Devis valable 30 jours. Prix en euros, TVA 20 %.', 110, 1645);
  ctx.fillText(new Date().toLocaleDateString('fr-FR'), 1010, 1645);
  return canvas;
}

function drawPdfQuoteTable(ctx, quote, x, y, width) {
  const rows = [];
  quote.textileRows.forEach((row) => {
    const designation = row.designationDetail || row.colorLabel || 'Textile';
    rows.push([`${row.label} · ${designation}`, row.quantity || 0, row.saleCents, row.saleTotalCents]);
  });
  quote.optionRows.forEach((row) => {
    rows.push([row.label, row.quantity, row.unitCents, row.totalCents]);
  });
  rows.push(['Livraison', 1, quote.deliveryHtCents, quote.deliveryHtCents]);
  if (quote.rushHtCents) rows.push(['Commande urgente', 1, quote.rushHtCents, quote.rushHtCents]);

  const rowHeight = 46;
  const columns = [x, x + 560, x + 730, x + 900];
  y += 16;
  ctx.fillStyle = '#171a22';
  roundRect(ctx, x, y, width, rowHeight, 8);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.font = '900 16px Arial';
  ctx.fillText('Désignation', columns[0] + 20, y + 29);
  ctx.fillText('Qté', columns[1], y + 29);
  ctx.fillText('PU HT', columns[2], y + 29);
  ctx.fillText('Total HT', columns[3], y + 29);

  const maxRows = 20;
  const visible = rows.slice(0, maxRows);
  visible.forEach((row, index) => {
    const rowY = y + rowHeight + index * rowHeight;
    ctx.fillStyle = index % 2 ? '#ffffff' : '#f8fafc';
    roundRect(ctx, x, rowY, width, rowHeight - 4, 8);
    ctx.fill();
    ctx.fillStyle = '#171a22';
    ctx.font = '800 16px Arial';
    drawPdfClippedText(ctx, String(row[0]), columns[0] + 20, rowY + 29, 520);
    ctx.fillStyle = '#667085';
    ctx.font = '700 15px Arial';
    ctx.fillText(String(row[1]), columns[1], rowY + 29);
    ctx.fillText(formatMoneyCents(row[2]), columns[2], rowY + 29);
    ctx.fillStyle = '#171a22';
    ctx.font = '800 16px Arial';
    ctx.fillText(formatMoneyCents(row[3]), columns[3], rowY + 29);
  });

  let endY = y + rowHeight + visible.length * rowHeight;
  if (rows.length > maxRows) {
    ctx.fillStyle = '#667085';
    ctx.font = '700 13px Arial';
    ctx.fillText(`+ ${rows.length - maxRows} autre(s) ligne(s)`, columns[0] + 20, endY + 20);
    endY += 26;
  }
  return endY;
}

function drawPdfTextilePricingTable(ctx, rows = [], x, y, width) {
  const rowHeight = 36;
  const cols = {
    name: x + 22,
    qty: x + 430,
    sale: x + 540,
    cost: x + 700,
    marginPct: x + 850,
    marginTotal: x + 960,
  };

  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText('Détail par textile', x, y);
  y += 36;

  ctx.fillStyle = '#171a22';
  roundRect(ctx, x, y, width, rowHeight, 8);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.font = '900 14px Arial';
  ctx.fillText('Textile', cols.name, y + 24);
  ctx.fillText('Qté', cols.qty, y + 24);
  ctx.fillText('PV unit.', cols.sale, y + 24);
  ctx.fillText('Coût unit.', cols.cost, y + 24);
  ctx.fillText('Marge %', cols.marginPct, y + 24);
  ctx.fillText('Marge totale', cols.marginTotal, y + 24);

  const maxRows = 22;
  const visibleRows = rows.slice(0, maxRows);
  visibleRows.forEach((row, index) => {
    const rowY = y + rowHeight + index * rowHeight;
    ctx.fillStyle = index % 2 ? '#ffffff' : '#f8fafc';
    roundRect(ctx, x, rowY, width, rowHeight - 4, 8);
    ctx.fill();
    ctx.fillStyle = '#171a22';
    ctx.font = '800 15px Arial';
    drawPdfClippedText(ctx, row.label + (row.colorLabel ? ` · ${row.colorLabel}` : ''), cols.name, rowY + 24, 384);
    ctx.fillStyle = '#667085';
    ctx.font = '700 14px Arial';
    ctx.fillText(String(row.quantity || 0), cols.qty, rowY + 24);
    ctx.fillStyle = '#171a22';
    ctx.font = '800 14px Arial';
    ctx.fillText(formatMoneyCents(row.saleCents), cols.sale, rowY + 24);
    ctx.fillStyle = '#667085';
    ctx.fillText(formatMoneyCents(row.costCents), cols.cost, rowY + 24);
    ctx.fillStyle = orderMarginToneInk(orderMarginTone(row.marginRate, row.marginCents));
    ctx.font = '900 14px Arial';
    ctx.fillText(formatProfitRate(row.marginRate), cols.marginPct, rowY + 24);
    ctx.fillText(formatMoneyCents(row.marginTotalCents), cols.marginTotal, rowY + 24);
  });

  let endY = y + rowHeight + visibleRows.length * rowHeight;
  if (rows.length > maxRows) {
    ctx.fillStyle = '#667085';
    ctx.font = '700 13px Arial';
    ctx.fillText(`+ ${rows.length - maxRows} autre(s) textile(s)`, cols.name, endY + 20);
    endY += 26;
  }
  return endY;
}

function drawPdfInfoRow(ctx, label, value, x, y, width) {
  ctx.fillStyle = '#f8fafc';
  roundRect(ctx, x, y - 28, width, 38, 8);
  ctx.fill();
  ctx.fillStyle = '#667085';
  ctx.font = '800 16px Arial';
  ctx.fillText(label, x + 22, y - 3);
  ctx.fillStyle = '#171a22';
  ctx.font = '800 18px Arial';
  drawPdfClippedText(ctx, String(value || '-'), x + 330, y - 3, width - 360);
}

function drawPdfSizeGrid(ctx, rows, x, y) {
  const cellWidth = Math.min(102, 1020 / Math.max(1, rows.length));
  const cellGap = 0;
  rows.forEach(([size, quantity], index) => {
    const cellX = x + index * (cellWidth + cellGap);
    ctx.fillStyle = quantity ? '#eff6ff' : '#f8fafc';
    roundRect(ctx, cellX, y, cellWidth - 4, 74, 8);
    ctx.fill();
    ctx.strokeStyle = '#dce1e8';
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.fillStyle = '#667085';
    ctx.font = '800 16px Arial';
    ctx.textAlign = 'center';
    ctx.fillText(size, cellX + cellWidth / 2 - 2, y + 28);
    ctx.fillStyle = quantity ? '#1d4ed8' : '#171a22';
    ctx.font = '900 22px Arial';
    ctx.fillText(String(quantity), cellX + cellWidth / 2 - 2, y + 56);
    ctx.textAlign = 'left';
  });
}

function drawPdfQuantitySummary(ctx, pricing, x, y) {
  if (normalizeQuantityMode(state.quantityMode) === 'sizes') {
    drawPdfSizeGrid(ctx, SIZE_OPTIONS.map((size) => [size, Number(state.sizeQuantities[size]) || 0]), x, y);
    return y + 90;
  }
  drawPdfInfoRow(ctx, 'Quantité totale', `${pricing.quantityTotal || 0} pièce${pricing.quantityTotal > 1 ? 's' : ''}`, x, y + 32, 1020);
  return y + 78;
}

function drawPdfChecklistLine(ctx, text, x, y) {
  ctx.strokeStyle = '#98a2b3';
  ctx.lineWidth = 2;
  roundRect(ctx, x, y - 18, 22, 22, 5);
  ctx.stroke();
  ctx.fillStyle = '#171a22';
  ctx.font = '800 18px Arial';
  ctx.fillText(text, x + 38, y);
}

function drawPdfPriceTable(ctx, pricing, x, y, width, order = null) {
  const quantity = pricing.quantityTotal;
  const textileCount = pricing.textile?.rows?.length || state.textiles.length || 1;
  const textileLabel = textileCount > 1 ? 'Textiles' : 'Textile';
  const quote = order ? getQuoteBreakdown(order, pricing) : null;
  const simplifiedMode = normalizeSimplifiedUnitPriceMode(quote?.simplifiedUnitPriceMode, quote?.includeOptionsInUnitPrice);
  const simplifiedExtras = quote?.simplifiedExtras || getSimplifiedUnitPriceExtras(pricing, order || { quantityTotal: quantity, deliverySaleCents: pricing.shipping.finalCents, pickupInStore: false }, simplifiedMode);
  const unitOptionsPerPieceCents = simplifiedExtras.unitOptionsPerPieceCents || 0;
  // When the project holds several textiles, split the price table so each
  // textile has its own row (quantity / unit sale price / total) consistent
  // with the on-screen per-textile pricing (order engine). Otherwise keep the
  // legacy aggregated layout.
  const splitPerTextile = Array.isArray(order?.rows) && order.rows.length > 0;
  let rows;
  let totalCents;
  if (splitPerTextile) {
    const textileRows = (quote?.textileRows || order.rows).map((row) => [
      `${row.label} · ${row.designationDetail || row.colorLabel || 'Textile'}`,
      row.quantity || 0,
      row.saleCents,
      row.saleTotalCents,
    ]);
    const optionRows = (quote?.optionRows || pricing.options.map((option) => ({
      label: option.label,
      pricingMode: option.pricingMode,
      quantity: option.pricingMode === 'global' ? 1 : quantity,
      unitCents: option.pricingMode === 'global' ? option.globalCents : option.unitCents,
      totalCents: option.totalCents,
    }))).map((option) => [
      option.label,
      option.quantity,
      option.unitCents,
      option.totalCents,
    ]);
    const optionsTotalCents = optionRows.reduce((total, row) => total + row[3], 0);
    const deliveryIncluded = Boolean(quote?.deliveryIncludedInUnitPrice);
    const deliveryCents = deliveryIncluded || order.pickupInStore ? 0 : order.deliverySaleCents;
    const rushCents = order.rushEnabled ? order.rushCents : 0;
    rows = [
      ...textileRows,
      ...optionRows,
      ...(deliveryIncluded
        ? []
        : (order.pickupInStore
          ? [['Retrait sur place', 1, 0, 0]]
          : [['Livraison', 1, deliveryCents, deliveryCents]])),
      ...(rushCents ? [['Commande urgente', 1, rushCents, rushCents]] : []),
    ];
    totalCents = (quote?.textileHtCents ?? order.textileSaleTotalCents) + optionsTotalCents + deliveryCents + rushCents;
  } else {
    const optionRows = pricing.options
      .filter((option) => {
        if (simplifiedMode === 'partial' && option.pricingMode === 'unit') return false;
        if (simplifiedMode === 'total') return false;
        return true;
      })
      .filter((option) => pricing.settings.splitSalePrice || option.pricingMode === 'global')
      .map((option) => [
        option.label,
        option.pricingMode === 'global' ? 1 : quantity,
        option.pricingMode === 'global' ? option.globalCents : option.unitCents,
        option.totalCents,
      ]);
    const unitPriceCents = simplifiedMode !== 'off'
      ? pricing.totalCents + simplifiedExtras.perPieceCents
      : pricing.totalCents;
    const showDelivery = simplifiedMode !== 'total';
    rows = pricing.settings.splitSalePrice ? [
      [textileLabel, quantity, pricing.textile.finalCents + (simplifiedMode !== 'off' ? simplifiedExtras.perPieceCents : 0), (pricing.textile.finalCents + (simplifiedMode !== 'off' ? simplifiedExtras.perPieceCents : 0)) * quantity],
      ...(pricing.settings.usePrint ? [['Impression', quantity, pricing.print.finalCents, pricing.print.finalCents * quantity]] : []),
      ...(pricing.settings.usePose ? [['Pose', quantity, pricing.pose.finalCents, pricing.pose.finalCents * quantity]] : []),
      ...(showDelivery ? [['Livraison', 1, pricing.shipping.finalCents, pricing.shipping.totalCents]] : []),
      ...optionRows,
      ...(pricing.urgentOrder.enabled ? [['Commande urgente', 1, pricing.urgentOrder.totalCents, pricing.urgentOrder.totalCents]] : []),
    ] : [
      ['Prix unitaire', quantity, unitPriceCents, unitPriceCents * quantity],
      ...(showDelivery ? [['Livraison', 1, pricing.shipping.finalCents, pricing.shipping.totalCents]] : []),
      ...optionRows,
      ...(pricing.urgentOrder.enabled ? [['Commande urgente', 1, pricing.urgentOrder.totalCents, pricing.urgentOrder.totalCents]] : []),
    ];
    totalCents = pricing.globalTotalCents;
  }
  const rowHeight = 50;
  const columns = [x, x + 470, x + 650, x + 835];

  ctx.fillStyle = '#171a22';
  roundRect(ctx, x, y, width, rowHeight, 8);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.font = '900 17px Arial';
  ctx.fillText('Ligne', columns[0] + 22, y + 31);
  ctx.fillText('Quantité', columns[1], y + 31);
  ctx.fillText('Prix unitaire HT', columns[2], y + 31);
  ctx.fillText('Total HT', columns[3], y + 31);

  rows.forEach((row, index) => {
    const rowY = y + rowHeight + index * rowHeight;
    ctx.fillStyle = index % 2 ? '#ffffff' : '#f8fafc';
    roundRect(ctx, x, rowY, width, rowHeight - 4, 8);
    ctx.fill();
    ctx.fillStyle = '#171a22';
    ctx.font = '800 17px Arial';
    drawPdfClippedText(ctx, row[0], columns[0] + 22, rowY + 31, 410);
    ctx.fillText(String(row[1]), columns[1], rowY + 31);
    ctx.fillText(formatMoneyCents(row[2]), columns[2], rowY + 31);
    ctx.fillText(formatMoneyCents(row[3]), columns[3], rowY + 31);
  });

  const totalY = y + rowHeight + rows.length * rowHeight + 12;
  ctx.fillStyle = '#eff6ff';
  roundRect(ctx, x, totalY, width, 62, 10);
  ctx.fill();
  ctx.fillStyle = '#171a22';
  ctx.font = '900 21px Arial';
  ctx.fillText('Total HT', columns[0] + 22, totalY + 39);
  ctx.fillStyle = '#1d4ed8';
  ctx.font = '900 24px Arial';
  ctx.fillText(formatMoneyCents(totalCents), columns[3], totalY + 39);
  ctx.fillStyle = '#667085';
  ctx.font = '700 15px Arial';
  ctx.fillText(pricing.sizeSummary, columns[0] + 170, totalY + 39);
  return totalY + 62;
}

function drawPdfProfitabilityKpis(ctx, profitability, x, y, width) {
  const gap = 14;
  const cardWidth = (width - gap * 2) / 3;
  const cardHeight = 88;
  const marginInk = orderMarginToneInk(orderMarginTone(profitability.grossMarginRate, profitability.grossMarginCents));
  const rows = [
    ['Prix de vente HT', formatMoneyCents(profitability.saleTotalCents), '#171a22'],
    ['Coûts HT', formatMoneyCents(profitability.costTotalCents), '#171a22'],
    ['Marge brute', formatMoneyCents(profitability.grossMarginCents), marginInk],
    ['Taux de marge brute', formatProfitRate(profitability.grossMarginRate), marginInk],
    ['Marge par pièce', formatMoneyCents(profitability.grossMarginPerPieceCents), marginInk],
  ];
  rows.forEach((row, index) => {
    const col = index % 3;
    const line = Math.floor(index / 3);
    const cardX = x + col * (cardWidth + gap);
    const cardY = y + line * (cardHeight + gap);
    ctx.fillStyle = '#f8fafc';
    roundRect(ctx, cardX, cardY, cardWidth, cardHeight, 10);
    ctx.fill();
    ctx.strokeStyle = '#dce1e8';
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.fillStyle = '#667085';
    ctx.font = '900 15px Arial';
    drawPdfClippedText(ctx, row[0], cardX + 20, cardY + 30, cardWidth - 40);
    ctx.fillStyle = row[2];
    ctx.font = '900 25px Arial';
    drawPdfClippedText(ctx, row[1], cardX + 20, cardY + 64, cardWidth - 40);
  });
}

function drawPdfProfitabilityTable(ctx, title, rows = [], x, y, width) {
  const rowHeight = 36;
  const columns = [x, x + 430, x + 820];
  const totalCents = rows.reduce((total, row) => total + row.amountCents, 0);

  ctx.fillStyle = '#171a22';
  ctx.font = '900 27px Arial';
  ctx.fillText(title, x, y);
  y += 36;

  ctx.fillStyle = '#171a22';
  roundRect(ctx, x, y, width, rowHeight, 8);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.font = '900 16px Arial';
  ctx.fillText('Ligne', columns[0] + 22, y + 24);
  ctx.fillText('Détail', columns[1], y + 24);
  ctx.fillText('Montant HT', columns[2], y + 24);

  rows.forEach((row, index) => {
    const rowY = y + rowHeight + index * rowHeight;
    ctx.fillStyle = index % 2 ? '#ffffff' : '#f8fafc';
    roundRect(ctx, x, rowY, width, rowHeight - 4, 8);
    ctx.fill();
    ctx.fillStyle = '#171a22';
    ctx.font = '800 15px Arial';
    drawPdfClippedText(ctx, row.label, columns[0] + 22, rowY + 24, 360);
    ctx.fillStyle = '#667085';
    ctx.font = '700 14px Arial';
    drawPdfClippedText(ctx, row.detail, columns[1], rowY + 24, 340);
    ctx.fillStyle = '#171a22';
    ctx.font = '900 15px Arial';
    ctx.fillText(formatMoneyCents(row.amountCents), columns[2], rowY + 24);
  });

  const totalY = y + rowHeight + rows.length * rowHeight + 10;
  ctx.fillStyle = '#eff6ff';
  roundRect(ctx, x, totalY, width, 46, 10);
  ctx.fill();
  ctx.fillStyle = '#171a22';
  ctx.font = '900 18px Arial';
  ctx.fillText(`Total ${title.toLowerCase()}`, columns[0] + 22, totalY + 30);
  ctx.fillStyle = '#1d4ed8';
  ctx.font = '900 21px Arial';
  ctx.fillText(formatMoneyCents(totalCents), columns[2], totalY + 30);
  return totalY + 46;
}

function drawPdfSignatureBox(ctx, x, y, width, height) {
  ctx.fillStyle = '#ffffff';
  ctx.strokeStyle = '#dce1e8';
  ctx.lineWidth = 2;
  roundRect(ctx, x, y, width, height, 12);
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = '#171a22';
  ctx.font = '900 20px Arial';
  ctx.fillText('Bon pour accord', x + 28, y + 42);
  ctx.font = '800 17px Arial';
  ctx.fillText('Nom :', x + 28, y + 94);
  ctx.fillText('Date :', x + 28, y + 148);
  ctx.fillText('Signature :', x + 520, y + 94);
  ctx.strokeStyle = '#98a2b3';
  ctx.lineWidth = 1.5;
  ctx.beginPath();
  ctx.moveTo(x + 92, y + 96);
  ctx.lineTo(x + 430, y + 96);
  ctx.moveTo(x + 90, y + 150);
  ctx.lineTo(x + 430, y + 150);
  ctx.moveTo(x + 620, y + 150);
  ctx.lineTo(x + width - 28, y + 150);
  ctx.stroke();
}

function drawPdfWrappedText(ctx, text, x, y, maxWidth, lineHeight) {
  const words = String(text).split(/\s+/).filter(Boolean);
  let line = '';
  let currentY = y;
  words.forEach((word) => {
    const testLine = line ? `${line} ${word}` : word;
    if (ctx.measureText(testLine).width > maxWidth && line) {
      ctx.fillText(line, x, currentY);
      line = word;
      currentY += lineHeight;
    } else {
      line = testLine;
    }
  });
  if (line) ctx.fillText(line, x, currentY);
  return currentY;
}

function drawBatDisclaimer(ctx, x, y, maxWidth = 900) {
  ctx.fillStyle = '#667085';
  ctx.font = '700 15px Arial';
  drawPdfWrappedText(
    ctx,
    'Cette prévisualisation est fournie à titre indicatif. Le rendu final peut présenter de légères différences de couleurs, de dimensions ou de positionnement.',
    x,
    y,
    maxWidth,
    20,
  );
}

function drawPdfClippedText(ctx, text, x, y, maxWidth) {
  const value = String(text || '-');
  if (ctx.measureText(value).width <= maxWidth) {
    ctx.fillText(value, x, y);
    return;
  }
  let clipped = value;
  while (clipped.length > 1 && ctx.measureText(`${clipped}...`).width > maxWidth) {
    clipped = clipped.slice(0, -1);
  }
  ctx.fillText(`${clipped}...`, x, y);
}

async function resolveBatExportProductImageUrl(product = getProduct(), viewId = state.viewId, colorId = state.colorId) {
  const customPhoto = getCustomProductPhoto(product, viewId, colorId);
  if (customPhoto?.src) return customPhoto.src;

  const color = getColor(product, colorId).hex;
  // Export-only: bake the same Figma SVG shown in the editor into a PNG so the
  // downloaded BAT matches the on-screen mockup (productImageSource skips SVGs).
  await preloadGarmentMockups();
  const garmentUrl = garmentMockupUrl(product, viewId);
  if (garmentUrl || getCachedGarmentSvg(product, viewId)) {
    if (!getCachedGarmentSvg(product, viewId) && garmentUrl) {
      await loadGarmentMockup(garmentMockupKey(product, viewId), garmentUrl);
    }
    const markup = garmentMockupMarkup(product, viewId, color);
    if (markup) {
      try {
        return await rasterizeSvgMarkupToPng(markup);
      } catch (_) {
        return svgToDataUrl(markup);
      }
    }
  }

  const rasterUrl = productRasterImageSource(product, viewId, colorId);
  if (rasterUrl) return rasterUrl;
  return svgToDataUrl(productSvg(product, viewId, color));
}

async function rasterizeSvgMarkupToPng(svgMarkup, size = 1024) {
  const image = await loadImage(svgToDataUrl(svgMarkup));
  const width = Math.max(1, image.naturalWidth || image.width || size);
  const height = Math.max(1, image.naturalHeight || image.height || size);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, width, height);
  ctx.drawImage(image, 0, 0, width, height);
  return canvas.toDataURL('image/png');
}

function getContainedImageRect(image, x, y, width, height) {
  const ratio = Math.min(width / Math.max(1, image.width), height / Math.max(1, image.height));
  const drawWidth = image.width * ratio;
  const drawHeight = image.height * ratio;
  return {
    x: x + (width - drawWidth) / 2,
    y: y + (height - drawHeight) / 2,
    w: drawWidth,
    h: drawHeight,
  };
}

async function drawProductPreview(ctx, viewId, x, y, width, height, showArea) {
  const product = getProduct();
  const productImageUrl = await resolveBatExportProductImageUrl(product, viewId, state.colorId);
  const productImage = await loadImage(productImageUrl);
  // Map logos onto the actual drawn garment rect (object-fit: contain), using the
  // same marking % math as the compose UI — not the old preview-group remap.
  const imageRect = getContainedImageRect(productImage, x, y, width, height);
  ctx.drawImage(productImage, imageRect.x, imageRect.y, imageRect.w, imageRect.h);
  const area = getPrintArea(product, viewId);
  const areaPx = {
    x: imageRect.x + (area.left / 100) * imageRect.w,
    y: imageRect.y + (area.top / 100) * imageRect.h,
    w: (area.width / 100) * imageRect.w,
    h: (area.height / 100) * imageRect.h,
  };
  if (showArea) {
    ctx.save();
    ctx.strokeStyle = 'rgba(37, 99, 235, .72)';
    ctx.setLineDash([10, 8]);
    ctx.lineWidth = 3;
    ctx.strokeRect(areaPx.x, areaPx.y, areaPx.w, areaPx.h);
    ctx.restore();
  }

  for (const layer of viewLayers(viewId)) {
    const rect = getLayerMarkingRectPercent(layer, product, viewId);
    const px = imageRect.x + (rect.x / 100) * imageRect.w;
    const py = imageRect.y + (rect.y / 100) * imageRect.h;
    const pw = (rect.w / 100) * imageRect.w;
    const ph = (rect.h / 100) * imageRect.h;
    ctx.save();
    ctx.translate(px + pw / 2, py + ph / 2);
    ctx.rotate((layer.rotation * Math.PI) / 180);
    if (layer.type === 'text') {
      drawTextLayer(ctx, layer, -pw / 2, -ph / 2, pw, ph);
    } else {
      const img = await loadImage(layer.src);
      ctx.drawImage(img, -pw / 2, -ph / 2, pw, ph);
    }
    ctx.restore();
  }
}

function drawContainedImage(ctx, image, x, y, width, height) {
  const rect = getContainedImageRect(image, x, y, width, height);
  ctx.drawImage(image, rect.x, rect.y, rect.w, rect.h);
}

async function drawPdfCompanyHeader(ctx, config, x, y, width, height) {
  const companyName = String(config.companyName || '').trim();
  const hasLogo = Boolean(config.companyLogoSrc);
  if (!companyName && !hasLogo) return;

  ctx.save();
  let textMaxWidth = width;
  if (hasLogo) {
    const logoBoxSize = Math.min(88, height);
    try {
      const logo = await loadImage(config.companyLogoSrc);
      drawContainedImage(ctx, logo, x + width - logoBoxSize, y, logoBoxSize, height);
      textMaxWidth = width - logoBoxSize - 18;
    } catch (error) {
      textMaxWidth = width;
    }
  }

  if (companyName) {
    ctx.textAlign = 'right';
    ctx.fillStyle = '#171a22';
    ctx.font = '900 22px Arial';
    ctx.fillText(companyName, x + textMaxWidth, y + 43, textMaxWidth);
    ctx.textAlign = 'left';
  }
  ctx.restore();
}

function buildPdfFromCanvases(canvases) {
  const encoder = new TextEncoder();
  const parts = [];
  const offsets = [0];
  let length = 0;
  const addBytes = (bytes) => {
    parts.push(bytes);
    length += bytes.length;
  };
  const addText = (text) => addBytes(encoder.encode(text));
  const addObject = (id, body) => {
    offsets[id] = length;
    addText(`${id} 0 obj\n${body}\nendobj\n`);
  };
  const addStreamObject = (id, dict, streamBytes) => {
    offsets[id] = length;
    addText(`${id} 0 obj\n<<${dict} /Length ${streamBytes.length}>>\nstream\n`);
    addBytes(streamBytes);
    addText('\nendstream\nendobj\n');
  };

  const pageWidth = 595.28;
  const pageHeight = 841.89;
  const images = canvases.map((canvas) => ({
    width: canvas.width,
    height: canvas.height,
    bytes: dataUrlToBytes(canvas.toDataURL('image/jpeg', 0.9)),
  }));
  const pageIds = images.map((_, index) => 3 + index * 3);

  addText('%PDF-1.4\n');
  addObject(1, '<< /Type /Catalog /Pages 2 0 R >>');
  addObject(2, `<< /Type /Pages /Kids [${pageIds.map((id) => `${id} 0 R`).join(' ')}] /Count ${pageIds.length} >>`);

  images.forEach((image, index) => {
    const pageId = 3 + index * 3;
    const contentId = pageId + 1;
    const imageId = pageId + 2;
    const imageName = `Im${index + 1}`;
    const content = encoder.encode(`q\n${pageWidth} 0 0 ${pageHeight} 0 0 cm\n/${imageName} Do\nQ\n`);
    addObject(pageId, `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageWidth} ${pageHeight}] /Resources << /XObject << /${imageName} ${imageId} 0 R >> >> /Contents ${contentId} 0 R >>`);
    addStreamObject(contentId, '', content);
    addStreamObject(imageId, ` /Type /XObject /Subtype /Image /Width ${image.width} /Height ${image.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode`, image.bytes);
  });

  const xrefStart = length;
  addText(`xref\n0 ${offsets.length}\n0000000000 65535 f \n`);
  for (let i = 1; i < offsets.length; i += 1) {
    addText(`${String(offsets[i]).padStart(10, '0')} 00000 n \n`);
  }
  addText(`trailer\n<< /Size ${offsets.length} /Root 1 0 R >>\nstartxref\n${xrefStart}\n%%EOF`);
  return new Blob(parts, { type: 'application/pdf' });
}

function layerStyle(layer, viewId = layer.viewId, product = getProductById(layer.productId) || getProduct()) {
  const rect = getLayerPrintRectPercent(layer, product, viewId);
  return [
    `left:${rect.x}%`,
    `top:${rect.y}%`,
    `width:${rect.w}%`,
    `height:${rect.h}%`,
    `transform:rotate(${layer.rotation}deg)`,
  ].join(';');
}

function updateCompositionLayerDom(layer, product = getProduct(), viewId = state.viewId) {
  const resolvedProduct = getProductById(layer.productId) || product || getProduct();
  const layerEl = Array.from(els.printArea.querySelectorAll('[data-composition-sheet] .bat-layer, [data-marking-area] .bat-layer'))
    .find((item) => item.dataset.layerId === layer.id);
  if (!layerEl) return;
  const sheet = layerEl.closest('[data-composition-sheet], [data-marking-area]');
  const isMarking = Boolean(sheet && sheet.hasAttribute('data-marking-area'));
  layerEl.setAttribute('style', isMarking
    ? markingLayerStyle(layer, resolvedProduct, viewId)
    : layerStyle(layer, viewId, resolvedProduct));
  const ui = sheet?.querySelector('.bat-layer-ui');
  if (ui && state.selectedLayerId === layer.id) {
    ui.setAttribute('style', isMarking
      ? markingSelectionUiStyle(layer, resolvedProduct, viewId)
      : selectionUiStyle(layer, resolvedProduct, viewId));
    const info = ui.querySelector('.bat-layer-info');
    if (info) info.textContent = selectedLayerInfoLabel(layer);
  }
  if (layer.type === 'text') fitTextLayers(sheet || els.printArea);
}

function selectionUiStyle(layer, product, viewId) {
  const rect = getLayerPrintRectPercent(layer, product, viewId);
  return [
    `left:${rect.x}%`,
    `top:${rect.y}%`,
    `width:${rect.w}%`,
    `height:${rect.h}%`,
  ].join(';');
}

function compositionSheetStyle(product, viewId) {
  const printSize = getPrintSize(product, viewId);
  return [
    'width:100%',
    `aspect-ratio:${printSize.width} / ${printSize.height}`,
  ].join(';');
}

function compositionMeasureStyle(product, viewId) {
  const printSize = getPrintSize(product, viewId);
  const ratio = printSize.width / Math.max(1, printSize.height);
  const width = ratio >= 1 ? 82 : 66;
  return [
    `width:${width}%`,
    `aspect-ratio:${printSize.width} / ${printSize.height}`,
  ].join(';');
}

function previewGroupStyle(rect) {
  return [
    `left:${rect.x}%`,
    `top:${rect.y}%`,
    `width:${rect.w}%`,
    `height:${rect.h}%`,
  ].join(';');
}

function getPrintAreaPreviewRect(product = getProduct(), viewId = state.viewId) {
  const area = getPrintArea(product, viewId);
  return normalizePreviewRect({
    x: area.left,
    y: area.top,
    w: area.width,
    h: area.height,
  });
}

// Free placement: the marking overlay now spans the whole garment visual so
// logos/text can be positioned anywhere on the textile (no zone constraint).
function getMarkingWorkspaceRect() {
  return { x: 0, y: 0, w: 100, h: 100 };
}

// Reference garment size in cm derived from the print zone so the cm<->px scale
// stays consistent across the whole textile (a 20 cm logo keeps its visual size).
function getGarmentReferenceSizeCm(product = getProduct(), viewId = state.viewId) {
  const printSize = getPrintSize(product, viewId);
  const area = getPrintAreaPreviewRect(product, viewId);
  return {
    width: (printSize.width * 100) / Math.max(1, area.w),
    height: (printSize.height * 100) / Math.max(1, area.h),
  };
}

// Position of a layer expressed as a percentage of the whole garment overlay.
// layer.x/y stay in "cm within the print zone" (0 = print-zone origin) so
// existing placements and cm dimensions are preserved, but values are no longer
// clamped, allowing the layer to travel across the entire textile.
function getLayerMarkingRectPercent(layer, product = getProduct(), viewId = layer.viewId) {
  const area = getPrintAreaPreviewRect(product, viewId);
  const printSize = getPrintSize(product, viewId);
  const scaleX = area.w / Math.max(1, printSize.width);
  const scaleY = area.h / Math.max(1, printSize.height);
  return {
    x: area.x + Number(layer.x || 0) * scaleX,
    y: area.y + Number(layer.y || 0) * scaleY,
    w: Math.max(0.5, Number(layer.w || 0) * scaleX),
    h: Math.max(0.5, Number(layer.h || 0) * scaleY),
  };
}

function markingLayerStyle(layer, product = getProduct(), viewId = layer.viewId) {
  const rect = getLayerMarkingRectPercent(layer, product, viewId);
  return [
    `left:${rect.x}%`,
    `top:${rect.y}%`,
    `width:${rect.w}%`,
    `height:${rect.h}%`,
    `transform:rotate(${layer.rotation}deg)`,
  ].join(';');
}

function markingSelectionUiStyle(layer, product = getProduct(), viewId = layer.viewId) {
  const rect = getLayerMarkingRectPercent(layer, product, viewId);
  return [
    `left:${rect.x}%`,
    `top:${rect.y}%`,
    `width:${rect.w}%`,
    `height:${rect.h}%`,
  ].join(';');
}

function previewRectCenterToPrintPosition(rect, product = getProduct(), viewId = state.viewId) {
  const area = getPrintAreaPreviewRect(product, viewId);
  const printSize = getPrintSize(product, viewId);
  const centerX = Number(rect.x) + Number(rect.w) / 2;
  const centerY = Number(rect.y) + Number(rect.h) / 2;
  return {
    x: clamp(((centerX - area.x) / Math.max(1, area.w)) * printSize.width, 0, printSize.width),
    y: clamp(((centerY - area.y) / Math.max(1, area.h)) * printSize.height, 0, printSize.height),
  };
}

function getLogoPlaceholderRect(product = getProduct(), viewId = state.viewId) {
  const rect = getPrintAreaPreviewRect(product, viewId);
  const width = clamp(rect.w * 0.48, 18, 28);
  const height = clamp(rect.h * 0.34, 14, 22);
  return normalizePreviewRect({
    x: clamp(rect.x + rect.w / 2 - width / 2, 4, 96 - width),
    y: clamp(rect.y + rect.h / 2 - height / 2, 4, 96 - height),
    w: width,
    h: height,
  });
}

function layerStyleInPreviewGroup(layer, product, viewId) {
  const rect = getLayerRectInPreviewGroup(layer, product, viewId);
  return [
    `left:${rect.x}%`,
    `top:${rect.y}%`,
    `width:${rect.w}%`,
    `height:${rect.h}%`,
    `transform:rotate(${layer.rotation}deg)`,
  ].join(';');
}

function selectedLayerInfoLabel(layer) {
  const asset = getAssetForLayer(layer);
  const pixels = layer.type === 'text'
    ? 'texte vectoriel'
    : `${Math.round(asset?.width || 0)}x${Math.round(asset?.height || 0)}px`;
  const dpi = layer.type === 'text' || asset?.isVector
    ? 'vectoriel'
    : `${getLayerEffectiveDpi(layer, asset) >= QUALITY_DPI ? `${QUALITY_DPI}+` : getLayerEffectiveDpi(layer, asset)} DPI`;
  return `${formatCm(layer.w)} cm x ${formatCm(layer.h)} cm · ${pixels} · ${dpi}`;
}

function toolbarIcon(name) {
  const icons = {
    duplicate: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="10" height="10" rx="2"></rect><path d="M6 16H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>',
    backward: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 7h10v10"></path><path d="M18 7 7 18"></path></svg>',
    forward: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16 17H6V7"></path><path d="M6 17 17 6"></path></svg>',
    rotate: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 12a9 9 0 1 1-3-6.7"></path><path d="M21 3v6h-6"></path></svg>',
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"></path><path d="M8 6V4h8v2"></path><path d="M7 6l1 14h8l1-14"></path></svg>',
  };
  return icons[name] || '';
}

function photoUploadIcon() {
  return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8h4l1.7-2h4.6L16 8h4v11H4V8Z"></path><circle cx="12" cy="13.5" r="3.2"></circle><path d="M18 11h.01"></path></svg>';
}

function layerMarkup(layer) {
  if (layer.type === 'text') {
    return `
      <span class="bat-text-layer" style="${textLayerStyle(layer)}">${escapeHtml(layer.text || layer.name || 'Texte')}</span>
    `;
  }
  return `<img src="${layer.src}" alt="">`;
}

function textLayerStyle(layer) {
  return [
    `color:${normalizeHexColor(layer.color, '#111827')}`,
    `font-family:${fontFamilyCss(layer.font)}`,
    // Fallback size only; fitTextLayers() recomputes the real size from the
    // rendered box so the text is never clipped inside its percentage-height box.
    `font-size:${textFontSize(layer)}px`,
  ].join(';');
}

function textFontSize(layer) {
  return Math.max(12, Math.min(72, Math.round(layer.h * 12)));
}

let textMeasureContext = null;
function getTextMeasureContext() {
  if (!textMeasureContext) {
    const canvas = document.createElement('canvas');
    textMeasureContext = canvas.getContext('2d');
  }
  return textMeasureContext;
}

// Post-render pass: size each text layer relative to the actual rendered height
// of its box (measured via getBoundingClientRect) instead of an absolute px
// value derived from the cm height. This fixes text appearing empty/clipped.
function fitTextLayers(root = els.printArea) {
  if (!root || typeof root.querySelectorAll !== 'function') return;
  const nodes = root.querySelectorAll('.bat-text-layer');
  if (!nodes.length) return;
  const ctx = getTextMeasureContext();
  nodes.forEach((node) => {
    const box = node.parentElement;
    if (!box) return;
    const rect = box.getBoundingClientRect();
    const boxW = rect.width;
    const boxH = rect.height;
    if (boxW < 1 || boxH < 1) return;
    const raw = node.textContent || 'Texte';
    const lines = raw.split('\n').filter((line) => line.length);
    const safeLines = lines.length ? lines : [raw || 'Texte'];
    const family = (node.style.fontFamily || getComputedStyle(node).fontFamily || 'Arial').trim() || 'Arial';
    let size = (boxH / safeLines.length) * 0.86;
    size = Math.max(6, Math.min(size, 600));
    for (let i = 0; i < 40; i += 1) {
      ctx.font = `800 ${size}px ${family}`;
      const widest = Math.max(1, ...safeLines.map((line) => ctx.measureText(line).width || 0));
      if (widest <= boxW * 0.98) break;
      const nextSize = size * ((boxW * 0.98) / widest);
      if (nextSize >= size || nextSize < 6) {
        size = Math.max(6, nextSize);
        break;
      }
      size = nextSize;
    }
    node.style.fontSize = `${size}px`;
    node.style.lineHeight = '1.02';
  });
}

function drawTextLayer(ctx, layer, x, y, width, height) {
  const lines = String(layer.text || layer.name || 'Texte').split(/\n+/).filter(Boolean);
  const safeLines = lines.length ? lines : ['Texte'];
  let size = Math.max(16, Math.min(96, (height / safeLines.length) * 0.72));
  ctx.fillStyle = normalizeHexColor(layer.color, '#111827');
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  while (size > 10) {
    ctx.font = `800 ${size}px ${canvasFontFamily(layer.font)}`;
    const tooWide = safeLines.some((line) => ctx.measureText(line).width > width * 0.92);
    if (!tooWide) break;
    size -= 2;
  }

  ctx.font = `800 ${size}px ${canvasFontFamily(layer.font)}`;
  const lineHeight = size * 1.08;
  const firstY = y + height / 2 - ((safeLines.length - 1) * lineHeight) / 2;
  safeLines.forEach((line, index) => {
    ctx.fillText(line, x + width / 2, firstY + index * lineHeight);
  });
}

function getLayerQualityReport(layer) {
  if (!layer) {
    return {
      overall: 'En attente',
      tone: 'empty',
      summary: 'Aucun logo sélectionné.',
      pdfSummary: 'Aucune vérification',
      score: '',
      metrics: [],
      recommendations: [],
    };
  }

  if (layer.type === 'text') {
    return {
      overall: 'Prêt pour impression',
      tone: 'good',
      summary: '100/100 · Texte vectoriel.',
      pdfSummary: 'Texte vectoriel',
      score: '100/100',
      metrics: [
        { label: 'Taille du logo demandé', value: formatSize(layer.w, layer.h), tone: 'good' },
        { label: 'Type de fichier', value: 'Vectoriel', tone: 'good' },
        { label: 'Résolution', value: 'Non concerné', tone: 'good' },
        { label: 'Semi-transparence', value: 'Non', tone: 'good' },
        { label: 'Fond', value: 'Non', tone: 'good' },
        { label: 'Zones fines', value: 'Non', tone: 'good' },
        { label: 'Couleur', value: normalizeHexColor(layer.color, '#111827'), tone: 'good' },
      ],
      recommendations: [],
    };
  }

  const asset = getAssetForLayer(layer);
  const quality = asset?.quality || emptyImageQuality();
  const dpi = getLayerEffectiveDpi(layer, asset);
  const isVector = Boolean(asset?.isVector);
  const thin = getLayerThinAnalysis(layer, asset, quality, dpi);
  const analysis = {
    ...quality,
    isVector,
    dpi,
    printWidthCm: layer.w,
    printHeightCm: layer.h,
    trimmedWidthCm: quality.boundsOriginal ? (quality.boundsOriginal.w / Math.max(1, asset?.width || quality.originalWidth || 1)) * layer.w : 0,
    trimmedHeightCm: quality.boundsOriginal ? (quality.boundsOriginal.h / Math.max(1, asset?.height || quality.originalHeight || 1)) * layer.h : 0,
    hasSemiTransparency: quality.hasSemiTransparency,
    hasBackground: quality.backgroundStatus !== 'none',
    thin,
    complex: !isVector && (quality.colorBucketCount > 42 || thin.hasThinAreas || quality.contentRatio > 0.72),
  };
  const issues = collectLogoIssues(analysis);
  const bad = issues.filter((item) => item.level === 'bad').length;
  const warn = issues.filter((item) => item.level === 'warn').length;
  const score = Math.max(0, 100 - bad * 28 - warn * 12);
  const tone = bad ? 'bad' : warn ? 'warn' : 'good';
  const overall = bad ? 'À corriger' : warn ? 'À améliorer' : 'Prêt pour impression';
  const recommendations = getLogoRecommendations(analysis);
  const trimmedVisible = shouldShowTrimmedMetric(analysis);

  const metrics = [
    { label: 'Taille du logo demandé', value: formatSize(analysis.printWidthCm, analysis.printHeightCm), tone: 'good' },
  ];
  if (trimmedVisible) {
    metrics.push({
      label: 'Dimensions du fichier sans espaces vides',
      value: analysis.boundsOriginal ? formatSize(analysis.trimmedWidthCm, analysis.trimmedHeightCm) : 'Logo non détecté',
      tone: analysis.boundsOriginal ? (analysis.hasWhitespace ? 'warn' : 'good') : 'bad',
    });
  }
  metrics.push(
    { label: 'Type de fichier', value: analysis.isVector ? 'Vectoriel' : 'Pixel', tone: 'good' },
    { label: 'Résolution', value: analysis.isVector ? 'Non concerné' : `${analysis.dpi} DPI`, tone: analysis.isVector ? 'good' : getDpiTone(analysis.dpi) },
    { label: 'Semi-transparence', value: analysis.hasSemiTransparency ? `Oui (${formatRatioPercent(analysis.semiRatio)})` : 'Non', tone: analysis.hasSemiTransparency ? 'warn' : 'good' },
    { label: 'Fond', value: backgroundLabel(analysis.backgroundStatus), tone: analysis.hasBackground ? 'warn' : 'good' },
    { label: 'Zones fines', value: analysis.thin.hasThinAreas ? `Oui (${formatRatioPercent(analysis.thin.ratio)})` : 'Non', tone: analysis.thin.hasThinAreas ? 'warn' : 'good' },
  );

  const pdfParts = [
    `Score ${score}/100`,
    analysis.isVector ? 'Vectoriel' : `${analysis.dpi} DPI`,
    `Fond ${backgroundLabel(analysis.backgroundStatus).toLowerCase()}`,
  ];

  return {
    overall,
    tone,
    summary: `${score}/100 · ${issues.length ? `${issues.length} point${issues.length > 1 ? 's' : ''} à vérifier.` : 'Aucune recommandation nécessaire à cette taille.'}`,
    pdfSummary: pdfParts.join(' · '),
    score: `${score}/100`,
    metrics,
    recommendations,
  };
}

function collectLogoIssues(analysis) {
  const issues = [];
  if (!analysis.hasContent) issues.push({ level: 'bad', text: 'Aucun logo détecté dans le fichier.' });
  if (!analysis.isVector && analysis.dpi < MIN_DPI) issues.push({ level: 'bad', text: `Résolution trop faible : ${analysis.dpi} DPI.` });
  else if (!analysis.isVector && analysis.dpi < QUALITY_DPI) issues.push({ level: 'warn', text: `Résolution correcte mais non parfaite : ${analysis.dpi} DPI.` });
  if (analysis.hasBackground) issues.push({ level: 'warn', text: `Fond détecté : ${backgroundLabel(analysis.backgroundStatus)}.` });
  if (analysis.hasContent && analysis.hasWhitespace && shouldShowTrimmedMetric(analysis)) {
    issues.push({ level: 'warn', text: `Espaces vides détectés : ${formatRatioPercent(analysis.whitespaceRatio)} du fichier.` });
  }
  if (analysis.hasSemiTransparency) issues.push({ level: 'warn', text: `Semi-transparence détectée : ${formatRatioPercent(analysis.semiRatio)} des pixels.` });
  if (analysis.thin.hasThinAreas) issues.push({ level: 'warn', text: 'Zones fines détectées, à vérifier avant impression.' });
  return issues;
}

function getLogoRecommendations(analysis) {
  const recommendations = [];
  if (!analysis.hasContent) {
    return [{
      title: 'Remplacer le fichier',
      text: 'Aucun logo exploitable n’a été détecté. Importez une version plus propre avant de préparer l’impression.',
      importance: 'Haute',
    }];
  }
  if (analysis.hasWhitespace && shouldShowTrimmedMetric(analysis)) {
    recommendations.push({
      title: 'Supprimer les espaces vides',
      text: 'Les espaces vides autour du logo sont inutiles et peuvent créer des erreurs de placement à l’impression.',
      importance: 'Moyenne',
    });
  }
  if (!analysis.isVector && analysis.dpi < QUALITY_DPI) {
    recommendations.push({
      title: analysis.complex || analysis.dpi < MIN_DPI ? 'Redessiner en vectoriel' : 'Vectoriser le logo',
      text: analysis.complex || analysis.dpi < MIN_DPI
        ? `La résolution est trop faible à cette taille (${analysis.dpi} DPI). Un redessin vectoriel sécurise la netteté du logo.`
        : `La résolution est correcte mais pas parfaite (${analysis.dpi} DPI). La vectorisation permet d’agrandir le logo sans perte de netteté.`,
      importance: analysis.dpi < MIN_DPI ? 'Haute' : 'Moyenne',
    });
  }
  if (analysis.hasSemiTransparency) {
    recommendations.push({
      title: 'Nettoyer la semi-transparence',
      text: 'Les pixels semi-transparents peuvent créer des bords flous ou imprévisibles. Il vaut mieux les rendre nets avant impression.',
      importance: 'Moyenne',
    });
  }
  if (analysis.hasBackground) {
    recommendations.push({
      title: 'Retirer le fond',
      text: 'Un fond opaque ou partiel peut s’imprimer comme un rectangle autour du logo.',
      importance: analysis.backgroundStatus === 'solid' ? 'Haute' : 'Moyenne',
    });
  }
  if (analysis.thin.hasThinAreas) {
    recommendations.push({
      title: 'Épaissir les zones fines',
      text: `Certaines zones semblent proches de ${formatMm(analysis.thin.thresholdMm)} ou moins. Elles peuvent être fragiles ou manquer de netteté.`,
      importance: 'À vérifier',
    });
  }
  return recommendations;
}

function getLayerThinAnalysis(layer, asset, quality, dpi) {
  if (!quality?.mask || !quality.analysisWidth || !quality.analysisHeight) {
    return { thresholdMm: THIN_MM, ratio: 0, hasThinAreas: false };
  }
  const width = quality.analysisWidth;
  const height = quality.analysisHeight;
  const pxPerMm = asset?.isVector
    ? width / Math.max(1, layer.w * 10)
    : Math.max(1, (dpi || QUALITY_DPI) / 25.4) * (quality.renderScale || 1);
  const threshold = Math.max(1, Math.round(THIN_MM * pxPerMm));
  let content = 0;
  let thin = 0;

  for (let y = 0; y < height; y += 1) {
    let runStart = -1;
    for (let x = 0; x <= width; x += 1) {
      const visible = x < width && quality.mask[y * width + x];
      if (visible && runStart < 0) runStart = x;
      if ((!visible || x === width) && runStart >= 0) {
        const run = x - runStart;
        content += run;
        if (run <= threshold) thin += run;
        runStart = -1;
      }
    }
  }

  for (let x = 0; x < width; x += 1) {
    let runStart = -1;
    for (let y = 0; y <= height; y += 1) {
      const visible = y < height && quality.mask[y * width + x];
      if (visible && runStart < 0) runStart = y;
      if ((!visible || y === height) && runStart >= 0) {
        const run = y - runStart;
        if (run <= threshold) thin += run;
        runStart = -1;
      }
    }
  }

  const ratio = content ? thin / (content * 2) : 0;
  return {
    thresholdMm: THIN_MM,
    ratio,
    hasThinAreas: ratio > 0.012,
  };
}

function shouldShowTrimmedMetric(analysis) {
  if (!analysis || !analysis.boundsOriginal) return true;
  const widthDelta = Math.abs((analysis.printWidthCm || 0) - (analysis.trimmedWidthCm || 0));
  const heightDelta = Math.abs((analysis.printHeightCm || 0) - (analysis.trimmedHeightCm || 0));
  return analysis.hasWhitespace || widthDelta >= 0.05 || heightDelta >= 0.05;
}

async function prepareLogoAsset(src, naturalWidth, naturalHeight, isVector) {
  const trimmed = await trimLogoWhitespace(src, naturalWidth, naturalHeight);
  return {
    src: trimmed.src,
    width: trimmed.width,
    height: trimmed.height,
    isVector: isVector && !trimmed.trimmed,
    trimmed: trimmed.trimmed,
  };
}

async function removeLogoBackground(src, naturalWidth, naturalHeight) {
  const image = await loadImage(src);
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, naturalWidth);
  canvas.height = Math.max(1, naturalHeight);
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  const bg = edgeAverageColor(data, imageData.width, imageData.height);
  const hardTolerance = BG_TOLERANCE + 10;
  const softTolerance = hardTolerance + 34;

  for (let i = 0; i < data.length; i += 4) {
    if (data[i + 3] < 8) continue;
    const distance = colorDistanceAt(data, i, bg);
    if (distance <= hardTolerance) {
      data[i + 3] = 0;
    } else if (distance <= softTolerance) {
      const keep = (distance - hardTolerance) / (softTolerance - hardTolerance);
      data[i + 3] = Math.round(data[i + 3] * keep);
    }
  }

  ctx.putImageData(imageData, 0, 0);
  const transparentSrc = canvas.toDataURL('image/png');
  const trimmed = await trimLogoWhitespace(transparentSrc, canvas.width, canvas.height);
  return {
    src: trimmed.src,
    width: trimmed.width,
    height: trimmed.height,
    isVector: false,
    trimmed: true,
  };
}

async function refreshAssetLogoPalette(asset) {
  if (!asset || Array.isArray(asset.palette) && asset.palette.length) return;
  try {
    asset.palette = await detectLogoPalette(asset.src, asset.width, asset.height);
    if (state.logoEditorOpen) renderLogoEditorModal();
  } catch (error) {
    console.warn('Impossible de générer la palette du logo', error);
  }
}

async function detectLogoPalette(src, naturalWidth, naturalHeight, maxColors = 10) {
  const image = await loadImage(src);
  const maxEdge = 220;
  const scale = Math.min(1, maxEdge / Math.max(1, naturalWidth, naturalHeight));
  const width = Math.max(1, Math.round(naturalWidth * scale));
  const height = Math.max(1, Math.round(naturalHeight * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  ctx.clearRect(0, 0, width, height);
  ctx.drawImage(image, 0, 0, width, height);
  const { data } = ctx.getImageData(0, 0, width, height);
  const buckets = new Map();
  const colors = new Map();
  let visiblePixels = 0;

  for (let i = 0; i < data.length; i += 4) {
    if (data[i + 3] < 24) continue;
    visiblePixels += 1;
    const r = Math.round(data[i] / 24) * 24;
    const g = Math.round(data[i + 1] / 24) * 24;
    const b = Math.round(data[i + 2] / 24) * 24;
    const key = `${r},${g},${b}`;
    buckets.set(key, (buckets.get(key) || 0) + 1);
    if (!colors.has(key)) colors.set(key, [data[i], data[i + 1], data[i + 2]]);
  }

  if (!visiblePixels) return [];
  return Array.from(buckets.entries())
    .sort((a, b) => b[1] - a[1])
    .slice(0, maxColors)
    .map(([key, count]) => ({
      hex: rgbToHex(colors.get(key) || key.split(',').map(Number)),
      percent: (count / visiblePixels) * 100,
    }));
}

async function trimLogoWhitespace(src, naturalWidth, naturalHeight) {
  const image = await loadImage(src);
  const scanMax = 1800;
  const scanScale = Math.min(1, scanMax / Math.max(1, naturalWidth, naturalHeight));
  const scanCanvas = document.createElement('canvas');
  scanCanvas.width = Math.max(1, Math.round(naturalWidth * scanScale));
  scanCanvas.height = Math.max(1, Math.round(naturalHeight * scanScale));
  const scanCtx = scanCanvas.getContext('2d', { willReadFrequently: true });
  scanCtx.clearRect(0, 0, scanCanvas.width, scanCanvas.height);
  scanCtx.drawImage(image, 0, 0, scanCanvas.width, scanCanvas.height);

  const imageData = scanCtx.getImageData(0, 0, scanCanvas.width, scanCanvas.height);
  const bounds = findVisibleBounds(imageData.data, imageData.width, imageData.height);
  if (!bounds) return { src, width: naturalWidth, height: naturalHeight, trimmed: false };

  const pad = 2;
  const sourceX = clamp(Math.floor((bounds.x - pad) / scanScale), 0, naturalWidth - 1);
  const sourceY = clamp(Math.floor((bounds.y - pad) / scanScale), 0, naturalHeight - 1);
  const sourceRight = clamp(Math.ceil((bounds.x + bounds.w + pad) / scanScale), sourceX + 1, naturalWidth);
  const sourceBottom = clamp(Math.ceil((bounds.y + bounds.h + pad) / scanScale), sourceY + 1, naturalHeight);
  const sourceW = sourceRight - sourceX;
  const sourceH = sourceBottom - sourceY;
  const trimmed = sourceX > 1 || sourceY > 1 || sourceRight < naturalWidth - 1 || sourceBottom < naturalHeight - 1;
  if (!trimmed) return { src, width: naturalWidth, height: naturalHeight, trimmed: false };

  const canvas = document.createElement('canvas');
  canvas.width = sourceW;
  canvas.height = sourceH;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, sourceW, sourceH);
  ctx.drawImage(image, sourceX, sourceY, sourceW, sourceH, 0, 0, sourceW, sourceH);
  return {
    src: canvas.toDataURL('image/png'),
    width: sourceW,
    height: sourceH,
    trimmed: true,
  };
}

function findVisibleBounds(data, width, height) {
  const total = width * height;
  const maxSamples = 9000000;
  const stride = total > maxSamples ? Math.ceil(Math.sqrt(total / maxSamples)) : 1;
  const edgeStats = analyzeTransparentEdges(data, width, height, stride);
  const transparentBackground = edgeStats.samples > 0 && edgeStats.transparent / edgeStats.samples > 0.01;
  const bg = dominantEdgeColor(data, width, height, stride) || edgeAverageColor(data, width, height);
  const rowCounts = new Uint32Array(height);
  const colCounts = new Uint32Array(width);
  let minX = width;
  let minY = height;
  let maxX = -1;
  let maxY = -1;

  for (let y = 0; y < height; y += stride) {
    for (let x = 0; x < width; x += stride) {
      const idx = (y * width + x) * 4;
      const alpha = data[idx + 3];
      const visible = transparentBackground
        ? alpha > VISIBLE_ALPHA_THRESHOLD
        : alpha > VISIBLE_ALPHA_THRESHOLD && colorDistanceAt(data, idx, bg) > BG_TOLERANCE + 4;
      if (!visible) continue;
      rowCounts[y] += 1;
      colCounts[x] += 1;
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
    }
  }

  if (maxX < minX || maxY < minY) return null;
  return refineVisibleBoundsByDensity(
    { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 },
    rowCounts,
    colCounts,
    width,
    height,
  );
}

function refineVisibleBoundsByDensity(bounds, rowCounts, colCounts, width, height) {
  const minRowPixels = Math.max(1, Math.round(width * 0.0012));
  const minColPixels = Math.max(1, Math.round(height * 0.0012));
  let left = bounds.x;
  let top = bounds.y;
  let right = bounds.x + bounds.w - 1;
  let bottom = bounds.y + bounds.h - 1;

  while (left <= right && colCounts[left] < minColPixels) left += 1;
  while (right >= left && colCounts[right] < minColPixels) right -= 1;
  while (top <= bottom && rowCounts[top] < minRowPixels) top += 1;
  while (bottom >= top && rowCounts[bottom] < minRowPixels) bottom -= 1;

  if (right < left || bottom < top) return bounds;
  return { x: left, y: top, w: right - left + 1, h: bottom - top + 1 };
}

async function analyzeImageQuality(src, naturalWidth, naturalHeight) {
  const image = await loadImage(src);
  const maxDimension = 1800;
  const scale = Math.min(1, maxDimension / Math.max(1, naturalWidth), maxDimension / Math.max(1, naturalHeight));
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(naturalWidth * scale));
  canvas.height = Math.max(1, Math.round(naturalHeight * scale));
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  const w = imageData.width;
  const h = imageData.height;
  const total = w * h;
  const edgeStats = analyzeLogoEdges(data, w, h);
  const transparentBackground = edgeStats.samples > 0 && edgeStats.transparent / edgeStats.samples > 0.01;
  const edgeOpaqueRatio = edgeStats.samples > 0 ? edgeStats.opaque / edgeStats.samples : 0;
  const bg = dominantEdgeColor(data, w, h, 1) || edgeAverageColor(data, w, h);

  const mask = new Uint8Array(total);
  let transparentPixels = 0;
  let semiPixels = 0;
  let contentPixels = 0;
  let minX = w;
  let minY = h;
  let maxX = -1;
  let maxY = -1;
  const rowCounts = new Uint32Array(h);
  const colCounts = new Uint32Array(w);
  const colorSet = new Set();
  const colorStep = Math.max(1, Math.floor(total / 30000));

  for (let y = 0; y < h; y += 1) {
    for (let x = 0; x < w; x += 1) {
      const p = y * w + x;
      const idx = p * 4;
      const alpha = data[idx + 3];
      if (alpha < 8) transparentPixels += 1;
      if (alpha > 8 && alpha < 245) semiPixels += 1;

      const visible = transparentBackground
        ? alpha > VISIBLE_ALPHA_THRESHOLD
        : alpha > VISIBLE_ALPHA_THRESHOLD && colorDistanceAt(data, idx, bg) > BG_TOLERANCE + 4;
      if (!visible) continue;
      mask[p] = 1;
      contentPixels += 1;
      rowCounts[y] += 1;
      colCounts[x] += 1;
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
      if (p % colorStep === 0) {
        colorSet.add(`${data[idx] >> 4}-${data[idx + 1] >> 4}-${data[idx + 2] >> 4}`);
      }
    }
  }

  const hasContent = contentPixels > 0;
  const rawBounds = hasContent
    ? { x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 }
    : null;
  const bounds = rawBounds ? refineVisibleBoundsByDensity(rawBounds, rowCounts, colCounts, w, h) : null;
  const boundsOriginal = bounds ? scaleRect(bounds, 1 / scale) : null;
  const whitespaceRatio = bounds ? clamp(1 - (bounds.w * bounds.h) / (w * h), 0, 1) : 1;
  const hasWhitespace = Boolean(bounds)
    && whitespaceRatio > 0.015
    && (bounds.x > 3 || bounds.y > 3 || bounds.x + bounds.w < w - 3 || bounds.y + bounds.h < h - 3);
  const semiRatio = total ? semiPixels / total : 0;
  const backgroundStatus = transparentBackground
    ? 'none'
    : edgeOpaqueRatio > 0.86
      ? 'solid'
      : 'partial';

  return {
    hasContent,
    hasWhitespace,
    whitespaceRatio,
    transparentBackground,
    transparentPixels,
    transparentRatio: total ? transparentPixels / total : 0,
    semiPixels,
    semiRatio,
    hasSemiTransparency: semiRatio > 0.001,
    backgroundStatus,
    boundsCanvas: bounds,
    boundsOriginal,
    originalWidth: naturalWidth,
    originalHeight: naturalHeight,
    analysisWidth: w,
    analysisHeight: h,
    renderScale: scale,
    mask,
    contentRatio: total ? contentPixels / total : 0,
    colorBucketCount: colorSet.size,
  };
}

function emptyImageQuality() {
  return {
    hasContent: false,
    hasWhitespace: true,
    whitespaceRatio: 1,
    transparentBackground: false,
    transparentPixels: 0,
    transparentRatio: 0,
    semiPixels: 0,
    semiRatio: 0,
    hasSemiTransparency: false,
    backgroundStatus: 'solid',
    boundsCanvas: null,
    boundsOriginal: null,
    originalWidth: 1,
    originalHeight: 1,
    analysisWidth: 1,
    analysisHeight: 1,
    renderScale: 1,
    mask: null,
    contentRatio: 0,
    colorBucketCount: 0,
  };
}

function getAssetForLayer(layer) {
  return state.assets.find((asset) => asset.id === layer.assetId) || null;
}

function getLayerEffectiveDpi(layer, asset) {
  if (!asset || asset.isVector) return 0;
  const widthInches = layer.w / CM_PER_INCH;
  const heightInches = layer.h / CM_PER_INCH;
  const widthDpi = widthInches > 0 ? asset.width / widthInches : 0;
  const heightDpi = heightInches > 0 ? asset.height / heightInches : 0;
  const dpi = Math.min(widthDpi || heightDpi, heightDpi || widthDpi);
  return Math.max(1, Math.round(dpi));
}

function getDpiTone(dpi) {
  if (dpi >= QUALITY_DPI) return 'good';
  if (dpi >= MIN_DPI) return 'warn';
  return 'bad';
}

function backgroundLabel(status) {
  if (status === 'none') return 'Non';
  if (status === 'partial') return 'Partiel';
  return 'Oui, fond opaque';
}

function analyzeLogoEdges(data, width, height) {
  let samples = 0;
  let transparent = 0;
  let opaque = 0;
  const maxSamples = 80;
  const add = (x, y) => {
    const idx = (y * width + x) * 4;
    const alpha = data[idx + 3];
    samples += 1;
    if (alpha < 245) transparent += 1;
    if (alpha > 245) opaque += 1;
  };
  for (let i = 0; i < maxSamples; i += 1) {
    const x = Math.round((width - 1) * (i / (maxSamples - 1)));
    const y = Math.round((height - 1) * (i / (maxSamples - 1)));
    add(x, 0);
    add(x, height - 1);
    add(0, y);
    add(width - 1, y);
  }
  return { samples, transparent, opaque };
}

function analyzeTransparentEdges(data, width, height, stride) {
  let samples = 0;
  let transparent = 0;
  const step = Math.max(1, stride);
  const add = (x, y) => {
    const idx = (y * width + x) * 4;
    samples += 1;
    if (data[idx + 3] < 245) transparent += 1;
  };

  for (let x = 0; x < width; x += step) {
    add(x, 0);
    add(x, height - 1);
  }
  for (let y = 0; y < height; y += step) {
    add(0, y);
    add(width - 1, y);
  }

  return { samples, transparent };
}

function edgeAverageColor(data, width, height) {
  const samples = [];
  const add = (x, y) => {
    const idx = (y * width + x) * 4;
    if (data[idx + 3] < 8) return;
    samples.push([data[idx], data[idx + 1], data[idx + 2]]);
  };
  const maxSamples = 60;
  for (let i = 0; i < maxSamples; i += 1) {
    const x = Math.round((width - 1) * (i / (maxSamples - 1)));
    const y = Math.round((height - 1) * (i / (maxSamples - 1)));
    add(x, 0);
    add(x, height - 1);
    add(0, y);
    add(width - 1, y);
  }
  if (!samples.length) return [255, 255, 255];
  const sum = samples.reduce((acc, item) => [acc[0] + item[0], acc[1] + item[1], acc[2] + item[2]], [0, 0, 0]);
  return sum.map((value) => Math.round(value / samples.length));
}

function dominantEdgeColor(data, width, height, stride = 1) {
  const buckets = new Map();
  const colors = new Map();
  const step = Math.max(1, stride);
  const add = (x, y) => {
    const idx = (y * width + x) * 4;
    if (data[idx + 3] < 8) return;
    const r = Math.round(data[idx] / 16) * 16;
    const g = Math.round(data[idx + 1] / 16) * 16;
    const b = Math.round(data[idx + 2] / 16) * 16;
    const key = `${r},${g},${b}`;
    buckets.set(key, (buckets.get(key) || 0) + 1);
    colors.set(key, [data[idx], data[idx + 1], data[idx + 2]]);
  };

  for (let x = 0; x < width; x += step) {
    add(x, 0);
    add(x, height - 1);
  }
  for (let y = 0; y < height; y += step) {
    add(0, y);
    add(width - 1, y);
  }

  let bestKey = '';
  let bestCount = 0;
  buckets.forEach((count, key) => {
    if (count > bestCount) {
      bestKey = key;
      bestCount = count;
    }
  });
  return colors.get(bestKey) || null;
}

function colorDistanceAt(data, idx, color) {
  const dr = data[idx] - color[0];
  const dg = data[idx + 1] - color[1];
  const db = data[idx + 2] - color[2];
  return Math.sqrt(dr * dr + dg * dg + db * db);
}

function scaleRect(rect, scale) {
  return {
    x: rect.x * scale,
    y: rect.y * scale,
    w: rect.w * scale,
    h: rect.h * scale,
  };
}

function formatRatioPercent(ratio) {
  const percent = ratio * 100;
  if (!Number.isFinite(percent) || percent <= 0) return '0%';
  if (percent < 0.1) return '< 0,1%';
  const rounded = percent >= 10 ? Math.round(percent) : Math.round(percent * 10) / 10;
  return `${String(rounded).replace('.', ',')}%`;
}

function pdfToneColor(tone) {
  if (tone === 'good') return '#16a34a';
  if (tone === 'bad') return '#dc2626';
  return '#d97706';
}

function layerTypeLabel(layer) {
  return layer?.type === 'text' ? 'Texte' : 'Logo';
}

// Default name for a newly added logo: sequential "Logo 1", "Logo 2", ...
// (based on the highest existing "Logo N" among image layers so deletions
// don't create duplicates). Users can still rename via the "Nom" field.
function nextLogoName() {
  let max = 0;
  state.layers.forEach((layer) => {
    if (layer?.type !== 'image') return;
    const match = /^Logo\s+(\d+)$/.exec(String(layer.name || '').trim());
    if (match) max = Math.max(max, Number(match[1]));
  });
  return `Logo ${max + 1}`;
}

function layerCounterLabel(count) {
  return `${count} élément${count > 1 ? 's' : ''}`;
}

function formatSize(width, height) {
  return `${formatCm(width)} x ${formatCm(height)} cm`;
}

function formatMm(value) {
  return `${String(Math.round(value * 100) / 100).replace('.', ',')} mm`;
}

function assetMetaLabel(asset) {
  if (asset.renderedFromPdf) {
    return `${asset.sourceFormat} · page 1 rendue · ${asset.width} x ${asset.height} px`;
  }
  if (asset.isVector && (asset.sourceFormat === 'AI' || asset.sourceFormat === 'PDF')) {
    return `${asset.sourceFormat} · vectoriel`;
  }
  const format = asset.sourceFormat ? `${asset.sourceFormat} · ` : '';
  return `${format}${asset.width} x ${asset.height} px${asset.trimmed ? ' · recadré' : ''}`;
}

function fontFamilyCss(font) {
  const fonts = {
    Arial: 'Arial, sans-serif',
    Montserrat: 'Montserrat, Arial, sans-serif',
    Helvetica: 'Helvetica, Arial, sans-serif',
    Inter: 'Inter, Arial, sans-serif',
    Poppins: 'Poppins, Arial, sans-serif',
    Roboto: 'Roboto, Arial, sans-serif',
    Avenir: 'Avenir, "Avenir Next", Arial, sans-serif',
    Futura: 'Futura, "Trebuchet MS", Arial, sans-serif',
    Impact: 'Impact, Haettenschweiler, sans-serif',
    'Trebuchet MS': '"Trebuchet MS", Arial, sans-serif',
    Verdana: 'Verdana, Geneva, sans-serif',
    Georgia: 'Georgia, serif',
    'Times New Roman': '"Times New Roman", Times, serif',
    'Courier New': '"Courier New", Courier, monospace',
  };
  return fonts[font] || fonts.Arial;
}

function canvasFontFamily(font) {
  const fonts = {
    Arial: 'Arial, sans-serif',
    Montserrat: 'Montserrat, Arial, sans-serif',
    Helvetica: 'Helvetica, Arial, sans-serif',
    Inter: 'Inter, Arial, sans-serif',
    Poppins: 'Poppins, Arial, sans-serif',
    Roboto: 'Roboto, Arial, sans-serif',
    Avenir: 'Avenir, Avenir Next, Arial, sans-serif',
    Futura: 'Futura, Trebuchet MS, Arial, sans-serif',
    Impact: 'Impact, Haettenschweiler, sans-serif',
    'Trebuchet MS': 'Trebuchet MS, Arial, sans-serif',
    Verdana: 'Verdana, Geneva, sans-serif',
    Georgia: 'Georgia, serif',
    'Times New Roman': 'Times New Roman, Times, serif',
    'Courier New': 'Courier New, Courier, monospace',
  };
  return fonts[font] || fonts.Arial;
}

function referenceItem(id, categoryId, templateId, label, fullLabel, code, textilePriceCents, witness = false, shape = '') {
  return { id, categoryId, templateId, label, fullLabel, code, textilePriceCents, witness, shape };
}

function normalizeShopifyBlankReferences(items = []) {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => {
      const title = String(item?.title || '').trim();
      if (!title) return null;
      const searchText = normalizeSearchText([
        title,
        item?.type,
        item?.handle,
        item?.vendor,
        ...(Array.isArray(item?.tags) ? item.tags : []),
      ].filter(Boolean).join(' '));
      const categoryId = inferProductCategoryId(searchText);
      const category = PRODUCT_CATEGORIES.find((entry) => entry.id === categoryId) || PRODUCT_CATEGORIES[0];
      const code = extractReferenceCode(title) || String(item?.handle || item?.id || '').toUpperCase();
      const safeId = sanitizeReferenceId(item?.id || item?.handle || code || title);
      return {
        id: `shopify-blank-${safeId}`,
        categoryId,
        templateId: inferProductTemplateId(categoryId, searchText),
        label: code ? `${category.label} ${code}` : title,
        fullLabel: title,
        code,
        textilePriceCents: Number(item?.priceCents) || 0,
        witness: false,
        shape: '',
        imageUrl: item?.imageUrl || '',
        shopifyProductId: item?.gid || (item?.productId ? `gid://shopify/Product/${item.productId}` : ''),
        handle: item?.handle || '',
        vendor: item?.vendor || '',
        source: 'shopify-blank',
      };
    })
    .filter(Boolean);
}

function mergeProductReferences(baseReferences, extraReferences) {
  const seen = new Set();
  return [...baseReferences, ...extraReferences].filter((reference) => {
    const key = referenceDedupKey(reference);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

async function hydrateShopifyBlankCatalog() {
  if (!window.fetch || window.location.protocol === 'file:') return;
  const handle = String(window.SHERPA_BAT_BLANK_COLLECTION_HANDLE || '').trim();
  // Liquid already seeds up to 60 blanks. Never fall back to store-wide `all`
  // (each products.json page is multi‑MB and was freezing the boot spinner).
  if (!handle || handle === 'all') return;
  const seeded = Array.isArray(window.SHERPA_BAT_BLANK_PRODUCTS)
    ? window.SHERPA_BAT_BLANK_PRODUCTS.length
    : 0;
  // Light top-up only: 1 page if Liquid already filled the picker, else a few.
  const maxPages = seeded >= 40 ? 1 : 3;
  const fetchedProducts = [];
  try {
    for (let page = 1; page <= maxPages; page += 1) {
      const response = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`, {
        credentials: 'same-origin',
      });
      if (!response.ok) break;
      const payload = await response.json();
      const pageProducts = Array.isArray(payload?.products) ? payload.products : [];
      if (!pageProducts.length) break;
      fetchedProducts.push(...pageProducts.map(normalizeShopifyJsonProduct).filter(Boolean));
      if (pageProducts.length < 250) break;
    }
  } catch (error) {
    console.warn('Catalogue Blank indisponible', error);
  }
  appendProductReferences(normalizeShopifyBlankReferences(fetchedProducts));
}

function appendProductReferences(references) {
  const mergedReferences = mergeProductReferences(ALL_PRODUCT_REFERENCES, references);
  const addedReferences = mergedReferences.filter((reference) => !PRODUCT_REFERENCE_MAP.has(reference.id));
  if (!addedReferences.length) return;
  ALL_PRODUCT_REFERENCES = mergedReferences;
  addedReferences.forEach((reference) => PRODUCT_REFERENCE_MAP.set(reference.id, reference));
  products.push(...addedReferences
    .filter((reference) => !products.some((product) => product.id === reference.id))
    .map(createReferenceProduct));
  renderProducts();
}

function normalizeShopifyJsonProduct(product) {
  if (!productHasBlankType(product)) return null;
  const firstVariant = Array.isArray(product.variants) ? product.variants[0] : null;
  const firstImage = product.image?.src || (Array.isArray(product.images) ? product.images[0]?.src : '');
  return {
    id: product.id,
    productId: product.id,
    gid: product.admin_graphql_api_id || (product.id ? `gid://shopify/Product/${product.id}` : ''),
    handle: product.handle || '',
    title: product.title || '',
    vendor: product.vendor || '',
    type: product.product_type || product.type || '',
    tags: Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map((tag) => tag.trim()),
    priceCents: parseCatalogPriceToCents(firstVariant?.price || product.price || product.price_min),
    imageUrl: firstVariant?.featured_image?.src || firstImage || '',
  };
}

function productHasBlankType(product) {
  return normalizeSearchText(product.product_type || product.type) === 'blank';
}

function parseCatalogPriceToCents(value) {
  if (value === null || value === undefined || value === '') return 0;
  if (typeof value === 'number') return Number.isInteger(value) && value >= 1000 ? value : Math.round(value * 100);
  const normalized = String(value).replace(/\s/g, '').replace(',', '.');
  const parsed = Number.parseFloat(normalized);
  return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
}

function referenceDedupKey(reference) {
  return normalizeSearchText(reference.shopifyProductId || reference.handle || reference.code || reference.fullLabel || reference.id);
}

function sanitizeReferenceId(value) {
  return String(value || '')
    .trim()
    .replace(/[^a-zA-Z0-9_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase() || `ref-${Date.now()}`;
}

function extractReferenceCode(title) {
  const hashMatch = String(title || '').match(/#\s*([A-Z0-9][A-Z0-9._-]*)/i);
  return hashMatch ? hashMatch[1].toUpperCase() : '';
}

function inferProductCategoryId(searchText) {
  if (/(casquette|bonnet|beanie|cap|trucker|snapback)/.test(searchText)) return 'caps';
  if (/(sweat|hoodie|capuche|crewneck|zip hoody|zip hoodie)/.test(searchText)) return 'hoodies';
  if (/(softshell|veste|blouson|doudoune|bodywarmer|coupe-vent|coupe vent|jacket)/.test(searchText)) return 'jackets';
  if (/(pantalon|short|bermuda|jogging|legging|pant)/.test(searchText)) return 'pants';
  if (/(totebag|tote|sac|bag|bagagerie|pochette|bandouliere|bandoulière)/.test(searchText)) return 'bags';
  if (/(polo|chemise|shirt|blouse)/.test(searchText)) return 'polos';
  if (/(serviette|eponge|éponge|fouta|towel|peignoir)/.test(searchText)) return 'towels';
  if (/(tablier|bandana|accessoire|accessory|pochette)/.test(searchText)) return 'accessories';
  return 'tshirts';
}

function inferProductTemplateId(categoryId, searchText) {
  if (categoryId === 'caps') return /bonnet|beanie/.test(searchText) ? 'beanie' : 'cap';
  if (categoryId === 'hoodies') return 'hoodie';
  if (categoryId === 'jackets') return 'softshell';
  if (categoryId === 'accessories') return 'accessory';
  if (categoryId === 'pants') return 'pants';
  if (categoryId === 'bags') return 'tote';
  if (categoryId === 'polos') return 'polo';
  if (categoryId === 'towels') return 'towel';
  return 'tshirt';
}

function createReferenceProduct(reference) {
  const template = getProductById(reference.templateId) || products[0];
  const clone = cloneProductData(template);
  let views = reference.shape
    ? clone.views.map((view) => ({ ...view, images: {} }))
    : clone.views;
  if (reference.imageUrl) {
    // Catalog bootstrap runs before `state` exists — use product colours only.
    const catalogColors = resolveProductColors(clone, '');
    const firstColorId = catalogColors[0]?.id || 'white';
    const whiteColorId = catalogColors.find((color) => {
      const label = normalizeSearchText(`${color.id || ''} ${color.label || ''}`);
      return label.includes('white') || label.includes('blanc');
    })?.id || firstColorId;
    views = clone.views.map((view) => ({
      ...view,
      images: {
        ...(view.images || {}),
        [firstColorId]: reference.imageUrl,
        [whiteColorId]: reference.imageUrl,
        white: reference.imageUrl,
      },
    }));
  }
  return {
    ...clone,
    id: reference.id,
    label: reference.label,
    fullLabel: reference.fullLabel,
    shopifyProductId: reference.shopifyProductId || clone.shopifyProductId || '',
    textilePriceCents: Number(reference.textilePriceCents) || clone.textilePriceCents || 0,
    shape: reference.shape || clone.shape,
    views,
    referenceCode: reference.code,
    referenceHandle: reference.handle || '',
    referenceVendor: reference.vendor || '',
    isCatalogReference: true,
    isWitnessReference: Boolean(reference.witness),
  };
}

function cloneProductData(product) {
  return JSON.parse(JSON.stringify(product));
}

function getProductById(id) {
  return products.find((product) => product.id === id) || null;
}

function getProductReference(product = getProduct()) {
  return PRODUCT_REFERENCE_MAP.get(product.id) || null;
}

function getProductCategoryId(product = getProduct()) {
  return getProductReference(product)?.categoryId || PRODUCT_CATEGORIES[0].id;
}

function getProductCategory(product = getProduct()) {
  return PRODUCT_CATEGORY_MAP.get(state.productCategoryId)
    || PRODUCT_CATEGORY_MAP.get(getProductCategoryId(product))
    || PRODUCT_CATEGORIES[0];
}

// Figma mockup library (HOmlIWwwAwAnSbI9PrIxCI): white fills = garment body colour.
// Keys look like "tshirt-front"; URLs come from Liquid via window.SHERPA_BAT_GARMENT_SVGS.
const GARMENT_FAMILY_BY_SHAPE = {
  tshirt: 'tshirt',
  hoodie: 'hoodie',
  sweatshirt: 'sweat',
  sweat: 'sweat',
  polo: 'polo',
  tank: 'debardeur',
  jacket: 'softshell',
  pants: 'jogging',
  cap: 'casquette',
  beanie: 'bonnet',
  tote: 'totebag',
};

function resolveGarmentFamily(product = getProduct()) {
  const shape = product?.shape || product?.id || 'tshirt';
  return GARMENT_FAMILY_BY_SHAPE[shape] || GARMENT_FAMILY_BY_SHAPE[product?.id] || 'tshirt';
}

function resolveGarmentViewKey(viewId = state.viewId) {
  if (viewId === 'front' || viewId === 'back') return viewId;
  if (viewId === 'collar') return 'col';
  if (viewId === 'right-side' || viewId === 'right-sleeve' || viewId === 'side' || viewId === 'sleeve') return 'right';
  if (viewId === 'left-side' || viewId === 'left-sleeve') return 'left';
  return 'front';
}

function garmentMockupKey(product, viewId) {
  return `${resolveGarmentFamily(product)}-${resolveGarmentViewKey(viewId)}`;
}

function garmentMockupUrl(product, viewId) {
  const urls = window.SHERPA_BAT_GARMENT_SVGS || {};
  const key = garmentMockupKey(product, viewId);
  return urls[key] || '';
}

// Only the white garment fills take the selected colour. Strokes, dark details,
// accents and the frame background stay untouched.
function recolorGarmentSvg(svgText, color) {
  const fill = normalizeHexColor(color, '#ffffff');
  return String(svgText || '')
    .replace(/<rect\b[^>]*\bfill="#F5F5F5"[^>]*\/?>/gi, '')
    .replace(/\bfill="white"/gi, `fill="${fill}"`)
    .replace(/\bfill="#fff(?:fff)?"/gi, `fill="${fill}"`)
    .replace(/\bfill="#FFFFFF"/g, `fill="${fill}"`)
    .replace(/\bfill:\s*white\b/gi, `fill:${fill}`)
    .replace(/\bfill:\s*#fff(?:fff)?\b/gi, `fill:${fill}`);
}

function getCachedGarmentSvg(product, viewId) {
  const key = garmentMockupKey(product, viewId);
  return garmentSvgCache.get(key) || '';
}

function garmentMockupMarkup(product, viewId, color) {
  const raw = getCachedGarmentSvg(product, viewId);
  if (!raw) return '';
  const label = `${product.label || ''} ${surfaceDisplayLabel(viewId, product)}`.trim();
  const recolored = recolorGarmentSvg(raw, color)
    .replace(/<svg\b([^>]*)>/i, (match, attrs) => {
      let next = attrs;
      if (!/\bclass=/.test(next)) next += ' class="bat-product-mockup"';
      else next = next.replace(/\bclass="([^"]*)"/, 'class="$1 bat-product-mockup"');
      if (!/\baria-label=/.test(next)) next += ` aria-label="${escapeHtml(label)}"`;
      return `<svg${next}>`;
    });
  return recolored;
}

async function loadGarmentMockup(key, url) {
  if (!key || !url || garmentSvgCache.has(key)) return garmentSvgCache.get(key) || '';
  try {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) return '';
    const text = await response.text();
    if (!text.includes('<svg')) return '';
    garmentSvgCache.set(key, text);
    return text;
  } catch (_) {
    return '';
  }
}

function preloadPriorityGarmentMockups() {
  const urls = window.SHERPA_BAT_GARMENT_SVGS || {};
  const keys = new Set(['tshirt-front']);
  try {
    const product = getProduct();
    getActiveViews(product).forEach((view) => {
      keys.add(garmentMockupKey(product, view.id));
    });
  } catch (error) {
    /* state may be mid-init; tee front is enough */
  }
  const entries = [...keys]
    .map((key) => [key, urls[key]])
    .filter(([, url]) => Boolean(url));
  return Promise.all(entries.map(([key, url]) => loadGarmentMockup(key, url)))
    .then((results) => results.filter(Boolean).length);
}

function preloadGarmentMockups() {
  if (garmentSvgPreloadPromise) return garmentSvgPreloadPromise;
  const urls = window.SHERPA_BAT_GARMENT_SVGS || {};
  const entries = Object.entries(urls).filter(([, url]) => Boolean(url));
  garmentSvgPreloadPromise = Promise.all(entries.map(([key, url]) => loadGarmentMockup(key, url)))
    .then((results) => results.filter(Boolean).length);
  return garmentSvgPreloadPromise;
}

function productMediaMarkup(product, viewId, colorId, options = {}) {
  // 1. User-uploaded custom photo always wins.
  if (options.includeCustom !== false) {
    const customPhoto = getCustomProductPhoto(product, viewId, colorId);
    if (customPhoto?.src) {
      const view = getProductView(product, viewId);
      const alt = `${product.fullLabel || product.label} ${view?.label || ''}`.trim();
      return `<img class="bat-product-photo" src="${customPhoto.src}" alt="${escapeHtml(alt)}" crossorigin="anonymous">`;
    }
  }
  const color = options.fallbackColorHex || getColor(product, colorId).hex;
  // 2. Figma SVG mockups (white fills → selected colour). Kick a fetch if missing
  //    so the next render picks them up; fall through while loading.
  const figma = garmentMockupMarkup(product, viewId, color);
  if (figma) return figma;
  const url = garmentMockupUrl(product, viewId);
  if (url) {
    const key = garmentMockupKey(product, viewId);
    loadGarmentMockup(key, url).then((text) => {
      // Also refresh colour/product thumbs — they were painted with the fallback
      // silhouette while this SVG was still downloading.
      if (text) scheduleGarmentMockupsUiRefresh();
    });
  }
  // 3. Legacy hand-drawn silhouette (still recolorable) while Figma SVG loads /
  //    when no mockup exists for this shape/view.
  return productSvg(product, viewId, color);
}

function productRasterImageSource(product, viewId, colorId, options = {}) {
  const view = getProductView(product, viewId);
  const imageView = view?.imageSourceId ? getProductView(product, view.imageSourceId) : view;
  if (!imageView?.images) return '';
  const resolvedColorId = options.preferColorOnly && colorId ? colorId : getColor(product, colorId).id;
  return imageView.images[resolvedColorId]
    || (options.preferColorOnly ? '' : imageView.images[getProductColors(product)[0]?.id])
    || '';
}

function productImageSource(product, viewId, colorId, options = {}) {
  if (options.includeCustom !== false) {
    const customPhoto = getCustomProductPhoto(product, viewId, colorId);
    if (customPhoto?.src) return customPhoto.src;
  }
  // Prefer Figma SVG mockups over the old per-colour raster photos so every
  // view (front/back/sides/collar) recolours consistently.
  if (garmentMockupUrl(product, viewId) || getCachedGarmentSvg(product, viewId)) return '';
  return productRasterImageSource(product, viewId, colorId, options);
}

function getCustomProductPhoto(product = getProduct(), viewId = state.viewId, colorId = state.colorId) {
  return state.customProductPhotos[customProductPhotoKey(product, viewId, colorId)] || null;
}

function customProductPhotoKey(product = getProduct(), viewId = state.viewId, colorId = state.colorId) {
  return `${product.id}:${viewId}:${getColor(product, colorId).id}`;
}

function getProductView(product, viewId) {
  return getProductViews(product).find((view) => view.id === viewId) || getProductViews(product)[0];
}

function getPrintArea(product, viewId) {
  return getProductView(product, viewId)?.area || product.area;
}

function getProductViews(product = getProduct()) {
  const views = product.views.map((view) => ({
    ...view,
    print: zonePrintSize(view.id, product),
    label: surfaceDisplayLabel(view.id, product),
  }));
  return mergeViewsById([
    ...views,
    {
      id: 'collar',
      label: surfaceDisplayLabel('collar', product),
      // No imageSourceId: the collar renders its own recolorable SVG (no front
      // raster borrow), so it follows the selected colour like front/back.
      print: zonePrintSize('collar', product),
      area: collarPrintArea(product),
    },
    {
      id: 'right-side',
      label: surfaceDisplayLabel('right-side', product),
      // Caps keep their genuine per-colour side photo; every other product
      // renders the recolorable side SVG (no front raster borrow).
      imageSourceId: product.id === 'cap' ? 'side' : undefined,
      print: zonePrintSize('right-side', product),
      area: sleevePrintArea(product, 'right-side'),
    },
    {
      id: 'left-side',
      label: surfaceDisplayLabel('left-side', product),
      imageSourceId: product.id === 'cap' ? 'side' : undefined,
      print: zonePrintSize('left-side', product),
      area: sleevePrintArea(product, 'left-side'),
    },
  ]);
}

function getPrintSize(product, viewId) {
  return getProductView(product, viewId)?.print || product.print;
}

function getLayerPrintRectPercent(layer, product = getProduct(), viewId = layer.viewId) {
  const printSize = getPrintSize(product, viewId);
  return normalizePreviewRect({
    x: (layer.x / printSize.width) * 100,
    y: (layer.y / printSize.height) * 100,
    w: (layer.w / printSize.width) * 100,
    h: (layer.h / printSize.height) * 100,
  });
}

function getLayerPreviewRect(layer, product = getProduct(), viewId = layer.viewId) {
  const printRect = getLayerPrintRectPercent(layer, product, viewId);
  const bounds = getCompositionBounds(product, viewId);
  const previewRect = getSurfacePreviewRect(product, viewId);
  if (bounds.w <= 0 || bounds.h <= 0) return printRect;
  return normalizePreviewRect({
    x: previewRect.x + ((printRect.x - bounds.x) / bounds.w) * previewRect.w,
    y: previewRect.y + ((printRect.y - bounds.y) / bounds.h) * previewRect.h,
    w: (printRect.w / bounds.w) * previewRect.w,
    h: (printRect.h / bounds.h) * previewRect.h,
  });
}

function getLayerRectInPreviewGroup(layer, product = getProduct(), viewId = layer.viewId) {
  const printRect = getLayerPrintRectPercent(layer, product, viewId);
  const bounds = getCompositionBounds(product, viewId);
  if (bounds.w <= 0 || bounds.h <= 0) return normalizePreviewRect(printRect);
  return normalizePreviewRect({
    x: ((printRect.x - bounds.x) / bounds.w) * 100,
    y: ((printRect.y - bounds.y) / bounds.h) * 100,
    w: (printRect.w / bounds.w) * 100,
    h: (printRect.h / bounds.h) * 100,
  });
}

function getCompositionBounds(product = getProduct(), viewId = state.viewId) {
  const rects = state.layers
    .filter((layer) => layer.productId === product.id && viewIdMatches(layer.viewId, viewId))
    .map((layer) => getLayerPrintRectPercent(layer, product, viewId));
  if (!rects.length) return { x: 0, y: 0, w: 100, h: 100 };
  const left = Math.min(...rects.map((rect) => rect.x));
  const top = Math.min(...rects.map((rect) => rect.y));
  const right = Math.max(...rects.map((rect) => rect.x + rect.w));
  const bottom = Math.max(...rects.map((rect) => rect.y + rect.h));
  return normalizePreviewRect({
    x: left,
    y: top,
    w: Math.max(1, right - left),
    h: Math.max(1, bottom - top),
  });
}

function getSurfacePreviewRect(product = getProduct(), viewId = state.viewId) {
  return normalizePreviewRect(state.previewAdjustments[previewAdjustmentKey(product, viewId)] || getDefaultSurfacePreviewRect(product, viewId));
}

function getDefaultSurfacePreviewRect(product = getProduct(), viewId = state.viewId) {
  const bounds = getCompositionBounds(product, viewId);
  const area = getPrintArea(product, viewId);
  return normalizePreviewRect({
    x: area.left + (bounds.x / 100) * area.width,
    y: area.top + (bounds.y / 100) * area.height,
    w: (bounds.w / 100) * area.width,
    h: (bounds.h / 100) * area.height,
  });
}

function previewAdjustmentKey(product = getProduct(), viewId = state.viewId) {
  return `${product.id}:${viewId}`;
}

function clearSurfacePreviewAdjustment(viewId = state.viewId, product = getProduct()) {
  delete state.previewAdjustments[previewAdjustmentKey(product, viewId)];
}

function clearProductPreviewAdjustments(product = getProduct()) {
  const prefix = `${product.id}:`;
  Object.keys(state.previewAdjustments).forEach((key) => {
    if (key.startsWith(prefix)) delete state.previewAdjustments[key];
  });
}

function normalizePreviewRect(rect) {
  const w = clamp(Number(rect.w) || 8, 1, 100);
  const h = clamp(Number(rect.h) || 8, 1, 100);
  return {
    x: clamp(Number(rect.x) || 0, 0, 100 - w),
    y: clamp(Number(rect.y) || 0, 0, 100 - h),
    w,
    h,
  };
}

function mergeViewsById(views) {
  const seen = new Set();
  return views.filter((view) => {
    if (!view?.id || seen.has(view.id)) return false;
    seen.add(view.id);
    return true;
  });
}

function isHeadwearProduct(product = getProduct()) {
  const shape = String(product?.shape || product?.id || '').toLowerCase();
  return shape === 'cap' || shape === 'beanie';
}

function zonePrintSize(viewId, product = getProduct()) {
  // Caps / beanies keep their catalog print area (typically 12×6), not tee zones.
  if (isHeadwearProduct(product)) {
    const catalog = product?.print || {};
    return {
      width: Number(catalog.width) > 0 ? Number(catalog.width) : 12,
      height: Number(catalog.height) > 0 ? Number(catalog.height) : 6,
    };
  }
  if (viewId === 'front' || viewId === 'back') return { width: 35, height: 50 };
  if (viewId === 'right-side' || viewId === 'left-side' || viewId === 'right-sleeve' || viewId === 'left-sleeve' || viewId === 'sleeve' || viewId === 'side') return { width: 14, height: 18 };
  if (viewId === 'collar') return { width: 10, height: 5 };
  return { width: 35, height: 50 };
}

function zoneDimensionLabel(viewId, product = getProduct()) {
  const size = zonePrintSize(viewId, product);
  return `${formatCm(size.width)} x ${formatCm(size.height)} cm`;
}

// Small garment thumbnail highlighting where the marking zone sits.
function zoneThumbnailSvg(zoneId) {
  const shirt = 'M15 5 L11 7 L4 13 L8 18 L12 15 L12 35 L28 35 L28 15 L32 18 L36 13 L29 7 L25 5 C25 8.5 15 8.5 15 5 Z';
  const highlights = {
    front: '<rect x="15" y="15" width="10" height="12" rx="1.5"/>',
    back: '<rect x="14" y="14" width="12" height="15" rx="1.5"/><path d="M17 7 C17 10 23 10 23 7" fill="none" stroke="currentColor" stroke-width="1.2"/>',
    'right-side': '<rect x="3.6" y="11.6" width="7" height="6.4" rx="1.4" transform="rotate(-32 7 14.8)"/>',
    'left-side': '<rect x="29.4" y="11.6" width="7" height="6.4" rx="1.4" transform="rotate(32 33 14.8)"/>',
    collar: '<path d="M16 5.4 Q20 9.2 24 5.4 L24 8.4 Q20 11.4 16 8.4 Z"/>',
  };
  return `
    <svg class="bat-zone-thumb-svg" viewBox="0 0 40 40" role="img">
      <path class="bat-zone-thumb-shirt" d="${shirt}"/>
      <g class="bat-zone-thumb-mark">${highlights[zoneId] || highlights.front}</g>
    </svg>
  `;
}

function normalizeCustomZoneSize(size) {
  return {
    width: clamp(Number(size?.width) || 20, 1, 100),
    height: clamp(Number(size?.height) || 15, 1, 100),
  };
}

// Map legacy/aliased zone ids onto the current 5-zone model.
// Old sleeve ids and generic side/sleeve aliases become the new side zones;
// the removed `custom` zone is dropped (returns null → filtered out).
function aliasZoneId(id) {
  if (id === 'right-sleeve' || id === 'sleeve' || id === 'side') return 'right-side';
  if (id === 'left-sleeve') return 'left-side';
  if (id === 'custom') return null;
  return id;
}

function normalizeZoneIds(ids) {
  const selected = new Set((Array.isArray(ids) ? ids : [])
    .map((id) => aliasZoneId(id))
    .filter(Boolean));
  const normalized = ZONE_OPTIONS.map((option) => option.id).filter((id) => selected.has(id));
  return normalized.length ? normalized : ['front'];
}

function normalizeZoneMarkings(markings = {}) {
  return ZONE_OPTIONS.reduce((acc, option) => {
    const raw = String(markings?.[option.id] || '').trim();
    acc[option.id] = ZONE_MARKING_TYPES.some((type) => type.id === raw) ? raw : 'print';
    return acc;
  }, {});
}

function zoneMarkingLabel(zoneId) {
  const id = state.zoneMarkings?.[zoneId] || 'print';
  return ZONE_MARKING_TYPES.find((type) => type.id === id)?.label || ZONE_MARKING_TYPES[0].label;
}

function placementToZoneIds(placementId) {
  const legacy = {
    front: ['front'],
    'front-back': ['front', 'back'],
    'front-back-sleeve': ['front', 'back', 'right-side'],
  };
  return legacy[placementId] || ['front'];
}

function sleevePrintArea(product, viewId) {
  // The Côté droit / Côté gauche views render the recolorable side-profile SVG
  // (torso + one sleeve) drawn in productSvg.
  //
  // The SVG frame (viewBox 0 0 1000 1000) is square, so it represents the same
  // real-world cm horizontally and vertically. A t-shirt side spans ~50 cm of
  // fabric across the full frame, so Wimg = Himg = 50 cm. With printSize
  // 14 x 18 cm:
  //   width  = printSize.width  * 100 / Wimg = 14 * 100 / 50 = 28 %
  //   height = printSize.height * 100 / Himg = 18 * 100 / 50 = 36 %
  // Centred on the sleeve (right-side draws the sleeve on the left of the frame,
  // roughly x 18–50 % / y 32–50 %). Left-side mirrors the SVG, so the rect is
  // mirrored (left = 100 - left - width) to stay on that sleeve.
  const base = { left: 20, top: 26, width: 28, height: 36 };
  if (viewId === 'left-side' || viewId === 'left-sleeve') {
    return { left: 100 - base.left - base.width, top: base.top, width: base.width, height: base.height };
  }
  return base;
}

function collarPrintArea(product) {
  // The Col view now renders the recolorable collar close-up SVG (crew neckline +
  // shoulders) drawn in productSvg, so the printable rect is calibrated to that
  // SVG geometry rather than the old collar photo.
  //
  // The SVG frame (viewBox 0 0 1000 1000) is square, so Wimg = Himg. A neckline
  // close-up spans ~40 cm of fabric across the full frame, so Wimg = Himg = 40 cm.
  // With printSize 10 x 5 cm:
  //   width  = printSize.width  * 100 / Wimg = 10 * 100 / 40 = 25 %
  //   height = printSize.height * 100 / Himg =  5 * 100 / 40 = 12.5 %
  // Centred horizontally (x = 50 %) over the neck-label band just below the crew
  // neckline (opening bottom ≈ y 46 %).
  return { left: 37.5, top: 42, width: 25, height: 12.5 };
}

function customPrintArea(product) {
  if (product.id === 'cap') return { left: 35, top: 38, width: 30, height: 18 };
  return { left: 35, top: 34, width: 30, height: 24 };
}

function getActiveViews(product = getProduct()) {
  const ids = normalizeZoneIds(state.activeZoneIds);
  state.activeZoneIds = ids;
  return ids.map((id) => getProductView(product, id)).filter(Boolean);
}

function ensureCurrentViewIsActive(product = getProduct()) {
  const activeViews = getActiveViews(product);
  if (activeViews.some((view) => view.id === state.viewId)) return;
  state.viewId = activeViews[0]?.id || getProductViews(product)[0]?.id || 'front';
}

function surfaceDisplayLabel(viewId, product = getProduct()) {
  if (viewId === 'front') return 'Face avant';
  if (viewId === 'back') return 'Face arrière';
  if (viewId === 'right-side' || viewId === 'right-sleeve') return 'Côté droit';
  if (viewId === 'left-side' || viewId === 'left-sleeve') return 'Côté gauche';
  if (viewId === 'side' || viewId === 'sleeve') return 'Côté droit';
  if (viewId === 'collar') return 'Col';
  return 'Zone';
}

function productSvg(product, viewId, color) {
  const shape = product.shape || product.id;
  const stroke = colorIsDark(color) ? '#f8fafc' : '#1f2937';
  const shadow = colorIsDark(color) ? 'rgba(255,255,255,.16)' : 'rgba(0,0,0,.14)';
  const common = `stroke="${stroke}" stroke-opacity=".16" stroke-width="6" stroke-linejoin="round"`;
  const back = viewId === 'back';
  const label = back ? 'Verso' : viewId === 'side' ? 'Côté' : 'Recto';
  const S = (inner) => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" aria-label="${product.label} ${label}"><rect width="1000" height="1000" fill="none"/>${inner}</svg>`;
  // Clean crew neckline: a thin ribbed collar crescent (front) / shallow arc (back).
  const crewNeck = (top = 150, w = 96) => back
    ? `<path d="M${500 - w} ${top} Q500 ${top + 62} ${500 + w} ${top}" fill="none" stroke="${shadow}" stroke-width="16" stroke-linecap="round"/>`
    : `<path d="M${500 - w} ${top + 2} Q500 ${top + 66} ${500 + w} ${top + 2} Q${500 + w - 8} ${top + 36} 500 ${top + 48} Q${500 - w + 8} ${top + 36} ${500 - w} ${top + 2} Z" fill="${darken(color, .13)}" opacity=".9"/>`;
  // Adaptive detail colour: light ribbing/seams on dark garments, subtle darken on
  // light ones, so the collar/side geometry recolours and reads on any colour.
  const detail = colorIsDark(color) ? 'rgba(255,255,255,.55)' : darken(color, .18);
  const seam = colorIsDark(color) ? 'rgba(255,255,255,.28)' : 'rgba(0,0,0,.16)';

  // Collar close-up: crew neckline + shoulders/upper chest, filled with the
  // garment colour. Placed before the shape branches so it applies to every
  // product (front/back below stay unchanged).
  if (viewId === 'collar') {
    return S(`
      <path d="M150 470 L178 358 Q206 296 336 272 Q432 260 470 320 Q500 372 530 320 Q568 260 664 272 Q794 296 822 358 L850 470 L850 812 Q500 862 150 812 Z" fill="${color}" ${common}/>
      <path d="M356 298 Q500 254 644 298 Q620 432 500 456 Q380 432 356 298 Z" fill="${darken(color, .30)}"/>
      <path d="M356 298 Q500 254 644 298 Q620 432 500 456 Q380 432 356 298 Z" fill="none" stroke="${detail}" stroke-width="30" stroke-linejoin="round"/>
      <path d="M300 300 Q362 362 430 378 M700 300 Q638 362 570 378" fill="none" stroke="${seam}" stroke-width="14" stroke-linecap="round"/>`);
  }

  // Side profile: torso side + one sleeve, filled with the garment colour.
  // Right-side is drawn sleeve-to-the-left; left-side is the same geometry
  // mirrored horizontally so the two views read as opposite sides. Legacy
  // sleeve/side ids alias onto the same silhouette.
  if (viewId === 'right-side' || viewId === 'left-side' || viewId === 'right-sleeve' || viewId === 'left-sleeve' || viewId === 'sleeve' || viewId === 'side') {
    const mirror = viewId === 'left-side' || viewId === 'left-sleeve';
    const sideInner = `
      <path d="M470 316 Q484 250 572 240 Q676 236 710 302 Q730 344 724 404 L724 812 Q612 852 500 816 L496 470 Z" fill="${color}" ${common}/>
      <path d="M498 322 Q372 318 254 378 Q190 410 182 456 Q188 502 244 494 Q360 474 486 474 L500 474 Z" fill="${darken(color, .07)}" ${common}/>
      <path d="M182 456 Q214 470 244 494" fill="none" stroke="${detail}" stroke-width="16" stroke-linecap="round"/>
      <path d="M544 250 Q582 240 612 252" fill="none" stroke="${detail}" stroke-width="20" stroke-linecap="round"/>
      <path d="M496 470 Q560 462 626 470" fill="none" stroke="${seam}" stroke-width="12" stroke-linecap="round"/>
      <path d="M668 322 L680 806" fill="none" stroke="${seam}" stroke-width="12" stroke-linecap="round"/>`;
    return S(mirror ? `<g transform="translate(1000,0) scale(-1,1)">${sideInner}</g>` : sideInner);
  }

  if (shape === 'sweatshirt') {
    return S(`
      <path d="M394 168h212l150 78 116 226-150 84-74-112 4 452c-108 30-296 30-404 0l4-452-74 112-150-84 116-226 150-78Z" fill="${color}" ${common}/>
      ${crewNeck(168, 96)}
      <path d="M250 700c22 40 48 60 84 74M750 700c-22 40-48 60-84 74" fill="none" stroke="${shadow}" stroke-width="16" stroke-linecap="round"/>
      <path d="M320 856c110 26 250 26 360 0" fill="none" stroke="${shadow}" stroke-width="16" stroke-linecap="round"/>`);
  }

  if (shape === 'hoodie') {
    const hood = back
      ? `<path d="M372 150 Q500 96 628 150 Q672 214 640 286 Q500 320 360 286 Q328 214 372 150 Z" fill="${darken(color, .1)}" ${common}/>`
      : `<path d="M366 148 Q500 92 634 148 Q676 210 646 278 Q574 250 574 210 L500 158 L426 210 Q426 250 354 278 Q324 210 366 148 Z" fill="${darken(color, .09)}"/>
         <path d="M430 206 Q500 246 570 206 L556 348 Q500 372 444 348 Z" fill="${darken(color, .17)}"/>`;
    const strings = back ? '' : `<path d="M470 300 v92M530 300 v92" stroke="${darken(color, .22)}" stroke-width="12" stroke-linecap="round"/><circle cx="470" cy="400" r="10" fill="${darken(color, .22)}"/><circle cx="530" cy="400" r="10" fill="${darken(color, .22)}"/>`;
    const pocket = back ? '' : `<path d="M372 612 h256 q-12 96 -128 96 q-116 0 -128 -96 Z" fill="${darken(color, .1)}" opacity=".7"/>`;
    return S(`
      <path d="M394 176h212l150 78 116 226-150 84-74-112 4 452c-108 30-296 30-404 0l4-452-74 112-150-84 116-226 150-78Z" fill="${color}" ${common}/>
      ${hood}${strings}${pocket}
      <path d="M250 706c22 40 48 60 84 74M750 706c-22 40-48 60-84 74" fill="none" stroke="${shadow}" stroke-width="15" stroke-linecap="round"/>`);
  }

  if (shape === 'jacket') {
    const collar = back
      ? `<path d="M400 160 Q500 220 600 160" fill="none" stroke="${shadow}" stroke-width="16" stroke-linecap="round"/>`
      : `<path d="M392 158 Q500 210 608 158 L636 226 Q500 262 364 226 Z" fill="${darken(color, .14)}"/>`;
    const zip = back ? '' : `<path d="M500 226 V842" stroke="${darken(color, .24)}" stroke-width="12"/>
      <path d="M492 300h16M492 380h16M492 460h16M492 540h16M492 620h16" stroke="${darken(color, .24)}" stroke-width="8" stroke-linecap="round"/>`;
    return S(`
      <path d="M356 176h288l120 62 118 236-138 86-70-118 6 508c-112 26-330 26-436 0l6-508-70 118-138-86 118-236 120-62Z" fill="${color}" ${common}/>
      ${collar}${zip}
      <path d="M250 520c24 40 52 62 90 76M750 520c-24 40-52 62-90 76" fill="none" stroke="${shadow}" stroke-width="15" stroke-linecap="round"/>`);
  }

  if (shape === 'cap') {
    return S(`
      <path d="M228 552c40-186 196-276 322-254 128 22 214 100 250 254H228Z" fill="${color}" ${common}/>
      <path d="M218 552c140 46 466 44 626 0 40 16 56 46 48 90-186 70-544 68-736 0-4-44 18-74 62-90Z" fill="${darken(color, .1)}" ${common}/>
      <path d="M500 300c-40 72-58 152-54 244M500 300c60 68 96 150 104 244" fill="none" stroke="${shadow}" stroke-width="12" stroke-linecap="round"/>
      <path d="M500 300c-16 0-30 8-38 22h76c-8-14-22-22-38-22Z" fill="${darken(color, .16)}"/>`);
  }

  if (shape === 'beanie') {
    return S(`
      <path d="M242 588c0-186 116-352 258-352s258 166 258 352H242Z" fill="${color}" ${common}/>
      <path d="M206 566h588v180c-186 74-402 74-588 0V566Z" fill="${darken(color, .1)}" ${common}/>
      <path d="M330 320c-28 78-42 166-42 262M440 262c-20 94-28 202-24 322M560 262c20 94 28 202 24 322M670 320c28 78 42 166 42 262" fill="none" stroke="${shadow}" stroke-width="13" stroke-linecap="round"/>
      <path d="M240 636h520M236 706h528" fill="none" stroke="${shadow}" stroke-width="16" stroke-linecap="round"/>`);
  }

  if (shape === 'tote') {
    return S(`
      <path d="M338 316c0-118 324-118 324 0" fill="none" stroke="${darken(color, .24)}" stroke-width="40" stroke-linecap="round"/>
      <path d="M236 300h528l-46 588H282L236 300Z" fill="${color}" ${common}/>
      <path d="M322 340v512M678 340v512" stroke="${shadow}" stroke-width="10" stroke-linecap="round"/>`);
  }

  if (shape === 'tank') {
    return S(`
      <path d="M352 172 Q446 168 462 150 L482 150 Q482 206 500 206 Q518 206 518 150 L538 150 Q554 168 648 172 Q706 214 656 300 L676 606 Q500 628 324 606 L344 300 Q294 214 352 172 Z" fill="${color}" ${common}/>
      ${back ? `<path d="M436 158 Q500 212 564 158" fill="none" stroke="${shadow}" stroke-width="16" stroke-linecap="round"/>` : ''}
      <path d="M366 196 Q332 250 352 300M634 196 Q668 250 648 300" fill="none" stroke="${shadow}" stroke-width="11" stroke-linecap="round"/>
      <path d="M382 600 Q500 618 618 600" fill="none" stroke="${shadow}" stroke-width="12" stroke-linecap="round"/>`);
  }

  if (shape === 'accessory') {
    return S(`
      <rect x="210" y="250" width="580" height="500" rx="60" fill="${color}" ${common}/>
      <path d="M260 300c120 34 240 48 340 42 100-6 180-28 250-64M260 700c120-34 240-48 340-42 100 6 180 28 250 64" fill="none" stroke="${shadow}" stroke-width="16" stroke-linecap="round"/>`);
  }

  if (shape === 'pants') {
    const waist = `<path d="M310 150h380v70H310Z" fill="${darken(color, .13)}" opacity=".85"/>`;
    const seam = back
      ? `<path d="M500 220v130M360 360l40 480M640 360l-40 480" fill="none" stroke="${shadow}" stroke-width="12" stroke-linecap="round"/>`
      : `<path d="M500 220v260M420 340h160" fill="none" stroke="${shadow}" stroke-width="12" stroke-linecap="round"/>`;
    return S(`
      <path d="M310 150h380l30 220-64 470H514l-14-360-14 360H344l-64-470 30-220Z" fill="${color}" ${common}/>
      ${waist}${seam}
      <path d="M330 210h340" stroke="${darken(color, .18)}" stroke-width="10" stroke-linecap="round"/>`);
  }

  if (shape === 'towel') {
    return S(`
      <rect x="165" y="235" width="670" height="530" rx="34" fill="${color}" ${common}/>
      <path d="M230 328h540M230 520h540M230 712h540" fill="none" stroke="${shadow}" stroke-width="16" stroke-linecap="round"/>
      <path d="M210 255c68 34 132 34 190 0 66 34 132 34 198 0 64 34 128 34 192 0" fill="none" stroke="${darken(color, .18)}" stroke-width="14" stroke-linecap="round" opacity=".6"/>`);
  }

  if (shape === 'polo') {
    const collar = back
      ? `<path d="M414 150 Q500 210 586 150" fill="none" stroke="${shadow}" stroke-width="16" stroke-linecap="round"/>`
      : `<path d="M432 150 L500 236 L470 300 L468 150 Z" fill="${darken(color, .16)}"/>
         <path d="M568 150 L500 236 L530 300 L532 150 Z" fill="${darken(color, .16)}"/>
         <path d="M486 236 h28 v96 h-28 Z" fill="${darken(color, .12)}"/>
         <circle cx="500" cy="270" r="7" fill="${darken(color, .22)}"/><circle cx="500" cy="312" r="7" fill="${darken(color, .22)}"/>`;
    return S(`
      <path d="M406 150h188l150 74 128 214-150 92-64-104 6 468H386l6-468-64 104-150-92 128-214 150-74Z" fill="${color}" ${common}/>
      ${collar}
      <path d="M300 512c60 24 122 34 186 36M700 512c-60 24-122 34-186 36" fill="none" stroke="${shadow}" stroke-width="14" stroke-linecap="round"/>`);
  }

  // Default: t-shirt (also fallback for unknown shapes).
  return S(`
    <path d="M406 150h188l150 74 128 214-150 92-64-104 6 468H386l6-468-64 104-150-92 128-214 150-74Z" fill="${color}" ${common}/>
    ${crewNeck(150, 94)}
    <path d="M300 512c60 24 122 34 186 36M700 512c-60 24-122 34-186 36" fill="none" stroke="${shadow}" stroke-width="14" stroke-linecap="round"/>
    <path d="M360 862h280" fill="none" stroke="${shadow}" stroke-width="12" stroke-linecap="round"/>`);
}

function getProduct() {
  return products.find((product) => product.id === state.productId) || products[0];
}

function resolveProductColors(product, productChoiceId) {
  // Choix rapide : palette tendance partagée (20 couleurs).
  // Référence catalogue précise : couleurs du produit.
  if (productChoiceId) return TRENDING_TEXTILE_COLORS;
  return product?.colors || TRENDING_TEXTILE_COLORS;
}

function getActiveProductChoiceId() {
  // `state` is created after catalog bootstrap; avoid TDZ crashes.
  try {
    return state?.productChoiceId || '';
  } catch (_) {
    return '';
  }
}

function getProductColors(product = getProduct()) {
  return resolveProductColors(product, getActiveProductChoiceId());
}

function getWhiteColorId(product = getProduct()) {
  const whiteColor = getProductColors(product).find((color) => {
    const label = normalizeSearchText(`${color.id || ''} ${color.label || ''}`);
    return label.includes('white') || label.includes('blanc');
  });
  return whiteColor?.id || getProductColors(product)[0]?.id || 'white';
}

function isCustomColorId(colorId) {
  const id = String(colorId || '');
  return id === CUSTOM_TEXTILE_COLOR_ID || id.startsWith(`${CUSTOM_TEXTILE_COLOR_ID}:`);
}

function makeCustomColorId(hex = DEFAULT_CUSTOM_TEXTILE_HEX) {
  return `${CUSTOM_TEXTILE_COLOR_ID}:${normalizeHexColor(hex, DEFAULT_CUSTOM_TEXTILE_HEX)}`;
}

function customColorHexFromId(colorId, fallback = DEFAULT_CUSTOM_TEXTILE_HEX) {
  const id = String(colorId || '');
  if (id.startsWith(`${CUSTOM_TEXTILE_COLOR_ID}:`)) {
    return normalizeHexColor(id.slice(CUSTOM_TEXTILE_COLOR_ID.length + 1), fallback);
  }
  return normalizeHexColor(state.customColorHex, fallback);
}

function getColor(product = getProduct(), colorId = state.colorId) {
  if (isCustomColorId(colorId)) {
    const hex = customColorHexFromId(colorId);
    return { id: makeCustomColorId(hex), label: 'personnalisée', hex };
  }
  const productColors = getProductColors(product);
  return productColors.find((color) => color.id === colorId) || productColors[0] || { id: 'none', label: 'Aucune variante', hex: '#f7f7f2' };
}

function getView() {
  return getProductView(getProduct(), state.viewId);
}

function viewLayers(viewId = state.viewId) {
  return state.layers.filter((layer) => layer.productId === state.productId && viewIdMatches(layer.viewId, viewId));
}

function viewIdMatches(layerViewId, targetViewId) {
  if (layerViewId === targetViewId) return true;
  // Backward-compat: match legacy sleeve/side ids onto the current side zones.
  if (aliasZoneId(layerViewId) === aliasZoneId(targetViewId)) return true;
  return false;
}

function getSelectedLayer() {
  return state.layers.find((layer) => layer.id === state.selectedLayerId) || null;
}

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    if (!src.startsWith('data:')) image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });
}

function svgToDataUrl(svg) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg.trim())}`;
}

function dataUrlToBytes(dataUrl) {
  const base64 = dataUrl.split(',')[1] || '';
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

async function buildZip(files) {
  const encoder = new TextEncoder();
  const now = new Date();
  const dosTime = (now.getHours() << 11) | (now.getMinutes() << 5) | Math.floor(now.getSeconds() / 2);
  const dosDate = ((now.getFullYear() - 1980) << 9) | ((now.getMonth() + 1) << 5) | now.getDate();
  const localParts = [];
  const centralParts = [];
  let offset = 0;

  for (const file of files) {
    const nameBytes = encoder.encode(file.name);
    const data = new Uint8Array(await file.blob.arrayBuffer());
    const crc = crc32(data);
    const localHeader = zipHeader([
      [0x04034b50, 4],
      [20, 2],
      [0, 2],
      [0, 2],
      [dosTime, 2],
      [dosDate, 2],
      [crc, 4],
      [data.length, 4],
      [data.length, 4],
      [nameBytes.length, 2],
      [0, 2],
    ]);
    localParts.push(localHeader, nameBytes, data);

    const centralHeader = zipHeader([
      [0x02014b50, 4],
      [20, 2],
      [20, 2],
      [0, 2],
      [0, 2],
      [dosTime, 2],
      [dosDate, 2],
      [crc, 4],
      [data.length, 4],
      [data.length, 4],
      [nameBytes.length, 2],
      [0, 2],
      [0, 2],
      [0, 2],
      [0, 2],
      [0, 4],
      [offset, 4],
    ]);
    centralParts.push(centralHeader, nameBytes);
    offset += localHeader.length + nameBytes.length + data.length;
  }

  const centralSize = centralParts.reduce((total, part) => total + part.length, 0);
  const endRecord = zipHeader([
    [0x06054b50, 4],
    [0, 2],
    [0, 2],
    [files.length, 2],
    [files.length, 2],
    [centralSize, 4],
    [offset, 4],
    [0, 2],
  ]);
  return new Blob([...localParts, ...centralParts, endRecord], { type: 'application/zip' });
}

function zipHeader(fields) {
  const length = fields.reduce((total, [, size]) => total + size, 0);
  const bytes = new Uint8Array(length);
  let offset = 0;
  fields.forEach(([value, size]) => {
    for (let i = 0; i < size; i += 1) {
      bytes[offset + i] = (value >>> (8 * i)) & 0xff;
    }
    offset += size;
  });
  return bytes;
}

let crc32Table = null;

function crc32(bytes) {
  if (!crc32Table) {
    crc32Table = Array.from({ length: 256 }, (_, index) => {
      let value = index;
      for (let bit = 0; bit < 8; bit += 1) {
        value = value & 1 ? 0xedb88320 ^ (value >>> 1) : value >>> 1;
      }
      return value >>> 0;
    });
  }
  let crc = 0xffffffff;
  bytes.forEach((byte) => {
    crc = crc32Table[(crc ^ byte) & 0xff] ^ (crc >>> 8);
  });
  return (crc ^ 0xffffffff) >>> 0;
}

function safeFileSlug(value) {
  return String(value || 'dossier')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/gi, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80) || 'dossier';
}

function downloadBlob(blob, name) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  window.setTimeout(() => {
    link.remove();
    URL.revokeObjectURL(url);
  }, 800);
}

function makeId(prefix) {
  return `${prefix}-${Math.random().toString(36).slice(2, 9)}`;
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function round(value) {
  return Math.round(value * 10) / 10;
}

function formatCm(value) {
  return String(round(value)).replace('.', ',');
}

function formatMoneyCents(cents) {
  const value = (Number(cents) || 0) / 100;
  return `${value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
}

// --- HT / TTC display toggle (sale prices only) ---------------------------
function getVatRate() {
  return TVA_RATE;
}

function isTtcPriceMode() {
  return state.priceDisplayMode === 'TTC';
}

function salePriceSuffix() {
  return isTtcPriceMode() ? 'TTC' : 'HT';
}

// Convert a stored HT sale amount (cents) into the value we display to the user
// depending on the active price display mode.
function toDisplaySaleCents(cents) {
  const base = Number(cents) || 0;
  return isTtcPriceMode() ? Math.round(base * (1 + getVatRate())) : base;
}

// Convert a displayed sale amount (cents) back into the HT value we persist,
// so editable sale-price fields round-trip while TTC display is active.
function fromDisplaySaleCents(cents) {
  const value = Number(cents) || 0;
  return isTtcPriceMode() ? Math.round(value / (1 + getVatRate())) : value;
}

function formatSaleMoneyCents(cents) {
  return formatMoneyCents(toDisplaySaleCents(cents));
}

function formatSaleMoneyInput(cents) {
  return formatMoneyInput(toDisplaySaleCents(cents));
}

function formatMoneyInput(cents) {
  return ((Number(cents) || 0) / 100).toFixed(2);
}

function formatDecimalInput(value) {
  const number = Number(value) || 0;
  return String(Math.round(number * 10) / 10);
}

function formatDecimal(value) {
  return formatDecimalInput(value).replace('.', ',');
}

function formatPercentInput(value) {
  return String(Math.round((Number(value) || 0) * 10) / 10);
}

function formatPercent(value) {
  return `${formatPercentInput(value).replace('.', ',')}%`;
}

function formatProfitRate(value) {
  return `${formatDecimal(value)}%`;
}

function createEmptySizeQuantities() {
  return SIZE_OPTIONS.reduce((acc, size) => {
    acc[size] = 10;
    return acc;
  }, {});
}

function createDefaultTotalQuantity() {
  return getSizeQuantityTotal(createEmptySizeQuantities());
}

function normalizeQuantityMode(value) {
  return QUANTITY_MODES.includes(value) ? value : 'total';
}

function createDefaultBatConfig() {
  return {
    textileReference: '',
    technique: normalizeAvailableMarkingTechnique(activeAdminDefaults.bat.technique),
    leadTime: activeAdminDefaults.bat.leadTime || '3 semaines',
    shippingCents: normalizeOverrideCents(activeAdminDefaults.bat.shippingCents) ?? 5000,
    options: [],
  };
}

function createDefaultProductionConfig() {
  const technique = normalizeAvailableMarkingTechnique(activeAdminDefaults.production.technique);
  return {
    orderReference: '',
    clientName: '',
    textileReference: '',
    textileColor: '',
    technique,
    textileSupplier: activeAdminDefaults.production.textileSupplier,
    transferSupplier: transferSupplierForTechnique(technique, activeAdminDefaults),
    carrierPickup: activeAdminDefaults.production.carrierPickup,
    productionDeadline: defaultProductionDateLabel(activeAdminDefaults.production.productionDelayWeeks),
    quoteComment: '',
    fabricationInstructions: '',
    filePrep: activeAdminDefaults.production.filePrep,
    placementNotes: activeAdminDefaults.production.placementNotes,
    qualityNotes: activeAdminDefaults.production.qualityNotes,
    packingNotes: activeAdminDefaults.production.packingNotes,
  };
}

function createBaseProfitabilityDefaults() {
  return {
    textilePurchaseCents: null,
    printPurchaseCents: null,
    largeSizePurchaseCents: 0,
    shippingPurchaseCents: null,
    otherCostsCents: 0,
    otherCosts: [],
    poseLaborCents: 25,
    fileSetupCents: 0,
    laborHourlyCents: 2500,
    laborSetupMinutes: 15,
    laborPerPieceMinutes: 1,
    // Editable defaults for recurring options / suppléments (Paramètres).
    embroideryProgramCents: 5000,
    technicalFeeCents: 2000,
    foldingUnitCents: 25,
    individualPackagingCents: 50,
    labelRemovalCents: 25,
    rushSupplementCents: null,
    // Internal packaging cost: default is a % of the order sale total HT.
    packagingPercent: 1,
    packagingCents: null,
  };
}

function getActiveProfitabilityDefaults() {
  try {
    return activeAdminDefaults?.profitability || createBaseProfitabilityDefaults();
  } catch (error) {
    return createBaseProfitabilityDefaults();
  }
}

function createDefaultProfitabilityConfig() {
  return normalizeProfitabilityConfig(getActiveProfitabilityDefaults(), createBaseProfitabilityDefaults());
}

function normalizeProfitabilityConfig(config = {}, defaults = createBaseProfitabilityDefaults()) {
  return {
    textilePurchaseCents: normalizeOverrideCents(config.textilePurchaseCents),
    printPurchaseCents: normalizeOverrideCents(config.printPurchaseCents),
    largeSizePurchaseCents: normalizeOverrideCents(config.largeSizePurchaseCents) ?? defaults.largeSizePurchaseCents,
    shippingPurchaseCents: normalizeOverrideCents(config.shippingPurchaseCents),
    deliverySaleCents: normalizeOverrideCents(config.deliverySaleCents),
    pickupInStore: Boolean(config.pickupInStore),
    otherCostsCents: normalizeOverrideCents(config.otherCostsCents) ?? defaults.otherCostsCents,
    otherCosts: normalizeProfitabilityOtherCosts(
      Array.isArray(config.otherCosts) ? config.otherCosts : defaults.otherCosts,
      config.otherCostsCents ?? defaults.otherCostsCents,
    ),
    poseLaborCents: normalizeOverrideCents(config.poseLaborCents) ?? defaults.poseLaborCents,
    fileSetupCents: normalizeOverrideCents(config.fileSetupCents) ?? defaults.fileSetupCents,
    laborHourlyCents: normalizeOverrideCents(config.laborHourlyCents) ?? defaults.laborHourlyCents,
    laborSetupMinutes: clamp(Number(config.laborSetupMinutes ?? defaults.laborSetupMinutes) || 0, 0, 10000),
    laborPerPieceMinutes: clamp(Number(config.laborPerPieceMinutes ?? defaults.laborPerPieceMinutes) || 0, 0, 10000),
    embroideryProgramCents: normalizeOverrideCents(config.embroideryProgramCents) ?? defaults.embroideryProgramCents,
    technicalFeeCents: normalizeOverrideCents(config.technicalFeeCents) ?? defaults.technicalFeeCents,
    foldingUnitCents: normalizeOverrideCents(config.foldingUnitCents) ?? defaults.foldingUnitCents,
    individualPackagingCents: normalizeOverrideCents(config.individualPackagingCents) ?? defaults.individualPackagingCents,
    labelRemovalCents: normalizeOverrideCents(config.labelRemovalCents) ?? defaults.labelRemovalCents,
    rushSupplementCents: normalizeOverrideCents(config.rushSupplementCents),
    packagingPercent: clamp(Number(config.packagingPercent ?? defaults.packagingPercent) || 0, 0, 100),
    packagingCents: normalizeOverrideCents(config.packagingCents),
  };
}

function normalizeProfitabilityOtherCosts(costs = [], legacyCents = 0) {
  const normalized = Array.isArray(costs)
    ? costs.map((cost) => ({
      id: String(cost?.id || makeId('cost')),
      label: String(cost?.label || 'Coût').trim() || 'Coût',
      cents: normalizeOverrideCents(cost?.cents ?? cost?.amountCents) ?? 0,
      pricingMode: cost?.pricingMode === 'unit' ? 'unit' : 'global',
    }))
    : [];
  if (normalized.length) return normalized;
  const cents = normalizeOverrideCents(legacyCents) ?? 0;
  return cents ? [{
    id: makeId('cost'),
    label: 'Autres',
    cents,
    pricingMode: 'global',
  }] : [];
}

function getProfitabilityOtherCostsPricing(costs, quantity) {
  const normalized = normalizeProfitabilityOtherCosts(costs);
  const safeQuantity = Math.max(1, Number(quantity) || 1);
  const rows = normalized.map((cost) => {
    const isUnit = cost.pricingMode === 'unit';
    return {
      label: cost.label,
      detail: isUnit ? `${formatMoneyCents(cost.cents)} / unité` : 'Global',
      amountCents: isUnit ? cost.cents * safeQuantity : cost.cents,
    };
  });
  return {
    rows,
    totalCents: rows.reduce((total, row) => total + row.amountCents, 0),
  };
}

function createDefaultPricingSettings() {
  const pricing = activeAdminDefaults?.bat?.pricingSettings || {};
  return {
    splitSalePrice: pricing.splitSalePrice ?? false,
    usePrint: pricing.usePrint ?? true,
    usePose: pricing.usePose ?? true,
    poseCentsPerZone: normalizeOverrideCents(pricing.poseCentsPerZone) ?? 100,
    useLargeSizeSurcharge: false,
    largeSizeSurchargeCents: normalizeOverrideCents(pricing.largeSizeSurchargeCents) ?? 25,
    useMargin: pricing.useMargin ?? true,
    marginPercent: clamp(Number(pricing.marginPercent ?? 30) || 0, 0, 500),
    salePriceMode: 'margin',
    targetGrossMarginPercent: clamp(Number(pricing.targetGrossMarginPercent ?? 30) || 0, 0, 95),
    useUrgentOrder: pricing.useUrgentOrder ?? false,
    urgentOrderCents: normalizeOverrideCents(pricing.urgentOrderCents),
    includeOptionsInUnitPrice: Boolean(pricing.includeOptionsInUnitPrice),
    simplifiedUnitPriceMode: normalizeSimplifiedUnitPriceMode(
      pricing.simplifiedUnitPriceMode,
      pricing.includeOptionsInUnitPrice,
    ),
  };
}

function normalizePricingSettings(settings = {}) {
  const defaults = createDefaultPricingSettings();
  const poseCentsPerZone = settings.poseCentsPerZone ?? settings.poseCentsPerUnit;
  const simplifiedUnitPriceMode = normalizeSimplifiedUnitPriceMode(
    settings.simplifiedUnitPriceMode ?? defaults.simplifiedUnitPriceMode,
    settings.includeOptionsInUnitPrice ?? defaults.includeOptionsInUnitPrice,
  );
  return {
    splitSalePrice: false,
    usePrint: settings.usePrint ?? defaults.usePrint,
    usePose: settings.usePose ?? defaults.usePose,
    poseCentsPerZone: normalizeOverrideCents(poseCentsPerZone) ?? defaults.poseCentsPerZone,
    useLargeSizeSurcharge: false,
    largeSizeSurchargeCents: normalizeOverrideCents(settings.largeSizeSurchargeCents) ?? defaults.largeSizeSurchargeCents,
    useMargin: settings.useMargin ?? defaults.useMargin,
    marginPercent: clamp(Number(settings.marginPercent ?? defaults.marginPercent) || 0, 0, 500),
    salePriceMode: settings.salePriceMode === 'amount' ? 'amount' : defaults.salePriceMode,
    targetGrossMarginPercent: clamp(Number(settings.targetGrossMarginPercent ?? defaults.targetGrossMarginPercent) || 0, 0, 95),
    useUrgentOrder: settings.useUrgentOrder ?? defaults.useUrgentOrder,
    urgentOrderCents: normalizeOverrideCents(settings.urgentOrderCents ?? defaults.urgentOrderCents),
    simplifiedUnitPriceMode,
    includeOptionsInUnitPrice: simplifiedUnitPriceMode !== 'off',
  };
}

function normalizePriceOverrides(overrides = {}) {
  return {
    totalCents: normalizeOverrideCents(overrides.totalCents),
    textileCents: normalizeOverrideCents(overrides.textileCents),
    printCents: normalizeOverrideCents(overrides.printCents),
    poseCents: normalizeOverrideCents(overrides.poseCents),
  };
}

function applyPricingMargin(cents, settings = state.pricingSettings) {
  const normalized = normalizePricingSettings(settings);
  const baseCents = normalizeOverrideCents(cents) ?? 0;
  if (!normalized.useMargin) return baseCents;
  return Math.round(baseCents * (1 + normalized.marginPercent / 100));
}

function getPoseZoneCount(rows) {
  const ids = new Set((rows || [])
    .filter((row) => row.layer)
    .map((row) => row.view?.id || row.layer.viewId)
    .filter(Boolean));
  return ids.size;
}

function getSizeQuantityTotal(quantities = state.sizeQuantities) {
  return SIZE_OPTIONS.reduce((total, size) => total + (Number(quantities?.[size]) || 0), 0);
}

function getTotalQuantityFromTotalMode() {
  return parseQuantityInput(state.totalQuantity);
}

function getLargeSizeQuantityFromTotalMode() {
  return Math.min(parseQuantityInput(state.totalLargeSizeQuantity), getTotalQuantityFromTotalMode());
}

function getTotalQuantity() {
  return ensureProjectTextileQuantities();
}

function getLargeSizeQuantity() {
  return 0;
}

function getSizeQuantitySummary() {
  const rows = getProjectTextilePriceRows().filter((row) => row.quantity > 0);
  if (!rows.length) return 'Aucune quantité renseignée';
  return rows.map((row) => `${row.label} ${row.quantity}`).join(' · ');
}

function budgetDetailLabel(pricing) {
  const base = `${formatMoneyCents(pricing.totalCents)} / unité x ${pricing.quantityTotal}`;
  const extras = [];
  if (pricing.optionsGlobalCents) extras.push(`${formatMoneyCents(pricing.optionsGlobalCents)} options globales`);
  if (pricing.shipping.finalCents) extras.push(`${formatMoneyCents(pricing.shipping.finalCents)} livraison`);
  if (pricing.urgentOrder.totalCents) extras.push(`${formatMoneyCents(pricing.urgentOrder.totalCents)} urgence`);
  return extras.length ? `${base} + ${extras.join(' + ')}` : base;
}

function parseQuantityInput(value) {
  const quantity = Math.floor(Number(value));
  return Number.isFinite(quantity) ? Math.max(0, quantity) : 0;
}

function parseMoneyInput(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return null;
  const normalized = raw.replace(',', '.').replace(/[^\d.]/g, '');
  const amount = Number(normalized);
  return Number.isFinite(amount) ? Math.max(0, Math.round(amount * 100)) : null;
}

function parsePercentInput(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return 0;
  const negative = raw.startsWith('-');
  const normalized = raw.replace(',', '.').replace(/[^\d.]/g, '');
  const amount = Number(normalized);
  if (!Number.isFinite(amount)) return 0;
  const signed = negative ? -amount : amount;
  return clamp(signed, -999, 500);
}

function parsePositiveDecimalInput(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return 0;
  const normalized = raw.replace(',', '.').replace(/[^\d.]/g, '');
  const amount = Number(normalized);
  return Number.isFinite(amount) ? Math.max(0, amount) : 0;
}

function normalizeOverrideCents(value) {
  return Number.isFinite(value) ? Math.max(0, Math.round(value)) : null;
}

function formatEuroRate(value) {
  return `${(Number(value) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} €`;
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function colorIsDark(hex) {
  const rgb = hexToRgb(hex);
  return rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114 < 120;
}

function darken(hex, amount) {
  const rgb = hexToRgb(hex).map((value) => Math.round(value * (1 - amount)));
  return `#${rgb.map((value) => value.toString(16).padStart(2, '0')).join('')}`;
}

function normalizeHexColor(value, fallback) {
  return /^#[0-9a-f]{6}$/i.test(String(value)) ? value : fallback;
}

function rgbToHex(rgb) {
  return `#${rgb
    .slice(0, 3)
    .map((value) => clamp(Math.round(value), 0, 255).toString(16).padStart(2, '0'))
    .join('')}`;
}

function hexToRgb(hex) {
  const clean = hex.replace('#', '');
  return [
    parseInt(clean.slice(0, 2), 16),
    parseInt(clean.slice(2, 4), 16),
    parseInt(clean.slice(4, 6), 16),
  ];
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

// Boot after every function/const in this file is initialized (avoids TDZ crashes
// when init → renderAll → garment mockup helpers touch later declarations).
init();

